(function () {
    "use strict";
    /******************************************************************************
      Copyright (c) Microsoft Corporation.

      Permission to use, copy, modify, and/or distribute this software for any
      purpose with or without fee is hereby granted.

      THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
      REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
      AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
      INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
      LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
      OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
      PERFORMANCE OF THIS SOFTWARE.
      ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function (d, b) {
      extendStatics =
        Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array &&
          function (d, b) {
            d.__proto__ = b;
          }) ||
        function (d, b) {
          for (var p in b)
            if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
      return extendStatics(d, b);
    };

    function __extends(d, b) {
      if (typeof b !== "function" && b !== null)
        throw new TypeError(
          "Class extends value " + String(b) + " is not a constructor or null"
        );
      extendStatics(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype =
        b === null ? Object.create(b) : ((__.prototype = b.prototype), new __());
    }

    var __assign = function () {
      __assign =
        Object.assign ||
        function __assign(t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
              if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
          return t;
        };
      return __assign.apply(this, arguments);
    };

    function __awaiter(thisArg, _arguments, P, generator) {
      function adopt(value) {
        return value instanceof P
          ? value
          : new P(function (resolve) {
              resolve(value);
            });
      }
      return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }
        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e) {
            reject(e);
          }
        }
        function step(result) {
          result.done
            ? resolve(result.value)
            : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    }

    function __generator(thisArg, body) {
      var _ = {
          label: 0,
          sent: function () {
            if (t[0] & 1) throw t[1];
            return t[1];
          },
          trys: [],
          ops: [],
        },
        f,
        y,
        t,
        g;
      return (
        (g = { next: verb(0), throw: verb(1), return: verb(2) }),
        typeof Symbol === "function" &&
          (g[Symbol.iterator] = function () {
            return this;
          }),
        g
      );
      function verb(n) {
        return function (v) {
          return step([n, v]);
        };
      }
      function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while ((g && ((g = 0), op[0] && (_ = 0)), _))
          try {
            if (
              ((f = 1),
              y &&
                (t =
                  op[0] & 2
                    ? y["return"]
                    : op[0]
                    ? y["throw"] || ((t = y["return"]) && t.call(y), 0)
                    : y.next) &&
                !(t = t.call(y, op[1])).done)
            )
              return t;
            if (((y = 0), t)) op = [op[0] & 2, t.value];
            switch (op[0]) {
              case 0:
              case 1:
                t = op;
                break;
              case 4:
                _.label++;
                return { value: op[1], done: false };
              case 5:
                _.label++;
                y = op[1];
                op = [0];
                continue;
              case 7:
                op = _.ops.pop();
                _.trys.pop();
                continue;
              default:
                if (
                  !((t = _.trys), (t = t.length > 0 && t[t.length - 1])) &&
                  (op[0] === 6 || op[0] === 2)
                ) {
                  _ = 0;
                  continue;
                }
                if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) {
                  _.label = op[1];
                  break;
                }
                if (op[0] === 6 && _.label < t[1]) {
                  _.label = t[1];
                  t = op;
                  break;
                }
                if (t && _.label < t[2]) {
                  _.label = t[2];
                  _.ops.push(op);
                  break;
                }
                if (t[2]) _.ops.pop();
                _.trys.pop();
                continue;
            }
            op = body.call(thisArg, _);
          } catch (e) {
            op = [6, e];
            y = 0;
          } finally {
            f = t = 0;
          }
        if (op[0] & 5) throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
      }
    }

    function __values(o) {
      var s = typeof Symbol === "function" && Symbol.iterator,
        m = s && o[s],
        i = 0;
      if (m) return m.call(o);
      if (o && typeof o.length === "number")
        return {
          next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
          },
        };
      throw new TypeError(
        s ? "Object is not iterable." : "Symbol.iterator is not defined."
      );
    }

    function __read(o, n) {
      var m = typeof Symbol === "function" && o[Symbol.iterator];
      if (!m) return o;
      var i = m.call(o),
        r,
        ar = [],
        e;
      try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done)
          ar.push(r.value);
      } catch (error) {
        e = { error: error };
      } finally {
        try {
          if (r && !r.done && (m = i["return"])) m.call(i);
        } finally {
          if (e) throw e.error;
        }
      }
      return ar;
    }

    function __spreadArray(to, from, pack) {
      if (pack || arguments.length === 2)
        for (var i = 0, l = from.length, ar; i < l; i++) {
          if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
          }
        }
      return to.concat(ar || Array.prototype.slice.call(from));
    }

    function __await(v) {
      return this instanceof __await ? ((this.v = v), this) : new __await(v);
    }

    function __asyncGenerator(thisArg, _arguments, generator) {
      if (!Symbol.asyncIterator)
        throw new TypeError("Symbol.asyncIterator is not defined.");
      var g = generator.apply(thisArg, _arguments || []),
        i,
        q = [];
      return (
        (i = {}),
        verb("next"),
        verb("throw"),
        verb("return"),
        (i[Symbol.asyncIterator] = function () {
          return this;
        }),
        i
      );
      function verb(n) {
        if (g[n])
          i[n] = function (v) {
            return new Promise(function (a, b) {
              q.push([n, v, a, b]) > 1 || resume(n, v);
            });
          };
      }
      function resume(n, v) {
        try {
          step(g[n](v));
        } catch (e) {
          settle(q[0][3], e);
        }
      }
      function step(r) {
        r.value instanceof __await
          ? Promise.resolve(r.value.v).then(fulfill, reject)
          : settle(q[0][2], r);
      }
      function fulfill(value) {
        resume("next", value);
      }
      function reject(value) {
        resume("throw", value);
      }
      function settle(f, v) {
        if ((f(v), q.shift(), q.length)) resume(q[0][0], q[0][1]);
      }
    }

    function __asyncValues(o) {
      if (!Symbol.asyncIterator)
        throw new TypeError("Symbol.asyncIterator is not defined.");
      var m = o[Symbol.asyncIterator],
        i;
      return m
        ? m.call(o)
        : ((o =
            typeof __values === "function" ? __values(o) : o[Symbol.iterator]()),
          (i = {}),
          verb("next"),
          verb("throw"),
          verb("return"),
          (i[Symbol.asyncIterator] = function () {
            return this;
          }),
          i);
      function verb(n) {
        i[n] =
          o[n] &&
          function (v) {
            return new Promise(function (resolve, reject) {
              (v = o[n](v)), settle(resolve, reject, v.done, v.value);
            });
          };
      }
      function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function (v) {
          resolve({ value: v, done: d });
        }, reject);
      }
    }

    var commonjsGlobal =
      typeof globalThis !== "undefined"
        ? globalThis
        : typeof window !== "undefined"
        ? window
        : typeof global !== "undefined"
        ? global
        : typeof self !== "undefined"
        ? self
        : {};

    var jquery = { exports: {} };

    /*!
     * jQuery JavaScript Library v3.6.0
     * https://jquery.com/
     *
     * Includes Sizzle.js
     * https://sizzlejs.com/
     *
     * Copyright OpenJS Foundation and other contributors
     * Released under the MIT license
     * https://jquery.org/license
     *
     * Date: 2021-03-02T17:08Z
     */

    (function (module) {
      (function (global, factory) {
        {
          // For CommonJS and CommonJS-like environments where a proper `window`
          // is present, execute the factory and get jQuery.
          // For environments that do not have a `window` with a `document`
          // (such as Node.js), expose a factory as module.exports.
          // This accentuates the need for the creation of a real `window`.
          // e.g. var jQuery = require("jquery")(window);
          // See ticket #14549 for more info.
          module.exports = global.document
            ? factory(global, true)
            : function (w) {
                if (!w.document) {
                  throw new Error("jQuery requires a window with a document");
                }
                return factory(w);
              };
        }

        // Pass this if window is not defined yet
      })(
        typeof window !== "undefined" ? window : commonjsGlobal,
        function (window, noGlobal) {
          var arr = [];

          var getProto = Object.getPrototypeOf;

          var slice = arr.slice;

          var flat = arr.flat
            ? function (array) {
                return arr.flat.call(array);
              }
            : function (array) {
                return arr.concat.apply([], array);
              };

          var push = arr.push;

          var indexOf = arr.indexOf;

          var class2type = {};

          var toString = class2type.toString;

          var hasOwn = class2type.hasOwnProperty;

          var fnToString = hasOwn.toString;

          var ObjectFunctionString = fnToString.call(Object);

          var support = {};

          var isFunction = function isFunction(obj) {
            // Support: Chrome <=57, Firefox <=52
            // In some browsers, typeof returns "function" for HTML <object> elements
            // (i.e., `typeof document.createElement( "object" ) === "function"`).
            // We don't want to classify *any* DOM node as a function.
            // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
            // Plus for old WebKit, typeof returns "function" for HTML collections
            // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
            return (
              typeof obj === "function" &&
              typeof obj.nodeType !== "number" &&
              typeof obj.item !== "function"
            );
          };

          var isWindow = function isWindow(obj) {
            return obj != null && obj === obj.window;
          };

          var document = window.document;

          var preservedScriptAttributes = {
            type: true,
            src: true,
            nonce: true,
            noModule: true,
          };

          function DOMEval(code, node, doc) {
            doc = doc || document;

            var i,
              val,
              script = doc.createElement("script");

            script.text = code;
            if (node) {
              for (i in preservedScriptAttributes) {
                // Support: Firefox 64+, Edge 18+
                // Some browsers don't support the "nonce" property on scripts.
                // On the other hand, just using `getAttribute` is not enough as
                // the `nonce` attribute is reset to an empty string whenever it
                // becomes browsing-context connected.
                // See https://github.com/whatwg/html/issues/2369
                // See https://html.spec.whatwg.org/#nonce-attributes
                // The `node.getAttribute` check was added for the sake of
                // `jQuery.globalEval` so that it can fake a nonce-containing node
                // via an object.
                val = node[i] || (node.getAttribute && node.getAttribute(i));
                if (val) {
                  script.setAttribute(i, val);
                }
              }
            }
            doc.head.appendChild(script).parentNode.removeChild(script);
          }

          function toType(obj) {
            if (obj == null) {
              return obj + "";
            }

            // Support: Android <=2.3 only (functionish RegExp)
            return typeof obj === "object" || typeof obj === "function"
              ? class2type[toString.call(obj)] || "object"
              : typeof obj;
          }
          /* global Symbol */
          // Defining this global in .eslintrc.json would create a danger of using the global
          // unguarded in another place, it seems safer to define global only for this module

          var version = "3.6.0",
            // Define a local copy of jQuery
            jQuery = function (selector, context) {
              // The jQuery object is actually just the init constructor 'enhanced'
              // Need init if jQuery is called (just allow error to be thrown if not included)
              return new jQuery.fn.init(selector, context);
            };

          jQuery.fn = jQuery.prototype = {
            // The current version of jQuery being used
            jquery: version,

            constructor: jQuery,

            // The default length of a jQuery object is 0
            length: 0,

            toArray: function () {
              return slice.call(this);
            },

            // Get the Nth element in the matched element set OR
            // Get the whole matched element set as a clean array
            get: function (num) {
              // Return all the elements in a clean array
              if (num == null) {
                return slice.call(this);
              }

              // Return just the one element from the set
              return num < 0 ? this[num + this.length] : this[num];
            },

            // Take an array of elements and push it onto the stack
            // (returning the new matched element set)
            pushStack: function (elems) {
              // Build a new jQuery matched element set
              var ret = jQuery.merge(this.constructor(), elems);

              // Add the old object onto the stack (as a reference)
              ret.prevObject = this;

              // Return the newly-formed element set
              return ret;
            },

            // Execute a callback for every element in the matched set.
            each: function (callback) {
              return jQuery.each(this, callback);
            },

            map: function (callback) {
              return this.pushStack(
                jQuery.map(this, function (elem, i) {
                  return callback.call(elem, i, elem);
                })
              );
            },

            slice: function () {
              return this.pushStack(slice.apply(this, arguments));
            },

            first: function () {
              return this.eq(0);
            },

            last: function () {
              return this.eq(-1);
            },

            even: function () {
              return this.pushStack(
                jQuery.grep(this, function (_elem, i) {
                  return (i + 1) % 2;
                })
              );
            },

            odd: function () {
              return this.pushStack(
                jQuery.grep(this, function (_elem, i) {
                  return i % 2;
                })
              );
            },

            eq: function (i) {
              var len = this.length,
                j = +i + (i < 0 ? len : 0);
              return this.pushStack(j >= 0 && j < len ? [this[j]] : []);
            },

            end: function () {
              return this.prevObject || this.constructor();
            },

            // For internal use only.
            // Behaves like an Array's method, not like a jQuery method.
            push: push,
            sort: arr.sort,
            splice: arr.splice,
          };

          jQuery.extend = jQuery.fn.extend = function () {
            var options,
              name,
              src,
              copy,
              copyIsArray,
              clone,
              target = arguments[0] || {},
              i = 1,
              length = arguments.length,
              deep = false;

            // Handle a deep copy situation
            if (typeof target === "boolean") {
              deep = target;

              // Skip the boolean and the target
              target = arguments[i] || {};
              i++;
            }

            // Handle case when target is a string or something (possible in deep copy)
            if (typeof target !== "object" && !isFunction(target)) {
              target = {};
            }

            // Extend jQuery itself if only one argument is passed
            if (i === length) {
              target = this;
              i--;
            }

            for (; i < length; i++) {
              // Only deal with non-null/undefined values
              if ((options = arguments[i]) != null) {
                // Extend the base object
                for (name in options) {
                  copy = options[name];

                  // Prevent Object.prototype pollution
                  // Prevent never-ending loop
                  if (name === "__proto__" || target === copy) {
                    continue;
                  }

                  // Recurse if we're merging plain objects or arrays
                  if (
                    deep &&
                    copy &&
                    (jQuery.isPlainObject(copy) ||
                      (copyIsArray = Array.isArray(copy)))
                  ) {
                    src = target[name];

                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) {
                      clone = [];
                    } else if (!copyIsArray && !jQuery.isPlainObject(src)) {
                      clone = {};
                    } else {
                      clone = src;
                    }
                    copyIsArray = false;

                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);

                    // Don't bring in undefined values
                  } else if (copy !== undefined) {
                    target[name] = copy;
                  }
                }
              }
            }

            // Return the modified object
            return target;
          };

          jQuery.extend({
            // Unique for each copy of jQuery on the page
            expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),

            // Assume jQuery is ready without the ready module
            isReady: true,

            error: function (msg) {
              throw new Error(msg);
            },

            noop: function () {},

            isPlainObject: function (obj) {
              var proto, Ctor;

              // Detect obvious negatives
              // Use toString instead of jQuery.type to catch host objects
              if (!obj || toString.call(obj) !== "[object Object]") {
                return false;
              }

              proto = getProto(obj);

              // Objects with no prototype (e.g., `Object.create( null )`) are plain
              if (!proto) {
                return true;
              }

              // Objects with prototype are plain iff they were constructed by a global Object function
              Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
              return (
                typeof Ctor === "function" &&
                fnToString.call(Ctor) === ObjectFunctionString
              );
            },

            isEmptyObject: function (obj) {
              var name;

              for (name in obj) {
                return false;
              }
              return true;
            },

            // Evaluates a script in a provided context; falls back to the global one
            // if not specified.
            globalEval: function (code, options, doc) {
              DOMEval(code, { nonce: options && options.nonce }, doc);
            },

            each: function (obj, callback) {
              var length,
                i = 0;

              if (isArrayLike(obj)) {
                length = obj.length;
                for (; i < length; i++) {
                  if (callback.call(obj[i], i, obj[i]) === false) {
                    break;
                  }
                }
              } else {
                for (i in obj) {
                  if (callback.call(obj[i], i, obj[i]) === false) {
                    break;
                  }
                }
              }

              return obj;
            },

            // results is for internal usage only
            makeArray: function (arr, results) {
              var ret = results || [];

              if (arr != null) {
                if (isArrayLike(Object(arr))) {
                  jQuery.merge(ret, typeof arr === "string" ? [arr] : arr);
                } else {
                  push.call(ret, arr);
                }
              }

              return ret;
            },

            inArray: function (elem, arr, i) {
              return arr == null ? -1 : indexOf.call(arr, elem, i);
            },

            // Support: Android <=4.0 only, PhantomJS 1 only
            // push.apply(_, arraylike) throws on ancient WebKit
            merge: function (first, second) {
              var len = +second.length,
                j = 0,
                i = first.length;

              for (; j < len; j++) {
                first[i++] = second[j];
              }

              first.length = i;

              return first;
            },

            grep: function (elems, callback, invert) {
              var callbackInverse,
                matches = [],
                i = 0,
                length = elems.length,
                callbackExpect = !invert;

              // Go through the array, only saving the items
              // that pass the validator function
              for (; i < length; i++) {
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) {
                  matches.push(elems[i]);
                }
              }

              return matches;
            },

            // arg is for internal usage only
            map: function (elems, callback, arg) {
              var length,
                value,
                i = 0,
                ret = [];

              // Go through the array, translating each of the items to their new values
              if (isArrayLike(elems)) {
                length = elems.length;
                for (; i < length; i++) {
                  value = callback(elems[i], i, arg);

                  if (value != null) {
                    ret.push(value);
                  }
                }

                // Go through every key on the object,
              } else {
                for (i in elems) {
                  value = callback(elems[i], i, arg);

                  if (value != null) {
                    ret.push(value);
                  }
                }
              }

              // Flatten any nested arrays
              return flat(ret);
            },

            // A global GUID counter for objects
            guid: 1,

            // jQuery.support is not used in Core but other projects attach their
            // properties to it so it needs to exist.
            support: support,
          });

          if (typeof Symbol === "function") {
            jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
          }

          // Populate the class2type map
          jQuery.each(
            "Boolean Number String Function Array Date RegExp Object Error Symbol".split(
              " "
            ),
            function (_i, name) {
              class2type["[object " + name + "]"] = name.toLowerCase();
            }
          );

          function isArrayLike(obj) {
            // Support: real iOS 8.2 only (not reproducible in simulator)
            // `in` check used to prevent JIT error (gh-2145)
            // hasOwn isn't used here due to false negatives
            // regarding Nodelist length in IE
            var length = !!obj && "length" in obj && obj.length,
              type = toType(obj);

            if (isFunction(obj) || isWindow(obj)) {
              return false;
            }

            return (
              type === "array" ||
              length === 0 ||
              (typeof length === "number" && length > 0 && length - 1 in obj)
            );
          }
          var Sizzle =
            /*!
             * Sizzle CSS Selector Engine v2.3.6
             * https://sizzlejs.com/
             *
             * Copyright JS Foundation and other contributors
             * Released under the MIT license
             * https://js.foundation/
             *
             * Date: 2021-02-16
             */
            (function (window) {
              var i,
                support,
                Expr,
                getText,
                isXML,
                tokenize,
                compile,
                select,
                outermostContext,
                sortInput,
                hasDuplicate,
                // Local document vars
                setDocument,
                document,
                docElem,
                documentIsHTML,
                rbuggyQSA,
                rbuggyMatches,
                matches,
                contains,
                // Instance-specific data
                expando = "sizzle" + 1 * new Date(),
                preferredDoc = window.document,
                dirruns = 0,
                done = 0,
                classCache = createCache(),
                tokenCache = createCache(),
                compilerCache = createCache(),
                nonnativeSelectorCache = createCache(),
                sortOrder = function (a, b) {
                  if (a === b) {
                    hasDuplicate = true;
                  }
                  return 0;
                },
                // Instance methods
                hasOwn = {}.hasOwnProperty,
                arr = [],
                pop = arr.pop,
                pushNative = arr.push,
                push = arr.push,
                slice = arr.slice,
                // Use a stripped-down indexOf as it's faster than native
                // https://jsperf.com/thor-indexof-vs-for/5
                indexOf = function (list, elem) {
                  var i = 0,
                    len = list.length;
                  for (; i < len; i++) {
                    if (list[i] === elem) {
                      return i;
                    }
                  }
                  return -1;
                },
                booleans =
                  "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
                  "ismap|loop|multiple|open|readonly|required|scoped",
                // Regular expressions

                // http://www.w3.org/TR/css3-selectors/#whitespace
                whitespace = "[\\x20\\t\\r\\n\\f]",
                // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
                identifier =
                  "(?:\\\\[\\da-fA-F]{1,6}" +
                  whitespace +
                  "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
                // Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
                attributes =
                  "\\[" +
                  whitespace +
                  "*(" +
                  identifier +
                  ")(?:" +
                  whitespace +
                  // Operator (capture 2)
                  "*([*^$|!~]?=)" +
                  whitespace +
                  // "Attribute values must be CSS identifiers [capture 5]
                  // or strings [capture 3 or capture 4]"
                  "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" +
                  identifier +
                  "))|)" +
                  whitespace +
                  "*\\]",
                pseudos =
                  ":(" +
                  identifier +
                  ")(?:\\((" +
                  // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
                  // 1. quoted (capture 3; capture 4 or capture 5)
                  "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
                  // 2. simple (capture 6)
                  "((?:\\\\.|[^\\\\()[\\]]|" +
                  attributes +
                  ")*)|" +
                  // 3. anything else (capture 2)
                  ".*" +
                  ")\\)|)",
                // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
                rwhitespace = new RegExp(whitespace + "+", "g"),
                rtrim = new RegExp(
                  "^" +
                    whitespace +
                    "+|((?:^|[^\\\\])(?:\\\\.)*)" +
                    whitespace +
                    "+$",
                  "g"
                ),
                rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"),
                rcombinators = new RegExp(
                  "^" +
                    whitespace +
                    "*([>+~]|" +
                    whitespace +
                    ")" +
                    whitespace +
                    "*"
                ),
                rdescend = new RegExp(whitespace + "|>"),
                rpseudo = new RegExp(pseudos),
                ridentifier = new RegExp("^" + identifier + "$"),
                matchExpr = {
                  ID: new RegExp("^#(" + identifier + ")"),
                  CLASS: new RegExp("^\\.(" + identifier + ")"),
                  TAG: new RegExp("^(" + identifier + "|[*])"),
                  ATTR: new RegExp("^" + attributes),
                  PSEUDO: new RegExp("^" + pseudos),
                  CHILD: new RegExp(
                    "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
                      whitespace +
                      "*(even|odd|(([+-]|)(\\d*)n|)" +
                      whitespace +
                      "*(?:([+-]|)" +
                      whitespace +
                      "*(\\d+)|))" +
                      whitespace +
                      "*\\)|)",
                    "i"
                  ),
                  bool: new RegExp("^(?:" + booleans + ")$", "i"),

                  // For use in libraries implementing .is()
                  // We use this for POS matching in `select`
                  needsContext: new RegExp(
                    "^" +
                      whitespace +
                      "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
                      whitespace +
                      "*((?:-\\d)?\\d*)" +
                      whitespace +
                      "*\\)|)(?=[^-]|$)",
                    "i"
                  ),
                },
                rhtml = /HTML$/i,
                rinputs = /^(?:input|select|textarea|button)$/i,
                rheader = /^h\d$/i,
                rnative = /^[^{]+\{\s*\[native \w/,
                // Easily-parseable/retrievable ID or TAG or CLASS selectors
                rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
                rsibling = /[+~]/,
                // CSS escapes
                // http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
                runescape = new RegExp(
                  "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])",
                  "g"
                ),
                funescape = function (escape, nonHex) {
                  var high = "0x" + escape.slice(1) - 0x10000;

                  return nonHex
                    ? // Strip the backslash prefix from a non-hex escape sequence
                      nonHex
                    : // Replace a hexadecimal escape sequence with the encoded Unicode code point
                    // Support: IE <=11+
                    // For values outside the Basic Multilingual Plane (BMP), manually construct a
                    // surrogate pair
                    high < 0
                    ? String.fromCharCode(high + 0x10000)
                    : String.fromCharCode(
                        (high >> 10) | 0xd800,
                        (high & 0x3ff) | 0xdc00
                      );
                },
                // CSS string/identifier serialization
                // https://drafts.csswg.org/cssom/#common-serializing-idioms
                rcssescape =
                  /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
                fcssescape = function (ch, asCodePoint) {
                  if (asCodePoint) {
                    // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
                    if (ch === "\0") {
                      return "\uFFFD";
                    }

                    // Control characters and (dependent upon position) numbers get escaped as code points
                    return (
                      ch.slice(0, -1) +
                      "\\" +
                      ch.charCodeAt(ch.length - 1).toString(16) +
                      " "
                    );
                  }

                  // Other potentially-special ASCII characters get backslash-escaped
                  return "\\" + ch;
                },
                // Used for iframes
                // See setDocument()
                // Removing the function wrapper causes a "Permission Denied"
                // error in IE
                unloadHandler = function () {
                  setDocument();
                },
                inDisabledFieldset = addCombinator(
                  function (elem) {
                    return (
                      elem.disabled === true &&
                      elem.nodeName.toLowerCase() === "fieldset"
                    );
                  },
                  { dir: "parentNode", next: "legend" }
                );

              // Optimize for push.apply( _, NodeList )
              try {
                push.apply(
                  (arr = slice.call(preferredDoc.childNodes)),
                  preferredDoc.childNodes
                );

                // Support: Android<4.0
                // Detect silently failing push.apply
                // eslint-disable-next-line no-unused-expressions
                arr[preferredDoc.childNodes.length].nodeType;
              } catch (e) {
                push = {
                  apply: arr.length
                    ? // Leverage slice if possible
                      function (target, els) {
                        pushNative.apply(target, slice.call(els));
                      }
                    : // Support: IE<9
                      // Otherwise append directly
                      function (target, els) {
                        var j = target.length,
                          i = 0;

                        // Can't trust NodeList.length
                        while ((target[j++] = els[i++])) {}
                        target.length = j - 1;
                      },
                };
              }

              function Sizzle(selector, context, results, seed) {
                var m,
                  i,
                  elem,
                  nid,
                  match,
                  groups,
                  newSelector,
                  newContext = context && context.ownerDocument,
                  // nodeType defaults to 9, since context defaults to document
                  nodeType = context ? context.nodeType : 9;

                results = results || [];

                // Return early from calls with invalid selector or context
                if (
                  typeof selector !== "string" ||
                  !selector ||
                  (nodeType !== 1 && nodeType !== 9 && nodeType !== 11)
                ) {
                  return results;
                }

                // Try to shortcut find operations (as opposed to filters) in HTML documents
                if (!seed) {
                  setDocument(context);
                  context = context || document;

                  if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                      // ID selector
                      if ((m = match[1])) {
                        // Document context
                        if (nodeType === 9) {
                          if ((elem = context.getElementById(m))) {
                            // Support: IE, Opera, Webkit
                            // TODO: identify versions
                            // getElementById can match elements by name instead of ID
                            if (elem.id === m) {
                              results.push(elem);
                              return results;
                            }
                          } else {
                            return results;
                          }

                          // Element context
                        } else {
                          // Support: IE, Opera, Webkit
                          // TODO: identify versions
                          // getElementById can match elements by name instead of ID
                          if (
                            newContext &&
                            (elem = newContext.getElementById(m)) &&
                            contains(context, elem) &&
                            elem.id === m
                          ) {
                            results.push(elem);
                            return results;
                          }
                        }

                        // Type selector
                      } else if (match[2]) {
                        push.apply(
                          results,
                          context.getElementsByTagName(selector)
                        );
                        return results;

                        // Class selector
                      } else if (
                        (m = match[3]) &&
                        support.getElementsByClassName &&
                        context.getElementsByClassName
                      ) {
                        push.apply(results, context.getElementsByClassName(m));
                        return results;
                      }
                    }

                    // Take advantage of querySelectorAll
                    if (
                      support.qsa &&
                      !nonnativeSelectorCache[selector + " "] &&
                      (!rbuggyQSA || !rbuggyQSA.test(selector)) &&
                      // Support: IE 8 only
                      // Exclude object elements
                      (nodeType !== 1 ||
                        context.nodeName.toLowerCase() !== "object")
                    ) {
                      newSelector = selector;
                      newContext = context;

                      // qSA considers elements outside a scoping root when evaluating child or
                      // descendant combinators, which is not what we want.
                      // In such cases, we work around the behavior by prefixing every selector in the
                      // list with an ID selector referencing the scope context.
                      // The technique has to be used as well when a leading combinator is used
                      // as such selectors are not recognized by querySelectorAll.
                      // Thanks to Andrew Dupont for this technique.
                      if (
                        nodeType === 1 &&
                        (rdescend.test(selector) || rcombinators.test(selector))
                      ) {
                        // Expand context for sibling selectors
                        newContext =
                          (rsibling.test(selector) &&
                            testContext(context.parentNode)) ||
                          context;

                        // We can use :scope instead of the ID hack if the browser
                        // supports it & if we're not changing the context.
                        if (newContext !== context || !support.scope) {
                          // Capture the context ID, setting it first if necessary
                          if ((nid = context.getAttribute("id"))) {
                            nid = nid.replace(rcssescape, fcssescape);
                          } else {
                            context.setAttribute("id", (nid = expando));
                          }
                        }

                        // Prefix every selector in the list
                        groups = tokenize(selector);
                        i = groups.length;
                        while (i--) {
                          groups[i] =
                            (nid ? "#" + nid : ":scope") +
                            " " +
                            toSelector(groups[i]);
                        }
                        newSelector = groups.join(",");
                      }

                      try {
                        push.apply(
                          results,
                          newContext.querySelectorAll(newSelector)
                        );
                        return results;
                      } catch (qsaError) {
                        nonnativeSelectorCache(selector, true);
                      } finally {
                        if (nid === expando) {
                          context.removeAttribute("id");
                        }
                      }
                    }
                  }
                }

                // All others
                return select(
                  selector.replace(rtrim, "$1"),
                  context,
                  results,
                  seed
                );
              }

              /**
               * Create key-value caches of limited size
               * @returns {function(string, object)} Returns the Object data after storing it on itself with
               *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
               *	deleting the oldest entry
               */
              function createCache() {
                var keys = [];

                function cache(key, value) {
                  // Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
                  if (keys.push(key + " ") > Expr.cacheLength) {
                    // Only keep the most recent entries
                    delete cache[keys.shift()];
                  }
                  return (cache[key + " "] = value);
                }
                return cache;
              }

              /**
               * Mark a function for special use by Sizzle
               * @param {Function} fn The function to mark
               */
              function markFunction(fn) {
                fn[expando] = true;
                return fn;
              }

              /**
               * Support testing using an element
               * @param {Function} fn Passed the created element and returns a boolean result
               */
              function assert(fn) {
                var el = document.createElement("fieldset");

                try {
                  return !!fn(el);
                } catch (e) {
                  return false;
                } finally {
                  // Remove from its parent by default
                  if (el.parentNode) {
                    el.parentNode.removeChild(el);
                  }

                  // release memory in IE
                  el = null;
                }
              }

              /**
               * Adds the same handler for all of the specified attrs
               * @param {String} attrs Pipe-separated list of attributes
               * @param {Function} handler The method that will be applied
               */
              function addHandle(attrs, handler) {
                var arr = attrs.split("|"),
                  i = arr.length;

                while (i--) {
                  Expr.attrHandle[arr[i]] = handler;
                }
              }

              /**
               * Checks document order of two siblings
               * @param {Element} a
               * @param {Element} b
               * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
               */
              function siblingCheck(a, b) {
                var cur = b && a,
                  diff =
                    cur &&
                    a.nodeType === 1 &&
                    b.nodeType === 1 &&
                    a.sourceIndex - b.sourceIndex;

                // Use IE sourceIndex if available on both nodes
                if (diff) {
                  return diff;
                }

                // Check if b follows a
                if (cur) {
                  while ((cur = cur.nextSibling)) {
                    if (cur === b) {
                      return -1;
                    }
                  }
                }

                return a ? 1 : -1;
              }

              /**
               * Returns a function to use in pseudos for input types
               * @param {String} type
               */
              function createInputPseudo(type) {
                return function (elem) {
                  var name = elem.nodeName.toLowerCase();
                  return name === "input" && elem.type === type;
                };
              }

              /**
               * Returns a function to use in pseudos for buttons
               * @param {String} type
               */
              function createButtonPseudo(type) {
                return function (elem) {
                  var name = elem.nodeName.toLowerCase();
                  return (
                    (name === "input" || name === "button") && elem.type === type
                  );
                };
              }

              /**
               * Returns a function to use in pseudos for :enabled/:disabled
               * @param {Boolean} disabled true for :disabled; false for :enabled
               */
              function createDisabledPseudo(disabled) {
                // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
                return function (elem) {
                  // Only certain elements can match :enabled or :disabled
                  // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                  // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                  if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                      // Option elements defer to a parent optgroup if present
                      if ("label" in elem) {
                        if ("label" in elem.parentNode) {
                          return elem.parentNode.disabled === disabled;
                        } else {
                          return elem.disabled === disabled;
                        }
                      }

                      // Support: IE 6 - 11
                      // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                      return (
                        elem.isDisabled === disabled ||
                        // Where there is no isDisabled, check manually
                        /* jshint -W018 */
                        (elem.isDisabled !== !disabled &&
                          inDisabledFieldset(elem) === disabled)
                      );
                    }

                    return elem.disabled === disabled;

                    // Try to winnow out elements that can't be disabled before trusting the disabled property.
                    // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                    // even exist on them, let alone have a boolean value.
                  } else if ("label" in elem) {
                    return elem.disabled === disabled;
                  }

                  // Remaining elements are neither :enabled nor :disabled
                  return false;
                };
              }

              /**
               * Returns a function to use in pseudos for positionals
               * @param {Function} fn
               */
              function createPositionalPseudo(fn) {
                return markFunction(function (argument) {
                  argument = +argument;
                  return markFunction(function (seed, matches) {
                    var j,
                      matchIndexes = fn([], seed.length, argument),
                      i = matchIndexes.length;

                    // Match elements found at the specified indexes
                    while (i--) {
                      if (seed[(j = matchIndexes[i])]) {
                        seed[j] = !(matches[j] = seed[j]);
                      }
                    }
                  });
                });
              }

              /**
               * Checks a node for validity as a Sizzle context
               * @param {Element|Object=} context
               * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
               */
              function testContext(context) {
                return (
                  context &&
                  typeof context.getElementsByTagName !== "undefined" &&
                  context
                );
              }

              // Expose support vars for convenience
              support = Sizzle.support = {};

              /**
               * Detects XML nodes
               * @param {Element|Object} elem An element or a document
               * @returns {Boolean} True iff elem is a non-HTML XML node
               */
              isXML = Sizzle.isXML = function (elem) {
                var namespace = elem && elem.namespaceURI,
                  docElem = elem && (elem.ownerDocument || elem).documentElement;

                // Support: IE <=8
                // Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
                // https://bugs.jquery.com/ticket/4833
                return !rhtml.test(
                  namespace || (docElem && docElem.nodeName) || "HTML"
                );
              };

              /**
               * Sets document-related variables once based on the current document
               * @param {Element|Object} [doc] An element or document object to use to set the document
               * @returns {Object} Returns the current document
               */
              setDocument = Sizzle.setDocument = function (node) {
                var hasCompare,
                  subWindow,
                  doc = node ? node.ownerDocument || node : preferredDoc;

                // Return early if doc is invalid or already selected
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                if (
                  doc == document ||
                  doc.nodeType !== 9 ||
                  !doc.documentElement
                ) {
                  return document;
                }

                // Update global variables
                document = doc;
                docElem = document.documentElement;
                documentIsHTML = !isXML(document);

                // Support: IE 9 - 11+, Edge 12 - 18+
                // Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                if (
                  preferredDoc != document &&
                  (subWindow = document.defaultView) &&
                  subWindow.top !== subWindow
                ) {
                  // Support: IE 11, Edge
                  if (subWindow.addEventListener) {
                    subWindow.addEventListener("unload", unloadHandler, false);

                    // Support: IE 9 - 10 only
                  } else if (subWindow.attachEvent) {
                    subWindow.attachEvent("onunload", unloadHandler);
                  }
                }

                // Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
                // Safari 4 - 5 only, Opera <=11.6 - 12.x only
                // IE/Edge & older browsers don't support the :scope pseudo-class.
                // Support: Safari 6.0 only
                // Safari 6.0 supports :scope but it's an alias of :root there.
                support.scope = assert(function (el) {
                  docElem
                    .appendChild(el)
                    .appendChild(document.createElement("div"));
                  return (
                    typeof el.querySelectorAll !== "undefined" &&
                    !el.querySelectorAll(":scope fieldset div").length
                  );
                });

                /* Attributes
          ---------------------------------------------------------------------- */

                // Support: IE<8
                // Verify that getAttribute really returns attributes and not properties
                // (excepting IE8 booleans)
                support.attributes = assert(function (el) {
                  el.className = "i";
                  return !el.getAttribute("className");
                });

                /* getElement(s)By*
          ---------------------------------------------------------------------- */

                // Check if getElementsByTagName("*") returns only elements
                support.getElementsByTagName = assert(function (el) {
                  el.appendChild(document.createComment(""));
                  return !el.getElementsByTagName("*").length;
                });

                // Support: IE<9
                support.getElementsByClassName = rnative.test(
                  document.getElementsByClassName
                );

                // Support: IE<10
                // Check if getElementById returns elements by name
                // The broken getElementById methods don't pick up programmatically-set names,
                // so use a roundabout getElementsByName test
                support.getById = assert(function (el) {
                  docElem.appendChild(el).id = expando;
                  return (
                    !document.getElementsByName ||
                    !document.getElementsByName(expando).length
                  );
                });

                // ID filter and find
                if (support.getById) {
                  Expr.filter["ID"] = function (id) {
                    var attrId = id.replace(runescape, funescape);
                    return function (elem) {
                      return elem.getAttribute("id") === attrId;
                    };
                  };
                  Expr.find["ID"] = function (id, context) {
                    if (
                      typeof context.getElementById !== "undefined" &&
                      documentIsHTML
                    ) {
                      var elem = context.getElementById(id);
                      return elem ? [elem] : [];
                    }
                  };
                } else {
                  Expr.filter["ID"] = function (id) {
                    var attrId = id.replace(runescape, funescape);
                    return function (elem) {
                      var node =
                        typeof elem.getAttributeNode !== "undefined" &&
                        elem.getAttributeNode("id");
                      return node && node.value === attrId;
                    };
                  };

                  // Support: IE 6 - 7 only
                  // getElementById is not reliable as a find shortcut
                  Expr.find["ID"] = function (id, context) {
                    if (
                      typeof context.getElementById !== "undefined" &&
                      documentIsHTML
                    ) {
                      var node,
                        i,
                        elems,
                        elem = context.getElementById(id);

                      if (elem) {
                        // Verify the id attribute
                        node = elem.getAttributeNode("id");
                        if (node && node.value === id) {
                          return [elem];
                        }

                        // Fall back on getElementsByName
                        elems = context.getElementsByName(id);
                        i = 0;
                        while ((elem = elems[i++])) {
                          node = elem.getAttributeNode("id");
                          if (node && node.value === id) {
                            return [elem];
                          }
                        }
                      }

                      return [];
                    }
                  };
                }

                // Tag
                Expr.find["TAG"] = support.getElementsByTagName
                  ? function (tag, context) {
                      if (typeof context.getElementsByTagName !== "undefined") {
                        return context.getElementsByTagName(tag);

                        // DocumentFragment nodes don't have gEBTN
                      } else if (support.qsa) {
                        return context.querySelectorAll(tag);
                      }
                    }
                  : function (tag, context) {
                      var elem,
                        tmp = [],
                        i = 0,
                        // By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
                        results = context.getElementsByTagName(tag);

                      // Filter out possible comments
                      if (tag === "*") {
                        while ((elem = results[i++])) {
                          if (elem.nodeType === 1) {
                            tmp.push(elem);
                          }
                        }

                        return tmp;
                      }
                      return results;
                    };

                // Class
                Expr.find["CLASS"] =
                  support.getElementsByClassName &&
                  function (className, context) {
                    if (
                      typeof context.getElementsByClassName !== "undefined" &&
                      documentIsHTML
                    ) {
                      return context.getElementsByClassName(className);
                    }
                  };

                /* QSA/matchesSelector
          ---------------------------------------------------------------------- */

                // QSA and matchesSelector support

                // matchesSelector(:active) reports false when true (IE9/Opera 11.5)
                rbuggyMatches = [];

                // qSa(:focus) reports false when true (Chrome 21)
                // We allow this because of a bug in IE8/9 that throws an error
                // whenever `document.activeElement` is accessed on an iframe
                // So, we allow :focus to pass through QSA all the time to avoid the IE error
                // See https://bugs.jquery.com/ticket/13378
                rbuggyQSA = [];

                if ((support.qsa = rnative.test(document.querySelectorAll))) {
                  // Build QSA regex
                  // Regex strategy adopted from Diego Perini
                  assert(function (el) {
                    var input;

                    // Select is set to empty string on purpose
                    // This is to test IE's treatment of not explicitly
                    // setting a boolean content attribute,
                    // since its presence should be enough
                    // https://bugs.jquery.com/ticket/12359
                    docElem.appendChild(el).innerHTML =
                      "<a id='" +
                      expando +
                      "'></a>" +
                      "<select id='" +
                      expando +
                      "-\r\\' msallowcapture=''>" +
                      "<option selected=''></option></select>";

                    // Support: IE8, Opera 11-12.16
                    // Nothing should be selected when empty strings follow ^= or $= or *=
                    // The test attribute must be unknown in Opera but "safe" for WinRT
                    // https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
                    if (el.querySelectorAll("[msallowcapture^='']").length) {
                      rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")");
                    }

                    // Support: IE8
                    // Boolean attributes and "value" are not treated correctly
                    if (!el.querySelectorAll("[selected]").length) {
                      rbuggyQSA.push(
                        "\\[" + whitespace + "*(?:value|" + booleans + ")"
                      );
                    }

                    // Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
                    if (!el.querySelectorAll("[id~=" + expando + "-]").length) {
                      rbuggyQSA.push("~=");
                    }

                    // Support: IE 11+, Edge 15 - 18+
                    // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                    // Adding a temporary attribute to the document before the selection works
                    // around the issue.
                    // Interestingly, IE 10 & older don't seem to have the issue.
                    input = document.createElement("input");
                    input.setAttribute("name", "");
                    el.appendChild(input);
                    if (!el.querySelectorAll("[name='']").length) {
                      rbuggyQSA.push(
                        "\\[" +
                          whitespace +
                          "*name" +
                          whitespace +
                          "*=" +
                          whitespace +
                          "*(?:''|\"\")"
                      );
                    }

                    // Webkit/Opera - :checked should return selected option elements
                    // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    // IE8 throws error here and will not see later tests
                    if (!el.querySelectorAll(":checked").length) {
                      rbuggyQSA.push(":checked");
                    }

                    // Support: Safari 8+, iOS 8+
                    // https://bugs.webkit.org/show_bug.cgi?id=136851
                    // In-page `selector#id sibling-combinator selector` fails
                    if (!el.querySelectorAll("a#" + expando + "+*").length) {
                      rbuggyQSA.push(".#.+[+~]");
                    }

                    // Support: Firefox <=3.6 - 5 only
                    // Old Firefox doesn't throw on a badly-escaped identifier.
                    el.querySelectorAll("\\\f");
                    rbuggyQSA.push("[\\r\\n\\f]");
                  });

                  assert(function (el) {
                    el.innerHTML =
                      "<a href='' disabled='disabled'></a>" +
                      "<select disabled='disabled'><option/></select>";

                    // Support: Windows 8 Native Apps
                    // The type and name attributes are restricted during .innerHTML assignment
                    var input = document.createElement("input");
                    input.setAttribute("type", "hidden");
                    el.appendChild(input).setAttribute("name", "D");

                    // Support: IE8
                    // Enforce case-sensitivity of name attribute
                    if (el.querySelectorAll("[name=d]").length) {
                      rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?=");
                    }

                    // FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
                    // IE8 throws error here and will not see later tests
                    if (el.querySelectorAll(":enabled").length !== 2) {
                      rbuggyQSA.push(":enabled", ":disabled");
                    }

                    // Support: IE9-11+
                    // IE's :disabled selector does not pick up the children of disabled fieldsets
                    docElem.appendChild(el).disabled = true;
                    if (el.querySelectorAll(":disabled").length !== 2) {
                      rbuggyQSA.push(":enabled", ":disabled");
                    }

                    // Support: Opera 10 - 11 only
                    // Opera 10-11 does not throw on post-comma invalid pseudos
                    el.querySelectorAll("*,:x");
                    rbuggyQSA.push(",.*:");
                  });
                }

                if (
                  (support.matchesSelector = rnative.test(
                    (matches =
                      docElem.matches ||
                      docElem.webkitMatchesSelector ||
                      docElem.mozMatchesSelector ||
                      docElem.oMatchesSelector ||
                      docElem.msMatchesSelector)
                  ))
                ) {
                  assert(function (el) {
                    // Check to see if it's possible to do matchesSelector
                    // on a disconnected node (IE 9)
                    support.disconnectedMatch = matches.call(el, "*");

                    // This should fail with an exception
                    // Gecko does not error, returns false instead
                    matches.call(el, "[s!='']:x");
                    rbuggyMatches.push("!=", pseudos);
                  });
                }

                rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
                rbuggyMatches =
                  rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"));

                /* Contains
          ---------------------------------------------------------------------- */
                hasCompare = rnative.test(docElem.compareDocumentPosition);

                // Element contains another
                // Purposefully self-exclusive
                // As in, an element does not contain itself
                contains =
                  hasCompare || rnative.test(docElem.contains)
                    ? function (a, b) {
                        var adown = a.nodeType === 9 ? a.documentElement : a,
                          bup = b && b.parentNode;
                        return (
                          a === bup ||
                          !!(
                            bup &&
                            bup.nodeType === 1 &&
                            (adown.contains
                              ? adown.contains(bup)
                              : a.compareDocumentPosition &&
                                a.compareDocumentPosition(bup) & 16)
                          )
                        );
                      }
                    : function (a, b) {
                        if (b) {
                          while ((b = b.parentNode)) {
                            if (b === a) {
                              return true;
                            }
                          }
                        }
                        return false;
                      };

                /* Sorting
          ---------------------------------------------------------------------- */

                // Document order sorting
                sortOrder = hasCompare
                  ? function (a, b) {
                      // Flag for duplicate removal
                      if (a === b) {
                        hasDuplicate = true;
                        return 0;
                      }

                      // Sort on method existence if only one input has compareDocumentPosition
                      var compare =
                        !a.compareDocumentPosition - !b.compareDocumentPosition;
                      if (compare) {
                        return compare;
                      }

                      // Calculate position if both inputs belong to the same document
                      // Support: IE 11+, Edge 17 - 18+
                      // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                      // two documents; shallow comparisons work.
                      // eslint-disable-next-line eqeqeq
                      compare =
                        (a.ownerDocument || a) == (b.ownerDocument || b)
                          ? a.compareDocumentPosition(b)
                          : // Otherwise we know they are disconnected
                            1;

                      // Disconnected nodes
                      if (
                        compare & 1 ||
                        (!support.sortDetached &&
                          b.compareDocumentPosition(a) === compare)
                      ) {
                        // Choose the first element that is related to our preferred document
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (
                          a == document ||
                          (a.ownerDocument == preferredDoc &&
                            contains(preferredDoc, a))
                        ) {
                          return -1;
                        }

                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (
                          b == document ||
                          (b.ownerDocument == preferredDoc &&
                            contains(preferredDoc, b))
                        ) {
                          return 1;
                        }

                        // Maintain original order
                        return sortInput
                          ? indexOf(sortInput, a) - indexOf(sortInput, b)
                          : 0;
                      }

                      return compare & 4 ? -1 : 1;
                    }
                  : function (a, b) {
                      // Exit early if the nodes are identical
                      if (a === b) {
                        hasDuplicate = true;
                        return 0;
                      }

                      var cur,
                        i = 0,
                        aup = a.parentNode,
                        bup = b.parentNode,
                        ap = [a],
                        bp = [b];

                      // Parentless nodes are either documents or disconnected
                      if (!aup || !bup) {
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        /* eslint-disable eqeqeq */
                        return a == document
                          ? -1
                          : b == document
                          ? 1
                          : /* eslint-enable eqeqeq */
                          aup
                          ? -1
                          : bup
                          ? 1
                          : sortInput
                          ? indexOf(sortInput, a) - indexOf(sortInput, b)
                          : 0;

                        // If the nodes are siblings, we can do a quick check
                      } else if (aup === bup) {
                        return siblingCheck(a, b);
                      }

                      // Otherwise we need full lists of their ancestors for comparison
                      cur = a;
                      while ((cur = cur.parentNode)) {
                        ap.unshift(cur);
                      }
                      cur = b;
                      while ((cur = cur.parentNode)) {
                        bp.unshift(cur);
                      }

                      // Walk down the tree looking for a discrepancy
                      while (ap[i] === bp[i]) {
                        i++;
                      }

                      return i
                        ? // Do a sibling check if the nodes have a common ancestor
                          siblingCheck(ap[i], bp[i])
                        : // Otherwise nodes in our document sort first
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        /* eslint-disable eqeqeq */
                        ap[i] == preferredDoc
                        ? -1
                        : bp[i] == preferredDoc
                        ? 1
                        : /* eslint-enable eqeqeq */
                          0;
                    };

                return document;
              };

              Sizzle.matches = function (expr, elements) {
                return Sizzle(expr, null, null, elements);
              };

              Sizzle.matchesSelector = function (elem, expr) {
                setDocument(elem);

                if (
                  support.matchesSelector &&
                  documentIsHTML &&
                  !nonnativeSelectorCache[expr + " "] &&
                  (!rbuggyMatches || !rbuggyMatches.test(expr)) &&
                  (!rbuggyQSA || !rbuggyQSA.test(expr))
                ) {
                  try {
                    var ret = matches.call(elem, expr);

                    // IE 9's matchesSelector returns false on disconnected nodes
                    if (
                      ret ||
                      support.disconnectedMatch ||
                      // As well, disconnected nodes are said to be in a document
                      // fragment in IE 9
                      (elem.document && elem.document.nodeType !== 11)
                    ) {
                      return ret;
                    }
                  } catch (e) {
                    nonnativeSelectorCache(expr, true);
                  }
                }

                return Sizzle(expr, document, null, [elem]).length > 0;
              };

              Sizzle.contains = function (context, elem) {
                // Set document vars if needed
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                if ((context.ownerDocument || context) != document) {
                  setDocument(context);
                }
                return contains(context, elem);
              };

              Sizzle.attr = function (elem, name) {
                // Set document vars if needed
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                if ((elem.ownerDocument || elem) != document) {
                  setDocument(elem);
                }

                var fn = Expr.attrHandle[name.toLowerCase()],
                  // Don't get fooled by Object.prototype properties (jQuery #13807)
                  val =
                    fn && hasOwn.call(Expr.attrHandle, name.toLowerCase())
                      ? fn(elem, name, !documentIsHTML)
                      : undefined;

                return val !== undefined
                  ? val
                  : support.attributes || !documentIsHTML
                  ? elem.getAttribute(name)
                  : (val = elem.getAttributeNode(name)) && val.specified
                  ? val.value
                  : null;
              };

              Sizzle.escape = function (sel) {
                return (sel + "").replace(rcssescape, fcssescape);
              };

              Sizzle.error = function (msg) {
                throw new Error("Syntax error, unrecognized expression: " + msg);
              };

              /**
               * Document sorting and removing duplicates
               * @param {ArrayLike} results
               */
              Sizzle.uniqueSort = function (results) {
                var elem,
                  duplicates = [],
                  j = 0,
                  i = 0;

                // Unless we *know* we can detect duplicates, assume their presence
                hasDuplicate = !support.detectDuplicates;
                sortInput = !support.sortStable && results.slice(0);
                results.sort(sortOrder);

                if (hasDuplicate) {
                  while ((elem = results[i++])) {
                    if (elem === results[i]) {
                      j = duplicates.push(i);
                    }
                  }
                  while (j--) {
                    results.splice(duplicates[j], 1);
                  }
                }

                // Clear input after sorting to release objects
                // See https://github.com/jquery/sizzle/pull/225
                sortInput = null;

                return results;
              };

              /**
               * Utility function for retrieving the text value of an array of DOM nodes
               * @param {Array|Element} elem
               */
              getText = Sizzle.getText = function (elem) {
                var node,
                  ret = "",
                  i = 0,
                  nodeType = elem.nodeType;

                if (!nodeType) {
                  // If no nodeType, this is expected to be an array
                  while ((node = elem[i++])) {
                    // Do not traverse comment nodes
                    ret += getText(node);
                  }
                } else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
                  // Use textContent for elements
                  // innerText usage removed for consistency of new lines (jQuery #11153)
                  if (typeof elem.textContent === "string") {
                    return elem.textContent;
                  } else {
                    // Traverse its children
                    for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
                      ret += getText(elem);
                    }
                  }
                } else if (nodeType === 3 || nodeType === 4) {
                  return elem.nodeValue;
                }

                // Do not include comment or processing instruction nodes

                return ret;
              };

              Expr = Sizzle.selectors = {
                // Can be adjusted by the user
                cacheLength: 50,

                createPseudo: markFunction,

                match: matchExpr,

                attrHandle: {},

                find: {},

                relative: {
                  ">": { dir: "parentNode", first: true },
                  " ": { dir: "parentNode" },
                  "+": { dir: "previousSibling", first: true },
                  "~": { dir: "previousSibling" },
                },

                preFilter: {
                  ATTR: function (match) {
                    match[1] = match[1].replace(runescape, funescape);

                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(
                      runescape,
                      funescape
                    );

                    if (match[2] === "~=") {
                      match[3] = " " + match[3] + " ";
                    }

                    return match.slice(0, 4);
                  },

                  CHILD: function (match) {
                    /* matches from matchExpr["CHILD"]
                      1 type (only|nth|...)
                      2 what (child|of-type)
                      3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
                      4 xn-component of xn+y argument ([+-]?\d*n|)
                      5 sign of xn-component
                      6 x of xn-component
                      7 sign of y-component
                      8 y of y-component
                  */
                    match[1] = match[1].toLowerCase();

                    if (match[1].slice(0, 3) === "nth") {
                      // nth-* requires argument
                      if (!match[3]) {
                        Sizzle.error(match[0]);
                      }

                      // numeric x and y parameters for Expr.filter.CHILD
                      // remember that false/true cast respectively to 0/1
                      match[4] = +(match[4]
                        ? match[5] + (match[6] || 1)
                        : 2 * (match[3] === "even" || match[3] === "odd"));
                      match[5] = +(match[7] + match[8] || match[3] === "odd");

                      // other types prohibit arguments
                    } else if (match[3]) {
                      Sizzle.error(match[0]);
                    }

                    return match;
                  },

                  PSEUDO: function (match) {
                    var excess,
                      unquoted = !match[6] && match[2];

                    if (matchExpr["CHILD"].test(match[0])) {
                      return null;
                    }

                    // Accept quoted arguments as-is
                    if (match[3]) {
                      match[2] = match[4] || match[5] || "";

                      // Strip excess characters from unquoted arguments
                    } else if (
                      unquoted &&
                      rpseudo.test(unquoted) &&
                      // Get excess from tokenize (recursively)
                      (excess = tokenize(unquoted, true)) &&
                      // advance to the next closing parenthesis
                      (excess =
                        unquoted.indexOf(")", unquoted.length - excess) -
                        unquoted.length)
                    ) {
                      // excess is a negative index
                      match[0] = match[0].slice(0, excess);
                      match[2] = unquoted.slice(0, excess);
                    }

                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                  },
                },

                filter: {
                  TAG: function (nodeNameSelector) {
                    var nodeName = nodeNameSelector
                      .replace(runescape, funescape)
                      .toLowerCase();
                    return nodeNameSelector === "*"
                      ? function () {
                          return true;
                        }
                      : function (elem) {
                          return (
                            elem.nodeName &&
                            elem.nodeName.toLowerCase() === nodeName
                          );
                        };
                  },

                  CLASS: function (className) {
                    var pattern = classCache[className + " "];

                    return (
                      pattern ||
                      ((pattern = new RegExp(
                        "(^|" +
                          whitespace +
                          ")" +
                          className +
                          "(" +
                          whitespace +
                          "|$)"
                      )) &&
                        classCache(className, function (elem) {
                          return pattern.test(
                            (typeof elem.className === "string" &&
                              elem.className) ||
                              (typeof elem.getAttribute !== "undefined" &&
                                elem.getAttribute("class")) ||
                              ""
                          );
                        }))
                    );
                  },

                  ATTR: function (name, operator, check) {
                    return function (elem) {
                      var result = Sizzle.attr(elem, name);

                      if (result == null) {
                        return operator === "!=";
                      }
                      if (!operator) {
                        return true;
                      }

                      result += "";

                      /* eslint-disable max-len */

                      return operator === "="
                        ? result === check
                        : operator === "!="
                        ? result !== check
                        : operator === "^="
                        ? check && result.indexOf(check) === 0
                        : operator === "*="
                        ? check && result.indexOf(check) > -1
                        : operator === "$="
                        ? check && result.slice(-check.length) === check
                        : operator === "~="
                        ? (" " + result.replace(rwhitespace, " ") + " ").indexOf(
                            check
                          ) > -1
                        : operator === "|="
                        ? result === check ||
                          result.slice(0, check.length + 1) === check + "-"
                        : false;
                      /* eslint-enable max-len */
                    };
                  },

                  CHILD: function (type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth",
                      forward = type.slice(-4) !== "last",
                      ofType = what === "of-type";

                    return first === 1 && last === 0
                      ? // Shortcut for :nth-*(n)
                        function (elem) {
                          return !!elem.parentNode;
                        }
                      : function (elem, _context, xml) {
                          var cache,
                            uniqueCache,
                            outerCache,
                            node,
                            nodeIndex,
                            start,
                            dir =
                              simple !== forward
                                ? "nextSibling"
                                : "previousSibling",
                            parent = elem.parentNode,
                            name = ofType && elem.nodeName.toLowerCase(),
                            useCache = !xml && !ofType,
                            diff = false;

                          if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                              while (dir) {
                                node = elem;
                                while ((node = node[dir])) {
                                  if (
                                    ofType
                                      ? node.nodeName.toLowerCase() === name
                                      : node.nodeType === 1
                                  ) {
                                    return false;
                                  }
                                }

                                // Reverse direction for :only-* (if we haven't yet done so)
                                start = dir =
                                  type === "only" && !start && "nextSibling";
                              }
                              return true;
                            }

                            start = [
                              forward ? parent.firstChild : parent.lastChild,
                            ];

                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                              // Seek `elem` from a previously-cached index

                              // ...in a gzip-friendly way
                              node = parent;
                              outerCache = node[expando] || (node[expando] = {});

                              // Support: IE <9 only
                              // Defend against cloned attroperties (jQuery gh-1709)
                              uniqueCache =
                                outerCache[node.uniqueID] ||
                                (outerCache[node.uniqueID] = {});

                              cache = uniqueCache[type] || [];
                              nodeIndex = cache[0] === dirruns && cache[1];
                              diff = nodeIndex && cache[2];
                              node = nodeIndex && parent.childNodes[nodeIndex];

                              while (
                                (node =
                                  (++nodeIndex && node && node[dir]) ||
                                  // Fallback to seeking `elem` from the start
                                  (diff = nodeIndex = 0) ||
                                  start.pop())
                              ) {
                                // When found, cache indexes on `parent` and break
                                if (
                                  node.nodeType === 1 &&
                                  ++diff &&
                                  node === elem
                                ) {
                                  uniqueCache[type] = [dirruns, nodeIndex, diff];
                                  break;
                                }
                              }
                            } else {
                              // Use previously-cached element index if available
                              if (useCache) {
                                // ...in a gzip-friendly way
                                node = elem;
                                outerCache =
                                  node[expando] || (node[expando] = {});

                                // Support: IE <9 only
                                // Defend against cloned attroperties (jQuery gh-1709)
                                uniqueCache =
                                  outerCache[node.uniqueID] ||
                                  (outerCache[node.uniqueID] = {});

                                cache = uniqueCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex;
                              }

                              // xml :nth-child(...)
                              // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                              if (diff === false) {
                                // Use the same loop as above to seek `elem` from the start
                                while (
                                  (node =
                                    (++nodeIndex && node && node[dir]) ||
                                    (diff = nodeIndex = 0) ||
                                    start.pop())
                                ) {
                                  if (
                                    (ofType
                                      ? node.nodeName.toLowerCase() === name
                                      : node.nodeType === 1) &&
                                    ++diff
                                  ) {
                                    // Cache the index of each encountered element
                                    if (useCache) {
                                      outerCache =
                                        node[expando] || (node[expando] = {});

                                      // Support: IE <9 only
                                      // Defend against cloned attroperties (jQuery gh-1709)
                                      uniqueCache =
                                        outerCache[node.uniqueID] ||
                                        (outerCache[node.uniqueID] = {});

                                      uniqueCache[type] = [dirruns, diff];
                                    }

                                    if (node === elem) {
                                      break;
                                    }
                                  }
                                }
                              }
                            }

                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return (
                              diff === first ||
                              (diff % first === 0 && diff / first >= 0)
                            );
                          }
                        };
                  },

                  PSEUDO: function (pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // http://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args,
                      fn =
                        Expr.pseudos[pseudo] ||
                        Expr.setFilters[pseudo.toLowerCase()] ||
                        Sizzle.error("unsupported pseudo: " + pseudo);

                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as Sizzle does
                    if (fn[expando]) {
                      return fn(argument);
                    }

                    // But maintain support for old signatures
                    if (fn.length > 1) {
                      args = [pseudo, pseudo, "", argument];
                      return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase())
                        ? markFunction(function (seed, matches) {
                            var idx,
                              matched = fn(seed, argument),
                              i = matched.length;
                            while (i--) {
                              idx = indexOf(seed, matched[i]);
                              seed[idx] = !(matches[idx] = matched[i]);
                            }
                          })
                        : function (elem) {
                            return fn(elem, 0, args);
                          };
                    }

                    return fn;
                  },
                },

                pseudos: {
                  // Potentially complex pseudos
                  not: markFunction(function (selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [],
                      results = [],
                      matcher = compile(selector.replace(rtrim, "$1"));

                    return matcher[expando]
                      ? markFunction(function (seed, matches, _context, xml) {
                          var elem,
                            unmatched = matcher(seed, null, xml, []),
                            i = seed.length;

                          // Match elements unmatched by `matcher`
                          while (i--) {
                            if ((elem = unmatched[i])) {
                              seed[i] = !(matches[i] = elem);
                            }
                          }
                        })
                      : function (elem, _context, xml) {
                          input[0] = elem;
                          matcher(input, null, xml, results);

                          // Don't keep the element (issue #299)
                          input[0] = null;
                          return !results.pop();
                        };
                  }),

                  has: markFunction(function (selector) {
                    return function (elem) {
                      return Sizzle(selector, elem).length > 0;
                    };
                  }),

                  contains: markFunction(function (text) {
                    text = text.replace(runescape, funescape);
                    return function (elem) {
                      return (
                        (elem.textContent || getText(elem)).indexOf(text) > -1
                      );
                    };
                  }),

                  // "Whether an element is represented by a :lang() selector
                  // is based solely on the element's language value
                  // being equal to the identifier C,
                  // or beginning with the identifier C immediately followed by "-".
                  // The matching of C against the element's language value is performed case-insensitively.
                  // The identifier C does not have to be a valid language name."
                  // http://www.w3.org/TR/selectors/#lang-pseudo
                  lang: markFunction(function (lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) {
                      Sizzle.error("unsupported lang: " + lang);
                    }
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function (elem) {
                      var elemLang;
                      do {
                        if (
                          (elemLang = documentIsHTML
                            ? elem.lang
                            : elem.getAttribute("xml:lang") ||
                              elem.getAttribute("lang"))
                        ) {
                          elemLang = elemLang.toLowerCase();
                          return (
                            elemLang === lang ||
                            elemLang.indexOf(lang + "-") === 0
                          );
                        }
                      } while ((elem = elem.parentNode) && elem.nodeType === 1);
                      return false;
                    };
                  }),

                  // Miscellaneous
                  target: function (elem) {
                    var hash = window.location && window.location.hash;
                    return hash && hash.slice(1) === elem.id;
                  },

                  root: function (elem) {
                    return elem === docElem;
                  },

                  focus: function (elem) {
                    return (
                      elem === document.activeElement &&
                      (!document.hasFocus || document.hasFocus()) &&
                      !!(elem.type || elem.href || ~elem.tabIndex)
                    );
                  },

                  // Boolean properties
                  enabled: createDisabledPseudo(false),
                  disabled: createDisabledPseudo(true),

                  checked: function (elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    var nodeName = elem.nodeName.toLowerCase();
                    return (
                      (nodeName === "input" && !!elem.checked) ||
                      (nodeName === "option" && !!elem.selected)
                    );
                  },

                  selected: function (elem) {
                    // Accessing this property makes selected-by-default
                    // options in Safari work properly
                    if (elem.parentNode) {
                      // eslint-disable-next-line no-unused-expressions
                      elem.parentNode.selectedIndex;
                    }

                    return elem.selected === true;
                  },

                  // Contents
                  empty: function (elem) {
                    // http://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
                      if (elem.nodeType < 6) {
                        return false;
                      }
                    }
                    return true;
                  },

                  parent: function (elem) {
                    return !Expr.pseudos["empty"](elem);
                  },

                  // Element/input types
                  header: function (elem) {
                    return rheader.test(elem.nodeName);
                  },

                  input: function (elem) {
                    return rinputs.test(elem.nodeName);
                  },

                  button: function (elem) {
                    var name = elem.nodeName.toLowerCase();
                    return (
                      (name === "input" && elem.type === "button") ||
                      name === "button"
                    );
                  },

                  text: function (elem) {
                    var attr;
                    return (
                      elem.nodeName.toLowerCase() === "input" &&
                      elem.type === "text" &&
                      // Support: IE<8
                      // New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
                      ((attr = elem.getAttribute("type")) == null ||
                        attr.toLowerCase() === "text")
                    );
                  },

                  // Position-in-collection
                  first: createPositionalPseudo(function () {
                    return [0];
                  }),

                  last: createPositionalPseudo(function (_matchIndexes, length) {
                    return [length - 1];
                  }),

                  eq: createPositionalPseudo(function (
                    _matchIndexes,
                    length,
                    argument
                  ) {
                    return [argument < 0 ? argument + length : argument];
                  }),

                  even: createPositionalPseudo(function (matchIndexes, length) {
                    var i = 0;
                    for (; i < length; i += 2) {
                      matchIndexes.push(i);
                    }
                    return matchIndexes;
                  }),

                  odd: createPositionalPseudo(function (matchIndexes, length) {
                    var i = 1;
                    for (; i < length; i += 2) {
                      matchIndexes.push(i);
                    }
                    return matchIndexes;
                  }),

                  lt: createPositionalPseudo(function (
                    matchIndexes,
                    length,
                    argument
                  ) {
                    var i =
                      argument < 0
                        ? argument + length
                        : argument > length
                        ? length
                        : argument;
                    for (; --i >= 0; ) {
                      matchIndexes.push(i);
                    }
                    return matchIndexes;
                  }),

                  gt: createPositionalPseudo(function (
                    matchIndexes,
                    length,
                    argument
                  ) {
                    var i = argument < 0 ? argument + length : argument;
                    for (; ++i < length; ) {
                      matchIndexes.push(i);
                    }
                    return matchIndexes;
                  }),
                },
              };

              Expr.pseudos["nth"] = Expr.pseudos["eq"];

              // Add button/input type pseudos
              for (i in {
                radio: true,
                checkbox: true,
                file: true,
                password: true,
                image: true,
              }) {
                Expr.pseudos[i] = createInputPseudo(i);
              }
              for (i in { submit: true, reset: true }) {
                Expr.pseudos[i] = createButtonPseudo(i);
              }

              // Easy API for creating new setFilters
              function setFilters() {}
              setFilters.prototype = Expr.filters = Expr.pseudos;
              Expr.setFilters = new setFilters();

              tokenize = Sizzle.tokenize = function (selector, parseOnly) {
                var matched,
                  match,
                  tokens,
                  type,
                  soFar,
                  groups,
                  preFilters,
                  cached = tokenCache[selector + " "];

                if (cached) {
                  return parseOnly ? 0 : cached.slice(0);
                }

                soFar = selector;
                groups = [];
                preFilters = Expr.preFilter;

                while (soFar) {
                  // Comma and first run
                  if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) {
                      // Don't consume trailing commas as valid
                      soFar = soFar.slice(match[0].length) || soFar;
                    }
                    groups.push((tokens = []));
                  }

                  matched = false;

                  // Combinators
                  if ((match = rcombinators.exec(soFar))) {
                    matched = match.shift();
                    tokens.push({
                      value: matched,

                      // Cast descendant combinators to space
                      type: match[0].replace(rtrim, " "),
                    });
                    soFar = soFar.slice(matched.length);
                  }

                  // Filters
                  for (type in Expr.filter) {
                    if (
                      (match = matchExpr[type].exec(soFar)) &&
                      (!preFilters[type] || (match = preFilters[type](match)))
                    ) {
                      matched = match.shift();
                      tokens.push({
                        value: matched,
                        type: type,
                        matches: match,
                      });
                      soFar = soFar.slice(matched.length);
                    }
                  }

                  if (!matched) {
                    break;
                  }
                }

                // Return the length of the invalid excess
                // if we're just parsing
                // Otherwise, throw an error or return tokens
                return parseOnly
                  ? soFar.length
                  : soFar
                  ? Sizzle.error(selector)
                  : // Cache the tokens
                    tokenCache(selector, groups).slice(0);
              };

              function toSelector(tokens) {
                var i = 0,
                  len = tokens.length,
                  selector = "";
                for (; i < len; i++) {
                  selector += tokens[i].value;
                }
                return selector;
              }

              function addCombinator(matcher, combinator, base) {
                var dir = combinator.dir,
                  skip = combinator.next,
                  key = skip || dir,
                  checkNonElements = base && key === "parentNode",
                  doneName = done++;

                return combinator.first
                  ? // Check against closest ancestor/preceding element
                    function (elem, context, xml) {
                      while ((elem = elem[dir])) {
                        if (elem.nodeType === 1 || checkNonElements) {
                          return matcher(elem, context, xml);
                        }
                      }
                      return false;
                    }
                  : // Check against all ancestor/preceding elements
                    function (elem, context, xml) {
                      var oldCache,
                        uniqueCache,
                        outerCache,
                        newCache = [dirruns, doneName];

                      // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                      if (xml) {
                        while ((elem = elem[dir])) {
                          if (elem.nodeType === 1 || checkNonElements) {
                            if (matcher(elem, context, xml)) {
                              return true;
                            }
                          }
                        }
                      } else {
                        while ((elem = elem[dir])) {
                          if (elem.nodeType === 1 || checkNonElements) {
                            outerCache = elem[expando] || (elem[expando] = {});

                            // Support: IE <9 only
                            // Defend against cloned attroperties (jQuery gh-1709)
                            uniqueCache =
                              outerCache[elem.uniqueID] ||
                              (outerCache[elem.uniqueID] = {});

                            if (skip && skip === elem.nodeName.toLowerCase()) {
                              elem = elem[dir] || elem;
                            } else if (
                              (oldCache = uniqueCache[key]) &&
                              oldCache[0] === dirruns &&
                              oldCache[1] === doneName
                            ) {
                              // Assign to newCache so results back-propagate to previous elements
                              return (newCache[2] = oldCache[2]);
                            } else {
                              // Reuse newcache so results back-propagate to previous elements
                              uniqueCache[key] = newCache;

                              // A match means we're done; a fail means we have to keep checking
                              if ((newCache[2] = matcher(elem, context, xml))) {
                                return true;
                              }
                            }
                          }
                        }
                      }
                      return false;
                    };
              }

              function elementMatcher(matchers) {
                return matchers.length > 1
                  ? function (elem, context, xml) {
                      var i = matchers.length;
                      while (i--) {
                        if (!matchers[i](elem, context, xml)) {
                          return false;
                        }
                      }
                      return true;
                    }
                  : matchers[0];
              }

              function multipleContexts(selector, contexts, results) {
                var i = 0,
                  len = contexts.length;
                for (; i < len; i++) {
                  Sizzle(selector, contexts[i], results);
                }
                return results;
              }

              function condense(unmatched, map, filter, context, xml) {
                var elem,
                  newUnmatched = [],
                  i = 0,
                  len = unmatched.length,
                  mapped = map != null;

                for (; i < len; i++) {
                  if ((elem = unmatched[i])) {
                    if (!filter || filter(elem, context, xml)) {
                      newUnmatched.push(elem);
                      if (mapped) {
                        map.push(i);
                      }
                    }
                  }
                }

                return newUnmatched;
              }

              function setMatcher(
                preFilter,
                selector,
                matcher,
                postFilter,
                postFinder,
                postSelector
              ) {
                if (postFilter && !postFilter[expando]) {
                  postFilter = setMatcher(postFilter);
                }
                if (postFinder && !postFinder[expando]) {
                  postFinder = setMatcher(postFinder, postSelector);
                }
                return markFunction(function (seed, results, context, xml) {
                  var temp,
                    i,
                    elem,
                    preMap = [],
                    postMap = [],
                    preexisting = results.length,
                    // Get initial elements from seed or context
                    elems =
                      seed ||
                      multipleContexts(
                        selector || "*",
                        context.nodeType ? [context] : context,
                        []
                      ),
                    // Prefilter to get matcher input, preserving a map for seed-results synchronization
                    matcherIn =
                      preFilter && (seed || !selector)
                        ? condense(elems, preMap, preFilter, context, xml)
                        : elems,
                    matcherOut = matcher
                      ? // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
                        postFinder ||
                        (seed ? preFilter : preexisting || postFilter)
                        ? // ...intermediate processing is necessary
                          []
                        : // ...otherwise use results directly
                          results
                      : matcherIn;

                  // Find primary matches
                  if (matcher) {
                    matcher(matcherIn, matcherOut, context, xml);
                  }

                  // Apply postFilter
                  if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);

                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while (i--) {
                      if ((elem = temp[i])) {
                        matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                      }
                    }
                  }

                  if (seed) {
                    if (postFinder || preFilter) {
                      if (postFinder) {
                        // Get the final matcherOut by condensing this intermediate into postFinder contexts
                        temp = [];
                        i = matcherOut.length;
                        while (i--) {
                          if ((elem = matcherOut[i])) {
                            // Restore matcherIn since elem is not yet a final match
                            temp.push((matcherIn[i] = elem));
                          }
                        }
                        postFinder(null, (matcherOut = []), temp, xml);
                      }

                      // Move matched elements from seed to results to keep them synchronized
                      i = matcherOut.length;
                      while (i--) {
                        if (
                          (elem = matcherOut[i]) &&
                          (temp = postFinder ? indexOf(seed, elem) : preMap[i]) >
                            -1
                        ) {
                          seed[temp] = !(results[temp] = elem);
                        }
                      }
                    }

                    // Add elements to results, through postFinder if defined
                  } else {
                    matcherOut = condense(
                      matcherOut === results
                        ? matcherOut.splice(preexisting, matcherOut.length)
                        : matcherOut
                    );
                    if (postFinder) {
                      postFinder(null, results, matcherOut, xml);
                    } else {
                      push.apply(results, matcherOut);
                    }
                  }
                });
              }

              function matcherFromTokens(tokens) {
                var checkContext,
                  matcher,
                  j,
                  len = tokens.length,
                  leadingRelative = Expr.relative[tokens[0].type],
                  implicitRelative = leadingRelative || Expr.relative[" "],
                  i = leadingRelative ? 1 : 0,
                  // The foundational matcher ensures that elements are reachable from top-level context(s)
                  matchContext = addCombinator(
                    function (elem) {
                      return elem === checkContext;
                    },
                    implicitRelative,
                    true
                  ),
                  matchAnyContext = addCombinator(
                    function (elem) {
                      return indexOf(checkContext, elem) > -1;
                    },
                    implicitRelative,
                    true
                  ),
                  matchers = [
                    function (elem, context, xml) {
                      var ret =
                        (!leadingRelative &&
                          (xml || context !== outermostContext)) ||
                        ((checkContext = context).nodeType
                          ? matchContext(elem, context, xml)
                          : matchAnyContext(elem, context, xml));

                      // Avoid hanging onto element (issue #299)
                      checkContext = null;
                      return ret;
                    },
                  ];

                for (; i < len; i++) {
                  if ((matcher = Expr.relative[tokens[i].type])) {
                    matchers = [addCombinator(elementMatcher(matchers), matcher)];
                  } else {
                    matcher = Expr.filter[tokens[i].type].apply(
                      null,
                      tokens[i].matches
                    );

                    // Return special upon seeing a positional matcher
                    if (matcher[expando]) {
                      // Find the next relative operator (if any) for proper handling
                      j = ++i;
                      for (; j < len; j++) {
                        if (Expr.relative[tokens[j].type]) {
                          break;
                        }
                      }
                      return setMatcher(
                        i > 1 && elementMatcher(matchers),
                        i > 1 &&
                          toSelector(
                            // If the preceding token was a descendant combinator, insert an implicit any-element `*`
                            tokens.slice(0, i - 1).concat({
                              value: tokens[i - 2].type === " " ? "*" : "",
                            })
                          ).replace(rtrim, "$1"),
                        matcher,
                        i < j && matcherFromTokens(tokens.slice(i, j)),
                        j < len && matcherFromTokens((tokens = tokens.slice(j))),
                        j < len && toSelector(tokens)
                      );
                    }
                    matchers.push(matcher);
                  }
                }

                return elementMatcher(matchers);
              }

              function matcherFromGroupMatchers(elementMatchers, setMatchers) {
                var bySet = setMatchers.length > 0,
                  byElement = elementMatchers.length > 0,
                  superMatcher = function (
                    seed,
                    context,
                    xml,
                    results,
                    outermost
                  ) {
                    var elem,
                      j,
                      matcher,
                      matchedCount = 0,
                      i = "0",
                      unmatched = seed && [],
                      setMatched = [],
                      contextBackup = outermostContext,
                      // We must always have either seed elements or outermost context
                      elems =
                        seed || (byElement && Expr.find["TAG"]("*", outermost)),
                      // Use integer dirruns iff this is the outermost matcher
                      dirrunsUnique = (dirruns +=
                        contextBackup == null ? 1 : Math.random() || 0.1),
                      len = elems.length;

                    if (outermost) {
                      // Support: IE 11+, Edge 17 - 18+
                      // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                      // two documents; shallow comparisons work.
                      // eslint-disable-next-line eqeqeq
                      outermostContext =
                        context == document || context || outermost;
                    }

                    // Add elements passing elementMatchers directly to results
                    // Support: IE<9, Safari
                    // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
                    for (; i !== len && (elem = elems[i]) != null; i++) {
                      if (byElement && elem) {
                        j = 0;

                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                          setDocument(elem);
                          xml = !documentIsHTML;
                        }
                        while ((matcher = elementMatchers[j++])) {
                          if (matcher(elem, context || document, xml)) {
                            results.push(elem);
                            break;
                          }
                        }
                        if (outermost) {
                          dirruns = dirrunsUnique;
                        }
                      }

                      // Track unmatched elements for set filters
                      if (bySet) {
                        // They will have gone through all possible matchers
                        if ((elem = !matcher && elem)) {
                          matchedCount--;
                        }

                        // Lengthen the array for every element, matched or not
                        if (seed) {
                          unmatched.push(elem);
                        }
                      }
                    }

                    // `i` is now the count of elements visited above, and adding it to `matchedCount`
                    // makes the latter nonnegative.
                    matchedCount += i;

                    // Apply set filters to unmatched elements
                    // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                    // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                    // no element matchers and no seed.
                    // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                    // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                    // numerically zero.
                    if (bySet && i !== matchedCount) {
                      j = 0;
                      while ((matcher = setMatchers[j++])) {
                        matcher(unmatched, setMatched, context, xml);
                      }

                      if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                          while (i--) {
                            if (!(unmatched[i] || setMatched[i])) {
                              setMatched[i] = pop.call(results);
                            }
                          }
                        }

                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                      }

                      // Add matches to results
                      push.apply(results, setMatched);

                      // Seedless set matches succeeding multiple successful matchers stipulate sorting
                      if (
                        outermost &&
                        !seed &&
                        setMatched.length > 0 &&
                        matchedCount + setMatchers.length > 1
                      ) {
                        Sizzle.uniqueSort(results);
                      }
                    }

                    // Override manipulation of globals by nested matchers
                    if (outermost) {
                      dirruns = dirrunsUnique;
                      outermostContext = contextBackup;
                    }

                    return unmatched;
                  };

                return bySet ? markFunction(superMatcher) : superMatcher;
              }

              compile = Sizzle.compile = function (
                selector,
                match /* Internal Use Only */
              ) {
                var i,
                  setMatchers = [],
                  elementMatchers = [],
                  cached = compilerCache[selector + " "];

                if (!cached) {
                  // Generate a function of recursive functions that can be used to check each element
                  if (!match) {
                    match = tokenize(selector);
                  }
                  i = match.length;
                  while (i--) {
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) {
                      setMatchers.push(cached);
                    } else {
                      elementMatchers.push(cached);
                    }
                  }

                  // Cache the compiled function
                  cached = compilerCache(
                    selector,
                    matcherFromGroupMatchers(elementMatchers, setMatchers)
                  );

                  // Save selector and tokenization
                  cached.selector = selector;
                }
                return cached;
              };

              /**
               * A low-level selection function that works with Sizzle's compiled
               *  selector functions
               * @param {String|Function} selector A selector or a pre-compiled
               *  selector function built with Sizzle.compile
               * @param {Element} context
               * @param {Array} [results]
               * @param {Array} [seed] A set of elements to match against
               */
              select = Sizzle.select = function (
                selector,
                context,
                results,
                seed
              ) {
                var i,
                  tokens,
                  token,
                  type,
                  find,
                  compiled = typeof selector === "function" && selector,
                  match =
                    !seed && tokenize((selector = compiled.selector || selector));

                results = results || [];

                // Try to minimize operations if there is only one selector in the list and no seed
                // (the latter of which guarantees us context)
                if (match.length === 1) {
                  // Reduce context if the leading compound selector is an ID
                  tokens = match[0] = match[0].slice(0);
                  if (
                    tokens.length > 2 &&
                    (token = tokens[0]).type === "ID" &&
                    context.nodeType === 9 &&
                    documentIsHTML &&
                    Expr.relative[tokens[1].type]
                  ) {
                    context = (Expr.find["ID"](
                      token.matches[0].replace(runescape, funescape),
                      context
                    ) || [])[0];
                    if (!context) {
                      return results;

                      // Precompiled matchers will still verify ancestry, so step up a level
                    } else if (compiled) {
                      context = context.parentNode;
                    }

                    selector = selector.slice(tokens.shift().value.length);
                  }

                  // Fetch a seed set for right-to-left matching
                  i = matchExpr["needsContext"].test(selector)
                    ? 0
                    : tokens.length;
                  while (i--) {
                    token = tokens[i];

                    // Abort if we hit a combinator
                    if (Expr.relative[(type = token.type)]) {
                      break;
                    }
                    if ((find = Expr.find[type])) {
                      // Search, expanding context for leading sibling combinators
                      if (
                        (seed = find(
                          token.matches[0].replace(runescape, funescape),
                          (rsibling.test(tokens[0].type) &&
                            testContext(context.parentNode)) ||
                            context
                        ))
                      ) {
                        // If seed is empty or no tokens remain, we can return early
                        tokens.splice(i, 1);
                        selector = seed.length && toSelector(tokens);
                        if (!selector) {
                          push.apply(results, seed);
                          return results;
                        }

                        break;
                      }
                    }
                  }
                }

                // Compile and execute a filtering function if one is not provided
                // Provide `match` to avoid retokenization if we modified the selector above
                (compiled || compile(selector, match))(
                  seed,
                  context,
                  !documentIsHTML,
                  results,
                  !context ||
                    (rsibling.test(selector) &&
                      testContext(context.parentNode)) ||
                    context
                );
                return results;
              };

              // One-time assignments

              // Sort stability
              support.sortStable =
                expando.split("").sort(sortOrder).join("") === expando;

              // Support: Chrome 14-35+
              // Always assume duplicates if they aren't passed to the comparison function
              support.detectDuplicates = !!hasDuplicate;

              // Initialize against the default document
              setDocument();

              // Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
              // Detached nodes confoundingly follow *each other*
              support.sortDetached = assert(function (el) {
                // Should return 1, but returns 4 (following)
                return (
                  el.compareDocumentPosition(document.createElement("fieldset")) &
                  1
                );
              });

              // Support: IE<8
              // Prevent attribute/property "interpolation"
              // https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
              if (
                !assert(function (el) {
                  el.innerHTML = "<a href='#'></a>";
                  return el.firstChild.getAttribute("href") === "#";
                })
              ) {
                addHandle("type|href|height|width", function (elem, name, isXML) {
                  if (!isXML) {
                    return elem.getAttribute(
                      name,
                      name.toLowerCase() === "type" ? 1 : 2
                    );
                  }
                });
              }

              // Support: IE<9
              // Use defaultValue in place of getAttribute("value")
              if (
                !support.attributes ||
                !assert(function (el) {
                  el.innerHTML = "<input/>";
                  el.firstChild.setAttribute("value", "");
                  return el.firstChild.getAttribute("value") === "";
                })
              ) {
                addHandle("value", function (elem, _name, isXML) {
                  if (!isXML && elem.nodeName.toLowerCase() === "input") {
                    return elem.defaultValue;
                  }
                });
              }

              // Support: IE<9
              // Use getAttributeNode to fetch booleans when getAttribute lies
              if (
                !assert(function (el) {
                  return el.getAttribute("disabled") == null;
                })
              ) {
                addHandle(booleans, function (elem, name, isXML) {
                  var val;
                  if (!isXML) {
                    return elem[name] === true
                      ? name.toLowerCase()
                      : (val = elem.getAttributeNode(name)) && val.specified
                      ? val.value
                      : null;
                  }
                });
              }

              return Sizzle;
            })(window);

          jQuery.find = Sizzle;
          jQuery.expr = Sizzle.selectors;

          // Deprecated
          jQuery.expr[":"] = jQuery.expr.pseudos;
          jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
          jQuery.text = Sizzle.getText;
          jQuery.isXMLDoc = Sizzle.isXML;
          jQuery.contains = Sizzle.contains;
          jQuery.escapeSelector = Sizzle.escape;

          var dir = function (elem, dir, until) {
            var matched = [],
              truncate = until !== undefined;

            while ((elem = elem[dir]) && elem.nodeType !== 9) {
              if (elem.nodeType === 1) {
                if (truncate && jQuery(elem).is(until)) {
                  break;
                }
                matched.push(elem);
              }
            }
            return matched;
          };

          var siblings = function (n, elem) {
            var matched = [];

            for (; n; n = n.nextSibling) {
              if (n.nodeType === 1 && n !== elem) {
                matched.push(n);
              }
            }

            return matched;
          };

          var rneedsContext = jQuery.expr.match.needsContext;

          function nodeName(elem, name) {
            return (
              elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase()
            );
          }
          var rsingleTag =
            /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

          // Implement the identical functionality for filter and not
          function winnow(elements, qualifier, not) {
            if (isFunction(qualifier)) {
              return jQuery.grep(elements, function (elem, i) {
                return !!qualifier.call(elem, i, elem) !== not;
              });
            }

            // Single element
            if (qualifier.nodeType) {
              return jQuery.grep(elements, function (elem) {
                return (elem === qualifier) !== not;
              });
            }

            // Arraylike of elements (jQuery, arguments, Array)
            if (typeof qualifier !== "string") {
              return jQuery.grep(elements, function (elem) {
                return indexOf.call(qualifier, elem) > -1 !== not;
              });
            }

            // Filtered directly for both simple and complex selectors
            return jQuery.filter(qualifier, elements, not);
          }

          jQuery.filter = function (expr, elems, not) {
            var elem = elems[0];

            if (not) {
              expr = ":not(" + expr + ")";
            }

            if (elems.length === 1 && elem.nodeType === 1) {
              return jQuery.find.matchesSelector(elem, expr) ? [elem] : [];
            }

            return jQuery.find.matches(
              expr,
              jQuery.grep(elems, function (elem) {
                return elem.nodeType === 1;
              })
            );
          };

          jQuery.fn.extend({
            find: function (selector) {
              var i,
                ret,
                len = this.length,
                self = this;

              if (typeof selector !== "string") {
                return this.pushStack(
                  jQuery(selector).filter(function () {
                    for (i = 0; i < len; i++) {
                      if (jQuery.contains(self[i], this)) {
                        return true;
                      }
                    }
                  })
                );
              }

              ret = this.pushStack([]);

              for (i = 0; i < len; i++) {
                jQuery.find(selector, self[i], ret);
              }

              return len > 1 ? jQuery.uniqueSort(ret) : ret;
            },
            filter: function (selector) {
              return this.pushStack(winnow(this, selector || [], false));
            },
            not: function (selector) {
              return this.pushStack(winnow(this, selector || [], true));
            },
            is: function (selector) {
              return !!winnow(
                this,

                // If this is a positional/relative selector, check membership in the returned set
                // so $("p:first").is("p:last") won't return true for a doc with two "p".
                typeof selector === "string" && rneedsContext.test(selector)
                  ? jQuery(selector)
                  : selector || [],
                false
              ).length;
            },
          });

          // Initialize a jQuery object

          // A central reference to the root jQuery(document)
          var rootjQuery,
            // A simple way to check for HTML strings
            // Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
            // Strict HTML recognition (#11290: must start with <)
            // Shortcut simple #id case for speed
            rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
            init = (jQuery.fn.init = function (selector, context, root) {
              var match, elem;

              // HANDLE: $(""), $(null), $(undefined), $(false)
              if (!selector) {
                return this;
              }

              // Method init() accepts an alternate rootjQuery
              // so migrate can support jQuery.sub (gh-2101)
              root = root || rootjQuery;

              // Handle HTML strings
              if (typeof selector === "string") {
                if (
                  selector[0] === "<" &&
                  selector[selector.length - 1] === ">" &&
                  selector.length >= 3
                ) {
                  // Assume that strings that start and end with <> are HTML and skip the regex check
                  match = [null, selector, null];
                } else {
                  match = rquickExpr.exec(selector);
                }

                // Match html or make sure no context is specified for #id
                if (match && (match[1] || !context)) {
                  // HANDLE: $(html) -> $(array)
                  if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;

                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(
                      this,
                      jQuery.parseHTML(
                        match[1],
                        context && context.nodeType
                          ? context.ownerDocument || context
                          : document,
                        true
                      )
                    );

                    // HANDLE: $(html, props)
                    if (
                      rsingleTag.test(match[1]) &&
                      jQuery.isPlainObject(context)
                    ) {
                      for (match in context) {
                        // Properties of context are called as methods if possible
                        if (isFunction(this[match])) {
                          this[match](context[match]);

                          // ...and otherwise set as attributes
                        } else {
                          this.attr(match, context[match]);
                        }
                      }
                    }

                    return this;

                    // HANDLE: $(#id)
                  } else {
                    elem = document.getElementById(match[2]);

                    if (elem) {
                      // Inject the element directly into the jQuery object
                      this[0] = elem;
                      this.length = 1;
                    }
                    return this;
                  }

                  // HANDLE: $(expr, $(...))
                } else if (!context || context.jquery) {
                  return (context || root).find(selector);

                  // HANDLE: $(expr, context)
                  // (which is just equivalent to: $(context).find(expr)
                } else {
                  return this.constructor(context).find(selector);
                }

                // HANDLE: $(DOMElement)
              } else if (selector.nodeType) {
                this[0] = selector;
                this.length = 1;
                return this;

                // HANDLE: $(function)
                // Shortcut for document ready
              } else if (isFunction(selector)) {
                return root.ready !== undefined
                  ? root.ready(selector)
                  : // Execute immediately if ready is not present
                    selector(jQuery);
              }

              return jQuery.makeArray(selector, this);
            });

          // Give the init function the jQuery prototype for later instantiation
          init.prototype = jQuery.fn;

          // Initialize central reference
          rootjQuery = jQuery(document);

          var rparentsprev = /^(?:parents|prev(?:Until|All))/,
            // Methods guaranteed to produce a unique set when starting from a unique set
            guaranteedUnique = {
              children: true,
              contents: true,
              next: true,
              prev: true,
            };

          jQuery.fn.extend({
            has: function (target) {
              var targets = jQuery(target, this),
                l = targets.length;

              return this.filter(function () {
                var i = 0;
                for (; i < l; i++) {
                  if (jQuery.contains(this, targets[i])) {
                    return true;
                  }
                }
              });
            },

            closest: function (selectors, context) {
              var cur,
                i = 0,
                l = this.length,
                matched = [],
                targets = typeof selectors !== "string" && jQuery(selectors);

              // Positional selectors never match, since there's no _selection_ context
              if (!rneedsContext.test(selectors)) {
                for (; i < l; i++) {
                  for (
                    cur = this[i];
                    cur && cur !== context;
                    cur = cur.parentNode
                  ) {
                    // Always skip document fragments
                    if (
                      cur.nodeType < 11 &&
                      (targets
                        ? targets.index(cur) > -1
                        : // Don't pass non-elements to Sizzle
                          cur.nodeType === 1 &&
                          jQuery.find.matchesSelector(cur, selectors))
                    ) {
                      matched.push(cur);
                      break;
                    }
                  }
                }
              }

              return this.pushStack(
                matched.length > 1 ? jQuery.uniqueSort(matched) : matched
              );
            },

            // Determine the position of an element within the set
            index: function (elem) {
              // No argument, return index in parent
              if (!elem) {
                return this[0] && this[0].parentNode
                  ? this.first().prevAll().length
                  : -1;
              }

              // Index in selector
              if (typeof elem === "string") {
                return indexOf.call(jQuery(elem), this[0]);
              }

              // Locate the position of the desired element
              return indexOf.call(
                this,

                // If it receives a jQuery object, the first element is used
                elem.jquery ? elem[0] : elem
              );
            },

            add: function (selector, context) {
              return this.pushStack(
                jQuery.uniqueSort(
                  jQuery.merge(this.get(), jQuery(selector, context))
                )
              );
            },

            addBack: function (selector) {
              return this.add(
                selector == null
                  ? this.prevObject
                  : this.prevObject.filter(selector)
              );
            },
          });

          function sibling(cur, dir) {
            while ((cur = cur[dir]) && cur.nodeType !== 1) {}
            return cur;
          }

          jQuery.each(
            {
              parent: function (elem) {
                var parent = elem.parentNode;
                return parent && parent.nodeType !== 11 ? parent : null;
              },
              parents: function (elem) {
                return dir(elem, "parentNode");
              },
              parentsUntil: function (elem, _i, until) {
                return dir(elem, "parentNode", until);
              },
              next: function (elem) {
                return sibling(elem, "nextSibling");
              },
              prev: function (elem) {
                return sibling(elem, "previousSibling");
              },
              nextAll: function (elem) {
                return dir(elem, "nextSibling");
              },
              prevAll: function (elem) {
                return dir(elem, "previousSibling");
              },
              nextUntil: function (elem, _i, until) {
                return dir(elem, "nextSibling", until);
              },
              prevUntil: function (elem, _i, until) {
                return dir(elem, "previousSibling", until);
              },
              siblings: function (elem) {
                return siblings((elem.parentNode || {}).firstChild, elem);
              },
              children: function (elem) {
                return siblings(elem.firstChild);
              },
              contents: function (elem) {
                if (
                  elem.contentDocument != null &&
                  // Support: IE 11+
                  // <object> elements with no `data` attribute has an object
                  // `contentDocument` with a `null` prototype.
                  getProto(elem.contentDocument)
                ) {
                  return elem.contentDocument;
                }

                // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
                // Treat the template element as a regular one in browsers that
                // don't support it.
                if (nodeName(elem, "template")) {
                  elem = elem.content || elem;
                }

                return jQuery.merge([], elem.childNodes);
              },
            },
            function (name, fn) {
              jQuery.fn[name] = function (until, selector) {
                var matched = jQuery.map(this, fn, until);

                if (name.slice(-5) !== "Until") {
                  selector = until;
                }

                if (selector && typeof selector === "string") {
                  matched = jQuery.filter(selector, matched);
                }

                if (this.length > 1) {
                  // Remove duplicates
                  if (!guaranteedUnique[name]) {
                    jQuery.uniqueSort(matched);
                  }

                  // Reverse order for parents* and prev-derivatives
                  if (rparentsprev.test(name)) {
                    matched.reverse();
                  }
                }

                return this.pushStack(matched);
              };
            }
          );
          var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;

          // Convert String-formatted options into Object-formatted ones
          function createOptions(options) {
            var object = {};
            jQuery.each(options.match(rnothtmlwhite) || [], function (_, flag) {
              object[flag] = true;
            });
            return object;
          }

          /*
           * Create a callback list using the following parameters:
           *
           *	options: an optional list of space-separated options that will change how
           *			the callback list behaves or a more traditional option object
           *
           * By default a callback list will act like an event callback list and can be
           * "fired" multiple times.
           *
           * Possible options:
           *
           *	once:			will ensure the callback list can only be fired once (like a Deferred)
           *
           *	memory:			will keep track of previous values and will call any callback added
           *					after the list has been fired right away with the latest "memorized"
           *					values (like a Deferred)
           *
           *	unique:			will ensure a callback can only be added once (no duplicate in the list)
           *
           *	stopOnFalse:	interrupt callings when a callback returns false
           *
           */
          jQuery.Callbacks = function (options) {
            // Convert options from String-formatted to Object-formatted if needed
            // (we check in cache first)
            options =
              typeof options === "string"
                ? createOptions(options)
                : jQuery.extend({}, options);

            var // Flag to know if list is currently firing
              firing,
              // Last fire value for non-forgettable lists
              memory,
              // Flag to know if list was already fired
              fired,
              // Flag to prevent firing
              locked,
              // Actual callback list
              list = [],
              // Queue of execution data for repeatable lists
              queue = [],
              // Index of currently firing callback (modified by add/remove as needed)
              firingIndex = -1,
              // Fire callbacks
              fire = function () {
                // Enforce single-firing
                locked = locked || options.once;

                // Execute callbacks for all pending executions,
                // respecting firingIndex overrides and runtime changes
                fired = firing = true;
                for (; queue.length; firingIndex = -1) {
                  memory = queue.shift();
                  while (++firingIndex < list.length) {
                    // Run callback and check for early termination
                    if (
                      list[firingIndex].apply(memory[0], memory[1]) === false &&
                      options.stopOnFalse
                    ) {
                      // Jump to end and forget the data so .add doesn't re-fire
                      firingIndex = list.length;
                      memory = false;
                    }
                  }
                }

                // Forget the data if we're done with it
                if (!options.memory) {
                  memory = false;
                }

                firing = false;

                // Clean up if we're done firing for good
                if (locked) {
                  // Keep an empty list if we have data for future add calls
                  if (memory) {
                    list = [];

                    // Otherwise, this object is spent
                  } else {
                    list = "";
                  }
                }
              },
              // Actual Callbacks object
              self = {
                // Add a callback or a collection of callbacks to the list
                add: function () {
                  if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                      firingIndex = list.length - 1;
                      queue.push(memory);
                    }

                    (function add(args) {
                      jQuery.each(args, function (_, arg) {
                        if (isFunction(arg)) {
                          if (!options.unique || !self.has(arg)) {
                            list.push(arg);
                          }
                        } else if (
                          arg &&
                          arg.length &&
                          toType(arg) !== "string"
                        ) {
                          // Inspect recursively
                          add(arg);
                        }
                      });
                    })(arguments);

                    if (memory && !firing) {
                      fire();
                    }
                  }
                  return this;
                },

                // Remove a callback from the list
                remove: function () {
                  jQuery.each(arguments, function (_, arg) {
                    var index;
                    while ((index = jQuery.inArray(arg, list, index)) > -1) {
                      list.splice(index, 1);

                      // Handle firing indexes
                      if (index <= firingIndex) {
                        firingIndex--;
                      }
                    }
                  });
                  return this;
                },

                // Check if a given callback is in the list.
                // If no argument is given, return whether or not list has callbacks attached.
                has: function (fn) {
                  return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
                },

                // Remove all callbacks from the list
                empty: function () {
                  if (list) {
                    list = [];
                  }
                  return this;
                },

                // Disable .fire and .add
                // Abort any current/pending executions
                // Clear all callbacks and values
                disable: function () {
                  locked = queue = [];
                  list = memory = "";
                  return this;
                },
                disabled: function () {
                  return !list;
                },

                // Disable .fire
                // Also disable .add unless we have memory (since it would have no effect)
                // Abort any pending executions
                lock: function () {
                  locked = queue = [];
                  if (!memory && !firing) {
                    list = memory = "";
                  }
                  return this;
                },
                locked: function () {
                  return !!locked;
                },

                // Call all callbacks with the given context and arguments
                fireWith: function (context, args) {
                  if (!locked) {
                    args = args || [];
                    args = [context, args.slice ? args.slice() : args];
                    queue.push(args);
                    if (!firing) {
                      fire();
                    }
                  }
                  return this;
                },

                // Call all the callbacks with the given arguments
                fire: function () {
                  self.fireWith(this, arguments);
                  return this;
                },

                // To know if the callbacks have already been called at least once
                fired: function () {
                  return !!fired;
                },
              };

            return self;
          };

          function Identity(v) {
            return v;
          }
          function Thrower(ex) {
            throw ex;
          }

          function adoptValue(value, resolve, reject, noValue) {
            var method;

            try {
              // Check for promise aspect first to privilege synchronous behavior
              if (value && isFunction((method = value.promise))) {
                method.call(value).done(resolve).fail(reject);

                // Other thenables
              } else if (value && isFunction((method = value.then))) {
                method.call(value, resolve, reject);

                // Other non-thenables
              } else {
                // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
                // * false: [ value ].slice( 0 ) => resolve( value )
                // * true: [ value ].slice( 1 ) => resolve()
                resolve.apply(undefined, [value].slice(noValue));
              }

              // For Promises/A+, convert exceptions into rejections
              // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
              // Deferred#then to conditionally suppress rejection.
            } catch (value) {
              // Support: Android 4.0 only
              // Strict mode functions invoked without .call/.apply get global-object context
              reject.apply(undefined, [value]);
            }
          }

          jQuery.extend({
            Deferred: function (func) {
              var tuples = [
                  // action, add listener, callbacks,
                  // ... .then handlers, argument index, [final state]
                  [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2,
                  ],
                  [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved",
                  ],
                  [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected",
                  ],
                ],
                state = "pending",
                promise = {
                  state: function () {
                    return state;
                  },
                  always: function () {
                    deferred.done(arguments).fail(arguments);
                    return this;
                  },
                  catch: function (fn) {
                    return promise.then(null, fn);
                  },

                  // Keep pipe for back-compat
                  pipe: function (/* fnDone, fnFail, fnProgress */) {
                    var fns = arguments;

                    return jQuery
                      .Deferred(function (newDefer) {
                        jQuery.each(tuples, function (_i, tuple) {
                          // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                          var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];

                          // deferred.progress(function() { bind to newDefer or newDefer.notify })
                          // deferred.done(function() { bind to newDefer or newDefer.resolve })
                          // deferred.fail(function() { bind to newDefer or newDefer.reject })
                          deferred[tuple[1]](function () {
                            var returned = fn && fn.apply(this, arguments);
                            if (returned && isFunction(returned.promise)) {
                              returned
                                .promise()
                                .progress(newDefer.notify)
                                .done(newDefer.resolve)
                                .fail(newDefer.reject);
                            } else {
                              newDefer[tuple[0] + "With"](
                                this,
                                fn ? [returned] : arguments
                              );
                            }
                          });
                        });
                        fns = null;
                      })
                      .promise();
                  },
                  then: function (onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                      return function () {
                        var that = this,
                          args = arguments,
                          mightThrow = function () {
                            var returned, then;

                            // Support: Promises/A+ section 2.3.3.3.3
                            // https://promisesaplus.com/#point-59
                            // Ignore double-resolution attempts
                            if (depth < maxDepth) {
                              return;
                            }

                            returned = handler.apply(that, args);

                            // Support: Promises/A+ section 2.3.1
                            // https://promisesaplus.com/#point-48
                            if (returned === deferred.promise()) {
                              throw new TypeError("Thenable self-resolution");
                            }

                            // Support: Promises/A+ sections 2.3.3.1, 3.5
                            // https://promisesaplus.com/#point-54
                            // https://promisesaplus.com/#point-75
                            // Retrieve `then` only once
                            then =
                              returned &&
                              // Support: Promises/A+ section 2.3.4
                              // https://promisesaplus.com/#point-64
                              // Only check objects and functions for thenability
                              (typeof returned === "object" ||
                                typeof returned === "function") &&
                              returned.then;

                            // Handle a returned thenable
                            if (isFunction(then)) {
                              // Special processors (notify) just wait for resolution
                              if (special) {
                                then.call(
                                  returned,
                                  resolve(maxDepth, deferred, Identity, special),
                                  resolve(maxDepth, deferred, Thrower, special)
                                );

                                // Normal processors (resolve) also hook into progress
                              } else {
                                // ...and disregard older resolution values
                                maxDepth++;

                                then.call(
                                  returned,
                                  resolve(maxDepth, deferred, Identity, special),
                                  resolve(maxDepth, deferred, Thrower, special),
                                  resolve(
                                    maxDepth,
                                    deferred,
                                    Identity,
                                    deferred.notifyWith
                                  )
                                );
                              }

                              // Handle all other returned values
                            } else {
                              // Only substitute handlers pass on context
                              // and multiple values (non-spec behavior)
                              if (handler !== Identity) {
                                that = undefined;
                                args = [returned];
                              }

                              // Process the value(s)
                              // Default process is resolve
                              (special || deferred.resolveWith)(that, args);
                            }
                          },
                          // Only normal processors (resolve) catch and reject exceptions
                          process = special
                            ? mightThrow
                            : function () {
                                try {
                                  mightThrow();
                                } catch (e) {
                                  if (jQuery.Deferred.exceptionHook) {
                                    jQuery.Deferred.exceptionHook(
                                      e,
                                      process.stackTrace
                                    );
                                  }

                                  // Support: Promises/A+ section 2.3.3.3.4.1
                                  // https://promisesaplus.com/#point-61
                                  // Ignore post-resolution exceptions
                                  if (depth + 1 >= maxDepth) {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Thrower) {
                                      that = undefined;
                                      args = [e];
                                    }

                                    deferred.rejectWith(that, args);
                                  }
                                }
                              };

                        // Support: Promises/A+ section 2.3.3.3.1
                        // https://promisesaplus.com/#point-57
                        // Re-resolve promises immediately to dodge false rejection from
                        // subsequent errors
                        if (depth) {
                          process();
                        } else {
                          // Call an optional hook to record the stack, in case of exception
                          // since it's otherwise lost when execution goes async
                          if (jQuery.Deferred.getStackHook) {
                            process.stackTrace = jQuery.Deferred.getStackHook();
                          }
                          window.setTimeout(process);
                        }
                      };
                    }

                    return jQuery
                      .Deferred(function (newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(
                          resolve(
                            0,
                            newDefer,
                            isFunction(onProgress) ? onProgress : Identity,
                            newDefer.notifyWith
                          )
                        );

                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(
                          resolve(
                            0,
                            newDefer,
                            isFunction(onFulfilled) ? onFulfilled : Identity
                          )
                        );

                        // rejected_handlers.add( ... )
                        tuples[2][3].add(
                          resolve(
                            0,
                            newDefer,
                            isFunction(onRejected) ? onRejected : Thrower
                          )
                        );
                      })
                      .promise();
                  },

                  // Get a promise for this deferred
                  // If obj is provided, the promise aspect is added to the object
                  promise: function (obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                  },
                },
                deferred = {};

              // Add list-specific methods
              jQuery.each(tuples, function (i, tuple) {
                var list = tuple[2],
                  stateString = tuple[5];

                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;

                // Handle state
                if (stateString) {
                  list.add(
                    function () {
                      // state = "resolved" (i.e., fulfilled)
                      // state = "rejected"
                      state = stateString;
                    },

                    // rejected_callbacks.disable
                    // fulfilled_callbacks.disable
                    tuples[3 - i][2].disable,

                    // rejected_handlers.disable
                    // fulfilled_handlers.disable
                    tuples[3 - i][3].disable,

                    // progress_callbacks.lock
                    tuples[0][2].lock,

                    // progress_handlers.lock
                    tuples[0][3].lock
                  );
                }

                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);

                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function () {
                  deferred[tuple[0] + "With"](
                    this === deferred ? undefined : this,
                    arguments
                  );
                  return this;
                };

                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
              });

              // Make the deferred a promise
              promise.promise(deferred);

              // Call given func if any
              if (func) {
                func.call(deferred, deferred);
              }

              // All done!
              return deferred;
            },

            // Deferred helper
            when: function (singleValue) {
              var // count of uncompleted subordinates
                remaining = arguments.length,
                // count of unprocessed arguments
                i = remaining,
                // subordinate fulfillment data
                resolveContexts = Array(i),
                resolveValues = slice.call(arguments),
                // the primary Deferred
                primary = jQuery.Deferred(),
                // subordinate callback factory
                updateFunc = function (i) {
                  return function (value) {
                    resolveContexts[i] = this;
                    resolveValues[i] =
                      arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) {
                      primary.resolveWith(resolveContexts, resolveValues);
                    }
                  };
                };

              // Single- and empty arguments are adopted like Promise.resolve
              if (remaining <= 1) {
                adoptValue(
                  singleValue,
                  primary.done(updateFunc(i)).resolve,
                  primary.reject,
                  !remaining
                );

                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (
                  primary.state() === "pending" ||
                  isFunction(resolveValues[i] && resolveValues[i].then)
                ) {
                  return primary.then();
                }
              }

              // Multiple arguments are aggregated like Promise.all array elements
              while (i--) {
                adoptValue(resolveValues[i], updateFunc(i), primary.reject);
              }

              return primary.promise();
            },
          });

          // These usually indicate a programmer mistake during development,
          // warn about them ASAP rather than swallowing them by default.
          var rerrorNames =
            /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

          jQuery.Deferred.exceptionHook = function (error, stack) {
            // Support: IE 8 - 9 only
            // Console exists when dev tools are open, which can happen at any time
            if (
              window.console &&
              window.console.warn &&
              error &&
              rerrorNames.test(error.name)
            ) {
              window.console.warn(
                "jQuery.Deferred exception: " + error.message,
                error.stack,
                stack
              );
            }
          };

          jQuery.readyException = function (error) {
            window.setTimeout(function () {
              throw error;
            });
          };

          // The deferred used on DOM ready
          var readyList = jQuery.Deferred();

          jQuery.fn.ready = function (fn) {
            readyList
              .then(fn)

              // Wrap jQuery.readyException in a function so that the lookup
              // happens at the time of error handling instead of callback
              // registration.
              .catch(function (error) {
                jQuery.readyException(error);
              });

            return this;
          };

          jQuery.extend({
            // Is the DOM ready to be used? Set to true once it occurs.
            isReady: false,

            // A counter to track how many items to wait for before
            // the ready event fires. See #6781
            readyWait: 1,

            // Handle when the DOM is ready
            ready: function (wait) {
              // Abort if there are pending holds or we're already ready
              if (wait === true ? --jQuery.readyWait : jQuery.isReady) {
                return;
              }

              // Remember that the DOM is ready
              jQuery.isReady = true;

              // If a normal DOM Ready event fired, decrement, and wait if need be
              if (wait !== true && --jQuery.readyWait > 0) {
                return;
              }

              // If there are functions bound, to execute
              readyList.resolveWith(document, [jQuery]);
            },
          });

          jQuery.ready.then = readyList.then;

          // The ready event handler and self cleanup method
          function completed() {
            document.removeEventListener("DOMContentLoaded", completed);
            window.removeEventListener("load", completed);
            jQuery.ready();
          }

          // Catch cases where $(document).ready() is called
          // after the browser event has already occurred.
          // Support: IE <=9 - 10 only
          // Older IE sometimes signals "interactive" too soon
          if (
            document.readyState === "complete" ||
            (document.readyState !== "loading" &&
              !document.documentElement.doScroll)
          ) {
            // Handle it asynchronously to allow scripts the opportunity to delay ready
            window.setTimeout(jQuery.ready);
          } else {
            // Use the handy event callback
            document.addEventListener("DOMContentLoaded", completed);

            // A fallback to window.onload, that will always work
            window.addEventListener("load", completed);
          }

          // Multifunctional method to get and set values of a collection
          // The value/s can optionally be executed if it's a function
          var access = function (
            elems,
            fn,
            key,
            value,
            chainable,
            emptyGet,
            raw
          ) {
            var i = 0,
              len = elems.length,
              bulk = key == null;

            // Sets many values
            if (toType(key) === "object") {
              chainable = true;
              for (i in key) {
                access(elems, fn, i, key[i], true, emptyGet, raw);
              }

              // Sets one value
            } else if (value !== undefined) {
              chainable = true;

              if (!isFunction(value)) {
                raw = true;
              }

              if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                  fn.call(elems, value);
                  fn = null;

                  // ...except when executing function values
                } else {
                  bulk = fn;
                  fn = function (elem, _key, value) {
                    return bulk.call(jQuery(elem), value);
                  };
                }
              }

              if (fn) {
                for (; i < len; i++) {
                  fn(
                    elems[i],
                    key,
                    raw ? value : value.call(elems[i], i, fn(elems[i], key))
                  );
                }
              }
            }

            if (chainable) {
              return elems;
            }

            // Gets
            if (bulk) {
              return fn.call(elems);
            }

            return len ? fn(elems[0], key) : emptyGet;
          };

          // Matches dashed string for camelizing
          var rmsPrefix = /^-ms-/,
            rdashAlpha = /-([a-z])/g;

          // Used by camelCase as callback to replace()
          function fcamelCase(_all, letter) {
            return letter.toUpperCase();
          }

          // Convert dashed to camelCase; used by the css and data modules
          // Support: IE <=9 - 11, Edge 12 - 15
          // Microsoft forgot to hump their vendor prefix (#9572)
          function camelCase(string) {
            return string
              .replace(rmsPrefix, "ms-")
              .replace(rdashAlpha, fcamelCase);
          }
          var acceptData = function (owner) {
            // Accepts only:
            //  - Node
            //    - Node.ELEMENT_NODE
            //    - Node.DOCUMENT_NODE
            //  - Object
            //    - Any
            return (
              owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType
            );
          };

          function Data() {
            this.expando = jQuery.expando + Data.uid++;
          }

          Data.uid = 1;

          Data.prototype = {
            cache: function (owner) {
              // Check if the owner object already has a cache
              var value = owner[this.expando];

              // If not, create one
              if (!value) {
                value = {};

                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see #8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                  // If it is a node unlikely to be stringify-ed or looped over
                  // use plain assignment
                  if (owner.nodeType) {
                    owner[this.expando] = value;

                    // Otherwise secure it in a non-enumerable property
                    // configurable must be true to allow the property to be
                    // deleted when data is removed
                  } else {
                    Object.defineProperty(owner, this.expando, {
                      value: value,
                      configurable: true,
                    });
                  }
                }
              }

              return value;
            },
            set: function (owner, data, value) {
              var prop,
                cache = this.cache(owner);

              // Handle: [ owner, key, value ] args
              // Always use camelCase key (gh-2257)
              if (typeof data === "string") {
                cache[camelCase(data)] = value;

                // Handle: [ owner, { properties } ] args
              } else {
                // Copy the properties one-by-one to the cache object
                for (prop in data) {
                  cache[camelCase(prop)] = data[prop];
                }
              }
              return cache;
            },
            get: function (owner, key) {
              return key === undefined
                ? this.cache(owner)
                : // Always use camelCase key (gh-2257)
                  owner[this.expando] && owner[this.expando][camelCase(key)];
            },
            access: function (owner, key, value) {
              // In cases where either:
              //
              //   1. No key was specified
              //   2. A string key was specified, but no value provided
              //
              // Take the "read" path and allow the get method to determine
              // which value to return, respectively either:
              //
              //   1. The entire cache object
              //   2. The data stored at the key
              //
              if (
                key === undefined ||
                (key && typeof key === "string" && value === undefined)
              ) {
                return this.get(owner, key);
              }

              // When the key is not a string, or both a key and value
              // are specified, set or extend (existing objects) with either:
              //
              //   1. An object of properties
              //   2. A key and value
              //
              this.set(owner, key, value);

              // Since the "set" path can have two possible entry points
              // return the expected data based on which path was taken[*]
              return value !== undefined ? value : key;
            },
            remove: function (owner, key) {
              var i,
                cache = owner[this.expando];

              if (cache === undefined) {
                return;
              }

              if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) {
                  // If key is an array of keys...
                  // We always set camelCase keys, so remove that.
                  key = key.map(camelCase);
                } else {
                  key = camelCase(key);

                  // If a key with the spaces exists, use it.
                  // Otherwise, create an array by matching non-whitespace
                  key = key in cache ? [key] : key.match(rnothtmlwhite) || [];
                }

                i = key.length;

                while (i--) {
                  delete cache[key[i]];
                }
              }

              // Remove the expando if there's no more data
              if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) {
                  owner[this.expando] = undefined;
                } else {
                  delete owner[this.expando];
                }
              }
            },
            hasData: function (owner) {
              var cache = owner[this.expando];
              return cache !== undefined && !jQuery.isEmptyObject(cache);
            },
          };
          var dataPriv = new Data();

          var dataUser = new Data();

          //	Implementation Summary
          //
          //	1. Enforce API surface and semantic compatibility with 1.9.x branch
          //	2. Improve the module's maintainability by reducing the storage
          //		paths to a single mechanism.
          //	3. Use the same single mechanism to support "private" and "user" data.
          //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
          //	5. Avoid exposing implementation details on user objects (eg. expando properties)
          //	6. Provide a clear path for implementation upgrade to WeakMap in 2014

          var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
            rmultiDash = /[A-Z]/g;

          function getData(data) {
            if (data === "true") {
              return true;
            }

            if (data === "false") {
              return false;
            }

            if (data === "null") {
              return null;
            }

            // Only convert to a number if it doesn't change the string
            if (data === +data + "") {
              return +data;
            }

            if (rbrace.test(data)) {
              return JSON.parse(data);
            }

            return data;
          }

          function dataAttr(elem, key, data) {
            var name;

            // If nothing was found internally, try to fetch any
            // data from the HTML5 data-* attribute
            if (data === undefined && elem.nodeType === 1) {
              name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
              data = elem.getAttribute(name);

              if (typeof data === "string") {
                try {
                  data = getData(data);
                } catch (e) {}

                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
              } else {
                data = undefined;
              }
            }
            return data;
          }

          jQuery.extend({
            hasData: function (elem) {
              return dataUser.hasData(elem) || dataPriv.hasData(elem);
            },

            data: function (elem, name, data) {
              return dataUser.access(elem, name, data);
            },

            removeData: function (elem, name) {
              dataUser.remove(elem, name);
            },

            // TODO: Now that all calls to _data and _removeData have been replaced
            // with direct calls to dataPriv methods, these can be deprecated.
            _data: function (elem, name, data) {
              return dataPriv.access(elem, name, data);
            },

            _removeData: function (elem, name) {
              dataPriv.remove(elem, name);
            },
          });

          jQuery.fn.extend({
            data: function (key, value) {
              var i,
                name,
                data,
                elem = this[0],
                attrs = elem && elem.attributes;

              // Gets all values
              if (key === undefined) {
                if (this.length) {
                  data = dataUser.get(elem);

                  if (
                    elem.nodeType === 1 &&
                    !dataPriv.get(elem, "hasDataAttrs")
                  ) {
                    i = attrs.length;
                    while (i--) {
                      // Support: IE 11 only
                      // The attrs elements can be null (#14894)
                      if (attrs[i]) {
                        name = attrs[i].name;
                        if (name.indexOf("data-") === 0) {
                          name = camelCase(name.slice(5));
                          dataAttr(elem, name, data[name]);
                        }
                      }
                    }
                    dataPriv.set(elem, "hasDataAttrs", true);
                  }
                }

                return data;
              }

              // Sets multiple values
              if (typeof key === "object") {
                return this.each(function () {
                  dataUser.set(this, key);
                });
              }

              return access(
                this,
                function (value) {
                  var data;

                  // The calling jQuery object (element matches) is not empty
                  // (and therefore has an element appears at this[ 0 ]) and the
                  // `value` parameter was not undefined. An empty jQuery object
                  // will result in `undefined` for elem = this[ 0 ] which will
                  // throw an exception if an attempt to read a data cache is made.
                  if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) {
                      return data;
                    }

                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) {
                      return data;
                    }

                    // We tried really hard, but the data doesn't exist.
                    return;
                  }

                  // Set the data...
                  this.each(function () {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                  });
                },
                null,
                value,
                arguments.length > 1,
                null,
                true
              );
            },

            removeData: function (key) {
              return this.each(function () {
                dataUser.remove(this, key);
              });
            },
          });

          jQuery.extend({
            queue: function (elem, type, data) {
              var queue;

              if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);

                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                  if (!queue || Array.isArray(data)) {
                    queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                  } else {
                    queue.push(data);
                  }
                }
                return queue || [];
              }
            },

            dequeue: function (elem, type) {
              type = type || "fx";

              var queue = jQuery.queue(elem, type),
                startLength = queue.length,
                fn = queue.shift(),
                hooks = jQuery._queueHooks(elem, type),
                next = function () {
                  jQuery.dequeue(elem, type);
                };

              // If the fx queue is dequeued, always remove the progress sentinel
              if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
              }

              if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") {
                  queue.unshift("inprogress");
                }

                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
              }

              if (!startLength && hooks) {
                hooks.empty.fire();
              }
            },

            // Not public - generate a queueHooks object, or return the current one
            _queueHooks: function (elem, type) {
              var key = type + "queueHooks";
              return (
                dataPriv.get(elem, key) ||
                dataPriv.access(elem, key, {
                  empty: jQuery.Callbacks("once memory").add(function () {
                    dataPriv.remove(elem, [type + "queue", key]);
                  }),
                })
              );
            },
          });

          jQuery.fn.extend({
            queue: function (type, data) {
              var setter = 2;

              if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
              }

              if (arguments.length < setter) {
                return jQuery.queue(this[0], type);
              }

              return data === undefined
                ? this
                : this.each(function () {
                    var queue = jQuery.queue(this, type, data);

                    // Ensure a hooks for this queue
                    jQuery._queueHooks(this, type);

                    if (type === "fx" && queue[0] !== "inprogress") {
                      jQuery.dequeue(this, type);
                    }
                  });
            },
            dequeue: function (type) {
              return this.each(function () {
                jQuery.dequeue(this, type);
              });
            },
            clearQueue: function (type) {
              return this.queue(type || "fx", []);
            },

            // Get a promise resolved when queues of a certain type
            // are emptied (fx is the type by default)
            promise: function (type, obj) {
              var tmp,
                count = 1,
                defer = jQuery.Deferred(),
                elements = this,
                i = this.length,
                resolve = function () {
                  if (!--count) {
                    defer.resolveWith(elements, [elements]);
                  }
                };

              if (typeof type !== "string") {
                obj = type;
                type = undefined;
              }
              type = type || "fx";

              while (i--) {
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                  count++;
                  tmp.empty.add(resolve);
                }
              }
              resolve();
              return defer.promise(obj);
            },
          });
          var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;

          var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");

          var cssExpand = ["Top", "Right", "Bottom", "Left"];

          var documentElement = document.documentElement;

          var isAttached = function (elem) {
              return jQuery.contains(elem.ownerDocument, elem);
            },
            composed = { composed: true };

          // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
          // Check attachment across shadow DOM boundaries when possible (gh-3504)
          // Support: iOS 10.0-10.2 only
          // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
          // leading to errors. We need to check for `getRootNode`.
          if (documentElement.getRootNode) {
            isAttached = function (elem) {
              return (
                jQuery.contains(elem.ownerDocument, elem) ||
                elem.getRootNode(composed) === elem.ownerDocument
              );
            };
          }
          var isHiddenWithinTree = function (elem, el) {
            // isHiddenWithinTree might be called from jQuery#filter function;
            // in that case, element will be second argument
            elem = el || elem;

            // Inline style trumps all
            return (
              elem.style.display === "none" ||
              (elem.style.display === "" &&
                // Otherwise, check computed style
                // Support: Firefox <=43 - 45
                // Disconnected elements can have computed display: none, so first confirm that elem is
                // in the document.
                isAttached(elem) &&
                jQuery.css(elem, "display") === "none")
            );
          };

          function adjustCSS(elem, prop, valueParts, tween) {
            var adjusted,
              scale,
              maxIterations = 20,
              currentValue = tween
                ? function () {
                    return tween.cur();
                  }
                : function () {
                    return jQuery.css(elem, prop, "");
                  },
              initial = currentValue(),
              unit =
                (valueParts && valueParts[3]) ||
                (jQuery.cssNumber[prop] ? "" : "px"),
              // Starting value computation is required for potential unit mismatches
              initialInUnit =
                elem.nodeType &&
                (jQuery.cssNumber[prop] || (unit !== "px" && +initial)) &&
                rcssNum.exec(jQuery.css(elem, prop));

            if (initialInUnit && initialInUnit[3] !== unit) {
              // Support: Firefox <=54
              // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
              initial = initial / 2;

              // Trust units reported by jQuery.css
              unit = unit || initialInUnit[3];

              // Iteratively approximate from a nonzero starting point
              initialInUnit = +initial || 1;

              while (maxIterations--) {
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if (
                  (1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <=
                  0
                ) {
                  maxIterations = 0;
                }
                initialInUnit = initialInUnit / scale;
              }

              initialInUnit = initialInUnit * 2;
              jQuery.style(elem, prop, initialInUnit + unit);

              // Make sure we update the tween properties later on
              valueParts = valueParts || [];
            }

            if (valueParts) {
              initialInUnit = +initialInUnit || +initial || 0;

              // Apply relative offset (+=/-=) if specified
              adjusted = valueParts[1]
                ? initialInUnit + (valueParts[1] + 1) * valueParts[2]
                : +valueParts[2];
              if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
              }
            }
            return adjusted;
          }

          var defaultDisplayMap = {};

          function getDefaultDisplay(elem) {
            var temp,
              doc = elem.ownerDocument,
              nodeName = elem.nodeName,
              display = defaultDisplayMap[nodeName];

            if (display) {
              return display;
            }

            temp = doc.body.appendChild(doc.createElement(nodeName));
            display = jQuery.css(temp, "display");

            temp.parentNode.removeChild(temp);

            if (display === "none") {
              display = "block";
            }
            defaultDisplayMap[nodeName] = display;

            return display;
          }

          function showHide(elements, show) {
            var display,
              elem,
              values = [],
              index = 0,
              length = elements.length;

            // Determine new display value for elements that need to change
            for (; index < length; index++) {
              elem = elements[index];
              if (!elem.style) {
                continue;
              }

              display = elem.style.display;
              if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                  values[index] = dataPriv.get(elem, "display") || null;
                  if (!values[index]) {
                    elem.style.display = "";
                  }
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) {
                  values[index] = getDefaultDisplay(elem);
                }
              } else {
                if (display !== "none") {
                  values[index] = "none";

                  // Remember what we're overwriting
                  dataPriv.set(elem, "display", display);
                }
              }
            }

            // Set the display of the elements in a second loop to avoid constant reflow
            for (index = 0; index < length; index++) {
              if (values[index] != null) {
                elements[index].style.display = values[index];
              }
            }

            return elements;
          }

          jQuery.fn.extend({
            show: function () {
              return showHide(this, true);
            },
            hide: function () {
              return showHide(this);
            },
            toggle: function (state) {
              if (typeof state === "boolean") {
                return state ? this.show() : this.hide();
              }

              return this.each(function () {
                if (isHiddenWithinTree(this)) {
                  jQuery(this).show();
                } else {
                  jQuery(this).hide();
                }
              });
            },
          });
          var rcheckableType = /^(?:checkbox|radio)$/i;

          var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;

          var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;

          (function () {
            var fragment = document.createDocumentFragment(),
              div = fragment.appendChild(document.createElement("div")),
              input = document.createElement("input");

            // Support: Android 4.0 - 4.3 only
            // Check state lost if the name is set (#11217)
            // Support: Windows Web Apps (WWA)
            // `name` and `type` must use .setAttribute for WWA (#14901)
            input.setAttribute("type", "radio");
            input.setAttribute("checked", "checked");
            input.setAttribute("name", "t");

            div.appendChild(input);

            // Support: Android <=4.1 only
            // Older WebKit doesn't clone checked state correctly in fragments
            support.checkClone = div
              .cloneNode(true)
              .cloneNode(true).lastChild.checked;

            // Support: IE <=11 only
            // Make sure textarea (and checkbox) defaultValue is properly cloned
            div.innerHTML = "<textarea>x</textarea>";
            support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;

            // Support: IE <=9 only
            // IE <=9 replaces <option> tags with their contents when inserted outside of
            // the select element.
            div.innerHTML = "<option></option>";
            support.option = !!div.lastChild;
          })();

          // We have to close these tags to support XHTML (#13200)
          var wrapMap = {
            // XHTML parsers do not magically insert elements in the
            // same way that tag soup parsers do. So we cannot shorten
            // this by omitting <tbody> or other required elements.
            thead: [1, "<table>", "</table>"],
            col: [2, "<table><colgroup>", "</colgroup></table>"],
            tr: [2, "<table><tbody>", "</tbody></table>"],
            td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],

            _default: [0, "", ""],
          };

          wrapMap.tbody =
            wrapMap.tfoot =
            wrapMap.colgroup =
            wrapMap.caption =
              wrapMap.thead;
          wrapMap.th = wrapMap.td;

          // Support: IE <=9 only
          if (!support.option) {
            wrapMap.optgroup = wrapMap.option = [
              1,
              "<select multiple='multiple'>",
              "</select>",
            ];
          }

          function getAll(context, tag) {
            // Support: IE <=9 - 11 only
            // Use typeof to avoid zero-argument method invocation on host objects (#15151)
            var ret;

            if (typeof context.getElementsByTagName !== "undefined") {
              ret = context.getElementsByTagName(tag || "*");
            } else if (typeof context.querySelectorAll !== "undefined") {
              ret = context.querySelectorAll(tag || "*");
            } else {
              ret = [];
            }

            if (tag === undefined || (tag && nodeName(context, tag))) {
              return jQuery.merge([context], ret);
            }

            return ret;
          }

          // Mark scripts as having already been evaluated
          function setGlobalEval(elems, refElements) {
            var i = 0,
              l = elems.length;

            for (; i < l; i++) {
              dataPriv.set(
                elems[i],
                "globalEval",
                !refElements || dataPriv.get(refElements[i], "globalEval")
              );
            }
          }

          var rhtml = /<|&#?\w+;/;

          function buildFragment(elems, context, scripts, selection, ignored) {
            var elem,
              tmp,
              tag,
              wrap,
              attached,
              j,
              fragment = context.createDocumentFragment(),
              nodes = [],
              i = 0,
              l = elems.length;

            for (; i < l; i++) {
              elem = elems[i];

              if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") {
                  // Support: Android <=4.0 only, PhantomJS 1 only
                  // push.apply(_, arraylike) throws on ancient WebKit
                  jQuery.merge(nodes, elem.nodeType ? [elem] : elem);

                  // Convert non-html into a text node
                } else if (!rhtml.test(elem)) {
                  nodes.push(context.createTextNode(elem));

                  // Convert html into DOM nodes
                } else {
                  tmp = tmp || fragment.appendChild(context.createElement("div"));

                  // Deserialize a standard representation
                  tag = (rtagName.exec(elem) || ["", ""])[1].toLowerCase();
                  wrap = wrapMap[tag] || wrapMap._default;
                  tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];

                  // Descend through wrappers to the right content
                  j = wrap[0];
                  while (j--) {
                    tmp = tmp.lastChild;
                  }

                  // Support: Android <=4.0 only, PhantomJS 1 only
                  // push.apply(_, arraylike) throws on ancient WebKit
                  jQuery.merge(nodes, tmp.childNodes);

                  // Remember the top-level container
                  tmp = fragment.firstChild;

                  // Ensure the created nodes are orphaned (#12392)
                  tmp.textContent = "";
                }
              }
            }

            // Remove wrapper from fragment
            fragment.textContent = "";

            i = 0;
            while ((elem = nodes[i++])) {
              // Skip elements already in the context collection (trac-4087)
              if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) {
                  ignored.push(elem);
                }
                continue;
              }

              attached = isAttached(elem);

              // Append to fragment
              tmp = getAll(fragment.appendChild(elem), "script");

              // Preserve script evaluation history
              if (attached) {
                setGlobalEval(tmp);
              }

              // Capture executables
              if (scripts) {
                j = 0;
                while ((elem = tmp[j++])) {
                  if (rscriptType.test(elem.type || "")) {
                    scripts.push(elem);
                  }
                }
              }
            }

            return fragment;
          }

          var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

          function returnTrue() {
            return true;
          }

          function returnFalse() {
            return false;
          }

          // Support: IE <=9 - 11+
          // focus() and blur() are asynchronous, except when they are no-op.
          // So expect focus to be synchronous when the element is already active,
          // and blur to be synchronous when the element is not already active.
          // (focus and blur are always synchronous in other supported browsers,
          // this just defines when we can count on it).
          function expectSync(elem, type) {
            return (elem === safeActiveElement()) === (type === "focus");
          }

          // Support: IE <=9 only
          // Accessing document.activeElement can throw unexpectedly
          // https://bugs.jquery.com/ticket/13393
          function safeActiveElement() {
            try {
              return document.activeElement;
            } catch (err) {}
          }

          function on(elem, types, selector, data, fn, one) {
            var origFn, type;

            // Types can be a map of types/handlers
            if (typeof types === "object") {
              // ( types-Object, selector, data )
              if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
              }
              for (type in types) {
                on(elem, type, selector, data, types[type], one);
              }
              return elem;
            }

            if (data == null && fn == null) {
              // ( types, fn )
              fn = selector;
              data = selector = undefined;
            } else if (fn == null) {
              if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
              } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
              }
            }
            if (fn === false) {
              fn = returnFalse;
            } else if (!fn) {
              return elem;
            }

            if (one === 1) {
              origFn = fn;
              fn = function (event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
              };

              // Use same guid so caller can remove using origFn
              fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
            }
            return elem.each(function () {
              jQuery.event.add(this, types, fn, data, selector);
            });
          }

          /*
           * Helper functions for managing events -- not part of the public interface.
           * Props to Dean Edwards' addEvent library for many of the ideas.
           */
          jQuery.event = {
            global: {},

            add: function (elem, types, handler, data, selector) {
              var handleObjIn,
                eventHandle,
                tmp,
                events,
                t,
                handleObj,
                special,
                handlers,
                type,
                namespaces,
                origType,
                elemData = dataPriv.get(elem);

              // Only attach events to objects that accept data
              if (!acceptData(elem)) {
                return;
              }

              // Caller can pass in an object of custom data in lieu of the handler
              if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
              }

              // Ensure that invalid selectors throw exceptions at attach time
              // Evaluate against documentElement in case elem is a non-element node (e.g., document)
              if (selector) {
                jQuery.find.matchesSelector(documentElement, selector);
              }

              // Make sure that the handler has a unique ID, used to find/remove it later
              if (!handler.guid) {
                handler.guid = jQuery.guid++;
              }

              // Init the element's event structure and main handler, if this is the first
              if (!(events = elemData.events)) {
                events = elemData.events = Object.create(null);
              }
              if (!(eventHandle = elemData.handle)) {
                eventHandle = elemData.handle = function (e) {
                  // Discard the second event of a jQuery.event.trigger() and
                  // when an event is called after a page has unloaded
                  return typeof jQuery !== "undefined" &&
                    jQuery.event.triggered !== e.type
                    ? jQuery.event.dispatch.apply(elem, arguments)
                    : undefined;
                };
              }

              // Handle multiple events separated by a space
              types = (types || "").match(rnothtmlwhite) || [""];
              t = types.length;
              while (t--) {
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();

                // There *must* be a type, no attaching namespace-only handlers
                if (!type) {
                  continue;
                }

                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};

                // If selector defined, determine special event api type, otherwise given type
                type =
                  (selector ? special.delegateType : special.bindType) || type;

                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};

                // handleObj is passed to all event handlers
                handleObj = jQuery.extend(
                  {
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext:
                      selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join("."),
                  },
                  handleObjIn
                );

                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                  handlers = events[type] = [];
                  handlers.delegateCount = 0;

                  // Only use addEventListener if the special events handler returns false
                  if (
                    !special.setup ||
                    special.setup.call(elem, data, namespaces, eventHandle) ===
                      false
                  ) {
                    if (elem.addEventListener) {
                      elem.addEventListener(type, eventHandle);
                    }
                  }
                }

                if (special.add) {
                  special.add.call(elem, handleObj);

                  if (!handleObj.handler.guid) {
                    handleObj.handler.guid = handler.guid;
                  }
                }

                // Add to the element's handler list, delegates in front
                if (selector) {
                  handlers.splice(handlers.delegateCount++, 0, handleObj);
                } else {
                  handlers.push(handleObj);
                }

                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
              }
            },

            // Detach an event or set of events from an element
            remove: function (elem, types, handler, selector, mappedTypes) {
              var j,
                origCount,
                tmp,
                events,
                t,
                handleObj,
                special,
                handlers,
                type,
                namespaces,
                origType,
                elemData = dataPriv.hasData(elem) && dataPriv.get(elem);

              if (!elemData || !(events = elemData.events)) {
                return;
              }

              // Once for each type.namespace in types; type may be omitted
              types = (types || "").match(rnothtmlwhite) || [""];
              t = types.length;
              while (t--) {
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();

                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                  for (type in events) {
                    jQuery.event.remove(
                      elem,
                      type + types[t],
                      handler,
                      selector,
                      true
                    );
                  }
                  continue;
                }

                special = jQuery.event.special[type] || {};
                type =
                  (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp =
                  tmp[2] &&
                  new RegExp(
                    "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)"
                  );

                // Remove matching events
                origCount = j = handlers.length;
                while (j--) {
                  handleObj = handlers[j];

                  if (
                    (mappedTypes || origType === handleObj.origType) &&
                    (!handler || handler.guid === handleObj.guid) &&
                    (!tmp || tmp.test(handleObj.namespace)) &&
                    (!selector ||
                      selector === handleObj.selector ||
                      (selector === "**" && handleObj.selector))
                  ) {
                    handlers.splice(j, 1);

                    if (handleObj.selector) {
                      handlers.delegateCount--;
                    }
                    if (special.remove) {
                      special.remove.call(elem, handleObj);
                    }
                  }
                }

                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                  if (
                    !special.teardown ||
                    special.teardown.call(elem, namespaces, elemData.handle) ===
                      false
                  ) {
                    jQuery.removeEvent(elem, type, elemData.handle);
                  }

                  delete events[type];
                }
              }

              // Remove data and the expando if it's no longer used
              if (jQuery.isEmptyObject(events)) {
                dataPriv.remove(elem, "handle events");
              }
            },

            dispatch: function (nativeEvent) {
              var i,
                j,
                ret,
                matched,
                handleObj,
                handlerQueue,
                args = new Array(arguments.length),
                // Make a writable jQuery.Event from the native event object
                event = jQuery.event.fix(nativeEvent),
                handlers =
                  (dataPriv.get(this, "events") || Object.create(null))[
                    event.type
                  ] || [],
                special = jQuery.event.special[event.type] || {};

              // Use the fix-ed jQuery.Event rather than the (read-only) native event
              args[0] = event;

              for (i = 1; i < arguments.length; i++) {
                args[i] = arguments[i];
              }

              event.delegateTarget = this;

              // Call the preDispatch hook for the mapped type, and let it bail if desired
              if (
                special.preDispatch &&
                special.preDispatch.call(this, event) === false
              ) {
                return;
              }

              // Determine handlers
              handlerQueue = jQuery.event.handlers.call(this, event, handlers);

              // Run delegates first; they may want to stop propagation beneath us
              i = 0;
              while (
                (matched = handlerQueue[i++]) &&
                !event.isPropagationStopped()
              ) {
                event.currentTarget = matched.elem;

                j = 0;
                while (
                  (handleObj = matched.handlers[j++]) &&
                  !event.isImmediatePropagationStopped()
                ) {
                  // If the event is namespaced, then each handler is only invoked if it is
                  // specially universal or its namespaces are a superset of the event's.
                  if (
                    !event.rnamespace ||
                    handleObj.namespace === false ||
                    event.rnamespace.test(handleObj.namespace)
                  ) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;

                    ret = (
                      (jQuery.event.special[handleObj.origType] || {}).handle ||
                      handleObj.handler
                    ).apply(matched.elem, args);

                    if (ret !== undefined) {
                      if ((event.result = ret) === false) {
                        event.preventDefault();
                        event.stopPropagation();
                      }
                    }
                  }
                }
              }

              // Call the postDispatch hook for the mapped type
              if (special.postDispatch) {
                special.postDispatch.call(this, event);
              }

              return event.result;
            },

            handlers: function (event, handlers) {
              var i,
                handleObj,
                sel,
                matchedHandlers,
                matchedSelectors,
                handlerQueue = [],
                delegateCount = handlers.delegateCount,
                cur = event.target;

              // Find delegate handlers
              if (
                delegateCount &&
                // Support: IE <=9
                // Black-hole SVG <use> instance trees (trac-13180)
                cur.nodeType &&
                // Support: Firefox <=42
                // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
                // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
                // Support: IE 11 only
                // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
                !(event.type === "click" && event.button >= 1)
              ) {
                for (; cur !== this; cur = cur.parentNode || this) {
                  // Don't check non-elements (#13208)
                  // Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
                  if (
                    cur.nodeType === 1 &&
                    !(event.type === "click" && cur.disabled === true)
                  ) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for (i = 0; i < delegateCount; i++) {
                      handleObj = handlers[i];

                      // Don't conflict with Object.prototype properties (#13203)
                      sel = handleObj.selector + " ";

                      if (matchedSelectors[sel] === undefined) {
                        matchedSelectors[sel] = handleObj.needsContext
                          ? jQuery(sel, this).index(cur) > -1
                          : jQuery.find(sel, this, null, [cur]).length;
                      }
                      if (matchedSelectors[sel]) {
                        matchedHandlers.push(handleObj);
                      }
                    }
                    if (matchedHandlers.length) {
                      handlerQueue.push({ elem: cur, handlers: matchedHandlers });
                    }
                  }
                }
              }

              // Add the remaining (directly-bound) handlers
              cur = this;
              if (delegateCount < handlers.length) {
                handlerQueue.push({
                  elem: cur,
                  handlers: handlers.slice(delegateCount),
                });
              }

              return handlerQueue;
            },

            addProp: function (name, hook) {
              Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,

                get: isFunction(hook)
                  ? function () {
                      if (this.originalEvent) {
                        return hook(this.originalEvent);
                      }
                    }
                  : function () {
                      if (this.originalEvent) {
                        return this.originalEvent[name];
                      }
                    },

                set: function (value) {
                  Object.defineProperty(this, name, {
                    enumerable: true,
                    configurable: true,
                    writable: true,
                    value: value,
                  });
                },
              });
            },

            fix: function (originalEvent) {
              return originalEvent[jQuery.expando]
                ? originalEvent
                : new jQuery.Event(originalEvent);
            },

            special: {
              load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true,
              },
              click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function (data) {
                  // For mutual compressibility with _default, replace `this` access with a local var.
                  // `|| data` is dead code meant only to preserve the variable through minification.
                  var el = this || data;

                  // Claim the first handler
                  if (
                    rcheckableType.test(el.type) &&
                    el.click &&
                    nodeName(el, "input")
                  ) {
                    // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", returnTrue);
                  }

                  // Return false to allow normal processing in the caller
                  return false;
                },
                trigger: function (data) {
                  // For mutual compressibility with _default, replace `this` access with a local var.
                  // `|| data` is dead code meant only to preserve the variable through minification.
                  var el = this || data;

                  // Force setup before triggering a click
                  if (
                    rcheckableType.test(el.type) &&
                    el.click &&
                    nodeName(el, "input")
                  ) {
                    leverageNative(el, "click");
                  }

                  // Return non-false to allow normal event-path propagation
                  return true;
                },

                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function (event) {
                  var target = event.target;
                  return (
                    (rcheckableType.test(target.type) &&
                      target.click &&
                      nodeName(target, "input") &&
                      dataPriv.get(target, "click")) ||
                    nodeName(target, "a")
                  );
                },
              },

              beforeunload: {
                postDispatch: function (event) {
                  // Support: Firefox 20+
                  // Firefox doesn't alert if the returnValue field is not set.
                  if (event.result !== undefined && event.originalEvent) {
                    event.originalEvent.returnValue = event.result;
                  }
                },
              },
            },
          };

          // Ensure the presence of an event listener that handles manually-triggered
          // synthetic events by interrupting progress until reinvoked in response to
          // *native* events that it fires directly, ensuring that state changes have
          // already occurred before other listeners are invoked.
          function leverageNative(el, type, expectSync) {
            // Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
            if (!expectSync) {
              if (dataPriv.get(el, type) === undefined) {
                jQuery.event.add(el, type, returnTrue);
              }
              return;
            }

            // Register the controller as a special universal handler for all event namespaces
            dataPriv.set(el, type, false);
            jQuery.event.add(el, type, {
              namespace: false,
              handler: function (event) {
                var notAsync,
                  result,
                  saved = dataPriv.get(this, type);

                if (event.isTrigger & 1 && this[type]) {
                  // Interrupt processing of the outer synthetic .trigger()ed event
                  // Saved data should be false in such cases, but might be a leftover capture object
                  // from an async native handler (gh-4350)
                  if (!saved.length) {
                    // Store arguments for use when handling the inner native event
                    // There will always be at least one argument (an event object), so this array
                    // will not be confused with a leftover capture object.
                    saved = slice.call(arguments);
                    dataPriv.set(this, type, saved);

                    // Trigger the native event and capture its result
                    // Support: IE <=9 - 11+
                    // focus() and blur() are asynchronous
                    notAsync = expectSync(this, type);
                    this[type]();
                    result = dataPriv.get(this, type);
                    if (saved !== result || notAsync) {
                      dataPriv.set(this, type, false);
                    } else {
                      result = {};
                    }
                    if (saved !== result) {
                      // Cancel the outer synthetic event
                      event.stopImmediatePropagation();
                      event.preventDefault();

                      // Support: Chrome 86+
                      // In Chrome, if an element having a focusout handler is blurred by
                      // clicking outside of it, it invokes the handler synchronously. If
                      // that handler calls `.remove()` on the element, the data is cleared,
                      // leaving `result` undefined. We need to guard against this.
                      return result && result.value;
                    }

                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering the
                    // native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                  } else if ((jQuery.event.special[type] || {}).delegateType) {
                    event.stopPropagation();
                  }

                  // If this is a native event triggered above, everything is now in order
                  // Fire an inner synthetic event with the original arguments
                } else if (saved.length) {
                  // ...and capture the result
                  dataPriv.set(this, type, {
                    value: jQuery.event.trigger(
                      // Support: IE <=9 - 11+
                      // Extend with the prototype to reset the above stopImmediatePropagation()
                      jQuery.extend(saved[0], jQuery.Event.prototype),
                      saved.slice(1),
                      this
                    ),
                  });

                  // Abort handling of the native event
                  event.stopImmediatePropagation();
                }
              },
            });
          }

          jQuery.removeEvent = function (elem, type, handle) {
            // This "if" is needed for plain objects
            if (elem.removeEventListener) {
              elem.removeEventListener(type, handle);
            }
          };

          jQuery.Event = function (src, props) {
            // Allow instantiation without the 'new' keyword
            if (!(this instanceof jQuery.Event)) {
              return new jQuery.Event(src, props);
            }

            // Event object
            if (src && src.type) {
              this.originalEvent = src;
              this.type = src.type;

              // Events bubbling up the document may have been marked as prevented
              // by a handler lower down the tree; reflect the correct value.
              this.isDefaultPrevented =
                src.defaultPrevented ||
                (src.defaultPrevented === undefined &&
                  // Support: Android <=2.3 only
                  src.returnValue === false)
                  ? returnTrue
                  : returnFalse;

              // Create target properties
              // Support: Safari <=6 - 7 only
              // Target should not be a text node (#504, #13143)
              this.target =
                src.target && src.target.nodeType === 3
                  ? src.target.parentNode
                  : src.target;

              this.currentTarget = src.currentTarget;
              this.relatedTarget = src.relatedTarget;

              // Event type
            } else {
              this.type = src;
            }

            // Put explicitly provided properties onto the event object
            if (props) {
              jQuery.extend(this, props);
            }

            // Create a timestamp if incoming event doesn't have one
            this.timeStamp = (src && src.timeStamp) || Date.now();

            // Mark it as fixed
            this[jQuery.expando] = true;
          };

          // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
          // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
          jQuery.Event.prototype = {
            constructor: jQuery.Event,
            isDefaultPrevented: returnFalse,
            isPropagationStopped: returnFalse,
            isImmediatePropagationStopped: returnFalse,
            isSimulated: false,

            preventDefault: function () {
              var e = this.originalEvent;

              this.isDefaultPrevented = returnTrue;

              if (e && !this.isSimulated) {
                e.preventDefault();
              }
            },
            stopPropagation: function () {
              var e = this.originalEvent;

              this.isPropagationStopped = returnTrue;

              if (e && !this.isSimulated) {
                e.stopPropagation();
              }
            },
            stopImmediatePropagation: function () {
              var e = this.originalEvent;

              this.isImmediatePropagationStopped = returnTrue;

              if (e && !this.isSimulated) {
                e.stopImmediatePropagation();
              }

              this.stopPropagation();
            },
          };

          // Includes all common event props including KeyEvent and MouseEvent specific props
          jQuery.each(
            {
              altKey: true,
              bubbles: true,
              cancelable: true,
              changedTouches: true,
              ctrlKey: true,
              detail: true,
              eventPhase: true,
              metaKey: true,
              pageX: true,
              pageY: true,
              shiftKey: true,
              view: true,
              char: true,
              code: true,
              charCode: true,
              key: true,
              keyCode: true,
              button: true,
              buttons: true,
              clientX: true,
              clientY: true,
              offsetX: true,
              offsetY: true,
              pointerId: true,
              pointerType: true,
              screenX: true,
              screenY: true,
              targetTouches: true,
              toElement: true,
              touches: true,
              which: true,
            },
            jQuery.event.addProp
          );

          jQuery.each(
            { focus: "focusin", blur: "focusout" },
            function (type, delegateType) {
              jQuery.event.special[type] = {
                // Utilize native event if possible so blur/focus sequence is correct
                setup: function () {
                  // Claim the first handler
                  // dataPriv.set( this, "focus", ... )
                  // dataPriv.set( this, "blur", ... )
                  leverageNative(this, type, expectSync);

                  // Return false to allow normal processing in the caller
                  return false;
                },
                trigger: function () {
                  // Force setup before trigger
                  leverageNative(this, type);

                  // Return non-false to allow normal event-path propagation
                  return true;
                },

                // Suppress native focus or blur as it's already being fired
                // in leverageNative.
                _default: function () {
                  return true;
                },

                delegateType: delegateType,
              };
            }
          );

          // Create mouseenter/leave events using mouseover/out and event-time checks
          // so that event delegation works in jQuery.
          // Do the same for pointerenter/pointerleave and pointerover/pointerout
          //
          // Support: Safari 7 only
          // Safari sends mouseenter too often; see:
          // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
          // for the description of the bug (it existed in older Chrome versions as well).
          jQuery.each(
            {
              mouseenter: "mouseover",
              mouseleave: "mouseout",
              pointerenter: "pointerover",
              pointerleave: "pointerout",
            },
            function (orig, fix) {
              jQuery.event.special[orig] = {
                delegateType: fix,
                bindType: fix,

                handle: function (event) {
                  var ret,
                    target = this,
                    related = event.relatedTarget,
                    handleObj = event.handleObj;

                  // For mouseenter/leave call the handler if related is outside the target.
                  // NB: No relatedTarget if the mouse left/entered the browser window
                  if (
                    !related ||
                    (related !== target && !jQuery.contains(target, related))
                  ) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                  }
                  return ret;
                },
              };
            }
          );

          jQuery.fn.extend({
            on: function (types, selector, data, fn) {
              return on(this, types, selector, data, fn);
            },
            one: function (types, selector, data, fn) {
              return on(this, types, selector, data, fn, 1);
            },
            off: function (types, selector, fn) {
              var handleObj, type;
              if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(
                  handleObj.namespace
                    ? handleObj.origType + "." + handleObj.namespace
                    : handleObj.origType,
                  handleObj.selector,
                  handleObj.handler
                );
                return this;
              }
              if (typeof types === "object") {
                // ( types-object [, selector] )
                for (type in types) {
                  this.off(type, selector, types[type]);
                }
                return this;
              }
              if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
              }
              if (fn === false) {
                fn = returnFalse;
              }
              return this.each(function () {
                jQuery.event.remove(this, types, fn, selector);
              });
            },
          });

          var // Support: IE <=10 - 11, Edge 12 - 13 only
            // In IE/Edge using regex groups here causes severe slowdowns.
            // See https://connect.microsoft.com/IE/feedback/details/1736512/
            rnoInnerhtml = /<script|<style|<link/i,
            // checked="checked" or checked
            rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
            rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

          // Prefer a tbody over its parent table for containing new rows
          function manipulationTarget(elem, content) {
            if (
              nodeName(elem, "table") &&
              nodeName(
                content.nodeType !== 11 ? content : content.firstChild,
                "tr"
              )
            ) {
              return jQuery(elem).children("tbody")[0] || elem;
            }

            return elem;
          }

          // Replace/restore the type attribute of script elements for safe DOM manipulation
          function disableScript(elem) {
            elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
            return elem;
          }
          function restoreScript(elem) {
            if ((elem.type || "").slice(0, 5) === "true/") {
              elem.type = elem.type.slice(5);
            } else {
              elem.removeAttribute("type");
            }

            return elem;
          }

          function cloneCopyEvent(src, dest) {
            var i, l, type, pdataOld, udataOld, udataCur, events;

            if (dest.nodeType !== 1) {
              return;
            }

            // 1. Copy private data: events, handlers, etc.
            if (dataPriv.hasData(src)) {
              pdataOld = dataPriv.get(src);
              events = pdataOld.events;

              if (events) {
                dataPriv.remove(dest, "handle events");

                for (type in events) {
                  for (i = 0, l = events[type].length; i < l; i++) {
                    jQuery.event.add(dest, type, events[type][i]);
                  }
                }
              }
            }

            // 2. Copy user data
            if (dataUser.hasData(src)) {
              udataOld = dataUser.access(src);
              udataCur = jQuery.extend({}, udataOld);

              dataUser.set(dest, udataCur);
            }
          }

          // Fix IE bugs, see support tests
          function fixInput(src, dest) {
            var nodeName = dest.nodeName.toLowerCase();

            // Fails to persist the checked state of a cloned checkbox or radio button.
            if (nodeName === "input" && rcheckableType.test(src.type)) {
              dest.checked = src.checked;

              // Fails to return the selected option to the default selected state when cloning options
            } else if (nodeName === "input" || nodeName === "textarea") {
              dest.defaultValue = src.defaultValue;
            }
          }

          function domManip(collection, args, callback, ignored) {
            // Flatten any nested arrays
            args = flat(args);

            var fragment,
              first,
              scripts,
              hasScripts,
              node,
              doc,
              i = 0,
              l = collection.length,
              iNoClone = l - 1,
              value = args[0],
              valueIsFunction = isFunction(value);

            // We can't cloneNode fragments that contain checked, in WebKit
            if (
              valueIsFunction ||
              (l > 1 &&
                typeof value === "string" &&
                !support.checkClone &&
                rchecked.test(value))
            ) {
              return collection.each(function (index) {
                var self = collection.eq(index);
                if (valueIsFunction) {
                  args[0] = value.call(this, index, self.html());
                }
                domManip(self, args, callback, ignored);
              });
            }

            if (l) {
              fragment = buildFragment(
                args,
                collection[0].ownerDocument,
                false,
                collection,
                ignored
              );
              first = fragment.firstChild;

              if (fragment.childNodes.length === 1) {
                fragment = first;
              }

              // Require either new content or an interest in ignored elements to invoke the callback
              if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;

                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (#8070).
                for (; i < l; i++) {
                  node = fragment;

                  if (i !== iNoClone) {
                    node = jQuery.clone(node, true, true);

                    // Keep references to cloned scripts for later restoration
                    if (hasScripts) {
                      // Support: Android <=4.0 only, PhantomJS 1 only
                      // push.apply(_, arraylike) throws on ancient WebKit
                      jQuery.merge(scripts, getAll(node, "script"));
                    }
                  }

                  callback.call(collection[i], node, i);
                }

                if (hasScripts) {
                  doc = scripts[scripts.length - 1].ownerDocument;

                  // Reenable scripts
                  jQuery.map(scripts, restoreScript);

                  // Evaluate executable scripts on first document insertion
                  for (i = 0; i < hasScripts; i++) {
                    node = scripts[i];
                    if (
                      rscriptType.test(node.type || "") &&
                      !dataPriv.access(node, "globalEval") &&
                      jQuery.contains(doc, node)
                    ) {
                      if (
                        node.src &&
                        (node.type || "").toLowerCase() !== "module"
                      ) {
                        // Optional AJAX dependency, but won't run scripts if not present
                        if (jQuery._evalUrl && !node.noModule) {
                          jQuery._evalUrl(
                            node.src,
                            {
                              nonce: node.nonce || node.getAttribute("nonce"),
                            },
                            doc
                          );
                        }
                      } else {
                        DOMEval(
                          node.textContent.replace(rcleanScript, ""),
                          node,
                          doc
                        );
                      }
                    }
                  }
                }
              }
            }

            return collection;
          }

          function remove(elem, selector, keepData) {
            var node,
              nodes = selector ? jQuery.filter(selector, elem) : elem,
              i = 0;

            for (; (node = nodes[i]) != null; i++) {
              if (!keepData && node.nodeType === 1) {
                jQuery.cleanData(getAll(node));
              }

              if (node.parentNode) {
                if (keepData && isAttached(node)) {
                  setGlobalEval(getAll(node, "script"));
                }
                node.parentNode.removeChild(node);
              }
            }

            return elem;
          }

          jQuery.extend({
            htmlPrefilter: function (html) {
              return html;
            },

            clone: function (elem, dataAndEvents, deepDataAndEvents) {
              var i,
                l,
                srcElements,
                destElements,
                clone = elem.cloneNode(true),
                inPage = isAttached(elem);

              // Fix IE cloning issues
              if (
                !support.noCloneChecked &&
                (elem.nodeType === 1 || elem.nodeType === 11) &&
                !jQuery.isXMLDoc(elem)
              ) {
                // We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);

                for (i = 0, l = srcElements.length; i < l; i++) {
                  fixInput(srcElements[i], destElements[i]);
                }
              }

              // Copy the events from the original to the clone
              if (dataAndEvents) {
                if (deepDataAndEvents) {
                  srcElements = srcElements || getAll(elem);
                  destElements = destElements || getAll(clone);

                  for (i = 0, l = srcElements.length; i < l; i++) {
                    cloneCopyEvent(srcElements[i], destElements[i]);
                  }
                } else {
                  cloneCopyEvent(elem, clone);
                }
              }

              // Preserve script evaluation history
              destElements = getAll(clone, "script");
              if (destElements.length > 0) {
                setGlobalEval(destElements, !inPage && getAll(elem, "script"));
              }

              // Return the cloned set
              return clone;
            },

            cleanData: function (elems) {
              var data,
                elem,
                type,
                special = jQuery.event.special,
                i = 0;

              for (; (elem = elems[i]) !== undefined; i++) {
                if (acceptData(elem)) {
                  if ((data = elem[dataPriv.expando])) {
                    if (data.events) {
                      for (type in data.events) {
                        if (special[type]) {
                          jQuery.event.remove(elem, type);

                          // This is a shortcut to avoid jQuery.event.remove's overhead
                        } else {
                          jQuery.removeEvent(elem, type, data.handle);
                        }
                      }
                    }

                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                  }
                  if (elem[dataUser.expando]) {
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataUser.expando] = undefined;
                  }
                }
              }
            },
          });

          jQuery.fn.extend({
            detach: function (selector) {
              return remove(this, selector, true);
            },

            remove: function (selector) {
              return remove(this, selector);
            },

            text: function (value) {
              return access(
                this,
                function (value) {
                  return value === undefined
                    ? jQuery.text(this)
                    : this.empty().each(function () {
                        if (
                          this.nodeType === 1 ||
                          this.nodeType === 11 ||
                          this.nodeType === 9
                        ) {
                          this.textContent = value;
                        }
                      });
                },
                null,
                value,
                arguments.length
              );
            },

            append: function () {
              return domManip(this, arguments, function (elem) {
                if (
                  this.nodeType === 1 ||
                  this.nodeType === 11 ||
                  this.nodeType === 9
                ) {
                  var target = manipulationTarget(this, elem);
                  target.appendChild(elem);
                }
              });
            },

            prepend: function () {
              return domManip(this, arguments, function (elem) {
                if (
                  this.nodeType === 1 ||
                  this.nodeType === 11 ||
                  this.nodeType === 9
                ) {
                  var target = manipulationTarget(this, elem);
                  target.insertBefore(elem, target.firstChild);
                }
              });
            },

            before: function () {
              return domManip(this, arguments, function (elem) {
                if (this.parentNode) {
                  this.parentNode.insertBefore(elem, this);
                }
              });
            },

            after: function () {
              return domManip(this, arguments, function (elem) {
                if (this.parentNode) {
                  this.parentNode.insertBefore(elem, this.nextSibling);
                }
              });
            },

            empty: function () {
              var elem,
                i = 0;

              for (; (elem = this[i]) != null; i++) {
                if (elem.nodeType === 1) {
                  // Prevent memory leaks
                  jQuery.cleanData(getAll(elem, false));

                  // Remove any remaining nodes
                  elem.textContent = "";
                }
              }

              return this;
            },

            clone: function (dataAndEvents, deepDataAndEvents) {
              dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
              deepDataAndEvents =
                deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

              return this.map(function () {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
              });
            },

            html: function (value) {
              return access(
                this,
                function (value) {
                  var elem = this[0] || {},
                    i = 0,
                    l = this.length;

                  if (value === undefined && elem.nodeType === 1) {
                    return elem.innerHTML;
                  }

                  // See if we can take a shortcut and just use innerHTML
                  if (
                    typeof value === "string" &&
                    !rnoInnerhtml.test(value) &&
                    !wrapMap[(rtagName.exec(value) || ["", ""])[1].toLowerCase()]
                  ) {
                    value = jQuery.htmlPrefilter(value);

                    try {
                      for (; i < l; i++) {
                        elem = this[i] || {};

                        // Remove element nodes and prevent memory leaks
                        if (elem.nodeType === 1) {
                          jQuery.cleanData(getAll(elem, false));
                          elem.innerHTML = value;
                        }
                      }

                      elem = 0;

                      // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                  }

                  if (elem) {
                    this.empty().append(value);
                  }
                },
                null,
                value,
                arguments.length
              );
            },

            replaceWith: function () {
              var ignored = [];

              // Make the changes, replacing each non-ignored context element with the new content
              return domManip(
                this,
                arguments,
                function (elem) {
                  var parent = this.parentNode;

                  if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) {
                      parent.replaceChild(elem, this);
                    }
                  }

                  // Force callback invocation
                },
                ignored
              );
            },
          });

          jQuery.each(
            {
              appendTo: "append",
              prependTo: "prepend",
              insertBefore: "before",
              insertAfter: "after",
              replaceAll: "replaceWith",
            },
            function (name, original) {
              jQuery.fn[name] = function (selector) {
                var elems,
                  ret = [],
                  insert = jQuery(selector),
                  last = insert.length - 1,
                  i = 0;

                for (; i <= last; i++) {
                  elems = i === last ? this : this.clone(true);
                  jQuery(insert[i])[original](elems);

                  // Support: Android <=4.0 only, PhantomJS 1 only
                  // .get() because push.apply(_, arraylike) throws on ancient WebKit
                  push.apply(ret, elems.get());
                }

                return this.pushStack(ret);
              };
            }
          );
          var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");

          var getStyles = function (elem) {
            // Support: IE <=11 only, Firefox <=30 (#15098, #14150)
            // IE throws on elements created in popups
            // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
            var view = elem.ownerDocument.defaultView;

            if (!view || !view.opener) {
              view = window;
            }

            return view.getComputedStyle(elem);
          };

          var swap = function (elem, options, callback) {
            var ret,
              name,
              old = {};

            // Remember the old values, and insert the new ones
            for (name in options) {
              old[name] = elem.style[name];
              elem.style[name] = options[name];
            }

            ret = callback.call(elem);

            // Revert the old values
            for (name in options) {
              elem.style[name] = old[name];
            }

            return ret;
          };

          var rboxStyle = new RegExp(cssExpand.join("|"), "i");

          (function () {
            // Executing both pixelPosition & boxSizingReliable tests require only one layout
            // so they're executed at the same time to save the second computation.
            function computeStyleTests() {
              // This is a singleton, we need to execute it only once
              if (!div) {
                return;
              }

              container.style.cssText =
                "position:absolute;left:-11111px;width:60px;" +
                "margin-top:1px;padding:0;border:0";
              div.style.cssText =
                "position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
                "margin:auto;border:1px;padding:1px;" +
                "width:60%;top:1%";
              documentElement.appendChild(container).appendChild(div);

              var divStyle = window.getComputedStyle(div);
              pixelPositionVal = divStyle.top !== "1%";

              // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
              reliableMarginLeftVal =
                roundPixelMeasures(divStyle.marginLeft) === 12;

              // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
              // Some styles come back with percentage values, even though they shouldn't
              div.style.right = "60%";
              pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;

              // Support: IE 9 - 11 only
              // Detect misreporting of content dimensions for box-sizing:border-box elements
              boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;

              // Support: IE 9 only
              // Detect overflow:scroll screwiness (gh-3699)
              // Support: Chrome <=64
              // Don't get tricked when zoom affects offsetWidth (gh-4029)
              div.style.position = "absolute";
              scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;

              documentElement.removeChild(container);

              // Nullify the div so it wouldn't be stored in the memory and
              // it will also be a sign that checks already performed
              div = null;
            }

            function roundPixelMeasures(measure) {
              return Math.round(parseFloat(measure));
            }

            var pixelPositionVal,
              boxSizingReliableVal,
              scrollboxSizeVal,
              pixelBoxStylesVal,
              reliableTrDimensionsVal,
              reliableMarginLeftVal,
              container = document.createElement("div"),
              div = document.createElement("div");

            // Finish early in limited (non-browser) environments
            if (!div.style) {
              return;
            }

            // Support: IE <=9 - 11 only
            // Style of cloned element affects source element cloned (#8908)
            div.style.backgroundClip = "content-box";
            div.cloneNode(true).style.backgroundClip = "";
            support.clearCloneStyle = div.style.backgroundClip === "content-box";

            jQuery.extend(support, {
              boxSizingReliable: function () {
                computeStyleTests();
                return boxSizingReliableVal;
              },
              pixelBoxStyles: function () {
                computeStyleTests();
                return pixelBoxStylesVal;
              },
              pixelPosition: function () {
                computeStyleTests();
                return pixelPositionVal;
              },
              reliableMarginLeft: function () {
                computeStyleTests();
                return reliableMarginLeftVal;
              },
              scrollboxSize: function () {
                computeStyleTests();
                return scrollboxSizeVal;
              },

              // Support: IE 9 - 11+, Edge 15 - 18+
              // IE/Edge misreport `getComputedStyle` of table rows with width/height
              // set in CSS while `offset*` properties report correct values.
              // Behavior in IE 9 is more subtle than in newer versions & it passes
              // some versions of this test; make sure not to make it pass there!
              //
              // Support: Firefox 70+
              // Only Firefox includes border widths
              // in computed dimensions. (gh-4529)
              reliableTrDimensions: function () {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                  table = document.createElement("table");
                  tr = document.createElement("tr");
                  trChild = document.createElement("div");

                  table.style.cssText =
                    "position:absolute;left:-11111px;border-collapse:separate";
                  tr.style.cssText = "border:1px solid";

                  // Support: Chrome 86+
                  // Height set through cssText does not get applied.
                  // Computed height then comes back as 0.
                  tr.style.height = "1px";
                  trChild.style.height = "9px";

                  // Support: Android 8 Chrome 86+
                  // In our bodyBackground.html iframe,
                  // display for all div elements is set to "inline",
                  // which causes a problem only in Android 8 Chrome 86.
                  // Ensuring the div is display: block
                  // gets around this issue.
                  trChild.style.display = "block";

                  documentElement
                    .appendChild(table)
                    .appendChild(tr)
                    .appendChild(trChild);

                  trStyle = window.getComputedStyle(tr);
                  reliableTrDimensionsVal =
                    parseInt(trStyle.height, 10) +
                      parseInt(trStyle.borderTopWidth, 10) +
                      parseInt(trStyle.borderBottomWidth, 10) ===
                    tr.offsetHeight;

                  documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
              },
            });
          })();

          function curCSS(elem, name, computed) {
            var width,
              minWidth,
              maxWidth,
              ret,
              // Support: Firefox 51+
              // Retrieving style before computed somehow
              // fixes an issue with getting wrong values
              // on detached elements
              style = elem.style;

            computed = computed || getStyles(elem);

            // getPropertyValue is needed for:
            //   .css('filter') (IE 9 only, #12537)
            //   .css('--customProperty) (#3144)
            if (computed) {
              ret = computed.getPropertyValue(name) || computed[name];

              if (ret === "" && !isAttached(elem)) {
                ret = jQuery.style(elem, name);
              }

              // A tribute to the "awesome hack by Dean Edwards"
              // Android Browser returns percentage for some values,
              // but width seems to be reliably pixels.
              // This is against the CSSOM draft spec:
              // https://drafts.csswg.org/cssom/#resolved-values
              if (
                !support.pixelBoxStyles() &&
                rnumnonpx.test(ret) &&
                rboxStyle.test(name)
              ) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;

                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;

                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
              }
            }

            return ret !== undefined
              ? // Support: IE <=9 - 11 only
                // IE returns zIndex value as an integer.
                ret + ""
              : ret;
          }

          function addGetHookIf(conditionFn, hookFn) {
            // Define the hook, we'll check on the first run if it's really needed.
            return {
              get: function () {
                if (conditionFn()) {
                  // Hook not needed (or it's not possible to use it due
                  // to missing dependency), remove it.
                  delete this.get;
                  return;
                }

                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
              },
            };
          }

          var cssPrefixes = ["Webkit", "Moz", "ms"],
            emptyStyle = document.createElement("div").style,
            vendorProps = {};

          // Return a vendor-prefixed property or undefined
          function vendorPropName(name) {
            // Check for vendor prefixed names
            var capName = name[0].toUpperCase() + name.slice(1),
              i = cssPrefixes.length;

            while (i--) {
              name = cssPrefixes[i] + capName;
              if (name in emptyStyle) {
                return name;
              }
            }
          }

          // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
          function finalPropName(name) {
            var final = jQuery.cssProps[name] || vendorProps[name];

            if (final) {
              return final;
            }
            if (name in emptyStyle) {
              return name;
            }
            return (vendorProps[name] = vendorPropName(name) || name);
          }

          var // Swappable if display is none or starts with table
            // except "table", "table-cell", or "table-caption"
            // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
            rdisplayswap = /^(none|table(?!-c[ea]).+)/,
            rcustomProp = /^--/,
            cssShow = {
              position: "absolute",
              visibility: "hidden",
              display: "block",
            },
            cssNormalTransform = {
              letterSpacing: "0",
              fontWeight: "400",
            };

          function setPositiveNumber(_elem, value, subtract) {
            // Any relative (+/-) values have already been
            // normalized at this point
            var matches = rcssNum.exec(value);
            return matches
              ? // Guard against undefined "subtract", e.g., when used as in cssHooks
                Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px")
              : value;
          }

          function boxModelAdjustment(
            elem,
            dimension,
            box,
            isBorderBox,
            styles,
            computedVal
          ) {
            var i = dimension === "width" ? 1 : 0,
              extra = 0,
              delta = 0;

            // Adjustment may not be necessary
            if (box === (isBorderBox ? "border" : "content")) {
              return 0;
            }

            for (; i < 4; i += 2) {
              // Both box models exclude margin
              if (box === "margin") {
                delta += jQuery.css(elem, box + cssExpand[i], true, styles);
              }

              // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
              if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);

                // For "border" or "margin", add border
                if (box !== "padding") {
                  delta += jQuery.css(
                    elem,
                    "border" + cssExpand[i] + "Width",
                    true,
                    styles
                  );

                  // But still keep track of it otherwise
                } else {
                  extra += jQuery.css(
                    elem,
                    "border" + cssExpand[i] + "Width",
                    true,
                    styles
                  );
                }

                // If we get here with a border-box (content + padding + border), we're seeking "content" or
                // "padding" or "margin"
              } else {
                // For "content", subtract padding
                if (box === "content") {
                  delta -= jQuery.css(
                    elem,
                    "padding" + cssExpand[i],
                    true,
                    styles
                  );
                }

                // For "content" or "padding", subtract border
                if (box !== "margin") {
                  delta -= jQuery.css(
                    elem,
                    "border" + cssExpand[i] + "Width",
                    true,
                    styles
                  );
                }
              }
            }

            // Account for positive content-box scroll gutter when requested by providing computedVal
            if (!isBorderBox && computedVal >= 0) {
              // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
              // Assuming integer scroll gutter, subtract the rest and round down
              delta +=
                Math.max(
                  0,
                  Math.ceil(
                    elem[
                      "offset" + dimension[0].toUpperCase() + dimension.slice(1)
                    ] -
                      computedVal -
                      delta -
                      extra -
                      0.5

                    // If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
                    // Use an explicit zero to avoid NaN (gh-3964)
                  )
                ) || 0;
            }

            return delta;
          }

          function getWidthOrHeight(elem, dimension, extra) {
            // Start with computed style
            var styles = getStyles(elem),
              // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
              // Fake content-box until we know it's needed to know the true value.
              boxSizingNeeded = !support.boxSizingReliable() || extra,
              isBorderBox =
                boxSizingNeeded &&
                jQuery.css(elem, "boxSizing", false, styles) === "border-box",
              valueIsBorderBox = isBorderBox,
              val = curCSS(elem, dimension, styles),
              offsetProp =
                "offset" + dimension[0].toUpperCase() + dimension.slice(1);

            // Support: Firefox <=54
            // Return a confounding non-pixel value or feign ignorance, as appropriate.
            if (rnumnonpx.test(val)) {
              if (!extra) {
                return val;
              }
              val = "auto";
            }

            // Support: IE 9 - 11 only
            // Use offsetWidth/offsetHeight for when box sizing is unreliable.
            // In those cases, the computed value can be trusted to be border-box.
            if (
              ((!support.boxSizingReliable() && isBorderBox) ||
                // Support: IE 10 - 11+, Edge 15 - 18+
                // IE/Edge misreport `getComputedStyle` of table rows with width/height
                // set in CSS while `offset*` properties report correct values.
                // Interestingly, in some cases IE 9 doesn't suffer from this issue.
                (!support.reliableTrDimensions() && nodeName(elem, "tr")) ||
                // Fall back to offsetWidth/offsetHeight when value is "auto"
                // This happens for inline elements with no explicit setting (gh-3571)
                val === "auto" ||
                // Support: Android <=4.1 - 4.3 only
                // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
                (!parseFloat(val) &&
                  jQuery.css(elem, "display", false, styles) === "inline")) &&
              // Make sure the element is visible & connected
              elem.getClientRects().length
            ) {
              isBorderBox =
                jQuery.css(elem, "boxSizing", false, styles) === "border-box";

              // Where available, offsetWidth/offsetHeight approximate border box dimensions.
              // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
              // retrieved value as a content box dimension.
              valueIsBorderBox = offsetProp in elem;
              if (valueIsBorderBox) {
                val = elem[offsetProp];
              }
            }

            // Normalize "" and auto
            val = parseFloat(val) || 0;

            // Adjust for the element's box model
            return (
              val +
              boxModelAdjustment(
                elem,
                dimension,
                extra || (isBorderBox ? "border" : "content"),
                valueIsBorderBox,
                styles,

                // Provide the current computed size to request scroll gutter calculation (gh-3589)
                val
              ) +
              "px"
            );
          }

          jQuery.extend({
            // Add in style property hooks for overriding the default
            // behavior of getting and setting a style property
            cssHooks: {
              opacity: {
                get: function (elem, computed) {
                  if (computed) {
                    // We should always get a number back from opacity
                    var ret = curCSS(elem, "opacity");
                    return ret === "" ? "1" : ret;
                  }
                },
              },
            },

            // Don't automatically add "px" to these possibly-unitless properties
            cssNumber: {
              animationIterationCount: true,
              columnCount: true,
              fillOpacity: true,
              flexGrow: true,
              flexShrink: true,
              fontWeight: true,
              gridArea: true,
              gridColumn: true,
              gridColumnEnd: true,
              gridColumnStart: true,
              gridRow: true,
              gridRowEnd: true,
              gridRowStart: true,
              lineHeight: true,
              opacity: true,
              order: true,
              orphans: true,
              widows: true,
              zIndex: true,
              zoom: true,
            },

            // Add in properties whose names you wish to fix before
            // setting or getting the value
            cssProps: {},

            // Get and set the style property on a DOM Node
            style: function (elem, name, value, extra) {
              // Don't set styles on text and comment nodes
              if (
                !elem ||
                elem.nodeType === 3 ||
                elem.nodeType === 8 ||
                !elem.style
              ) {
                return;
              }

              // Make sure that we're working with the right name
              var ret,
                type,
                hooks,
                origName = camelCase(name),
                isCustomProp = rcustomProp.test(name),
                style = elem.style;

              // Make sure that we're working with the right name. We don't
              // want to query the value if it is a CSS custom property
              // since they are user-defined.
              if (!isCustomProp) {
                name = finalPropName(origName);
              }

              // Gets hook for the prefixed version, then unprefixed version
              hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];

              // Check if we're setting a value
              if (value !== undefined) {
                type = typeof value;

                // Convert "+=" or "-=" to relative numbers (#7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                  value = adjustCSS(elem, name, ret);

                  // Fixes bug #9237
                  type = "number";
                }

                // Make sure that null and NaN values aren't set (#7116)
                if (value == null || value !== value) {
                  return;
                }

                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) {
                  value +=
                    (ret && ret[3]) || (jQuery.cssNumber[origName] ? "" : "px");
                }

                // background-* props affect original clone's values
                if (
                  !support.clearCloneStyle &&
                  value === "" &&
                  name.indexOf("background") === 0
                ) {
                  style[name] = "inherit";
                }

                // If a hook was provided, use that value, otherwise just set the specified value
                if (
                  !hooks ||
                  !("set" in hooks) ||
                  (value = hooks.set(elem, value, extra)) !== undefined
                ) {
                  if (isCustomProp) {
                    style.setProperty(name, value);
                  } else {
                    style[name] = value;
                  }
                }
              } else {
                // If a hook was provided get the non-computed value from there
                if (
                  hooks &&
                  "get" in hooks &&
                  (ret = hooks.get(elem, false, extra)) !== undefined
                ) {
                  return ret;
                }

                // Otherwise just get the value from the style object
                return style[name];
              }
            },

            css: function (elem, name, extra, styles) {
              var val,
                num,
                hooks,
                origName = camelCase(name),
                isCustomProp = rcustomProp.test(name);

              // Make sure that we're working with the right name. We don't
              // want to modify the value if it is a CSS custom property
              // since they are user-defined.
              if (!isCustomProp) {
                name = finalPropName(origName);
              }

              // Try prefixed name followed by the unprefixed name
              hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];

              // If a hook was provided get the computed value from there
              if (hooks && "get" in hooks) {
                val = hooks.get(elem, true, extra);
              }

              // Otherwise, if a way to get the computed value exists, use that
              if (val === undefined) {
                val = curCSS(elem, name, styles);
              }

              // Convert "normal" to computed value
              if (val === "normal" && name in cssNormalTransform) {
                val = cssNormalTransform[name];
              }

              // Make numeric if forced or a qualifier was provided and val looks numeric
              if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
              }

              return val;
            },
          });

          jQuery.each(["height", "width"], function (_i, dimension) {
            jQuery.cssHooks[dimension] = {
              get: function (elem, computed, extra) {
                if (computed) {
                  // Certain elements can have dimension info if we invisibly show them
                  // but it must have a current display style that would benefit
                  return rdisplayswap.test(jQuery.css(elem, "display")) &&
                    // Support: Safari 8+
                    // Table columns in Safari have non-zero offsetWidth & zero
                    // getBoundingClientRect().width unless display is changed.
                    // Support: IE <=11 only
                    // Running getBoundingClientRect on a disconnected node
                    // in IE throws an error.
                    (!elem.getClientRects().length ||
                      !elem.getBoundingClientRect().width)
                    ? swap(elem, cssShow, function () {
                        return getWidthOrHeight(elem, dimension, extra);
                      })
                    : getWidthOrHeight(elem, dimension, extra);
                }
              },

              set: function (elem, value, extra) {
                var matches,
                  styles = getStyles(elem),
                  // Only read styles.position if the test has a chance to fail
                  // to avoid forcing a reflow.
                  scrollboxSizeBuggy =
                    !support.scrollboxSize() && styles.position === "absolute",
                  // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                  boxSizingNeeded = scrollboxSizeBuggy || extra,
                  isBorderBox =
                    boxSizingNeeded &&
                    jQuery.css(elem, "boxSizing", false, styles) === "border-box",
                  subtract = extra
                    ? boxModelAdjustment(
                        elem,
                        dimension,
                        extra,
                        isBorderBox,
                        styles
                      )
                    : 0;

                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) {
                  subtract -= Math.ceil(
                    elem[
                      "offset" + dimension[0].toUpperCase() + dimension.slice(1)
                    ] -
                      parseFloat(styles[dimension]) -
                      boxModelAdjustment(
                        elem,
                        dimension,
                        "border",
                        false,
                        styles
                      ) -
                      0.5
                  );
                }

                // Convert to pixels if value adjustment is needed
                if (
                  subtract &&
                  (matches = rcssNum.exec(value)) &&
                  (matches[3] || "px") !== "px"
                ) {
                  elem.style[dimension] = value;
                  value = jQuery.css(elem, dimension);
                }

                return setPositiveNumber(elem, value, subtract);
              },
            };
          });

          jQuery.cssHooks.marginLeft = addGetHookIf(
            support.reliableMarginLeft,
            function (elem, computed) {
              if (computed) {
                return (
                  (parseFloat(curCSS(elem, "marginLeft")) ||
                    elem.getBoundingClientRect().left -
                      swap(elem, { marginLeft: 0 }, function () {
                        return elem.getBoundingClientRect().left;
                      })) + "px"
                );
              }
            }
          );

          // These hooks are used by animate to expand properties
          jQuery.each(
            {
              margin: "",
              padding: "",
              border: "Width",
            },
            function (prefix, suffix) {
              jQuery.cssHooks[prefix + suffix] = {
                expand: function (value) {
                  var i = 0,
                    expanded = {},
                    // Assumes a single number if not a string
                    parts =
                      typeof value === "string" ? value.split(" ") : [value];

                  for (; i < 4; i++) {
                    expanded[prefix + cssExpand[i] + suffix] =
                      parts[i] || parts[i - 2] || parts[0];
                  }

                  return expanded;
                },
              };

              if (prefix !== "margin") {
                jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
              }
            }
          );

          jQuery.fn.extend({
            css: function (name, value) {
              return access(
                this,
                function (elem, name, value) {
                  var styles,
                    len,
                    map = {},
                    i = 0;

                  if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;

                    for (; i < len; i++) {
                      map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    }

                    return map;
                  }

                  return value !== undefined
                    ? jQuery.style(elem, name, value)
                    : jQuery.css(elem, name);
                },
                name,
                value,
                arguments.length > 1
              );
            },
          });

          function Tween(elem, options, prop, end, easing) {
            return new Tween.prototype.init(elem, options, prop, end, easing);
          }
          jQuery.Tween = Tween;

          Tween.prototype = {
            constructor: Tween,
            init: function (elem, options, prop, end, easing, unit) {
              this.elem = elem;
              this.prop = prop;
              this.easing = easing || jQuery.easing._default;
              this.options = options;
              this.start = this.now = this.cur();
              this.end = end;
              this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
            },
            cur: function () {
              var hooks = Tween.propHooks[this.prop];

              return hooks && hooks.get
                ? hooks.get(this)
                : Tween.propHooks._default.get(this);
            },
            run: function (percent) {
              var eased,
                hooks = Tween.propHooks[this.prop];

              if (this.options.duration) {
                this.pos = eased = jQuery.easing[this.easing](
                  percent,
                  this.options.duration * percent,
                  0,
                  1,
                  this.options.duration
                );
              } else {
                this.pos = eased = percent;
              }
              this.now = (this.end - this.start) * eased + this.start;

              if (this.options.step) {
                this.options.step.call(this.elem, this.now, this);
              }

              if (hooks && hooks.set) {
                hooks.set(this);
              } else {
                Tween.propHooks._default.set(this);
              }
              return this;
            },
          };

          Tween.prototype.init.prototype = Tween.prototype;

          Tween.propHooks = {
            _default: {
              get: function (tween) {
                var result;

                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (
                  tween.elem.nodeType !== 1 ||
                  (tween.elem[tween.prop] != null &&
                    tween.elem.style[tween.prop] == null)
                ) {
                  return tween.elem[tween.prop];
                }

                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");

                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
              },
              set: function (tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) {
                  jQuery.fx.step[tween.prop](tween);
                } else if (
                  tween.elem.nodeType === 1 &&
                  (jQuery.cssHooks[tween.prop] ||
                    tween.elem.style[finalPropName(tween.prop)] != null)
                ) {
                  jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                } else {
                  tween.elem[tween.prop] = tween.now;
                }
              },
            },
          };

          // Support: IE <=9 only
          // Panic based approach to setting things on disconnected nodes
          Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
            set: function (tween) {
              if (tween.elem.nodeType && tween.elem.parentNode) {
                tween.elem[tween.prop] = tween.now;
              }
            },
          };

          jQuery.easing = {
            linear: function (p) {
              return p;
            },
            swing: function (p) {
              return 0.5 - Math.cos(p * Math.PI) / 2;
            },
            _default: "swing",
          };

          jQuery.fx = Tween.prototype.init;

          // Back compat <1.8 extension point
          jQuery.fx.step = {};

          var fxNow,
            inProgress,
            rfxtypes = /^(?:toggle|show|hide)$/,
            rrun = /queueHooks$/;

          function schedule() {
            if (inProgress) {
              if (document.hidden === false && window.requestAnimationFrame) {
                window.requestAnimationFrame(schedule);
              } else {
                window.setTimeout(schedule, jQuery.fx.interval);
              }

              jQuery.fx.tick();
            }
          }

          // Animations created synchronously will run synchronously
          function createFxNow() {
            window.setTimeout(function () {
              fxNow = undefined;
            });
            return (fxNow = Date.now());
          }

          // Generate parameters to create a standard animation
          function genFx(type, includeWidth) {
            var which,
              i = 0,
              attrs = { height: type };

            // If we include width, step value is 1 to do all cssExpand values,
            // otherwise step value is 2 to skip over Left and Right
            includeWidth = includeWidth ? 1 : 0;
            for (; i < 4; i += 2 - includeWidth) {
              which = cssExpand[i];
              attrs["margin" + which] = attrs["padding" + which] = type;
            }

            if (includeWidth) {
              attrs.opacity = attrs.width = type;
            }

            return attrs;
          }

          function createTween(value, prop, animation) {
            var tween,
              collection = (Animation.tweeners[prop] || []).concat(
                Animation.tweeners["*"]
              ),
              index = 0,
              length = collection.length;
            for (; index < length; index++) {
              if ((tween = collection[index].call(animation, prop, value))) {
                // We're done with this property
                return tween;
              }
            }
          }

          function defaultPrefilter(elem, props, opts) {
            var prop,
              value,
              toggle,
              hooks,
              oldfire,
              propTween,
              restoreDisplay,
              display,
              isBox = "width" in props || "height" in props,
              anim = this,
              orig = {},
              style = elem.style,
              hidden = elem.nodeType && isHiddenWithinTree(elem),
              dataShow = dataPriv.get(elem, "fxshow");

            // Queue-skipping animations hijack the fx hooks
            if (!opts.queue) {
              hooks = jQuery._queueHooks(elem, "fx");
              if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function () {
                  if (!hooks.unqueued) {
                    oldfire();
                  }
                };
              }
              hooks.unqueued++;

              anim.always(function () {
                // Ensure the complete handler is called before this completes
                anim.always(function () {
                  hooks.unqueued--;
                  if (!jQuery.queue(elem, "fx").length) {
                    hooks.empty.fire();
                  }
                });
              });
            }

            // Detect show/hide animations
            for (prop in props) {
              value = props[prop];
              if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                  // Pretend to be hidden if this is a "show" and
                  // there is still data from a stopped show/hide
                  if (
                    value === "show" &&
                    dataShow &&
                    dataShow[prop] !== undefined
                  ) {
                    hidden = true;

                    // Ignore all other no-op show/hide data
                  } else {
                    continue;
                  }
                }
                orig[prop] =
                  (dataShow && dataShow[prop]) || jQuery.style(elem, prop);
              }
            }

            // Bail out if this is a no-op like .hide().hide()
            propTween = !jQuery.isEmptyObject(props);
            if (!propTween && jQuery.isEmptyObject(orig)) {
              return;
            }

            // Restrict "overflow" and "display" styles during box animations
            if (isBox && elem.nodeType === 1) {
              // Support: IE <=9 - 11, Edge 12 - 15
              // Record all 3 overflow attributes because IE does not infer the shorthand
              // from identically-valued overflowX and overflowY and Edge just mirrors
              // the overflowX value there.
              opts.overflow = [style.overflow, style.overflowX, style.overflowY];

              // Identify a display type, preferring old show/hide data over the CSS cascade
              restoreDisplay = dataShow && dataShow.display;
              if (restoreDisplay == null) {
                restoreDisplay = dataPriv.get(elem, "display");
              }
              display = jQuery.css(elem, "display");
              if (display === "none") {
                if (restoreDisplay) {
                  display = restoreDisplay;
                } else {
                  // Get nonempty value(s) by temporarily forcing visibility
                  showHide([elem], true);
                  restoreDisplay = elem.style.display || restoreDisplay;
                  display = jQuery.css(elem, "display");
                  showHide([elem]);
                }
              }

              // Animate inline elements as inline-block
              if (
                display === "inline" ||
                (display === "inline-block" && restoreDisplay != null)
              ) {
                if (jQuery.css(elem, "float") === "none") {
                  // Restore the original display value at the end of pure show/hide animations
                  if (!propTween) {
                    anim.done(function () {
                      style.display = restoreDisplay;
                    });
                    if (restoreDisplay == null) {
                      display = style.display;
                      restoreDisplay = display === "none" ? "" : display;
                    }
                  }
                  style.display = "inline-block";
                }
              }
            }

            if (opts.overflow) {
              style.overflow = "hidden";
              anim.always(function () {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
              });
            }

            // Implement show/hide animations
            propTween = false;
            for (prop in orig) {
              // General show/hide setup for this element animation
              if (!propTween) {
                if (dataShow) {
                  if ("hidden" in dataShow) {
                    hidden = dataShow.hidden;
                  }
                } else {
                  dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay,
                  });
                }

                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) {
                  dataShow.hidden = !hidden;
                }

                // Show elements before animating them
                if (hidden) {
                  showHide([elem], true);
                }

                /* eslint-disable no-loop-func */

                anim.done(function () {
                  /* eslint-enable no-loop-func */

                  // The final step of a "hide" animation is actually hiding the element
                  if (!hidden) {
                    showHide([elem]);
                  }
                  dataPriv.remove(elem, "fxshow");
                  for (prop in orig) {
                    jQuery.style(elem, prop, orig[prop]);
                  }
                });
              }

              // Per-property setup
              propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
              if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                  propTween.end = propTween.start;
                  propTween.start = 0;
                }
              }
            }
          }

          function propFilter(props, specialEasing) {
            var index, name, easing, value, hooks;

            // camelCase, specialEasing and expand cssHook pass
            for (index in props) {
              name = camelCase(index);
              easing = specialEasing[name];
              value = props[index];
              if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
              }

              if (index !== name) {
                props[name] = value;
                delete props[index];
              }

              hooks = jQuery.cssHooks[name];
              if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];

                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for (index in value) {
                  if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                  }
                }
              } else {
                specialEasing[name] = easing;
              }
            }
          }

          function Animation(elem, properties, options) {
            var result,
              stopped,
              index = 0,
              length = Animation.prefilters.length,
              deferred = jQuery.Deferred().always(function () {
                // Don't match elem in the :animated selector
                delete tick.elem;
              }),
              tick = function () {
                if (stopped) {
                  return false;
                }
                var currentTime = fxNow || createFxNow(),
                  remaining = Math.max(
                    0,
                    animation.startTime + animation.duration - currentTime
                  ),
                  // Support: Android 2.3 only
                  // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
                  temp = remaining / animation.duration || 0,
                  percent = 1 - temp,
                  index = 0,
                  length = animation.tweens.length;

                for (; index < length; index++) {
                  animation.tweens[index].run(percent);
                }

                deferred.notifyWith(elem, [animation, percent, remaining]);

                // If there's more to do, yield
                if (percent < 1 && length) {
                  return remaining;
                }

                // If this was an empty animation, synthesize a final progress notification
                if (!length) {
                  deferred.notifyWith(elem, [animation, 1, 0]);
                }

                // Resolve the animation and report its conclusion
                deferred.resolveWith(elem, [animation]);
                return false;
              },
              animation = deferred.promise({
                elem: elem,
                props: jQuery.extend({}, properties),
                opts: jQuery.extend(
                  true,
                  {
                    specialEasing: {},
                    easing: jQuery.easing._default,
                  },
                  options
                ),
                originalProperties: properties,
                originalOptions: options,
                startTime: fxNow || createFxNow(),
                duration: options.duration,
                tweens: [],
                createTween: function (prop, end) {
                  var tween = jQuery.Tween(
                    elem,
                    animation.opts,
                    prop,
                    end,
                    animation.opts.specialEasing[prop] || animation.opts.easing
                  );
                  animation.tweens.push(tween);
                  return tween;
                },
                stop: function (gotoEnd) {
                  var index = 0,
                    // If we are going to the end, we want to run all the tweens
                    // otherwise we skip this part
                    length = gotoEnd ? animation.tweens.length : 0;
                  if (stopped) {
                    return this;
                  }
                  stopped = true;
                  for (; index < length; index++) {
                    animation.tweens[index].run(1);
                  }

                  // Resolve when we played the last frame; otherwise, reject
                  if (gotoEnd) {
                    deferred.notifyWith(elem, [animation, 1, 0]);
                    deferred.resolveWith(elem, [animation, gotoEnd]);
                  } else {
                    deferred.rejectWith(elem, [animation, gotoEnd]);
                  }
                  return this;
                },
              }),
              props = animation.props;

            propFilter(props, animation.opts.specialEasing);

            for (; index < length; index++) {
              result = Animation.prefilters[index].call(
                animation,
                elem,
                props,
                animation.opts
              );
              if (result) {
                if (isFunction(result.stop)) {
                  jQuery._queueHooks(animation.elem, animation.opts.queue).stop =
                    result.stop.bind(result);
                }
                return result;
              }
            }

            jQuery.map(props, createTween, animation);

            if (isFunction(animation.opts.start)) {
              animation.opts.start.call(elem, animation);
            }

            // Attach callbacks from options
            animation
              .progress(animation.opts.progress)
              .done(animation.opts.done, animation.opts.complete)
              .fail(animation.opts.fail)
              .always(animation.opts.always);

            jQuery.fx.timer(
              jQuery.extend(tick, {
                elem: elem,
                anim: animation,
                queue: animation.opts.queue,
              })
            );

            return animation;
          }

          jQuery.Animation = jQuery.extend(Animation, {
            tweeners: {
              "*": [
                function (prop, value) {
                  var tween = this.createTween(prop, value);
                  adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                  return tween;
                },
              ],
            },

            tweener: function (props, callback) {
              if (isFunction(props)) {
                callback = props;
                props = ["*"];
              } else {
                props = props.match(rnothtmlwhite);
              }

              var prop,
                index = 0,
                length = props.length;

              for (; index < length; index++) {
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
              }
            },

            prefilters: [defaultPrefilter],

            prefilter: function (callback, prepend) {
              if (prepend) {
                Animation.prefilters.unshift(callback);
              } else {
                Animation.prefilters.push(callback);
              }
            },
          });

          jQuery.speed = function (speed, easing, fn) {
            var opt =
              speed && typeof speed === "object"
                ? jQuery.extend({}, speed)
                : {
                    complete:
                      fn || (!fn && easing) || (isFunction(speed) && speed),
                    duration: speed,
                    easing:
                      (fn && easing) || (easing && !isFunction(easing) && easing),
                  };

            // Go to the end state if fx are off
            if (jQuery.fx.off) {
              opt.duration = 0;
            } else {
              if (typeof opt.duration !== "number") {
                if (opt.duration in jQuery.fx.speeds) {
                  opt.duration = jQuery.fx.speeds[opt.duration];
                } else {
                  opt.duration = jQuery.fx.speeds._default;
                }
              }
            }

            // Normalize opt.queue - true/undefined/null -> "fx"
            if (opt.queue == null || opt.queue === true) {
              opt.queue = "fx";
            }

            // Queueing
            opt.old = opt.complete;

            opt.complete = function () {
              if (isFunction(opt.old)) {
                opt.old.call(this);
              }

              if (opt.queue) {
                jQuery.dequeue(this, opt.queue);
              }
            };

            return opt;
          };

          jQuery.fn.extend({
            fadeTo: function (speed, to, easing, callback) {
              // Show any hidden elements after setting opacity to 0
              return (
                this.filter(isHiddenWithinTree)
                  .css("opacity", 0)
                  .show()

                  // Animate to the value specified
                  .end()
                  .animate({ opacity: to }, speed, easing, callback)
              );
            },
            animate: function (prop, speed, easing, callback) {
              var empty = jQuery.isEmptyObject(prop),
                optall = jQuery.speed(speed, easing, callback),
                doAnimation = function () {
                  // Operate on a copy of prop so per-property easing won't be lost
                  var anim = Animation(this, jQuery.extend({}, prop), optall);

                  // Empty animations, or finishing resolves immediately
                  if (empty || dataPriv.get(this, "finish")) {
                    anim.stop(true);
                  }
                };

              doAnimation.finish = doAnimation;

              return empty || optall.queue === false
                ? this.each(doAnimation)
                : this.queue(optall.queue, doAnimation);
            },
            stop: function (type, clearQueue, gotoEnd) {
              var stopQueue = function (hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
              };

              if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
              }
              if (clearQueue) {
                this.queue(type || "fx", []);
              }

              return this.each(function () {
                var dequeue = true,
                  index = type != null && type + "queueHooks",
                  timers = jQuery.timers,
                  data = dataPriv.get(this);

                if (index) {
                  if (data[index] && data[index].stop) {
                    stopQueue(data[index]);
                  }
                } else {
                  for (index in data) {
                    if (data[index] && data[index].stop && rrun.test(index)) {
                      stopQueue(data[index]);
                    }
                  }
                }

                for (index = timers.length; index--; ) {
                  if (
                    timers[index].elem === this &&
                    (type == null || timers[index].queue === type)
                  ) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                  }
                }

                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) {
                  jQuery.dequeue(this, type);
                }
              });
            },
            finish: function (type) {
              if (type !== false) {
                type = type || "fx";
              }
              return this.each(function () {
                var index,
                  data = dataPriv.get(this),
                  queue = data[type + "queue"],
                  hooks = data[type + "queueHooks"],
                  timers = jQuery.timers,
                  length = queue ? queue.length : 0;

                // Enable finishing flag on private data
                data.finish = true;

                // Empty the queue first
                jQuery.queue(this, type, []);

                if (hooks && hooks.stop) {
                  hooks.stop.call(this, true);
                }

                // Look for any active animations, and finish them
                for (index = timers.length; index--; ) {
                  if (
                    timers[index].elem === this &&
                    timers[index].queue === type
                  ) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                  }
                }

                // Look for any animations in the old queue and finish them
                for (index = 0; index < length; index++) {
                  if (queue[index] && queue[index].finish) {
                    queue[index].finish.call(this);
                  }
                }

                // Turn off finishing flag
                delete data.finish;
              });
            },
          });

          jQuery.each(["toggle", "show", "hide"], function (_i, name) {
            var cssFn = jQuery.fn[name];
            jQuery.fn[name] = function (speed, easing, callback) {
              return speed == null || typeof speed === "boolean"
                ? cssFn.apply(this, arguments)
                : this.animate(genFx(name, true), speed, easing, callback);
            };
          });

          // Generate shortcuts for custom animations
          jQuery.each(
            {
              slideDown: genFx("show"),
              slideUp: genFx("hide"),
              slideToggle: genFx("toggle"),
              fadeIn: { opacity: "show" },
              fadeOut: { opacity: "hide" },
              fadeToggle: { opacity: "toggle" },
            },
            function (name, props) {
              jQuery.fn[name] = function (speed, easing, callback) {
                return this.animate(props, speed, easing, callback);
              };
            }
          );

          jQuery.timers = [];
          jQuery.fx.tick = function () {
            var timer,
              i = 0,
              timers = jQuery.timers;

            fxNow = Date.now();

            for (; i < timers.length; i++) {
              timer = timers[i];

              // Run the timer and safely remove it when done (allowing for external removal)
              if (!timer() && timers[i] === timer) {
                timers.splice(i--, 1);
              }
            }

            if (!timers.length) {
              jQuery.fx.stop();
            }
            fxNow = undefined;
          };

          jQuery.fx.timer = function (timer) {
            jQuery.timers.push(timer);
            jQuery.fx.start();
          };

          jQuery.fx.interval = 13;
          jQuery.fx.start = function () {
            if (inProgress) {
              return;
            }

            inProgress = true;
            schedule();
          };

          jQuery.fx.stop = function () {
            inProgress = null;
          };

          jQuery.fx.speeds = {
            slow: 600,
            fast: 200,

            // Default speed
            _default: 400,
          };

          // Based off of the plugin by Clint Helfers, with permission.
          // https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
          jQuery.fn.delay = function (time, type) {
            time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
            type = type || "fx";

            return this.queue(type, function (next, hooks) {
              var timeout = window.setTimeout(next, time);
              hooks.stop = function () {
                window.clearTimeout(timeout);
              };
            });
          };

          (function () {
            var input = document.createElement("input"),
              select = document.createElement("select"),
              opt = select.appendChild(document.createElement("option"));

            input.type = "checkbox";

            // Support: Android <=4.3 only
            // Default value for a checkbox should be "on"
            support.checkOn = input.value !== "";

            // Support: IE <=11 only
            // Must access selectedIndex to make default options select
            support.optSelected = opt.selected;

            // Support: IE <=11 only
            // An input loses its value after becoming a radio
            input = document.createElement("input");
            input.value = "t";
            input.type = "radio";
            support.radioValue = input.value === "t";
          })();

          var boolHook,
            attrHandle = jQuery.expr.attrHandle;

          jQuery.fn.extend({
            attr: function (name, value) {
              return access(this, jQuery.attr, name, value, arguments.length > 1);
            },

            removeAttr: function (name) {
              return this.each(function () {
                jQuery.removeAttr(this, name);
              });
            },
          });

          jQuery.extend({
            attr: function (elem, name, value) {
              var ret,
                hooks,
                nType = elem.nodeType;

              // Don't get/set attributes on text, comment and attribute nodes
              if (nType === 3 || nType === 8 || nType === 2) {
                return;
              }

              // Fallback to prop when attributes are not supported
              if (typeof elem.getAttribute === "undefined") {
                return jQuery.prop(elem, name, value);
              }

              // Attribute hooks are determined by the lowercase version
              // Grab necessary hook if one is defined
              if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                hooks =
                  jQuery.attrHooks[name.toLowerCase()] ||
                  (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
              }

              if (value !== undefined) {
                if (value === null) {
                  jQuery.removeAttr(elem, name);
                  return;
                }

                if (
                  hooks &&
                  "set" in hooks &&
                  (ret = hooks.set(elem, value, name)) !== undefined
                ) {
                  return ret;
                }

                elem.setAttribute(name, value + "");
                return value;
              }

              if (
                hooks &&
                "get" in hooks &&
                (ret = hooks.get(elem, name)) !== null
              ) {
                return ret;
              }

              ret = jQuery.find.attr(elem, name);

              // Non-existent attributes return null, we normalize to undefined
              return ret == null ? undefined : ret;
            },

            attrHooks: {
              type: {
                set: function (elem, value) {
                  if (
                    !support.radioValue &&
                    value === "radio" &&
                    nodeName(elem, "input")
                  ) {
                    var val = elem.value;
                    elem.setAttribute("type", value);
                    if (val) {
                      elem.value = val;
                    }
                    return value;
                  }
                },
              },
            },

            removeAttr: function (elem, value) {
              var name,
                i = 0,
                // Attribute names can contain non-HTML whitespace characters
                // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
                attrNames = value && value.match(rnothtmlwhite);

              if (attrNames && elem.nodeType === 1) {
                while ((name = attrNames[i++])) {
                  elem.removeAttribute(name);
                }
              }
            },
          });

          // Hooks for boolean attributes
          boolHook = {
            set: function (elem, value, name) {
              if (value === false) {
                // Remove boolean attributes when set to false
                jQuery.removeAttr(elem, name);
              } else {
                elem.setAttribute(name, name);
              }
              return name;
            },
          };

          jQuery.each(
            jQuery.expr.match.bool.source.match(/\w+/g),
            function (_i, name) {
              var getter = attrHandle[name] || jQuery.find.attr;

              attrHandle[name] = function (elem, name, isXML) {
                var ret,
                  handle,
                  lowercaseName = name.toLowerCase();

                if (!isXML) {
                  // Avoid an infinite loop by temporarily removing this function from the getter
                  handle = attrHandle[lowercaseName];
                  attrHandle[lowercaseName] = ret;
                  ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                  attrHandle[lowercaseName] = handle;
                }
                return ret;
              };
            }
          );

          var rfocusable = /^(?:input|select|textarea|button)$/i,
            rclickable = /^(?:a|area)$/i;

          jQuery.fn.extend({
            prop: function (name, value) {
              return access(this, jQuery.prop, name, value, arguments.length > 1);
            },

            removeProp: function (name) {
              return this.each(function () {
                delete this[jQuery.propFix[name] || name];
              });
            },
          });

          jQuery.extend({
            prop: function (elem, name, value) {
              var ret,
                hooks,
                nType = elem.nodeType;

              // Don't get/set properties on text, comment and attribute nodes
              if (nType === 3 || nType === 8 || nType === 2) {
                return;
              }

              if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
              }

              if (value !== undefined) {
                if (
                  hooks &&
                  "set" in hooks &&
                  (ret = hooks.set(elem, value, name)) !== undefined
                ) {
                  return ret;
                }

                return (elem[name] = value);
              }

              if (
                hooks &&
                "get" in hooks &&
                (ret = hooks.get(elem, name)) !== null
              ) {
                return ret;
              }

              return elem[name];
            },

            propHooks: {
              tabIndex: {
                get: function (elem) {
                  // Support: IE <=9 - 11 only
                  // elem.tabIndex doesn't always return the
                  // correct value when it hasn't been explicitly set
                  // https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
                  // Use proper attribute retrieval(#12072)
                  var tabindex = jQuery.find.attr(elem, "tabindex");

                  if (tabindex) {
                    return parseInt(tabindex, 10);
                  }

                  if (
                    rfocusable.test(elem.nodeName) ||
                    (rclickable.test(elem.nodeName) && elem.href)
                  ) {
                    return 0;
                  }

                  return -1;
                },
              },
            },

            propFix: {
              for: "htmlFor",
              class: "className",
            },
          });

          // Support: IE <=11 only
          // Accessing the selectedIndex property
          // forces the browser to respect setting selected
          // on the option
          // The getter ensures a default option is selected
          // when in an optgroup
          // eslint rule "no-unused-expressions" is disabled for this code
          // since it considers such accessions noop
          if (!support.optSelected) {
            jQuery.propHooks.selected = {
              get: function (elem) {
                /* eslint no-unused-expressions: "off" */

                var parent = elem.parentNode;
                if (parent && parent.parentNode) {
                  parent.parentNode.selectedIndex;
                }
                return null;
              },
              set: function (elem) {
                /* eslint no-unused-expressions: "off" */

                var parent = elem.parentNode;
                if (parent) {
                  parent.selectedIndex;

                  if (parent.parentNode) {
                    parent.parentNode.selectedIndex;
                  }
                }
              },
            };
          }

          jQuery.each(
            [
              "tabIndex",
              "readOnly",
              "maxLength",
              "cellSpacing",
              "cellPadding",
              "rowSpan",
              "colSpan",
              "useMap",
              "frameBorder",
              "contentEditable",
            ],
            function () {
              jQuery.propFix[this.toLowerCase()] = this;
            }
          );

          // Strip and collapse whitespace according to HTML spec
          // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
          function stripAndCollapse(value) {
            var tokens = value.match(rnothtmlwhite) || [];
            return tokens.join(" ");
          }

          function getClass(elem) {
            return (elem.getAttribute && elem.getAttribute("class")) || "";
          }

          function classesToArray(value) {
            if (Array.isArray(value)) {
              return value;
            }
            if (typeof value === "string") {
              return value.match(rnothtmlwhite) || [];
            }
            return [];
          }

          jQuery.fn.extend({
            addClass: function (value) {
              var classes,
                elem,
                cur,
                curValue,
                clazz,
                j,
                finalValue,
                i = 0;

              if (isFunction(value)) {
                return this.each(function (j) {
                  jQuery(this).addClass(value.call(this, j, getClass(this)));
                });
              }

              classes = classesToArray(value);

              if (classes.length) {
                while ((elem = this[i++])) {
                  curValue = getClass(elem);
                  cur =
                    elem.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";

                  if (cur) {
                    j = 0;
                    while ((clazz = classes[j++])) {
                      if (cur.indexOf(" " + clazz + " ") < 0) {
                        cur += clazz + " ";
                      }
                    }

                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) {
                      elem.setAttribute("class", finalValue);
                    }
                  }
                }
              }

              return this;
            },

            removeClass: function (value) {
              var classes,
                elem,
                cur,
                curValue,
                clazz,
                j,
                finalValue,
                i = 0;

              if (isFunction(value)) {
                return this.each(function (j) {
                  jQuery(this).removeClass(value.call(this, j, getClass(this)));
                });
              }

              if (!arguments.length) {
                return this.attr("class", "");
              }

              classes = classesToArray(value);

              if (classes.length) {
                while ((elem = this[i++])) {
                  curValue = getClass(elem);

                  // This expression is here for better compressibility (see addClass)
                  cur =
                    elem.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";

                  if (cur) {
                    j = 0;
                    while ((clazz = classes[j++])) {
                      // Remove *all* instances
                      while (cur.indexOf(" " + clazz + " ") > -1) {
                        cur = cur.replace(" " + clazz + " ", " ");
                      }
                    }

                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) {
                      elem.setAttribute("class", finalValue);
                    }
                  }
                }
              }

              return this;
            },

            toggleClass: function (value, stateVal) {
              var type = typeof value,
                isValidValue = type === "string" || Array.isArray(value);

              if (typeof stateVal === "boolean" && isValidValue) {
                return stateVal ? this.addClass(value) : this.removeClass(value);
              }

              if (isFunction(value)) {
                return this.each(function (i) {
                  jQuery(this).toggleClass(
                    value.call(this, i, getClass(this), stateVal),
                    stateVal
                  );
                });
              }

              return this.each(function () {
                var className, i, self, classNames;

                if (isValidValue) {
                  // Toggle individual class names
                  i = 0;
                  self = jQuery(this);
                  classNames = classesToArray(value);

                  while ((className = classNames[i++])) {
                    // Check each className given, space separated list
                    if (self.hasClass(className)) {
                      self.removeClass(className);
                    } else {
                      self.addClass(className);
                    }
                  }

                  // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                  className = getClass(this);
                  if (className) {
                    // Store className if set
                    dataPriv.set(this, "__className__", className);
                  }

                  // If the element has a class name or if we're passed `false`,
                  // then remove the whole classname (if there was one, the above saved it).
                  // Otherwise bring back whatever was previously saved (if anything),
                  // falling back to the empty string if nothing was stored.
                  if (this.setAttribute) {
                    this.setAttribute(
                      "class",
                      className || value === false
                        ? ""
                        : dataPriv.get(this, "__className__") || ""
                    );
                  }
                }
              });
            },

            hasClass: function (selector) {
              var className,
                elem,
                i = 0;

              className = " " + selector + " ";
              while ((elem = this[i++])) {
                if (
                  elem.nodeType === 1 &&
                  (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(
                    className
                  ) > -1
                ) {
                  return true;
                }
              }

              return false;
            },
          });

          var rreturn = /\r/g;

          jQuery.fn.extend({
            val: function (value) {
              var hooks,
                ret,
                valueIsFunction,
                elem = this[0];

              if (!arguments.length) {
                if (elem) {
                  hooks =
                    jQuery.valHooks[elem.type] ||
                    jQuery.valHooks[elem.nodeName.toLowerCase()];

                  if (
                    hooks &&
                    "get" in hooks &&
                    (ret = hooks.get(elem, "value")) !== undefined
                  ) {
                    return ret;
                  }

                  ret = elem.value;

                  // Handle most common string cases
                  if (typeof ret === "string") {
                    return ret.replace(rreturn, "");
                  }

                  // Handle cases where value is null/undef or number
                  return ret == null ? "" : ret;
                }

                return;
              }

              valueIsFunction = isFunction(value);

              return this.each(function (i) {
                var val;

                if (this.nodeType !== 1) {
                  return;
                }

                if (valueIsFunction) {
                  val = value.call(this, i, jQuery(this).val());
                } else {
                  val = value;
                }

                // Treat null/undefined as ""; convert numbers to string
                if (val == null) {
                  val = "";
                } else if (typeof val === "number") {
                  val += "";
                } else if (Array.isArray(val)) {
                  val = jQuery.map(val, function (value) {
                    return value == null ? "" : value + "";
                  });
                }

                hooks =
                  jQuery.valHooks[this.type] ||
                  jQuery.valHooks[this.nodeName.toLowerCase()];

                // If set returns undefined, fall back to normal setting
                if (
                  !hooks ||
                  !("set" in hooks) ||
                  hooks.set(this, val, "value") === undefined
                ) {
                  this.value = val;
                }
              });
            },
          });

          jQuery.extend({
            valHooks: {
              option: {
                get: function (elem) {
                  var val = jQuery.find.attr(elem, "value");
                  return val != null
                    ? val
                    : // Support: IE <=10 - 11 only
                      // option.text throws exceptions (#14686, #14858)
                      // Strip and collapse whitespace
                      // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                      stripAndCollapse(jQuery.text(elem));
                },
              },
              select: {
                get: function (elem) {
                  var value,
                    option,
                    i,
                    options = elem.options,
                    index = elem.selectedIndex,
                    one = elem.type === "select-one",
                    values = one ? null : [],
                    max = one ? index + 1 : options.length;

                  if (index < 0) {
                    i = max;
                  } else {
                    i = one ? index : 0;
                  }

                  // Loop through all the selected options
                  for (; i < max; i++) {
                    option = options[i];

                    // Support: IE <=9 only
                    // IE8-9 doesn't update selected after form reset (#2551)
                    if (
                      (option.selected || i === index) &&
                      // Don't return options that are disabled or in a disabled optgroup
                      !option.disabled &&
                      (!option.parentNode.disabled ||
                        !nodeName(option.parentNode, "optgroup"))
                    ) {
                      // Get the specific value for the option
                      value = jQuery(option).val();

                      // We don't need an array for one selects
                      if (one) {
                        return value;
                      }

                      // Multi-Selects return an array
                      values.push(value);
                    }
                  }

                  return values;
                },

                set: function (elem, value) {
                  var optionSet,
                    option,
                    options = elem.options,
                    values = jQuery.makeArray(value),
                    i = options.length;

                  while (i--) {
                    option = options[i];

                    /* eslint-disable no-cond-assign */

                    if (
                      (option.selected =
                        jQuery.inArray(
                          jQuery.valHooks.option.get(option),
                          values
                        ) > -1)
                    ) {
                      optionSet = true;
                    }

                    /* eslint-enable no-cond-assign */
                  }

                  // Force browsers to behave consistently when non-matching value is set
                  if (!optionSet) {
                    elem.selectedIndex = -1;
                  }
                  return values;
                },
              },
            },
          });

          // Radios and checkboxes getter/setter
          jQuery.each(["radio", "checkbox"], function () {
            jQuery.valHooks[this] = {
              set: function (elem, value) {
                if (Array.isArray(value)) {
                  return (elem.checked =
                    jQuery.inArray(jQuery(elem).val(), value) > -1);
                }
              },
            };
            if (!support.checkOn) {
              jQuery.valHooks[this].get = function (elem) {
                return elem.getAttribute("value") === null ? "on" : elem.value;
              };
            }
          });

          // Return jQuery for attributes-only inclusion

          support.focusin = "onfocusin" in window;

          var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
            stopPropagationCallback = function (e) {
              e.stopPropagation();
            };

          jQuery.extend(jQuery.event, {
            trigger: function (event, data, elem, onlyHandlers) {
              var i,
                cur,
                tmp,
                bubbleType,
                ontype,
                handle,
                special,
                lastElement,
                eventPath = [elem || document],
                type = hasOwn.call(event, "type") ? event.type : event,
                namespaces = hasOwn.call(event, "namespace")
                  ? event.namespace.split(".")
                  : [];

              cur = lastElement = tmp = elem = elem || document;

              // Don't do events on text and comment nodes
              if (elem.nodeType === 3 || elem.nodeType === 8) {
                return;
              }

              // focus/blur morphs to focusin/out; ensure we're not firing them right now
              if (rfocusMorph.test(type + jQuery.event.triggered)) {
                return;
              }

              if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
              }
              ontype = type.indexOf(":") < 0 && "on" + type;

              // Caller can pass in a jQuery.Event object, Object, or just an event type string
              event = event[jQuery.expando]
                ? event
                : new jQuery.Event(type, typeof event === "object" && event);

              // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
              event.isTrigger = onlyHandlers ? 2 : 3;
              event.namespace = namespaces.join(".");
              event.rnamespace = event.namespace
                ? new RegExp(
                    "(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)"
                  )
                : null;

              // Clean up the event in case it is being reused
              event.result = undefined;
              if (!event.target) {
                event.target = elem;
              }

              // Clone any incoming data and prepend the event, creating the handler arg list
              data = data == null ? [event] : jQuery.makeArray(data, [event]);

              // Allow special events to draw outside the lines
              special = jQuery.event.special[type] || {};
              if (
                !onlyHandlers &&
                special.trigger &&
                special.trigger.apply(elem, data) === false
              ) {
                return;
              }

              // Determine event propagation path in advance, per W3C events spec (#9951)
              // Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
              if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) {
                  cur = cur.parentNode;
                }
                for (; cur; cur = cur.parentNode) {
                  eventPath.push(cur);
                  tmp = cur;
                }

                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) {
                  eventPath.push(tmp.defaultView || tmp.parentWindow || window);
                }
              }

              // Fire handlers on the event path
              i = 0;
              while ((cur = eventPath[i++]) && !event.isPropagationStopped()) {
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;

                // jQuery handler
                handle =
                  (dataPriv.get(cur, "events") || Object.create(null))[
                    event.type
                  ] && dataPriv.get(cur, "handle");
                if (handle) {
                  handle.apply(cur, data);
                }

                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                  event.result = handle.apply(cur, data);
                  if (event.result === false) {
                    event.preventDefault();
                  }
                }
              }
              event.type = type;

              // If nobody prevented the default action, do it now
              if (!onlyHandlers && !event.isDefaultPrevented()) {
                if (
                  (!special._default ||
                    special._default.apply(eventPath.pop(), data) === false) &&
                  acceptData(elem)
                ) {
                  // Call a native DOM method on the target with the same name as the event.
                  // Don't do default actions on window, that's where global variables be (#6170)
                  if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                    // Don't re-trigger an onFOO event when we call its FOO() method
                    tmp = elem[ontype];

                    if (tmp) {
                      elem[ontype] = null;
                    }

                    // Prevent re-triggering of the same event, since we already bubbled it above
                    jQuery.event.triggered = type;

                    if (event.isPropagationStopped()) {
                      lastElement.addEventListener(type, stopPropagationCallback);
                    }

                    elem[type]();

                    if (event.isPropagationStopped()) {
                      lastElement.removeEventListener(
                        type,
                        stopPropagationCallback
                      );
                    }

                    jQuery.event.triggered = undefined;

                    if (tmp) {
                      elem[ontype] = tmp;
                    }
                  }
                }
              }

              return event.result;
            },

            // Piggyback on a donor event to simulate a different one
            // Used only for `focus(in | out)` events
            simulate: function (type, elem, event) {
              var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true,
              });

              jQuery.event.trigger(e, null, elem);
            },
          });

          jQuery.fn.extend({
            trigger: function (type, data) {
              return this.each(function () {
                jQuery.event.trigger(type, data, this);
              });
            },
            triggerHandler: function (type, data) {
              var elem = this[0];
              if (elem) {
                return jQuery.event.trigger(type, data, elem, true);
              }
            },
          });

          // Support: Firefox <=44
          // Firefox doesn't have focus(in | out) events
          // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
          //
          // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
          // focus(in | out) events fire after focus & blur events,
          // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
          // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
          if (!support.focusin) {
            jQuery.each(
              { focus: "focusin", blur: "focusout" },
              function (orig, fix) {
                // Attach a single capturing handler on the document while someone wants focusin/focusout
                var handler = function (event) {
                  jQuery.event.simulate(
                    fix,
                    event.target,
                    jQuery.event.fix(event)
                  );
                };

                jQuery.event.special[fix] = {
                  setup: function () {
                    // Handle: regular nodes (via `this.ownerDocument`), window
                    // (via `this.document`) & document (via `this`).
                    var doc = this.ownerDocument || this.document || this,
                      attaches = dataPriv.access(doc, fix);

                    if (!attaches) {
                      doc.addEventListener(orig, handler, true);
                    }
                    dataPriv.access(doc, fix, (attaches || 0) + 1);
                  },
                  teardown: function () {
                    var doc = this.ownerDocument || this.document || this,
                      attaches = dataPriv.access(doc, fix) - 1;

                    if (!attaches) {
                      doc.removeEventListener(orig, handler, true);
                      dataPriv.remove(doc, fix);
                    } else {
                      dataPriv.access(doc, fix, attaches);
                    }
                  },
                };
              }
            );
          }
          var location = window.location;

          var nonce = { guid: Date.now() };

          var rquery = /\?/;

          // Cross-browser xml parsing
          jQuery.parseXML = function (data) {
            var xml, parserErrorElem;
            if (!data || typeof data !== "string") {
              return null;
            }

            // Support: IE 9 - 11 only
            // IE throws on parseFromString with invalid input.
            try {
              xml = new window.DOMParser().parseFromString(data, "text/xml");
            } catch (e) {}

            parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
            if (!xml || parserErrorElem) {
              jQuery.error(
                "Invalid XML: " +
                  (parserErrorElem
                    ? jQuery
                        .map(parserErrorElem.childNodes, function (el) {
                          return el.textContent;
                        })
                        .join("\n")
                    : data)
              );
            }
            return xml;
          };

          var rbracket = /\[\]$/,
            rCRLF = /\r?\n/g,
            rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
            rsubmittable = /^(?:input|select|textarea|keygen)/i;

          function buildParams(prefix, obj, traditional, add) {
            var name;

            if (Array.isArray(obj)) {
              // Serialize array item.
              jQuery.each(obj, function (i, v) {
                if (traditional || rbracket.test(prefix)) {
                  // Treat each array item as a scalar.
                  add(prefix, v);
                } else {
                  // Item is non-scalar (array or object), encode its numeric index.
                  buildParams(
                    prefix +
                      "[" +
                      (typeof v === "object" && v != null ? i : "") +
                      "]",
                    v,
                    traditional,
                    add
                  );
                }
              });
            } else if (!traditional && toType(obj) === "object") {
              // Serialize object item.
              for (name in obj) {
                buildParams(
                  prefix + "[" + name + "]",
                  obj[name],
                  traditional,
                  add
                );
              }
            } else {
              // Serialize scalar item.
              add(prefix, obj);
            }
          }

          // Serialize an array of form elements or a set of
          // key/values into a query string
          jQuery.param = function (a, traditional) {
            var prefix,
              s = [],
              add = function (key, valueOrFunction) {
                // If value is a function, invoke it and use its return value
                var value = isFunction(valueOrFunction)
                  ? valueOrFunction()
                  : valueOrFunction;

                s[s.length] =
                  encodeURIComponent(key) +
                  "=" +
                  encodeURIComponent(value == null ? "" : value);
              };

            if (a == null) {
              return "";
            }

            // If an array was passed in, assume that it is an array of form elements.
            if (Array.isArray(a) || (a.jquery && !jQuery.isPlainObject(a))) {
              // Serialize the form elements
              jQuery.each(a, function () {
                add(this.name, this.value);
              });
            } else {
              // If traditional, encode the "old" way (the way 1.3.2 or older
              // did it), otherwise encode params recursively.
              for (prefix in a) {
                buildParams(prefix, a[prefix], traditional, add);
              }
            }

            // Return the resulting serialization
            return s.join("&");
          };

          jQuery.fn.extend({
            serialize: function () {
              return jQuery.param(this.serializeArray());
            },
            serializeArray: function () {
              return this.map(function () {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
              })
                .filter(function () {
                  var type = this.type;

                  // Use .is( ":disabled" ) so that fieldset[disabled] works
                  return (
                    this.name &&
                    !jQuery(this).is(":disabled") &&
                    rsubmittable.test(this.nodeName) &&
                    !rsubmitterTypes.test(type) &&
                    (this.checked || !rcheckableType.test(type))
                  );
                })
                .map(function (_i, elem) {
                  var val = jQuery(this).val();

                  if (val == null) {
                    return null;
                  }

                  if (Array.isArray(val)) {
                    return jQuery.map(val, function (val) {
                      return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n"),
                      };
                    });
                  }

                  return { name: elem.name, value: val.replace(rCRLF, "\r\n") };
                })
                .get();
            },
          });

          var r20 = /%20/g,
            rhash = /#.*$/,
            rantiCache = /([?&])_=[^&]*/,
            rheaders = /^(.*?):[ \t]*([^\r\n]*)$/gm,
            // #7653, #8125, #8152: local protocol detection
            rlocalProtocol =
              /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
            rnoContent = /^(?:GET|HEAD)$/,
            rprotocol = /^\/\//,
            /* Prefilters
             * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
             * 2) These are called:
             *    - BEFORE asking for a transport
             *    - AFTER param serialization (s.data is a string if s.processData is true)
             * 3) key is the dataType
             * 4) the catchall symbol "*" can be used
             * 5) execution will start with transport dataType and THEN continue down to "*" if needed
             */
            prefilters = {},
            /* Transports bindings
             * 1) key is the dataType
             * 2) the catchall symbol "*" can be used
             * 3) selection will start with transport dataType and THEN go to "*" if needed
             */
            transports = {},
            // Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
            allTypes = "*/".concat("*"),
            // Anchor tag for parsing the document origin
            originAnchor = document.createElement("a");

          originAnchor.href = location.href;

          // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
          function addToPrefiltersOrTransports(structure) {
            // dataTypeExpression is optional and defaults to "*"
            return function (dataTypeExpression, func) {
              if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
              }

              var dataType,
                i = 0,
                dataTypes =
                  dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];

              if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while ((dataType = dataTypes[i++])) {
                  // Prepend if requested
                  if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(
                      func
                    );

                    // Otherwise append
                  } else {
                    (structure[dataType] = structure[dataType] || []).push(func);
                  }
                }
              }
            };
          }

          // Base inspection function for prefilters and transports
          function inspectPrefiltersOrTransports(
            structure,
            options,
            originalOptions,
            jqXHR
          ) {
            var inspected = {},
              seekingTransport = structure === transports;

            function inspect(dataType) {
              var selected;
              inspected[dataType] = true;
              jQuery.each(
                structure[dataType] || [],
                function (_, prefilterOrFactory) {
                  var dataTypeOrTransport = prefilterOrFactory(
                    options,
                    originalOptions,
                    jqXHR
                  );
                  if (
                    typeof dataTypeOrTransport === "string" &&
                    !seekingTransport &&
                    !inspected[dataTypeOrTransport]
                  ) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                  } else if (seekingTransport) {
                    return !(selected = dataTypeOrTransport);
                  }
                }
              );
              return selected;
            }

            return (
              inspect(options.dataTypes[0]) || (!inspected["*"] && inspect("*"))
            );
          }

          // A special extend for ajax options
          // that takes "flat" options (not to be deep extended)
          // Fixes #9887
          function ajaxExtend(target, src) {
            var key,
              deep,
              flatOptions = jQuery.ajaxSettings.flatOptions || {};

            for (key in src) {
              if (src[key] !== undefined) {
                (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
              }
            }
            if (deep) {
              jQuery.extend(true, target, deep);
            }

            return target;
          }

          /* Handles responses to an ajax request:
           * - finds the right dataType (mediates between content-type and expected dataType)
           * - returns the corresponding response
           */
          function ajaxHandleResponses(s, jqXHR, responses) {
            var ct,
              type,
              finalDataType,
              firstDataType,
              contents = s.contents,
              dataTypes = s.dataTypes;

            // Remove auto dataType and get content-type in the process
            while (dataTypes[0] === "*") {
              dataTypes.shift();
              if (ct === undefined) {
                ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
              }
            }

            // Check if we're dealing with a known content-type
            if (ct) {
              for (type in contents) {
                if (contents[type] && contents[type].test(ct)) {
                  dataTypes.unshift(type);
                  break;
                }
              }
            }

            // Check to see if we have a response for the expected dataType
            if (dataTypes[0] in responses) {
              finalDataType = dataTypes[0];
            } else {
              // Try convertible dataTypes
              for (type in responses) {
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                  finalDataType = type;
                  break;
                }
                if (!firstDataType) {
                  firstDataType = type;
                }
              }

              // Or just use first one
              finalDataType = finalDataType || firstDataType;
            }

            // If we found a dataType
            // We add the dataType to the list if needed
            // and return the corresponding response
            if (finalDataType) {
              if (finalDataType !== dataTypes[0]) {
                dataTypes.unshift(finalDataType);
              }
              return responses[finalDataType];
            }
          }

          /* Chain conversions given the request and the original response
           * Also sets the responseXXX fields on the jqXHR instance
           */
          function ajaxConvert(s, response, jqXHR, isSuccess) {
            var conv2,
              current,
              conv,
              tmp,
              prev,
              converters = {},
              // Work with a copy of dataTypes in case we need to modify it for conversion
              dataTypes = s.dataTypes.slice();

            // Create converters map with lowercased keys
            if (dataTypes[1]) {
              for (conv in s.converters) {
                converters[conv.toLowerCase()] = s.converters[conv];
              }
            }

            current = dataTypes.shift();

            // Convert to each sequential dataType
            while (current) {
              if (s.responseFields[current]) {
                jqXHR[s.responseFields[current]] = response;
              }

              // Apply the dataFilter if provided
              if (!prev && isSuccess && s.dataFilter) {
                response = s.dataFilter(response, s.dataType);
              }

              prev = current;
              current = dataTypes.shift();

              if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") {
                  current = prev;

                  // Convert response if prev dataType is non-auto and differs from current
                } else if (prev !== "*" && prev !== current) {
                  // Seek a direct converter
                  conv =
                    converters[prev + " " + current] ||
                    converters["* " + current];

                  // If none found, seek a pair
                  if (!conv) {
                    for (conv2 in converters) {
                      // If conv2 outputs current
                      tmp = conv2.split(" ");
                      if (tmp[1] === current) {
                        // If prev can be converted to accepted input
                        conv =
                          converters[prev + " " + tmp[0]] ||
                          converters["* " + tmp[0]];
                        if (conv) {
                          // Condense equivalence converters
                          if (conv === true) {
                            conv = converters[conv2];

                            // Otherwise, insert the intermediate dataType
                          } else if (converters[conv2] !== true) {
                            current = tmp[0];
                            dataTypes.unshift(tmp[1]);
                          }
                          break;
                        }
                      }
                    }
                  }

                  // Apply converter (if not an equivalence)
                  if (conv !== true) {
                    // Unless errors are allowed to bubble, catch and return them
                    if (conv && s.throws) {
                      response = conv(response);
                    } else {
                      try {
                        response = conv(response);
                      } catch (e) {
                        return {
                          state: "parsererror",
                          error: conv
                            ? e
                            : "No conversion from " + prev + " to " + current,
                        };
                      }
                    }
                  }
                }
              }
            }

            return { state: "success", data: response };
          }

          jQuery.extend({
            // Counter for holding the number of active queries
            active: 0,

            // Last-Modified header cache for next request
            lastModified: {},
            etag: {},

            ajaxSettings: {
              url: location.href,
              type: "GET",
              isLocal: rlocalProtocol.test(location.protocol),
              global: true,
              processData: true,
              async: true,
              contentType: "application/x-www-form-urlencoded; charset=UTF-8",

              /*
              timeout: 0,
              data: null,
              dataType: null,
              username: null,
              password: null,
              cache: null,
              throws: false,
              traditional: false,
              headers: {},
              */

              accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript",
              },

              contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/,
              },

              responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON",
              },

              // Data converters
              // Keys separate source (or catchall "*") and destination types with a single space
              converters: {
                // Convert anything to text
                "* text": String,

                // Text to html (true = no transformation)
                "text html": true,

                // Evaluate text as a json expression
                "text json": JSON.parse,

                // Parse text as xml
                "text xml": jQuery.parseXML,
              },

              // For options that shouldn't be deep extended:
              // you can add your own custom options here if
              // and when you create one that shouldn't be
              // deep extended (see ajaxExtend)
              flatOptions: {
                url: true,
                context: true,
              },
            },

            // Creates a full fledged settings object into target
            // with both ajaxSettings and settings fields.
            // If target is omitted, writes into ajaxSettings.
            ajaxSetup: function (target, settings) {
              return settings
                ? // Building a settings object
                  ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings)
                : // Extending ajaxSettings
                  ajaxExtend(jQuery.ajaxSettings, target);
            },

            ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
            ajaxTransport: addToPrefiltersOrTransports(transports),

            // Main method
            ajax: function (url, options) {
              // If url is an object, simulate pre-1.5 signature
              if (typeof url === "object") {
                options = url;
                url = undefined;
              }

              // Force options to be an object
              options = options || {};

              var transport,
                // URL without anti-cache param
                cacheURL,
                // Response headers
                responseHeadersString,
                responseHeaders,
                // timeout handle
                timeoutTimer,
                // Url cleanup var
                urlAnchor,
                // Request state (becomes false upon send and true upon completion)
                completed,
                // To know if global events are to be dispatched
                fireGlobals,
                // Loop variable
                i,
                // uncached part of the url
                uncached,
                // Create the final options object
                s = jQuery.ajaxSetup({}, options),
                // Callbacks context
                callbackContext = s.context || s,
                // Context for global events is callbackContext if it is a DOM node or jQuery collection
                globalEventContext =
                  s.context &&
                  (callbackContext.nodeType || callbackContext.jquery)
                    ? jQuery(callbackContext)
                    : jQuery.event,
                // Deferreds
                deferred = jQuery.Deferred(),
                completeDeferred = jQuery.Callbacks("once memory"),
                // Status-dependent callbacks
                statusCode = s.statusCode || {},
                // Headers (they are sent all at once)
                requestHeaders = {},
                requestHeadersNames = {},
                // Default abort message
                strAbort = "canceled",
                // Fake xhr
                jqXHR = {
                  readyState: 0,

                  // Builds headers hashtable if needed
                  getResponseHeader: function (key) {
                    var match;
                    if (completed) {
                      if (!responseHeaders) {
                        responseHeaders = {};
                        while ((match = rheaders.exec(responseHeadersString))) {
                          responseHeaders[match[1].toLowerCase() + " "] = (
                            responseHeaders[match[1].toLowerCase() + " "] || []
                          ).concat(match[2]);
                        }
                      }
                      match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                  },

                  // Raw string
                  getAllResponseHeaders: function () {
                    return completed ? responseHeadersString : null;
                  },

                  // Caches the header
                  setRequestHeader: function (name, value) {
                    if (completed == null) {
                      name = requestHeadersNames[name.toLowerCase()] =
                        requestHeadersNames[name.toLowerCase()] || name;
                      requestHeaders[name] = value;
                    }
                    return this;
                  },

                  // Overrides response content-type header
                  overrideMimeType: function (type) {
                    if (completed == null) {
                      s.mimeType = type;
                    }
                    return this;
                  },

                  // Status-dependent callbacks
                  statusCode: function (map) {
                    var code;
                    if (map) {
                      if (completed) {
                        // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                      } else {
                        // Lazy-add the new callbacks in a way that preserves old ones
                        for (code in map) {
                          statusCode[code] = [statusCode[code], map[code]];
                        }
                      }
                    }
                    return this;
                  },

                  // Cancel the request
                  abort: function (statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) {
                      transport.abort(finalText);
                    }
                    done(0, finalText);
                    return this;
                  },
                };

              // Attach deferreds
              deferred.promise(jqXHR);

              // Add protocol if not provided (prefilters might expect it)
              // Handle falsy url in the settings object (#10093: consistency with old signature)
              // We also use the url parameter if available
              s.url = ((url || s.url || location.href) + "").replace(
                rprotocol,
                location.protocol + "//"
              );

              // Alias method option to type as per ticket #12004
              s.type = options.method || options.type || s.method || s.type;

              // Extract dataTypes list
              s.dataTypes = (s.dataType || "*")
                .toLowerCase()
                .match(rnothtmlwhite) || [""];

              // A cross-domain request is in order when the origin doesn't match the current origin.
              if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");

                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                  urlAnchor.href = s.url;

                  // Support: IE <=8 - 11 only
                  // Anchor's host property isn't correctly set when s.url is relative
                  urlAnchor.href = urlAnchor.href;
                  s.crossDomain =
                    originAnchor.protocol + "//" + originAnchor.host !==
                    urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                  // If there is an error parsing the URL, assume it is crossDomain,
                  // it can be rejected by the transport if it is invalid
                  s.crossDomain = true;
                }
              }

              // Convert data if not already a string
              if (s.data && s.processData && typeof s.data !== "string") {
                s.data = jQuery.param(s.data, s.traditional);
              }

              // Apply prefilters
              inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);

              // If request was aborted inside a prefilter, stop there
              if (completed) {
                return jqXHR;
              }

              // We can fire global events as of now if asked to
              // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
              fireGlobals = jQuery.event && s.global;

              // Watch for a new set of requests
              if (fireGlobals && jQuery.active++ === 0) {
                jQuery.event.trigger("ajaxStart");
              }

              // Uppercase the type
              s.type = s.type.toUpperCase();

              // Determine if request has content
              s.hasContent = !rnoContent.test(s.type);

              // Save the URL in case we're toying with the If-Modified-Since
              // and/or If-None-Match header later on
              // Remove hash to simplify url manipulation
              cacheURL = s.url.replace(rhash, "");

              // More options handling for requests with no content
              if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);

                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                  cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;

                  // #9682: remove data so that it's not used in an eventual retry
                  delete s.data;
                }

                // Add or update anti-cache param if needed
                if (s.cache === false) {
                  cacheURL = cacheURL.replace(rantiCache, "$1");
                  uncached =
                    (rquery.test(cacheURL) ? "&" : "?") +
                    "_=" +
                    nonce.guid++ +
                    uncached;
                }

                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;

                // Change '%20' to '+' if this is encoded form body content (gh-2658)
              } else if (
                s.data &&
                s.processData &&
                (s.contentType || "").indexOf(
                  "application/x-www-form-urlencoded"
                ) === 0
              ) {
                s.data = s.data.replace(r20, "+");
              }

              // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
              if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) {
                  jqXHR.setRequestHeader(
                    "If-Modified-Since",
                    jQuery.lastModified[cacheURL]
                  );
                }
                if (jQuery.etag[cacheURL]) {
                  jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
                }
              }

              // Set the correct header, if data is being sent
              if (
                (s.data && s.hasContent && s.contentType !== false) ||
                options.contentType
              ) {
                jqXHR.setRequestHeader("Content-Type", s.contentType);
              }

              // Set the Accepts header for the server, depending on the dataType
              jqXHR.setRequestHeader(
                "Accept",
                s.dataTypes[0] && s.accepts[s.dataTypes[0]]
                  ? s.accepts[s.dataTypes[0]] +
                      (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "")
                  : s.accepts["*"]
              );

              // Check for headers option
              for (i in s.headers) {
                jqXHR.setRequestHeader(i, s.headers[i]);
              }

              // Allow custom headers/mimetypes and early abort
              if (
                s.beforeSend &&
                (s.beforeSend.call(callbackContext, jqXHR, s) === false ||
                  completed)
              ) {
                // Abort if not done already and return
                return jqXHR.abort();
              }

              // Aborting is no longer a cancellation
              strAbort = "abort";

              // Install callbacks on deferreds
              completeDeferred.add(s.complete);
              jqXHR.done(s.success);
              jqXHR.fail(s.error);

              // Get transport
              transport = inspectPrefiltersOrTransports(
                transports,
                s,
                options,
                jqXHR
              );

              // If no transport, we auto-abort
              if (!transport) {
                done(-1, "No Transport");
              } else {
                jqXHR.readyState = 1;

                // Send global event
                if (fireGlobals) {
                  globalEventContext.trigger("ajaxSend", [jqXHR, s]);
                }

                // If request was aborted inside ajaxSend, stop there
                if (completed) {
                  return jqXHR;
                }

                // Timeout
                if (s.async && s.timeout > 0) {
                  timeoutTimer = window.setTimeout(function () {
                    jqXHR.abort("timeout");
                  }, s.timeout);
                }

                try {
                  completed = false;
                  transport.send(requestHeaders, done);
                } catch (e) {
                  // Rethrow post-completion exceptions
                  if (completed) {
                    throw e;
                  }

                  // Propagate others as results
                  done(-1, e);
                }
              }

              // Callback for when everything is done
              function done(status, nativeStatusText, responses, headers) {
                var isSuccess,
                  success,
                  error,
                  response,
                  modified,
                  statusText = nativeStatusText;

                // Ignore repeat invocations
                if (completed) {
                  return;
                }

                completed = true;

                // Clear timeout if it exists
                if (timeoutTimer) {
                  window.clearTimeout(timeoutTimer);
                }

                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;

                // Cache response headers
                responseHeadersString = headers || "";

                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;

                // Determine if successful
                isSuccess = (status >= 200 && status < 300) || status === 304;

                // Get response data
                if (responses) {
                  response = ajaxHandleResponses(s, jqXHR, responses);
                }

                // Use a noop converter for missing script but not if jsonp
                if (
                  !isSuccess &&
                  jQuery.inArray("script", s.dataTypes) > -1 &&
                  jQuery.inArray("json", s.dataTypes) < 0
                ) {
                  s.converters["text script"] = function () {};
                }

                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);

                // If successful, handle type chaining
                if (isSuccess) {
                  // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                  if (s.ifModified) {
                    modified = jqXHR.getResponseHeader("Last-Modified");
                    if (modified) {
                      jQuery.lastModified[cacheURL] = modified;
                    }
                    modified = jqXHR.getResponseHeader("etag");
                    if (modified) {
                      jQuery.etag[cacheURL] = modified;
                    }
                  }

                  // if no content
                  if (status === 204 || s.type === "HEAD") {
                    statusText = "nocontent";

                    // if not modified
                  } else if (status === 304) {
                    statusText = "notmodified";

                    // If we have data, let's convert it
                  } else {
                    statusText = response.state;
                    success = response.data;
                    error = response.error;
                    isSuccess = !error;
                  }
                } else {
                  // Extract error from statusText and normalize for non-aborts
                  error = statusText;
                  if (status || !statusText) {
                    statusText = "error";
                    if (status < 0) {
                      status = 0;
                    }
                  }
                }

                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";

                // Success/Error
                if (isSuccess) {
                  deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR,
                  ]);
                } else {
                  deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error,
                  ]);
                }

                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;

                if (fireGlobals) {
                  globalEventContext.trigger(
                    isSuccess ? "ajaxSuccess" : "ajaxError",
                    [jqXHR, s, isSuccess ? success : error]
                  );
                }

                // Complete
                completeDeferred.fireWith(callbackContext, [jqXHR, statusText]);

                if (fireGlobals) {
                  globalEventContext.trigger("ajaxComplete", [jqXHR, s]);

                  // Handle the global AJAX counter
                  if (!--jQuery.active) {
                    jQuery.event.trigger("ajaxStop");
                  }
                }
              }

              return jqXHR;
            },

            getJSON: function (url, data, callback) {
              return jQuery.get(url, data, callback, "json");
            },

            getScript: function (url, callback) {
              return jQuery.get(url, undefined, callback, "script");
            },
          });

          jQuery.each(["get", "post"], function (_i, method) {
            jQuery[method] = function (url, data, callback, type) {
              // Shift arguments if data argument was omitted
              if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
              }

              // The url can be an options object (which then must have .url)
              return jQuery.ajax(
                jQuery.extend(
                  {
                    url: url,
                    type: method,
                    dataType: type,
                    data: data,
                    success: callback,
                  },
                  jQuery.isPlainObject(url) && url
                )
              );
            };
          });

          jQuery.ajaxPrefilter(function (s) {
            var i;
            for (i in s.headers) {
              if (i.toLowerCase() === "content-type") {
                s.contentType = s.headers[i] || "";
              }
            }
          });

          jQuery._evalUrl = function (url, options, doc) {
            return jQuery.ajax({
              url: url,

              // Make this explicit, since user can override this through ajaxSetup (#11264)
              type: "GET",
              dataType: "script",
              cache: true,
              async: false,
              global: false,

              // Only evaluate the response if it is successful (gh-4126)
              // dataFilter is not invoked for failure responses, so using it instead
              // of the default converter is kludgy but it works.
              converters: {
                "text script": function () {},
              },
              dataFilter: function (response) {
                jQuery.globalEval(response, options, doc);
              },
            });
          };

          jQuery.fn.extend({
            wrapAll: function (html) {
              var wrap;

              if (this[0]) {
                if (isFunction(html)) {
                  html = html.call(this[0]);
                }

                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);

                if (this[0].parentNode) {
                  wrap.insertBefore(this[0]);
                }

                wrap
                  .map(function () {
                    var elem = this;

                    while (elem.firstElementChild) {
                      elem = elem.firstElementChild;
                    }

                    return elem;
                  })
                  .append(this);
              }

              return this;
            },

            wrapInner: function (html) {
              if (isFunction(html)) {
                return this.each(function (i) {
                  jQuery(this).wrapInner(html.call(this, i));
                });
              }

              return this.each(function () {
                var self = jQuery(this),
                  contents = self.contents();

                if (contents.length) {
                  contents.wrapAll(html);
                } else {
                  self.append(html);
                }
              });
            },

            wrap: function (html) {
              var htmlIsFunction = isFunction(html);

              return this.each(function (i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
              });
            },

            unwrap: function (selector) {
              this.parent(selector)
                .not("body")
                .each(function () {
                  jQuery(this).replaceWith(this.childNodes);
                });
              return this;
            },
          });

          jQuery.expr.pseudos.hidden = function (elem) {
            return !jQuery.expr.pseudos.visible(elem);
          };
          jQuery.expr.pseudos.visible = function (elem) {
            return !!(
              elem.offsetWidth ||
              elem.offsetHeight ||
              elem.getClientRects().length
            );
          };

          jQuery.ajaxSettings.xhr = function () {
            try {
              return new window.XMLHttpRequest();
            } catch (e) {}
          };

          var xhrSuccessStatus = {
              // File protocol always yields status code 0, assume 200
              0: 200,

              // Support: IE <=9 only
              // #1450: sometimes IE returns 1223 when it should be 204
              1223: 204,
            },
            xhrSupported = jQuery.ajaxSettings.xhr();

          support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
          support.ajax = xhrSupported = !!xhrSupported;

          jQuery.ajaxTransport(function (options) {
            var callback, errorCallback;

            // Cross domain only allowed if supported through XMLHttpRequest
            if (support.cors || (xhrSupported && !options.crossDomain)) {
              return {
                send: function (headers, complete) {
                  var i,
                    xhr = options.xhr();

                  xhr.open(
                    options.type,
                    options.url,
                    options.async,
                    options.username,
                    options.password
                  );

                  // Apply custom fields if provided
                  if (options.xhrFields) {
                    for (i in options.xhrFields) {
                      xhr[i] = options.xhrFields[i];
                    }
                  }

                  // Override mime type if needed
                  if (options.mimeType && xhr.overrideMimeType) {
                    xhr.overrideMimeType(options.mimeType);
                  }

                  // X-Requested-With header
                  // For cross-domain requests, seeing as conditions for a preflight are
                  // akin to a jigsaw puzzle, we simply never set it to be sure.
                  // (it can always be set on a per-request basis or even using ajaxSetup)
                  // For same-domain requests, won't change header if already provided.
                  if (!options.crossDomain && !headers["X-Requested-With"]) {
                    headers["X-Requested-With"] = "XMLHttpRequest";
                  }

                  // Set headers
                  for (i in headers) {
                    xhr.setRequestHeader(i, headers[i]);
                  }

                  // Callback
                  callback = function (type) {
                    return function () {
                      if (callback) {
                        callback =
                          errorCallback =
                          xhr.onload =
                          xhr.onerror =
                          xhr.onabort =
                          xhr.ontimeout =
                          xhr.onreadystatechange =
                            null;

                        if (type === "abort") {
                          xhr.abort();
                        } else if (type === "error") {
                          // Support: IE <=9 only
                          // On a manual native abort, IE9 throws
                          // errors on any property access that is not readyState
                          if (typeof xhr.status !== "number") {
                            complete(0, "error");
                          } else {
                            complete(
                              // File: protocol always yields status 0; see #8605, #14207
                              xhr.status,
                              xhr.statusText
                            );
                          }
                        } else {
                          complete(
                            xhrSuccessStatus[xhr.status] || xhr.status,
                            xhr.statusText,

                            // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" ||
                              typeof xhr.responseText !== "string"
                              ? { binary: xhr.response }
                              : { text: xhr.responseText },
                            xhr.getAllResponseHeaders()
                          );
                        }
                      }
                    };
                  };

                  // Listen to events
                  xhr.onload = callback();
                  errorCallback = xhr.onerror = xhr.ontimeout = callback("error");

                  // Support: IE 9 only
                  // Use onreadystatechange to replace onabort
                  // to handle uncaught aborts
                  if (xhr.onabort !== undefined) {
                    xhr.onabort = errorCallback;
                  } else {
                    xhr.onreadystatechange = function () {
                      // Check readyState before timeout as it changes
                      if (xhr.readyState === 4) {
                        // Allow onerror to be called first,
                        // but that will not handle a native abort
                        // Also, save errorCallback to a variable
                        // as xhr.onerror cannot be accessed
                        window.setTimeout(function () {
                          if (callback) {
                            errorCallback();
                          }
                        });
                      }
                    };
                  }

                  // Create the abort callback
                  callback = callback("abort");

                  try {
                    // Do send the request (this may raise an exception)
                    xhr.send((options.hasContent && options.data) || null);
                  } catch (e) {
                    // #14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) {
                      throw e;
                    }
                  }
                },

                abort: function () {
                  if (callback) {
                    callback();
                  }
                },
              };
            }
          });

          // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
          jQuery.ajaxPrefilter(function (s) {
            if (s.crossDomain) {
              s.contents.script = false;
            }
          });

          // Install script dataType
          jQuery.ajaxSetup({
            accepts: {
              script:
                "text/javascript, application/javascript, " +
                "application/ecmascript, application/x-ecmascript",
            },
            contents: {
              script: /\b(?:java|ecma)script\b/,
            },
            converters: {
              "text script": function (text) {
                jQuery.globalEval(text);
                return text;
              },
            },
          });

          // Handle cache's special case and crossDomain
          jQuery.ajaxPrefilter("script", function (s) {
            if (s.cache === undefined) {
              s.cache = false;
            }
            if (s.crossDomain) {
              s.type = "GET";
            }
          });

          // Bind script tag hack transport
          jQuery.ajaxTransport("script", function (s) {
            // This transport only deals with cross domain or forced-by-attrs requests
            if (s.crossDomain || s.scriptAttrs) {
              var script, callback;
              return {
                send: function (_, complete) {
                  script = jQuery("<script>")
                    .attr(s.scriptAttrs || {})
                    .prop({ charset: s.scriptCharset, src: s.url })
                    .on(
                      "load error",
                      (callback = function (evt) {
                        script.remove();
                        callback = null;
                        if (evt) {
                          complete(evt.type === "error" ? 404 : 200, evt.type);
                        }
                      })
                    );

                  // Use native DOM manipulation to avoid our domManip AJAX trickery
                  document.head.appendChild(script[0]);
                },
                abort: function () {
                  if (callback) {
                    callback();
                  }
                },
              };
            }
          });

          var oldCallbacks = [],
            rjsonp = /(=)\?(?=&|$)|\?\?/;

          // Default jsonp settings
          jQuery.ajaxSetup({
            jsonp: "callback",
            jsonpCallback: function () {
              var callback =
                oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
              this[callback] = true;
              return callback;
            },
          });

          // Detect, normalize options and install callbacks for jsonp requests
          jQuery.ajaxPrefilter(
            "json jsonp",
            function (s, originalSettings, jqXHR) {
              var callbackName,
                overwritten,
                responseContainer,
                jsonProp =
                  s.jsonp !== false &&
                  (rjsonp.test(s.url)
                    ? "url"
                    : typeof s.data === "string" &&
                      (s.contentType || "").indexOf(
                        "application/x-www-form-urlencoded"
                      ) === 0 &&
                      rjsonp.test(s.data) &&
                      "data");

              // Handle iff the expected data type is "jsonp" or we have a parameter to set
              if (jsonProp || s.dataTypes[0] === "jsonp") {
                // Get callback name, remembering preexisting value associated with it
                callbackName = s.jsonpCallback = isFunction(s.jsonpCallback)
                  ? s.jsonpCallback()
                  : s.jsonpCallback;

                // Insert callback into url or form data
                if (jsonProp) {
                  s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
                } else if (s.jsonp !== false) {
                  s.url +=
                    (rquery.test(s.url) ? "&" : "?") +
                    s.jsonp +
                    "=" +
                    callbackName;
                }

                // Use data converter to retrieve json after script execution
                s.converters["script json"] = function () {
                  if (!responseContainer) {
                    jQuery.error(callbackName + " was not called");
                  }
                  return responseContainer[0];
                };

                // Force json dataType
                s.dataTypes[0] = "json";

                // Install callback
                overwritten = window[callbackName];
                window[callbackName] = function () {
                  responseContainer = arguments;
                };

                // Clean-up function (fires after converters)
                jqXHR.always(function () {
                  // If previous value didn't exist - remove it
                  if (overwritten === undefined) {
                    jQuery(window).removeProp(callbackName);

                    // Otherwise restore preexisting value
                  } else {
                    window[callbackName] = overwritten;
                  }

                  // Save back as free
                  if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;

                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                  }

                  // Call if it was a function and we have a response
                  if (responseContainer && isFunction(overwritten)) {
                    overwritten(responseContainer[0]);
                  }

                  responseContainer = overwritten = undefined;
                });

                // Delegate to script
                return "script";
              }
            }
          );

          // Support: Safari 8 only
          // In Safari 8 documents created via document.implementation.createHTMLDocument
          // collapse sibling forms: the second one becomes a child of the first one.
          // Because of that, this security measure has to be disabled in Safari 8.
          // https://bugs.webkit.org/show_bug.cgi?id=137337
          support.createHTMLDocument = (function () {
            var body = document.implementation.createHTMLDocument("").body;
            body.innerHTML = "<form></form><form></form>";
            return body.childNodes.length === 2;
          })();

          // Argument "data" should be string of html
          // context (optional): If specified, the fragment will be created in this context,
          // defaults to document
          // keepScripts (optional): If true, will include scripts passed in the html string
          jQuery.parseHTML = function (data, context, keepScripts) {
            if (typeof data !== "string") {
              return [];
            }
            if (typeof context === "boolean") {
              keepScripts = context;
              context = false;
            }

            var base, parsed, scripts;

            if (!context) {
              // Stop scripts or inline event handlers from being executed immediately
              // by using document.implementation
              if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");

                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
              } else {
                context = document;
              }
            }

            parsed = rsingleTag.exec(data);
            scripts = !keepScripts && [];

            // Single tag
            if (parsed) {
              return [context.createElement(parsed[1])];
            }

            parsed = buildFragment([data], context, scripts);

            if (scripts && scripts.length) {
              jQuery(scripts).remove();
            }

            return jQuery.merge([], parsed.childNodes);
          };

          /**
           * Load a url into a page
           */
          jQuery.fn.load = function (url, params, callback) {
            var selector,
              type,
              response,
              self = this,
              off = url.indexOf(" ");

            if (off > -1) {
              selector = stripAndCollapse(url.slice(off));
              url = url.slice(0, off);
            }

            // If it's a function
            if (isFunction(params)) {
              // We assume that it's the callback
              callback = params;
              params = undefined;

              // Otherwise, build a param string
            } else if (params && typeof params === "object") {
              type = "POST";
            }

            // If we have elements to modify, make the request
            if (self.length > 0) {
              jQuery
                .ajax({
                  url: url,

                  // If "type" variable is undefined, then "GET" method will be used.
                  // Make value of this field explicit since
                  // user can override it through ajaxSetup method
                  type: type || "GET",
                  dataType: "html",
                  data: params,
                })
                .done(function (responseText) {
                  // Save response for use in complete callback
                  response = arguments;

                  self.html(
                    selector
                      ? // If a selector was specified, locate the right elements in a dummy div
                        // Exclude scripts to avoid IE 'Permission Denied' errors
                        jQuery("<div>")
                          .append(jQuery.parseHTML(responseText))
                          .find(selector)
                      : // Otherwise use the full result
                        responseText
                  );

                  // If the request succeeds, this function gets "data", "status", "jqXHR"
                  // but they are ignored because response was set above.
                  // If it fails, this function gets "jqXHR", "status", "error"
                })
                .always(
                  callback &&
                    function (jqXHR, status) {
                      self.each(function () {
                        callback.apply(
                          this,
                          response || [jqXHR.responseText, status, jqXHR]
                        );
                      });
                    }
                );
            }

            return this;
          };

          jQuery.expr.pseudos.animated = function (elem) {
            return jQuery.grep(jQuery.timers, function (fn) {
              return elem === fn.elem;
            }).length;
          };

          jQuery.offset = {
            setOffset: function (elem, options, i) {
              var curPosition,
                curLeft,
                curCSSTop,
                curTop,
                curOffset,
                curCSSLeft,
                calculatePosition,
                position = jQuery.css(elem, "position"),
                curElem = jQuery(elem),
                props = {};

              // Set position first, in-case top/left are set even on static elem
              if (position === "static") {
                elem.style.position = "relative";
              }

              curOffset = curElem.offset();
              curCSSTop = jQuery.css(elem, "top");
              curCSSLeft = jQuery.css(elem, "left");
              calculatePosition =
                (position === "absolute" || position === "fixed") &&
                (curCSSTop + curCSSLeft).indexOf("auto") > -1;

              // Need to be able to calculate position if either
              // top or left is auto and position is either absolute or fixed
              if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
              } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
              }

              if (isFunction(options)) {
                // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
                options = options.call(elem, i, jQuery.extend({}, curOffset));
              }

              if (options.top != null) {
                props.top = options.top - curOffset.top + curTop;
              }
              if (options.left != null) {
                props.left = options.left - curOffset.left + curLeft;
              }

              if ("using" in options) {
                options.using.call(elem, props);
              } else {
                curElem.css(props);
              }
            },
          };

          jQuery.fn.extend({
            // offset() relates an element's border box to the document origin
            offset: function (options) {
              // Preserve chaining for setter
              if (arguments.length) {
                return options === undefined
                  ? this
                  : this.each(function (i) {
                      jQuery.offset.setOffset(this, options, i);
                    });
              }

              var rect,
                win,
                elem = this[0];

              if (!elem) {
                return;
              }

              // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
              // Support: IE <=11 only
              // Running getBoundingClientRect on a
              // disconnected node in IE throws an error
              if (!elem.getClientRects().length) {
                return { top: 0, left: 0 };
              }

              // Get document-relative position by adding viewport scroll to viewport-relative gBCR
              rect = elem.getBoundingClientRect();
              win = elem.ownerDocument.defaultView;
              return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset,
              };
            },

            // position() relates an element's margin box to its offset parent's padding box
            // This corresponds to the behavior of CSS absolute positioning
            position: function () {
              if (!this[0]) {
                return;
              }

              var offsetParent,
                offset,
                doc,
                elem = this[0],
                parentOffset = { top: 0, left: 0 };

              // position:fixed elements are offset from the viewport, which itself always has zero offset
              if (jQuery.css(elem, "position") === "fixed") {
                // Assume position:fixed implies availability of getBoundingClientRect
                offset = elem.getBoundingClientRect();
              } else {
                offset = this.offset();

                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while (
                  offsetParent &&
                  (offsetParent === doc.body ||
                    offsetParent === doc.documentElement) &&
                  jQuery.css(offsetParent, "position") === "static"
                ) {
                  offsetParent = offsetParent.parentNode;
                }
                if (
                  offsetParent &&
                  offsetParent !== elem &&
                  offsetParent.nodeType === 1
                ) {
                  // Incorporate borders into its offset, since they are outside its content origin
                  parentOffset = jQuery(offsetParent).offset();
                  parentOffset.top += jQuery.css(
                    offsetParent,
                    "borderTopWidth",
                    true
                  );
                  parentOffset.left += jQuery.css(
                    offsetParent,
                    "borderLeftWidth",
                    true
                  );
                }
              }

              // Subtract parent offsets and element margins
              return {
                top:
                  offset.top -
                  parentOffset.top -
                  jQuery.css(elem, "marginTop", true),
                left:
                  offset.left -
                  parentOffset.left -
                  jQuery.css(elem, "marginLeft", true),
              };
            },

            // This method will return documentElement in the following cases:
            // 1) For the element inside the iframe without offsetParent, this method will return
            //    documentElement of the parent window
            // 2) For the hidden or detached element
            // 3) For body or html element, i.e. in case of the html node - it will return itself
            //
            // but those exceptions were never presented as a real life use-cases
            // and might be considered as more preferable results.
            //
            // This logic, however, is not guaranteed and can change at any point in the future
            offsetParent: function () {
              return this.map(function () {
                var offsetParent = this.offsetParent;

                while (
                  offsetParent &&
                  jQuery.css(offsetParent, "position") === "static"
                ) {
                  offsetParent = offsetParent.offsetParent;
                }

                return offsetParent || documentElement;
              });
            },
          });

          // Create scrollLeft and scrollTop methods
          jQuery.each(
            { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" },
            function (method, prop) {
              var top = "pageYOffset" === prop;

              jQuery.fn[method] = function (val) {
                return access(
                  this,
                  function (elem, method, val) {
                    // Coalesce documents and windows
                    var win;
                    if (isWindow(elem)) {
                      win = elem;
                    } else if (elem.nodeType === 9) {
                      win = elem.defaultView;
                    }

                    if (val === undefined) {
                      return win ? win[prop] : elem[method];
                    }

                    if (win) {
                      win.scrollTo(
                        !top ? val : win.pageXOffset,
                        top ? val : win.pageYOffset
                      );
                    } else {
                      elem[method] = val;
                    }
                  },
                  method,
                  val,
                  arguments.length
                );
              };
            }
          );

          // Support: Safari <=7 - 9.1, Chrome <=37 - 49
          // Add the top/left cssHooks using jQuery.fn.position
          // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
          // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
          // getComputedStyle returns percent when specified for top/left/bottom/right;
          // rather than make the css module depend on the offset module, just check for it here
          jQuery.each(["top", "left"], function (_i, prop) {
            jQuery.cssHooks[prop] = addGetHookIf(
              support.pixelPosition,
              function (elem, computed) {
                if (computed) {
                  computed = curCSS(elem, prop);

                  // If curCSS returns percentage, fallback to offset
                  return rnumnonpx.test(computed)
                    ? jQuery(elem).position()[prop] + "px"
                    : computed;
                }
              }
            );
          });

          // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
          jQuery.each(
            { Height: "height", Width: "width" },
            function (name, type) {
              jQuery.each(
                {
                  padding: "inner" + name,
                  content: type,
                  "": "outer" + name,
                },
                function (defaultExtra, funcName) {
                  // Margin is only for outerHeight, outerWidth
                  jQuery.fn[funcName] = function (margin, value) {
                    var chainable =
                        arguments.length &&
                        (defaultExtra || typeof margin !== "boolean"),
                      extra =
                        defaultExtra ||
                        (margin === true || value === true ? "margin" : "border");

                    return access(
                      this,
                      function (elem, type, value) {
                        var doc;

                        if (isWindow(elem)) {
                          // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                          return funcName.indexOf("outer") === 0
                            ? elem["inner" + name]
                            : elem.document.documentElement["client" + name];
                        }

                        // Get document width or height
                        if (elem.nodeType === 9) {
                          doc = elem.documentElement;

                          // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                          // whichever is greatest
                          return Math.max(
                            elem.body["scroll" + name],
                            doc["scroll" + name],
                            elem.body["offset" + name],
                            doc["offset" + name],
                            doc["client" + name]
                          );
                        }

                        return value === undefined
                          ? // Get width or height on the element, requesting but not forcing parseFloat
                            jQuery.css(elem, type, extra)
                          : // Set width or height on the element
                            jQuery.style(elem, type, value, extra);
                      },
                      type,
                      chainable ? margin : undefined,
                      chainable
                    );
                  };
                }
              );
            }
          );

          jQuery.each(
            [
              "ajaxStart",
              "ajaxStop",
              "ajaxComplete",
              "ajaxError",
              "ajaxSuccess",
              "ajaxSend",
            ],
            function (_i, type) {
              jQuery.fn[type] = function (fn) {
                return this.on(type, fn);
              };
            }
          );

          jQuery.fn.extend({
            bind: function (types, data, fn) {
              return this.on(types, null, data, fn);
            },
            unbind: function (types, fn) {
              return this.off(types, null, fn);
            },

            delegate: function (selector, types, data, fn) {
              return this.on(types, selector, data, fn);
            },
            undelegate: function (selector, types, fn) {
              // ( namespace ) or ( selector, types [, fn] )
              return arguments.length === 1
                ? this.off(selector, "**")
                : this.off(types, selector || "**", fn);
            },

            hover: function (fnOver, fnOut) {
              return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
            },
          });

          jQuery.each(
            (
              "blur focus focusin focusout resize scroll click dblclick " +
              "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
              "change select submit keydown keypress keyup contextmenu"
            ).split(" "),
            function (_i, name) {
              // Handle event binding
              jQuery.fn[name] = function (data, fn) {
                return arguments.length > 0
                  ? this.on(name, null, data, fn)
                  : this.trigger(name);
              };
            }
          );

          // Support: Android <=4.0 only
          // Make sure we trim BOM and NBSP
          var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

          // Bind a function to a context, optionally partially applying any
          // arguments.
          // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
          // However, it is not slated for removal any time soon
          jQuery.proxy = function (fn, context) {
            var tmp, args, proxy;

            if (typeof context === "string") {
              tmp = fn[context];
              context = fn;
              fn = tmp;
            }

            // Quick check to determine if target is callable, in the spec
            // this throws a TypeError, but we will just return undefined.
            if (!isFunction(fn)) {
              return undefined;
            }

            // Simulated bind
            args = slice.call(arguments, 2);
            proxy = function () {
              return fn.apply(
                context || this,
                args.concat(slice.call(arguments))
              );
            };

            // Set the guid of unique handler to the same of original handler, so it can be removed
            proxy.guid = fn.guid = fn.guid || jQuery.guid++;

            return proxy;
          };

          jQuery.holdReady = function (hold) {
            if (hold) {
              jQuery.readyWait++;
            } else {
              jQuery.ready(true);
            }
          };
          jQuery.isArray = Array.isArray;
          jQuery.parseJSON = JSON.parse;
          jQuery.nodeName = nodeName;
          jQuery.isFunction = isFunction;
          jQuery.isWindow = isWindow;
          jQuery.camelCase = camelCase;
          jQuery.type = toType;

          jQuery.now = Date.now;

          jQuery.isNumeric = function (obj) {
            // As of jQuery 3.0, isNumeric is limited to
            // strings and numbers (primitives or objects)
            // that can be coerced to finite numbers (gh-2662)
            var type = jQuery.type(obj);
            return (
              (type === "number" || type === "string") &&
              // parseFloat NaNs numeric-cast false positives ("")
              // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
              // subtraction forces infinities to NaN
              !isNaN(obj - parseFloat(obj))
            );
          };

          jQuery.trim = function (text) {
            return text == null ? "" : (text + "").replace(rtrim, "");
          };

          var // Map over jQuery in case of overwrite
            _jQuery = window.jQuery,
            // Map over the $ in case of overwrite
            _$ = window.$;

          jQuery.noConflict = function (deep) {
            if (window.$ === jQuery) {
              window.$ = _$;
            }

            if (deep && window.jQuery === jQuery) {
              window.jQuery = _jQuery;
            }

            return jQuery;
          };

          // Expose jQuery and $ identifiers, even in AMD
          // (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
          // and CommonJS for browser emulators (#13566)
          if (typeof noGlobal === "undefined") {
            window.jQuery = window.$ = jQuery;
          }

          return jQuery;
        }
      );
    })(jquery);

    var $ = jquery.exports;

    function t(t) {
      return "object" == typeof t && null != t && 1 === t.nodeType;
    }
    function e(t, e) {
      return (!e || "hidden" !== t) && "visible" !== t && "clip" !== t;
    }
    function n(t, n) {
      if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        var r = getComputedStyle(t, null);
        return (
          e(r.overflowY, n) ||
          e(r.overflowX, n) ||
          (function (t) {
            var e = (function (t) {
              if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
              try {
                return t.ownerDocument.defaultView.frameElement;
              } catch (t) {
                return null;
              }
            })(t);
            return (
              !!e &&
              (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth)
            );
          })(t)
        );
      }
      return !1;
    }
    function r(t, e, n, r, i, o, l, d) {
      return (o < t && l > e) || (o > t && l < e)
        ? 0
        : (o <= t && d <= n) || (l >= e && d >= n)
        ? o - t - r
        : (l > e && d < n) || (o < t && d > n)
        ? l - e + i
        : 0;
    }
    var i = function (e, i) {
      var o = window,
        l = i.scrollMode,
        d = i.block,
        f = i.inline,
        h = i.boundary,
        u = i.skipOverflowHiddenElements,
        s =
          "function" == typeof h
            ? h
            : function (t) {
                return t !== h;
              };
      if (!t(e)) throw new TypeError("Invalid target");
      for (
        var a,
          c,
          g = document.scrollingElement || document.documentElement,
          p = [],
          m = e;
        t(m) && s(m);

      ) {
        if (
          (m =
            null == (c = (a = m).parentElement)
              ? a.getRootNode().host || null
              : c) === g
        ) {
          p.push(m);
          break;
        }
        (null != m &&
          m === document.body &&
          n(m) &&
          !n(document.documentElement)) ||
          (null != m && n(m, u) && p.push(m));
      }
      for (
        var w = o.visualViewport ? o.visualViewport.width : innerWidth,
          v = o.visualViewport ? o.visualViewport.height : innerHeight,
          W = window.scrollX || pageXOffset,
          H = window.scrollY || pageYOffset,
          b = e.getBoundingClientRect(),
          y = b.height,
          E = b.width,
          M = b.top,
          V = b.right,
          x = b.bottom,
          I = b.left,
          C = "start" === d || "nearest" === d ? M : "end" === d ? x : M + y / 2,
          R = "center" === f ? I + E / 2 : "end" === f ? V : I,
          T = [],
          k = 0;
        k < p.length;
        k++
      ) {
        var B = p[k],
          D = B.getBoundingClientRect(),
          O = D.height,
          X = D.width,
          Y = D.top,
          L = D.right,
          S = D.bottom,
          j = D.left;
        if (
          "if-needed" === l &&
          M >= 0 &&
          I >= 0 &&
          x <= v &&
          V <= w &&
          M >= Y &&
          x <= S &&
          I >= j &&
          V <= L
        )
          return T;
        var N = getComputedStyle(B),
          q = parseInt(N.borderLeftWidth, 10),
          z = parseInt(N.borderTopWidth, 10),
          A = parseInt(N.borderRightWidth, 10),
          F = parseInt(N.borderBottomWidth, 10),
          G = 0,
          J = 0,
          K = "offsetWidth" in B ? B.offsetWidth - B.clientWidth - q - A : 0,
          P = "offsetHeight" in B ? B.offsetHeight - B.clientHeight - z - F : 0,
          Q =
            "offsetWidth" in B
              ? 0 === B.offsetWidth
                ? 0
                : X / B.offsetWidth
              : 0,
          U =
            "offsetHeight" in B
              ? 0 === B.offsetHeight
                ? 0
                : O / B.offsetHeight
              : 0;
        if (g === B)
          (G =
            "start" === d
              ? C
              : "end" === d
              ? C - v
              : "nearest" === d
              ? r(H, H + v, v, z, F, H + C, H + C + y, y)
              : C - v / 2),
            (J =
              "start" === f
                ? R
                : "center" === f
                ? R - w / 2
                : "end" === f
                ? R - w
                : r(W, W + w, w, q, A, W + R, W + R + E, E)),
            (G = Math.max(0, G + H)),
            (J = Math.max(0, J + W));
        else {
          (G =
            "start" === d
              ? C - Y - z
              : "end" === d
              ? C - S + F + P
              : "nearest" === d
              ? r(Y, S, O, z, F + P, C, C + y, y)
              : C - (Y + O / 2) + P / 2),
            (J =
              "start" === f
                ? R - j - q
                : "center" === f
                ? R - (j + X / 2) + K / 2
                : "end" === f
                ? R - L + A + K
                : r(j, L, X, q, A + K, R, R + E, E));
          var Z = B.scrollLeft,
            $ = B.scrollTop;
          (C +=
            $ -
            (G = Math.max(0, Math.min($ + G / U, B.scrollHeight - O / U + P)))),
            (R +=
              Z -
              (J = Math.max(0, Math.min(Z + J / Q, B.scrollWidth - X / Q + K))));
        }
        T.push({ el: B, top: G, left: J });
      }
      return T;
    };

    function isOptionsObject(options) {
      return options === Object(options) && Object.keys(options).length !== 0;
    }

    function defaultBehavior(actions, behavior) {
      if (behavior === void 0) {
        behavior = "auto";
      }

      var canSmoothScroll = "scrollBehavior" in document.body.style;
      actions.forEach(function (_ref) {
        var el = _ref.el,
          top = _ref.top,
          left = _ref.left;

        if (el.scroll && canSmoothScroll) {
          el.scroll({
            top: top,
            left: left,
            behavior: behavior,
          });
        } else {
          el.scrollTop = top;
          el.scrollLeft = left;
        }
      });
    }

    function getOptions(options) {
      if (options === false) {
        return {
          block: "end",
          inline: "nearest",
        };
      }

      if (isOptionsObject(options)) {
        return options;
      }

      return {
        block: "start",
        inline: "nearest",
      };
    }

    function scrollIntoView(target, options) {
      var isTargetAttached =
        target.isConnected ||
        target.ownerDocument.documentElement.contains(target);

      if (isOptionsObject(options) && typeof options.behavior === "function") {
        return options.behavior(isTargetAttached ? i(target, options) : []);
      }

      if (!isTargetAttached) {
        return;
      }

      var computeOptions = getOptions(options);
      return defaultBehavior(i(target, computeOptions), computeOptions.behavior);
    }

    function isFunction(value) {
      return typeof value === "function";
    }

    function createErrorClass(createImpl) {
      var _super = function (instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
      };
      var ctorFunc = createImpl(_super);
      ctorFunc.prototype = Object.create(Error.prototype);
      ctorFunc.prototype.constructor = ctorFunc;
      return ctorFunc;
    }

    var UnsubscriptionError = createErrorClass(function (_super) {
      return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors
          ? errors.length +
            " errors occurred during unsubscription:\n" +
            errors
              .map(function (err, i) {
                return i + 1 + ") " + err.toString();
              })
              .join("\n  ")
          : "";
        this.name = "UnsubscriptionError";
        this.errors = errors;
      };
    });

    function arrRemove(arr, item) {
      if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
      }
    }

    var Subscription = (function () {
      function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
      }
      Subscription.prototype.unsubscribe = function () {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
          this.closed = true;
          var _parentage = this._parentage;
          if (_parentage) {
            this._parentage = null;
            if (Array.isArray(_parentage)) {
              try {
                for (
                  var _parentage_1 = __values(_parentage),
                    _parentage_1_1 = _parentage_1.next();
                  !_parentage_1_1.done;
                  _parentage_1_1 = _parentage_1.next()
                ) {
                  var parent_1 = _parentage_1_1.value;
                  parent_1.remove(this);
                }
              } catch (e_1_1) {
                e_1 = { error: e_1_1 };
              } finally {
                try {
                  if (
                    _parentage_1_1 &&
                    !_parentage_1_1.done &&
                    (_a = _parentage_1.return)
                  )
                    _a.call(_parentage_1);
                } finally {
                  if (e_1) throw e_1.error;
                }
              }
            } else {
              _parentage.remove(this);
            }
          }
          var initialFinalizer = this.initialTeardown;
          if (isFunction(initialFinalizer)) {
            try {
              initialFinalizer();
            } catch (e) {
              errors = e instanceof UnsubscriptionError ? e.errors : [e];
            }
          }
          var _finalizers = this._finalizers;
          if (_finalizers) {
            this._finalizers = null;
            try {
              for (
                var _finalizers_1 = __values(_finalizers),
                  _finalizers_1_1 = _finalizers_1.next();
                !_finalizers_1_1.done;
                _finalizers_1_1 = _finalizers_1.next()
              ) {
                var finalizer = _finalizers_1_1.value;
                try {
                  execFinalizer(finalizer);
                } catch (err) {
                  errors = errors !== null && errors !== void 0 ? errors : [];
                  if (err instanceof UnsubscriptionError) {
                    errors = __spreadArray(
                      __spreadArray([], __read(errors)),
                      __read(err.errors)
                    );
                  } else {
                    errors.push(err);
                  }
                }
              }
            } catch (e_2_1) {
              e_2 = { error: e_2_1 };
            } finally {
              try {
                if (
                  _finalizers_1_1 &&
                  !_finalizers_1_1.done &&
                  (_b = _finalizers_1.return)
                )
                  _b.call(_finalizers_1);
              } finally {
                if (e_2) throw e_2.error;
              }
            }
          }
          if (errors) {
            throw new UnsubscriptionError(errors);
          }
        }
      };
      Subscription.prototype.add = function (teardown) {
        var _a;
        if (teardown && teardown !== this) {
          if (this.closed) {
            execFinalizer(teardown);
          } else {
            if (teardown instanceof Subscription) {
              if (teardown.closed || teardown._hasParent(this)) {
                return;
              }
              teardown._addParent(this);
            }
            (this._finalizers =
              (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(
              teardown
            );
          }
        }
      };
      Subscription.prototype._hasParent = function (parent) {
        var _parentage = this._parentage;
        return (
          _parentage === parent ||
          (Array.isArray(_parentage) && _parentage.includes(parent))
        );
      };
      Subscription.prototype._addParent = function (parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage)
          ? (_parentage.push(parent), _parentage)
          : _parentage
          ? [_parentage, parent]
          : parent;
      };
      Subscription.prototype._removeParent = function (parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) {
          this._parentage = null;
        } else if (Array.isArray(_parentage)) {
          arrRemove(_parentage, parent);
        }
      };
      Subscription.prototype.remove = function (teardown) {
        var _finalizers = this._finalizers;
        _finalizers && arrRemove(_finalizers, teardown);
        if (teardown instanceof Subscription) {
          teardown._removeParent(this);
        }
      };
      Subscription.EMPTY = (function () {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
      })();
      return Subscription;
    })();
    var EMPTY_SUBSCRIPTION = Subscription.EMPTY;
    function isSubscription(value) {
      return (
        value instanceof Subscription ||
        (value &&
          "closed" in value &&
          isFunction(value.remove) &&
          isFunction(value.add) &&
          isFunction(value.unsubscribe))
      );
    }
    function execFinalizer(finalizer) {
      if (isFunction(finalizer)) {
        finalizer();
      } else {
        finalizer.unsubscribe();
      }
    }

    var config = {
      onUnhandledError: null,
      onStoppedNotification: null,
      Promise: undefined,
      useDeprecatedSynchronousErrorHandling: false,
      useDeprecatedNextContext: false,
    };

    var timeoutProvider = {
      setTimeout: function (handler, timeout) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
          args[_i - 2] = arguments[_i];
        }
        var delegate = timeoutProvider.delegate;
        if (
          delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout
        ) {
          return delegate.setTimeout.apply(
            delegate,
            __spreadArray([handler, timeout], __read(args))
          );
        }
        return setTimeout.apply(
          void 0,
          __spreadArray([handler, timeout], __read(args))
        );
      },
      clearTimeout: function (handle) {
        var delegate = timeoutProvider.delegate;
        return (
          (delegate === null || delegate === void 0
            ? void 0
            : delegate.clearTimeout) || clearTimeout
        )(handle);
      },
      delegate: undefined,
    };

    function reportUnhandledError(err) {
      timeoutProvider.setTimeout(function () {
        {
          throw err;
        }
      });
    }

    function noop() {}

    var context = null;
    function errorContext(cb) {
      if (config.useDeprecatedSynchronousErrorHandling) {
        var isRoot = !context;
        if (isRoot) {
          context = { errorThrown: false, error: null };
        }
        cb();
        if (isRoot) {
          var _a = context,
            errorThrown = _a.errorThrown,
            error = _a.error;
          context = null;
          if (errorThrown) {
            throw error;
          }
        }
      } else {
        cb();
      }
    }

    var Subscriber = (function (_super) {
      __extends(Subscriber, _super);
      function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
          _this.destination = destination;
          if (isSubscription(destination)) {
            destination.add(_this);
          }
        } else {
          _this.destination = EMPTY_OBSERVER;
        }
        return _this;
      }
      Subscriber.create = function (next, error, complete) {
        return new SafeSubscriber(next, error, complete);
      };
      Subscriber.prototype.next = function (value) {
        if (this.isStopped);
        else {
          this._next(value);
        }
      };
      Subscriber.prototype.error = function (err) {
        if (this.isStopped);
        else {
          this.isStopped = true;
          this._error(err);
        }
      };
      Subscriber.prototype.complete = function () {
        if (this.isStopped);
        else {
          this.isStopped = true;
          this._complete();
        }
      };
      Subscriber.prototype.unsubscribe = function () {
        if (!this.closed) {
          this.isStopped = true;
          _super.prototype.unsubscribe.call(this);
          this.destination = null;
        }
      };
      Subscriber.prototype._next = function (value) {
        this.destination.next(value);
      };
      Subscriber.prototype._error = function (err) {
        try {
          this.destination.error(err);
        } finally {
          this.unsubscribe();
        }
      };
      Subscriber.prototype._complete = function () {
        try {
          this.destination.complete();
        } finally {
          this.unsubscribe();
        }
      };
      return Subscriber;
    })(Subscription);
    var _bind = Function.prototype.bind;
    function bind(fn, thisArg) {
      return _bind.call(fn, thisArg);
    }
    var ConsumerObserver = (function () {
      function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
      }
      ConsumerObserver.prototype.next = function (value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) {
          try {
            partialObserver.next(value);
          } catch (error) {
            handleUnhandledError(error);
          }
        }
      };
      ConsumerObserver.prototype.error = function (err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) {
          try {
            partialObserver.error(err);
          } catch (error) {
            handleUnhandledError(error);
          }
        } else {
          handleUnhandledError(err);
        }
      };
      ConsumerObserver.prototype.complete = function () {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) {
          try {
            partialObserver.complete();
          } catch (error) {
            handleUnhandledError(error);
          }
        }
      };
      return ConsumerObserver;
    })();
    var SafeSubscriber = (function (_super) {
      __extends(SafeSubscriber, _super);
      function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if (isFunction(observerOrNext) || !observerOrNext) {
          partialObserver = {
            next:
              observerOrNext !== null && observerOrNext !== void 0
                ? observerOrNext
                : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete:
              complete !== null && complete !== void 0 ? complete : undefined,
          };
        } else {
          var context_1;
          if (_this && config.useDeprecatedNextContext) {
            context_1 = Object.create(observerOrNext);
            context_1.unsubscribe = function () {
              return _this.unsubscribe();
            };
            partialObserver = {
              next: observerOrNext.next && bind(observerOrNext.next, context_1),
              error:
                observerOrNext.error && bind(observerOrNext.error, context_1),
              complete:
                observerOrNext.complete &&
                bind(observerOrNext.complete, context_1),
            };
          } else {
            partialObserver = observerOrNext;
          }
        }
        _this.destination = new ConsumerObserver(partialObserver);
        return _this;
      }
      return SafeSubscriber;
    })(Subscriber);
    function handleUnhandledError(error) {
      {
        reportUnhandledError(error);
      }
    }
    function defaultErrorHandler(err) {
      throw err;
    }
    var EMPTY_OBSERVER = {
      closed: true,
      next: noop,
      error: defaultErrorHandler,
      complete: noop,
    };

    var observable = (function () {
      return (
        (typeof Symbol === "function" && Symbol.observable) || "@@observable"
      );
    })();

    function identity(x) {
      return x;
    }

    function pipeFromArray(fns) {
      if (fns.length === 0) {
        return identity;
      }
      if (fns.length === 1) {
        return fns[0];
      }
      return function piped(input) {
        return fns.reduce(function (prev, fn) {
          return fn(prev);
        }, input);
      };
    }

    var Observable = (function () {
      function Observable(subscribe) {
        if (subscribe) {
          this._subscribe = subscribe;
        }
      }
      Observable.prototype.lift = function (operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
      };
      Observable.prototype.subscribe = function (
        observerOrNext,
        error,
        complete
      ) {
        var _this = this;
        var subscriber = isSubscriber(observerOrNext)
          ? observerOrNext
          : new SafeSubscriber(observerOrNext, error, complete);
        errorContext(function () {
          var _a = _this,
            operator = _a.operator,
            source = _a.source;
          subscriber.add(
            operator
              ? operator.call(subscriber, source)
              : source
              ? _this._subscribe(subscriber)
              : _this._trySubscribe(subscriber)
          );
        });
        return subscriber;
      };
      Observable.prototype._trySubscribe = function (sink) {
        try {
          return this._subscribe(sink);
        } catch (err) {
          sink.error(err);
        }
      };
      Observable.prototype.forEach = function (next, promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
          var subscriber = new SafeSubscriber({
            next: function (value) {
              try {
                next(value);
              } catch (err) {
                reject(err);
                subscriber.unsubscribe();
              }
            },
            error: reject,
            complete: resolve,
          });
          _this.subscribe(subscriber);
        });
      };
      Observable.prototype._subscribe = function (subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0
          ? void 0
          : _a.subscribe(subscriber);
      };
      Observable.prototype[observable] = function () {
        return this;
      };
      Observable.prototype.pipe = function () {
        var operations = [];
        for (var _i = 0; _i < arguments.length; _i++) {
          operations[_i] = arguments[_i];
        }
        return pipeFromArray(operations)(this);
      };
      Observable.prototype.toPromise = function (promiseCtor) {
        var _this = this;
        promiseCtor = getPromiseCtor(promiseCtor);
        return new promiseCtor(function (resolve, reject) {
          var value;
          _this.subscribe(
            function (x) {
              return (value = x);
            },
            function (err) {
              return reject(err);
            },
            function () {
              return resolve(value);
            }
          );
        });
      };
      Observable.create = function (subscribe) {
        return new Observable(subscribe);
      };
      return Observable;
    })();
    function getPromiseCtor(promiseCtor) {
      var _a;
      return (_a =
        promiseCtor !== null && promiseCtor !== void 0
          ? promiseCtor
          : config.Promise) !== null && _a !== void 0
        ? _a
        : Promise;
    }
    function isObserver(value) {
      return (
        value &&
        isFunction(value.next) &&
        isFunction(value.error) &&
        isFunction(value.complete)
      );
    }
    function isSubscriber(value) {
      return (
        (value && value instanceof Subscriber) ||
        (isObserver(value) && isSubscription(value))
      );
    }

    function hasLift(source) {
      return isFunction(
        source === null || source === void 0 ? void 0 : source.lift
      );
    }
    function operate(init) {
      return function (source) {
        if (hasLift(source)) {
          return source.lift(function (liftedSource) {
            try {
              return init(liftedSource, this);
            } catch (err) {
              this.error(err);
            }
          });
        }
        throw new TypeError("Unable to lift unknown Observable type");
      };
    }

    function createOperatorSubscriber(
      destination,
      onNext,
      onComplete,
      onError,
      onFinalize
    ) {
      return new OperatorSubscriber(
        destination,
        onNext,
        onComplete,
        onError,
        onFinalize
      );
    }
    var OperatorSubscriber = (function (_super) {
      __extends(OperatorSubscriber, _super);
      function OperatorSubscriber(
        destination,
        onNext,
        onComplete,
        onError,
        onFinalize,
        shouldUnsubscribe
      ) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext
          ? function (value) {
              try {
                onNext(value);
              } catch (err) {
                destination.error(err);
              }
            }
          : _super.prototype._next;
        _this._error = onError
          ? function (err) {
              try {
                onError(err);
              } catch (err) {
                destination.error(err);
              } finally {
                this.unsubscribe();
              }
            }
          : _super.prototype._error;
        _this._complete = onComplete
          ? function () {
              try {
                onComplete();
              } catch (err) {
                destination.error(err);
              } finally {
                this.unsubscribe();
              }
            }
          : _super.prototype._complete;
        return _this;
      }
      OperatorSubscriber.prototype.unsubscribe = function () {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
          var closed_1 = this.closed;
          _super.prototype.unsubscribe.call(this);
          !closed_1 &&
            ((_a = this.onFinalize) === null || _a === void 0
              ? void 0
              : _a.call(this));
        }
      };
      return OperatorSubscriber;
    })(Subscriber);

    var ObjectUnsubscribedError = createErrorClass(function (_super) {
      return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = "ObjectUnsubscribedError";
        this.message = "object unsubscribed";
      };
    });

    var Subject = (function (_super) {
      __extends(Subject, _super);
      function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
      }
      Subject.prototype.lift = function (operator) {
        var subject = new AnonymousSubject(this, this);
        subject.operator = operator;
        return subject;
      };
      Subject.prototype._throwIfClosed = function () {
        if (this.closed) {
          throw new ObjectUnsubscribedError();
        }
      };
      Subject.prototype.next = function (value) {
        var _this = this;
        errorContext(function () {
          var e_1, _a;
          _this._throwIfClosed();
          if (!_this.isStopped) {
            if (!_this.currentObservers) {
              _this.currentObservers = Array.from(_this.observers);
            }
            try {
              for (
                var _b = __values(_this.currentObservers), _c = _b.next();
                !_c.done;
                _c = _b.next()
              ) {
                var observer = _c.value;
                observer.next(value);
              }
            } catch (e_1_1) {
              e_1 = { error: e_1_1 };
            } finally {
              try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
              } finally {
                if (e_1) throw e_1.error;
              }
            }
          }
        });
      };
      Subject.prototype.error = function (err) {
        var _this = this;
        errorContext(function () {
          _this._throwIfClosed();
          if (!_this.isStopped) {
            _this.hasError = _this.isStopped = true;
            _this.thrownError = err;
            var observers = _this.observers;
            while (observers.length) {
              observers.shift().error(err);
            }
          }
        });
      };
      Subject.prototype.complete = function () {
        var _this = this;
        errorContext(function () {
          _this._throwIfClosed();
          if (!_this.isStopped) {
            _this.isStopped = true;
            var observers = _this.observers;
            while (observers.length) {
              observers.shift().complete();
            }
          }
        });
      };
      Subject.prototype.unsubscribe = function () {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
      };
      Object.defineProperty(Subject.prototype, "observed", {
        get: function () {
          var _a;
          return (
            ((_a = this.observers) === null || _a === void 0
              ? void 0
              : _a.length) > 0
          );
        },
        enumerable: false,
        configurable: true,
      });
      Subject.prototype._trySubscribe = function (subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
      };
      Subject.prototype._subscribe = function (subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
      };
      Subject.prototype._innerSubscribe = function (subscriber) {
        var _this = this;
        var _a = this,
          hasError = _a.hasError,
          isStopped = _a.isStopped,
          observers = _a.observers;
        if (hasError || isStopped) {
          return EMPTY_SUBSCRIPTION;
        }
        this.currentObservers = null;
        observers.push(subscriber);
        return new Subscription(function () {
          _this.currentObservers = null;
          arrRemove(observers, subscriber);
        });
      };
      Subject.prototype._checkFinalizedStatuses = function (subscriber) {
        var _a = this,
          hasError = _a.hasError,
          thrownError = _a.thrownError,
          isStopped = _a.isStopped;
        if (hasError) {
          subscriber.error(thrownError);
        } else if (isStopped) {
          subscriber.complete();
        }
      };
      Subject.prototype.asObservable = function () {
        var observable = new Observable();
        observable.source = this;
        return observable;
      };
      Subject.create = function (destination, source) {
        return new AnonymousSubject(destination, source);
      };
      return Subject;
    })(Observable);
    var AnonymousSubject = (function (_super) {
      __extends(AnonymousSubject, _super);
      function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
      }
      AnonymousSubject.prototype.next = function (value) {
        var _a, _b;
        (_b =
          (_a = this.destination) === null || _a === void 0
            ? void 0
            : _a.next) === null || _b === void 0
          ? void 0
          : _b.call(_a, value);
      };
      AnonymousSubject.prototype.error = function (err) {
        var _a, _b;
        (_b =
          (_a = this.destination) === null || _a === void 0
            ? void 0
            : _a.error) === null || _b === void 0
          ? void 0
          : _b.call(_a, err);
      };
      AnonymousSubject.prototype.complete = function () {
        var _a, _b;
        (_b =
          (_a = this.destination) === null || _a === void 0
            ? void 0
            : _a.complete) === null || _b === void 0
          ? void 0
          : _b.call(_a);
      };
      AnonymousSubject.prototype._subscribe = function (subscriber) {
        var _a, _b;
        return (_b =
          (_a = this.source) === null || _a === void 0
            ? void 0
            : _a.subscribe(subscriber)) !== null && _b !== void 0
          ? _b
          : EMPTY_SUBSCRIPTION;
      };
      return AnonymousSubject;
    })(Subject);

    var dateTimestampProvider = {
      now: function () {
        return (dateTimestampProvider.delegate || Date).now();
      },
      delegate: undefined,
    };

    var ReplaySubject = (function (_super) {
      __extends(ReplaySubject, _super);
      function ReplaySubject(_bufferSize, _windowTime, _timestampProvider) {
        if (_bufferSize === void 0) {
          _bufferSize = Infinity;
        }
        if (_windowTime === void 0) {
          _windowTime = Infinity;
        }
        if (_timestampProvider === void 0) {
          _timestampProvider = dateTimestampProvider;
        }
        var _this = _super.call(this) || this;
        _this._bufferSize = _bufferSize;
        _this._windowTime = _windowTime;
        _this._timestampProvider = _timestampProvider;
        _this._buffer = [];
        _this._infiniteTimeWindow = true;
        _this._infiniteTimeWindow = _windowTime === Infinity;
        _this._bufferSize = Math.max(1, _bufferSize);
        _this._windowTime = Math.max(1, _windowTime);
        return _this;
      }
      ReplaySubject.prototype.next = function (value) {
        var _a = this,
          isStopped = _a.isStopped,
          _buffer = _a._buffer,
          _infiniteTimeWindow = _a._infiniteTimeWindow,
          _timestampProvider = _a._timestampProvider,
          _windowTime = _a._windowTime;
        if (!isStopped) {
          _buffer.push(value);
          !_infiniteTimeWindow &&
            _buffer.push(_timestampProvider.now() + _windowTime);
        }
        this._trimBuffer();
        _super.prototype.next.call(this, value);
      };
      ReplaySubject.prototype._subscribe = function (subscriber) {
        this._throwIfClosed();
        this._trimBuffer();
        var subscription = this._innerSubscribe(subscriber);
        var _a = this,
          _infiniteTimeWindow = _a._infiniteTimeWindow,
          _buffer = _a._buffer;
        var copy = _buffer.slice();
        for (
          var i = 0;
          i < copy.length && !subscriber.closed;
          i += _infiniteTimeWindow ? 1 : 2
        ) {
          subscriber.next(copy[i]);
        }
        this._checkFinalizedStatuses(subscriber);
        return subscription;
      };
      ReplaySubject.prototype._trimBuffer = function () {
        var _a = this,
          _bufferSize = _a._bufferSize,
          _timestampProvider = _a._timestampProvider,
          _buffer = _a._buffer,
          _infiniteTimeWindow = _a._infiniteTimeWindow;
        var adjustedBufferSize = (_infiniteTimeWindow ? 1 : 2) * _bufferSize;
        _bufferSize < Infinity &&
          adjustedBufferSize < _buffer.length &&
          _buffer.splice(0, _buffer.length - adjustedBufferSize);
        if (!_infiniteTimeWindow) {
          var now = _timestampProvider.now();
          var last = 0;
          for (var i = 1; i < _buffer.length && _buffer[i] <= now; i += 2) {
            last = i;
          }
          last && _buffer.splice(0, last + 1);
        }
      };
      return ReplaySubject;
    })(Subject);

    var Action = (function (_super) {
      __extends(Action, _super);
      function Action(scheduler, work) {
        return _super.call(this) || this;
      }
      Action.prototype.schedule = function (state, delay) {
        return this;
      };
      return Action;
    })(Subscription);

    var intervalProvider = {
      setInterval: function (handler, timeout) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
          args[_i - 2] = arguments[_i];
        }
        var delegate = intervalProvider.delegate;
        if (
          delegate === null || delegate === void 0 ? void 0 : delegate.setInterval
        ) {
          return delegate.setInterval.apply(
            delegate,
            __spreadArray([handler, timeout], __read(args))
          );
        }
        return setInterval.apply(
          void 0,
          __spreadArray([handler, timeout], __read(args))
        );
      },
      clearInterval: function (handle) {
        var delegate = intervalProvider.delegate;
        return (
          (delegate === null || delegate === void 0
            ? void 0
            : delegate.clearInterval) || clearInterval
        )(handle);
      },
      delegate: undefined,
    };

    var AsyncAction = (function (_super) {
      __extends(AsyncAction, _super);
      function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
      }
      AsyncAction.prototype.schedule = function (state, delay) {
        var _a;
        if (delay === void 0) {
          delay = 0;
        }
        if (this.closed) {
          return this;
        }
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) {
          this.id = this.recycleAsyncId(scheduler, id, delay);
        }
        this.pending = true;
        this.delay = delay;
        this.id =
          (_a = this.id) !== null && _a !== void 0
            ? _a
            : this.requestAsyncId(scheduler, this.id, delay);
        return this;
      };
      AsyncAction.prototype.requestAsyncId = function (scheduler, _id, delay) {
        if (delay === void 0) {
          delay = 0;
        }
        return intervalProvider.setInterval(
          scheduler.flush.bind(scheduler, this),
          delay
        );
      };
      AsyncAction.prototype.recycleAsyncId = function (_scheduler, id, delay) {
        if (delay === void 0) {
          delay = 0;
        }
        if (delay != null && this.delay === delay && this.pending === false) {
          return id;
        }
        if (id != null) {
          intervalProvider.clearInterval(id);
        }
        return undefined;
      };
      AsyncAction.prototype.execute = function (state, delay) {
        if (this.closed) {
          return new Error("executing a cancelled action");
        }
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) {
          return error;
        } else if (this.pending === false && this.id != null) {
          this.id = this.recycleAsyncId(this.scheduler, this.id, null);
        }
      };
      AsyncAction.prototype._execute = function (state, _delay) {
        var errored = false;
        var errorValue;
        try {
          this.work(state);
        } catch (e) {
          errored = true;
          errorValue = e ? e : new Error("Scheduled action threw falsy error");
        }
        if (errored) {
          this.unsubscribe();
          return errorValue;
        }
      };
      AsyncAction.prototype.unsubscribe = function () {
        if (!this.closed) {
          var _a = this,
            id = _a.id,
            scheduler = _a.scheduler;
          var actions = scheduler.actions;
          this.work = this.state = this.scheduler = null;
          this.pending = false;
          arrRemove(actions, this);
          if (id != null) {
            this.id = this.recycleAsyncId(scheduler, id, null);
          }
          this.delay = null;
          _super.prototype.unsubscribe.call(this);
        }
      };
      return AsyncAction;
    })(Action);

    var Scheduler = (function () {
      function Scheduler(schedulerActionCtor, now) {
        if (now === void 0) {
          now = Scheduler.now;
        }
        this.schedulerActionCtor = schedulerActionCtor;
        this.now = now;
      }
      Scheduler.prototype.schedule = function (work, delay, state) {
        if (delay === void 0) {
          delay = 0;
        }
        return new this.schedulerActionCtor(this, work).schedule(state, delay);
      };
      Scheduler.now = dateTimestampProvider.now;
      return Scheduler;
    })();

    var AsyncScheduler = (function (_super) {
      __extends(AsyncScheduler, _super);
      function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) {
          now = Scheduler.now;
        }
        var _this = _super.call(this, SchedulerAction, now) || this;
        _this.actions = [];
        _this._active = false;
        return _this;
      }
      AsyncScheduler.prototype.flush = function (action) {
        var actions = this.actions;
        if (this._active) {
          actions.push(action);
          return;
        }
        var error;
        this._active = true;
        do {
          if ((error = action.execute(action.state, action.delay))) {
            break;
          }
        } while ((action = actions.shift()));
        this._active = false;
        if (error) {
          while ((action = actions.shift())) {
            action.unsubscribe();
          }
          throw error;
        }
      };
      return AsyncScheduler;
    })(Scheduler);

    var asyncScheduler = new AsyncScheduler(AsyncAction);
    var async = asyncScheduler;

    var EMPTY = new Observable(function (subscriber) {
      return subscriber.complete();
    });

    function isScheduler(value) {
      return value && isFunction(value.schedule);
    }

    function last(arr) {
      return arr[arr.length - 1];
    }
    function popScheduler(args) {
      return isScheduler(last(args)) ? args.pop() : undefined;
    }
    function popNumber(args, defaultValue) {
      return typeof last(args) === "number" ? args.pop() : defaultValue;
    }

    var isArrayLike = function (x) {
      return x && typeof x.length === "number" && typeof x !== "function";
    };

    function isPromise(value) {
      return isFunction(value === null || value === void 0 ? void 0 : value.then);
    }

    function isInteropObservable(input) {
      return isFunction(input[observable]);
    }

    function isAsyncIterable(obj) {
      return (
        Symbol.asyncIterator &&
        isFunction(
          obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]
        )
      );
    }

    function createInvalidObservableTypeError(input) {
      return new TypeError(
        "You provided " +
          (input !== null && typeof input === "object"
            ? "an invalid object"
            : "'" + input + "'") +
          " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable."
      );
    }

    function getSymbolIterator() {
      if (typeof Symbol !== "function" || !Symbol.iterator) {
        return "@@iterator";
      }
      return Symbol.iterator;
    }
    var iterator = getSymbolIterator();

    function isIterable(input) {
      return isFunction(
        input === null || input === void 0 ? void 0 : input[iterator]
      );
    }

    function readableStreamLikeToAsyncGenerator(readableStream) {
      return __asyncGenerator(
        this,
        arguments,
        function readableStreamLikeToAsyncGenerator_1() {
          var reader, _a, value, done;
          return __generator(this, function (_b) {
            switch (_b.label) {
              case 0:
                reader = readableStream.getReader();
                _b.label = 1;
              case 1:
                _b.trys.push([1, , 9, 10]);
                _b.label = 2;
              case 2:
                return [4, __await(reader.read())];
              case 3:
                (_a = _b.sent()), (value = _a.value), (done = _a.done);
                if (!done) return [3, 5];
                return [4, __await(void 0)];
              case 4:
                return [2, _b.sent()];
              case 5:
                return [4, __await(value)];
              case 6:
                return [4, _b.sent()];
              case 7:
                _b.sent();
                return [3, 2];
              case 8:
                return [3, 10];
              case 9:
                reader.releaseLock();
                return [7];
              case 10:
                return [2];
            }
          });
        }
      );
    }
    function isReadableStreamLike(obj) {
      return isFunction(obj === null || obj === void 0 ? void 0 : obj.getReader);
    }

    function innerFrom(input) {
      if (input instanceof Observable) {
        return input;
      }
      if (input != null) {
        if (isInteropObservable(input)) {
          return fromInteropObservable(input);
        }
        if (isArrayLike(input)) {
          return fromArrayLike(input);
        }
        if (isPromise(input)) {
          return fromPromise(input);
        }
        if (isAsyncIterable(input)) {
          return fromAsyncIterable(input);
        }
        if (isIterable(input)) {
          return fromIterable(input);
        }
        if (isReadableStreamLike(input)) {
          return fromReadableStreamLike(input);
        }
      }
      throw createInvalidObservableTypeError(input);
    }
    function fromInteropObservable(obj) {
      return new Observable(function (subscriber) {
        var obs = obj[observable]();
        if (isFunction(obs.subscribe)) {
          return obs.subscribe(subscriber);
        }
        throw new TypeError(
          "Provided object does not correctly implement Symbol.observable"
        );
      });
    }
    function fromArrayLike(array) {
      return new Observable(function (subscriber) {
        for (var i = 0; i < array.length && !subscriber.closed; i++) {
          subscriber.next(array[i]);
        }
        subscriber.complete();
      });
    }
    function fromPromise(promise) {
      return new Observable(function (subscriber) {
        promise
          .then(
            function (value) {
              if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
              }
            },
            function (err) {
              return subscriber.error(err);
            }
          )
          .then(null, reportUnhandledError);
      });
    }
    function fromIterable(iterable) {
      return new Observable(function (subscriber) {
        var e_1, _a;
        try {
          for (
            var iterable_1 = __values(iterable), iterable_1_1 = iterable_1.next();
            !iterable_1_1.done;
            iterable_1_1 = iterable_1.next()
          ) {
            var value = iterable_1_1.value;
            subscriber.next(value);
            if (subscriber.closed) {
              return;
            }
          }
        } catch (e_1_1) {
          e_1 = { error: e_1_1 };
        } finally {
          try {
            if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return))
              _a.call(iterable_1);
          } finally {
            if (e_1) throw e_1.error;
          }
        }
        subscriber.complete();
      });
    }
    function fromAsyncIterable(asyncIterable) {
      return new Observable(function (subscriber) {
        process(asyncIterable, subscriber).catch(function (err) {
          return subscriber.error(err);
        });
      });
    }
    function fromReadableStreamLike(readableStream) {
      return fromAsyncIterable(
        readableStreamLikeToAsyncGenerator(readableStream)
      );
    }
    function process(asyncIterable, subscriber) {
      var asyncIterable_1, asyncIterable_1_1;
      var e_2, _a;
      return __awaiter(this, void 0, void 0, function () {
        var value, e_2_1;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              _b.trys.push([0, 5, 6, 11]);
              asyncIterable_1 = __asyncValues(asyncIterable);
              _b.label = 1;
            case 1:
              return [4, asyncIterable_1.next()];
            case 2:
              if (!((asyncIterable_1_1 = _b.sent()), !asyncIterable_1_1.done))
                return [3, 4];
              value = asyncIterable_1_1.value;
              subscriber.next(value);
              if (subscriber.closed) {
                return [2];
              }
              _b.label = 3;
            case 3:
              return [3, 1];
            case 4:
              return [3, 11];
            case 5:
              e_2_1 = _b.sent();
              e_2 = { error: e_2_1 };
              return [3, 11];
            case 6:
              _b.trys.push([6, , 9, 10]);
              if (
                !(
                  asyncIterable_1_1 &&
                  !asyncIterable_1_1.done &&
                  (_a = asyncIterable_1.return)
                )
              )
                return [3, 8];
              return [4, _a.call(asyncIterable_1)];
            case 7:
              _b.sent();
              _b.label = 8;
            case 8:
              return [3, 10];
            case 9:
              if (e_2) throw e_2.error;
              return [7];
            case 10:
              return [7];
            case 11:
              subscriber.complete();
              return [2];
          }
        });
      });
    }

    function executeSchedule(parentSubscription, scheduler, work, delay, repeat) {
      if (delay === void 0) {
        delay = 0;
      }
      if (repeat === void 0) {
        repeat = false;
      }
      var scheduleSubscription = scheduler.schedule(function () {
        work();
        if (repeat) {
          parentSubscription.add(this.schedule(null, delay));
        } else {
          this.unsubscribe();
        }
      }, delay);
      parentSubscription.add(scheduleSubscription);
      if (!repeat) {
        return scheduleSubscription;
      }
    }

    function observeOn(scheduler, delay) {
      if (delay === void 0) {
        delay = 0;
      }
      return operate(function (source, subscriber) {
        source.subscribe(
          createOperatorSubscriber(
            subscriber,
            function (value) {
              return executeSchedule(
                subscriber,
                scheduler,
                function () {
                  return subscriber.next(value);
                },
                delay
              );
            },
            function () {
              return executeSchedule(
                subscriber,
                scheduler,
                function () {
                  return subscriber.complete();
                },
                delay
              );
            },
            function (err) {
              return executeSchedule(
                subscriber,
                scheduler,
                function () {
                  return subscriber.error(err);
                },
                delay
              );
            }
          )
        );
      });
    }

    function subscribeOn(scheduler, delay) {
      if (delay === void 0) {
        delay = 0;
      }
      return operate(function (source, subscriber) {
        subscriber.add(
          scheduler.schedule(function () {
            return source.subscribe(subscriber);
          }, delay)
        );
      });
    }

    function scheduleObservable(input, scheduler) {
      return innerFrom(input).pipe(subscribeOn(scheduler), observeOn(scheduler));
    }

    function schedulePromise(input, scheduler) {
      return innerFrom(input).pipe(subscribeOn(scheduler), observeOn(scheduler));
    }

    function scheduleArray(input, scheduler) {
      return new Observable(function (subscriber) {
        var i = 0;
        return scheduler.schedule(function () {
          if (i === input.length) {
            subscriber.complete();
          } else {
            subscriber.next(input[i++]);
            if (!subscriber.closed) {
              this.schedule();
            }
          }
        });
      });
    }

    function scheduleIterable(input, scheduler) {
      return new Observable(function (subscriber) {
        var iterator$1;
        executeSchedule(subscriber, scheduler, function () {
          iterator$1 = input[iterator]();
          executeSchedule(
            subscriber,
            scheduler,
            function () {
              var _a;
              var value;
              var done;
              try {
                (_a = iterator$1.next()), (value = _a.value), (done = _a.done);
              } catch (err) {
                subscriber.error(err);
                return;
              }
              if (done) {
                subscriber.complete();
              } else {
                subscriber.next(value);
              }
            },
            0,
            true
          );
        });
        return function () {
          return (
            isFunction(
              iterator$1 === null || iterator$1 === void 0
                ? void 0
                : iterator$1.return
            ) && iterator$1.return()
          );
        };
      });
    }

    function scheduleAsyncIterable(input, scheduler) {
      if (!input) {
        throw new Error("Iterable cannot be null");
      }
      return new Observable(function (subscriber) {
        executeSchedule(subscriber, scheduler, function () {
          var iterator = input[Symbol.asyncIterator]();
          executeSchedule(
            subscriber,
            scheduler,
            function () {
              iterator.next().then(function (result) {
                if (result.done) {
                  subscriber.complete();
                } else {
                  subscriber.next(result.value);
                }
              });
            },
            0,
            true
          );
        });
      });
    }

    function scheduleReadableStreamLike(input, scheduler) {
      return scheduleAsyncIterable(
        readableStreamLikeToAsyncGenerator(input),
        scheduler
      );
    }

    function scheduled(input, scheduler) {
      if (input != null) {
        if (isInteropObservable(input)) {
          return scheduleObservable(input, scheduler);
        }
        if (isArrayLike(input)) {
          return scheduleArray(input, scheduler);
        }
        if (isPromise(input)) {
          return schedulePromise(input, scheduler);
        }
        if (isAsyncIterable(input)) {
          return scheduleAsyncIterable(input, scheduler);
        }
        if (isIterable(input)) {
          return scheduleIterable(input, scheduler);
        }
        if (isReadableStreamLike(input)) {
          return scheduleReadableStreamLike(input, scheduler);
        }
      }
      throw createInvalidObservableTypeError(input);
    }

    function from(input, scheduler) {
      return scheduler ? scheduled(input, scheduler) : innerFrom(input);
    }

    function of() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      var scheduler = popScheduler(args);
      return from(args, scheduler);
    }

    function isValidDate(value) {
      return value instanceof Date && !isNaN(value);
    }

    function map(project, thisArg) {
      return operate(function (source, subscriber) {
        var index = 0;
        source.subscribe(
          createOperatorSubscriber(subscriber, function (value) {
            subscriber.next(project.call(thisArg, value, index++));
          })
        );
      });
    }

    var isArray = Array.isArray;
    function callOrApply(fn, args) {
      return isArray(args)
        ? fn.apply(void 0, __spreadArray([], __read(args)))
        : fn(args);
    }
    function mapOneOrManyArgs(fn) {
      return map(function (args) {
        return callOrApply(fn, args);
      });
    }

    function mergeInternals(
      source,
      subscriber,
      project,
      concurrent,
      onBeforeNext,
      expand,
      innerSubScheduler,
      additionalFinalizer
    ) {
      var buffer = [];
      var active = 0;
      var index = 0;
      var isComplete = false;
      var checkComplete = function () {
        if (isComplete && !buffer.length && !active) {
          subscriber.complete();
        }
      };
      var outerNext = function (value) {
        return active < concurrent ? doInnerSub(value) : buffer.push(value);
      };
      var doInnerSub = function (value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        innerFrom(project(value, index++)).subscribe(
          createOperatorSubscriber(
            subscriber,
            function (innerValue) {
              onBeforeNext === null || onBeforeNext === void 0
                ? void 0
                : onBeforeNext(innerValue);
              if (expand) {
                outerNext(innerValue);
              } else {
                subscriber.next(innerValue);
              }
            },
            function () {
              innerComplete = true;
            },
            undefined,
            function () {
              if (innerComplete) {
                try {
                  active--;
                  var _loop_1 = function () {
                    var bufferedValue = buffer.shift();
                    if (innerSubScheduler) {
                      executeSchedule(subscriber, innerSubScheduler, function () {
                        return doInnerSub(bufferedValue);
                      });
                    } else {
                      doInnerSub(bufferedValue);
                    }
                  };
                  while (buffer.length && active < concurrent) {
                    _loop_1();
                  }
                  checkComplete();
                } catch (err) {
                  subscriber.error(err);
                }
              }
            }
          )
        );
      };
      source.subscribe(
        createOperatorSubscriber(subscriber, outerNext, function () {
          isComplete = true;
          checkComplete();
        })
      );
      return function () {
        additionalFinalizer === null || additionalFinalizer === void 0
          ? void 0
          : additionalFinalizer();
      };
    }

    function mergeMap(project, resultSelector, concurrent) {
      if (concurrent === void 0) {
        concurrent = Infinity;
      }
      if (isFunction(resultSelector)) {
        return mergeMap(function (a, i) {
          return map(function (b, ii) {
            return resultSelector(a, b, i, ii);
          })(innerFrom(project(a, i)));
        }, concurrent);
      } else if (typeof resultSelector === "number") {
        concurrent = resultSelector;
      }
      return operate(function (source, subscriber) {
        return mergeInternals(source, subscriber, project, concurrent);
      });
    }

    function mergeAll(concurrent) {
      if (concurrent === void 0) {
        concurrent = Infinity;
      }
      return mergeMap(identity, concurrent);
    }

    function defer(observableFactory) {
      return new Observable(function (subscriber) {
        innerFrom(observableFactory()).subscribe(subscriber);
      });
    }

    var nodeEventEmitterMethods = ["addListener", "removeListener"];
    var eventTargetMethods = ["addEventListener", "removeEventListener"];
    var jqueryMethods = ["on", "off"];
    function fromEvent(target, eventName, options, resultSelector) {
      if (isFunction(options)) {
        resultSelector = options;
        options = undefined;
      }
      if (resultSelector) {
        return fromEvent(target, eventName, options).pipe(
          mapOneOrManyArgs(resultSelector)
        );
      }
      var _a = __read(
          isEventTarget(target)
            ? eventTargetMethods.map(function (methodName) {
                return function (handler) {
                  return target[methodName](eventName, handler, options);
                };
              })
            : isNodeStyleEventEmitter(target)
            ? nodeEventEmitterMethods.map(
                toCommonHandlerRegistry(target, eventName)
              )
            : isJQueryStyleEventEmitter(target)
            ? jqueryMethods.map(toCommonHandlerRegistry(target, eventName))
            : [],
          2
        ),
        add = _a[0],
        remove = _a[1];
      if (!add) {
        if (isArrayLike(target)) {
          return mergeMap(function (subTarget) {
            return fromEvent(subTarget, eventName, options);
          })(innerFrom(target));
        }
      }
      if (!add) {
        throw new TypeError("Invalid event target");
      }
      return new Observable(function (subscriber) {
        var handler = function () {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
          }
          return subscriber.next(1 < args.length ? args : args[0]);
        };
        add(handler);
        return function () {
          return remove(handler);
        };
      });
    }
    function toCommonHandlerRegistry(target, eventName) {
      return function (methodName) {
        return function (handler) {
          return target[methodName](eventName, handler);
        };
      };
    }
    function isNodeStyleEventEmitter(target) {
      return isFunction(target.addListener) && isFunction(target.removeListener);
    }
    function isJQueryStyleEventEmitter(target) {
      return isFunction(target.on) && isFunction(target.off);
    }
    function isEventTarget(target) {
      return (
        isFunction(target.addEventListener) &&
        isFunction(target.removeEventListener)
      );
    }

    function iif(condition, trueResult, falseResult) {
      return defer(function () {
        return condition() ? trueResult : falseResult;
      });
    }

    function timer(dueTime, intervalOrScheduler, scheduler) {
      if (dueTime === void 0) {
        dueTime = 0;
      }
      if (scheduler === void 0) {
        scheduler = async;
      }
      var intervalDuration = -1;
      if (intervalOrScheduler != null) {
        if (isScheduler(intervalOrScheduler)) {
          scheduler = intervalOrScheduler;
        } else {
          intervalDuration = intervalOrScheduler;
        }
      }
      return new Observable(function (subscriber) {
        var due = isValidDate(dueTime) ? +dueTime - scheduler.now() : dueTime;
        if (due < 0) {
          due = 0;
        }
        var n = 0;
        return scheduler.schedule(function () {
          if (!subscriber.closed) {
            subscriber.next(n++);
            if (0 <= intervalDuration) {
              this.schedule(undefined, intervalDuration);
            } else {
              subscriber.complete();
            }
          }
        }, due);
      });
    }

    function merge() {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      var scheduler = popScheduler(args);
      var concurrent = popNumber(args, Infinity);
      var sources = args;
      return !sources.length
        ? EMPTY
        : sources.length === 1
        ? innerFrom(sources[0])
        : mergeAll(concurrent)(from(sources, scheduler));
    }

    function filter(predicate, thisArg) {
      return operate(function (source, subscriber) {
        var index = 0;
        source.subscribe(
          createOperatorSubscriber(subscriber, function (value) {
            return (
              predicate.call(thisArg, value, index++) && subscriber.next(value)
            );
          })
        );
      });
    }

    function debounce(durationSelector) {
      return operate(function (source, subscriber) {
        var hasValue = false;
        var lastValue = null;
        var durationSubscriber = null;
        var emit = function () {
          durationSubscriber === null || durationSubscriber === void 0
            ? void 0
            : durationSubscriber.unsubscribe();
          durationSubscriber = null;
          if (hasValue) {
            hasValue = false;
            var value = lastValue;
            lastValue = null;
            subscriber.next(value);
          }
        };
        source.subscribe(
          createOperatorSubscriber(
            subscriber,
            function (value) {
              durationSubscriber === null || durationSubscriber === void 0
                ? void 0
                : durationSubscriber.unsubscribe();
              hasValue = true;
              lastValue = value;
              durationSubscriber = createOperatorSubscriber(
                subscriber,
                emit,
                noop
              );
              innerFrom(durationSelector(value)).subscribe(durationSubscriber);
            },
            function () {
              emit();
              subscriber.complete();
            },
            undefined,
            function () {
              lastValue = durationSubscriber = null;
            }
          )
        );
      });
    }

    function distinct(keySelector, flushes) {
      return operate(function (source, subscriber) {
        var distinctKeys = new Set();
        source.subscribe(
          createOperatorSubscriber(subscriber, function (value) {
            var key = keySelector ? keySelector(value) : value;
            if (!distinctKeys.has(key)) {
              distinctKeys.add(key);
              subscriber.next(value);
            }
          })
        );
        flushes &&
          innerFrom(flushes).subscribe(
            createOperatorSubscriber(
              subscriber,
              function () {
                return distinctKeys.clear();
              },
              noop
            )
          );
      });
    }

    const PROJECT_CLASSES = {
      AVOID_CHANGE_DETECTION: "u1st-avoid-change-detection",
      TRIGGER_ELEMENT: "u1st-trigger-element",
      PREV_TABINDEX: "u1st-prev-tabindex",
      PREV_ARIA_HIDDEN: "u1st-prev-ariaHidden",
      SR_ONLY: "u1st-sr-only",
      SKIP_LINK: "u1st_skipLink",
      DISPLAY_BLOCK: "u1st-display-block",
      DISPLAY_NONE: "u1st-display-none",
      CAROUSEL: "u1st-carousel",
      ALERT: "u1st-alert",
      TEXT_NODE_PARENT: "u1st-textNodeParent",
      MAX_HEIGHT: "u1st-maxHeight",
      TABBABLE_ELEMENT: "u1st-tabbable-element",
      FOCUSED_ELEMENT: "u1st-focused",
      ACTIVE_ELEMENT: "u1st-active",
      EXCLUDE_ATTRIBUTE: "u1-exclude",
    };
    const PROJECT_ATTRIBUTES = {
      ADDED_DESCRIPTION: "u1st-added-description",
      FONT_SIZE: "u1st-font-size",
      RADIO_INDEX: "u1st-radio-index",
      CELL_INDEX: "u1st-cell-index",
      ROW_INDEX: "u1st-row-index",
      CALENDAR_INDEX: "u1st-calendar-index",
    };
    const COMMON_SELECTORS = {
      TABBABLE_ELEMENTS_SELECTOR: `a[href]:not([tabindex='-1']),
    button:not([tabindex='-1']),
    input:not([tabindex='-1']),
    select:not([tabindex='-1']),
    textarea:not([tabindex='-1']),
    [contenteditable]:not([tabindex='-1']),
    [tabindex]:not([tabindex='-1'])`,
      FOCUSABLE_ELEMENTS_SELECTOR: `a[href],button,input,select,textarea,[contenteditable]`,
      HEADING_ELEMENTS_SELECTOR: `h1,h2,h3,h4,h5,h6`,
      U1_ELEMENTS: `[u1-button], [u1-link], [u1-item], [u1-trigger]`,
    };
    const ARIA = {
      LABELLEDBY: `aria-labelledby`,
      MODAL: `aria-modal`,
      HIDDEN: `aria-hidden`,
      ACTIVEDESCENDANT: `aria-activedescendant`,
      EXPANDED: `aria-expanded`,
      HASPOPUP: `aria-haspopup`,
      SELECTED: `aria-selected`,
      LABEL: `aria-label`,
      REQUIRED: `aria-required`,
      INVALID: `aria-invalid`,
      DESCRIBEDBY: `aria-describedby`,
      OWNS: `aria-owns`,
      CONTROLS: `aria-controls`,
      AUTOCOMPLETE: `aria-autocomplete`,
      LIVE: `aria-live`,
      ATOMIC: `aria-atomic`,
      DISABLED: `aria-disabled`,
      PRESSED: `aria-pressed`,
      LEVEL: "aria-level",
      ROLEDESCRIPTION: `aria-roledescription`,
      CHECKED: `aria-checked`,
      SORT: `aria-sort`,
      CURRENT: `aria-current`,
    };
    const ATTRIBUTES = {
      ROLE: "role",
      TABINDEX: "tabindex",
      ID: "id",
      FOR: "for",
      PLACEHOLDER: "placeholder",
      VALUE: "value",
      TYPE: "type",
      ALT: "alt",
      TITLE: "title",
    };
    const TAG_NAMES = {
      INPUT: "input",
      TEXTAREA: "textarea",
      SELECT: "select",
      LABEL: "label",
      DIV: "div",
      SPAN: "span",
      A: "a",
      OBJECT: "object",
      H1: "h1",
      TR: "tr",
      TABLE: "table",
    };
    const KEYBOARD_EVENT_CODE$1 = {
      TAB: "Tab",
      ENTER: "Enter",
      ESC: "Escape",
      SPACE: "Space",
      PAGEUP: "PageUp",
      PAGEDOWN: "PageDown",
      END: "End",
      HOME: "Home",
      LEFT: "ArrowLeft",
      UP: "ArrowUp",
      RIGHT: "ArrowRight",
      DOWN: "ArrowDown",
    };
    const EVENT_TYPES = {
      CLICK: "click",
      KEYDOWN: "keydown",
      FOCUS_IN: "focusin",
      FOCUS_OUT: "focusout",
    };
    const ROLE$1 = {
      FORM: `form`,
      SEARCH: `search`,
      ALERT: `alert`,
      STATUS: `status`,
      LINK: `link`,
      LISTBOX: `listbox`,
      OPTION: `option`,
      BUTTON: `button`,
      GROUP: `group`,
      TAB: `tab`,
      TABLIST: `tablist`,
      TABPANEL: `tabpanel`,
      RADIO: `radio`,
      RADIOGROUP: `radiogroup`,
      CHECKBOX: `checkbox`,
      IMG: `img`,
      DIALOG: `dialog`,
      GRID: `grid`,
      GRIDCELL: `gridcell`,
      COLUMNHEADER: `columnheader`,
      ROWHEADER: `rowheader`,
      ROW: `row`,
      CELL: `cell`,
      TABLE: `table`,
      HEADING: `heading`,
      REGION: `region`,
      TOOLTIP: `tooltip`,
      METER: `meter`,
    };
    const DIRECTION = {
      START: "start",
      END: "end",
    };
    const MENU_IFRAME_ID = "u1st-accessibility-menu";
    const U1_ACCESSIBILITY_BUTTON = "Accessibility Button";
    const CLICKABLE_HTML_ELEMENTS =
      "a, button, input, textarea, select, [tabindex='0']";

    var __async$2 = (__this, __arguments, generator) => {
      return new Promise((resolve, reject) => {
        var fulfilled = (value) => {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        };
        var rejected = (value) => {
          try {
            step(generator.throw(value));
          } catch (e) {
            reject(e);
          }
        };
        var step = (x) =>
          x.done
            ? resolve(x.value)
            : Promise.resolve(x.value).then(fulfilled, rejected);
        step((generator = generator.apply(__this, __arguments)).next());
      });
    };
    class Utils$1 {
      static mod(a, n) {
        return ((a % n) + n) % n;
      }
      static uuid() {
        return "u1st-xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
          /[xy]/g,
          function (c) {
            const r = (Math.random() * 16) | 0,
              v = c == "x" ? r : (r & 3) | 8;
            return v.toString(16);
          }
        );
      }
      static isMobileDevice() {
        if (
          navigator.userAgent.match(/Android/i) ||
          navigator.userAgent.match(/Phone/i) ||
          navigator.userAgent.match(/Mobile/i)
        ) {
          return true;
        }
        return false;
      }
      static isChrome(navigator2) {
        return navigator2.userAgent.match(/Chrome/i) ? true : false;
      }
      static isSafari(navigator2) {
        return navigator2.userAgent.match(/Safari/i) ? true : false;
      }
      static isFireFox(navigator2) {
        return navigator2.userAgent.match(/Firefox/i) ? true : false;
      }
      static waitForTimeout(domProvider, time) {
        return __async$2(this, null, function* () {
          return new Promise((resolve, reject) => {
            domProvider.setTimeout(() => {
              resolve();
            }, time);
          });
        });
      }
      static isRtl(langCode) {
        const rtlLang = ["he", "ar"];
        return rtlLang.includes(langCode);
      }
      static getOrCreateId(element) {
        element.id || (element.id = this.uuid());
        return element.id;
      }
      static getOrCreateIdSelector(element) {
        return `[id='${this.getOrCreateId(element)}']`;
      }
      static isContainsTabbable(htmlElements) {
        return [...htmlElements].some((htmlElement) =>
          htmlElement.querySelector(COMMON_SELECTORS.TABBABLE_ELEMENTS_SELECTOR)
        );
      }
      static isAsc(htmlElements) {
        return this.sortAndCompare(htmlElements, (cellA, cellB) =>
          cellA == null
            ? void 0
            : cellA.innerText.localeCompare(
                cellB == null ? void 0 : cellB.innerText
              )
        );
      }
      static isDesc(htmlElements) {
        return this.sortAndCompare(htmlElements, (cellA, cellB) =>
          cellB == null
            ? void 0
            : cellB.innerText.localeCompare(
                cellA == null ? void 0 : cellA.innerText
              )
        );
      }
      static getFirstTabbableElements(tabbableElements) {
        return tabbableElements.map((focusableCell) => {
          const child = focusableCell.querySelector(
            COMMON_SELECTORS.TABBABLE_ELEMENTS_SELECTOR
          );
          return child != null ? child : focusableCell;
        });
      }
      static getSharedParent(elementsSelector, context) {
        const elToSearch = context != null ? context : document;
        const allElements = elToSearch.querySelectorAll(elementsSelector);
        if (allElements) {
          let isFound = false;
          let parent = allElements[0];
          while (!isFound) {
            parent = parent.parentElement;
            const elsInsideLength =
              parent == null
                ? void 0
                : parent.querySelectorAll(elementsSelector).length;
            if (elsInsideLength === allElements.length) isFound = true;
          }
          return parent;
        }
      }
      // todo: should make smarter approach
      static sortAndCompare(htmlElements, comparator) {
        return [...htmlElements].sort(comparator).every((value, idx) => {
          var _a;
          return (
            (value == null ? void 0 : value.innerText) ===
            ((_a = htmlElements[idx]) == null ? void 0 : _a.innerText)
          );
        });
      }
      static addContextToSelectors(props, container) {
        for (const key in props.selectors) {
          if (key !== "container" && typeof props.selectors[key] === "string") {
            props.selectors[key] = `${container} ${props.selectors[key]}`;
          }
        }
      }
      static findParentWithAttribute(element, attributeName, attributeValue) {
        while (element.parentElement) {
          element = element.parentElement;
          if (
            element.hasAttribute(attributeName) ||
            (attributeValue &&
              element.getAttribute(attributeName) === attributeValue)
          ) {
            return element;
          }
        }
        return null;
      }
      static isAssistiveTechEvent(event) {
        return event.offsetX === 0 && event.offsetY === 0;
      }
      static hideElement(element) {
        element.setAttribute(ARIA.HIDDEN, "true");
        element.setAttribute(ATTRIBUTES.TABINDEX, "-1");
      }
      static makeElementTabbable(element) {
        element.setAttribute(ARIA.HIDDEN, "false");
        element.setAttribute(ATTRIBUTES.TABINDEX, "0");
      }
    }
    Utils$1.removeClientsWCAGAttributes = (elements, attributesToRemove) => {
      const defaultAttributes = ["role", "tabindex"];
      let finalAttributesArray = [];
      if (attributesToRemove) {
        finalAttributesArray = defaultAttributes.concat(attributesToRemove);
      } else {
        finalAttributesArray = defaultAttributes;
      }
      elements.forEach((elm) => {
        if (elm.id.startsWith("u1st")) {
          return;
        }
        finalAttributesArray.forEach((attr) => {
          elm.removeAttribute(attr);
        });
      });
    };
    //TODO: Refactor this method - change the name to be more specific, add handling of tabindex etc. Decide if it's a Util...
    Utils$1.setRolePresentation = (element, elementsToExcludeSelectors) => {
      let elementsInsideMainElement;
      if (elementsToExcludeSelectors) {
        elementsInsideMainElement = Array.prototype.slice.call(
          element.querySelectorAll("*:not(" + elementsToExcludeSelectors + ")"),
          0
        );
      } else {
        elementsInsideMainElement = Array.prototype.slice.call(
          element.querySelectorAll("*"),
          0
        );
      }
      elementsInsideMainElement.forEach((el) => {
        el.setAttribute("role", "presentation");
      });
    };
    Utils$1.isNotWhiteSpaceCharacter = (str) => {
      return str.length === 1 && str.match(/\S/) ? true : false;
    };

    class EventListenerHandler {
      constructor() {
        this.addEventListener = (
          element,
          eventType,
          funcToExecute,
          useCapture = false
        ) => {
          element.addEventListener(
            eventType,
            this.handleEventsMap(element, funcToExecute),
            useCapture
          );
        };
        this.removeEventListener = (element, eventType, funcToExecute) => {
          element.removeEventListener(eventType, funcToExecute);
        };
        this.handleEventsMap = (element, funcToExecute) => {
          const eventsMap = this.eventsMap;
          if (!eventsMap.has(element)) {
            eventsMap.set(element, /* @__PURE__ */ new Map());
          }
          const elementMap = eventsMap.get(element);
          const hash = this.hashCode(funcToExecute.toString());
          if (!elementMap.has(hash)) {
            elementMap.set(hash, funcToExecute);
          }
          return elementMap.get(hash);
        };
        this.hashCode = (str) => {
          let hash = 0;
          if (str.length == 0) return hash;
          for (let i = 0; i < str.length; i++) {
            const char = str.charCodeAt(i);
            hash = (hash << 5) - hash + char;
            hash = hash & hash;
          }
          return hash;
        };
        this.eventsMap = /* @__PURE__ */ new Map();
      }
      static Instance() {
        if (!EventListenerHandler._instance) {
          EventListenerHandler._instance = new EventListenerHandler();
        }
        return EventListenerHandler._instance;
      }
      removeFromMap(element, funcToRemove) {
        throw new Error("Method not implemented.");
      }
      eventsMapSizeOnEl(el) {
        var _a, _b;
        return (_b = (_a = this.eventsMap.get(el)) == null ? void 0 : _a.size) !=
          null
          ? _b
          : 0;
      }
      reset() {
        this.eventsMap.clear();
      }
    }

    class DomProvider {
      constructor(domDocument = window.document, domWindow = window) {
        this.domDocument = domDocument;
        this.domWindow = domWindow;
        this.getDomDocument = () => {
          return this.domDocument;
        };
        this.getDocumentElement = () => {
          return this.domDocument.documentElement;
        };
        this.getLang = () => {
          return this.domDocument.documentElement.lang;
        };
        this.getBody = () => {
          return this.domDocument.body;
        };
        this.getHtml = () => {
          return this.getBody().parentElement;
        };
      }
      getWindow() {
        return this.domWindow;
      }
      removeElement(element) {
        element.remove();
      }
      removeElements(elements) {
        elements.forEach((el) => {
          el.remove();
        });
      }
      getHead() {
        return this.domDocument.head;
      }
      getDomWindow() {
        return this.domWindow;
      }
      setTimeout(callback, timer) {
        this.domWindow.setTimeout(() => callback(), timer);
      }
      setInterval(callback, timer) {
        const interval = this.domWindow.setInterval(
          () => callback(interval),
          timer
        );
        return interval;
      }
      getNavigator() {
        return this.domWindow.navigator;
      }
      querySelector(selector, context = this.domDocument.body) {
        if (context === "body") context = this.domDocument.body;
        const results = selector === "body" ? $(selector) : $(selector, context);
        return results.length > 0 ? results[0] : null;
      }
      querySelectorAll(selector, context = this.domDocument.body) {
        if (context === "body") context = this.domDocument.body;
        const $elements =
          selector === "body" ? $(selector) : $(selector, context);
        return Array.prototype.slice.call($elements, 0);
      }
      getElementById(id) {
        return this.domDocument.getElementById(id);
      }
      getNextSiblingAttr(element, attribute) {
        return element.nextElementSibling
          ? element.nextElementSibling.getAttribute(attribute)
          : null;
      }
      getPrevSiblingAttr(element, attribute) {
        return element.previousElementSibling
          ? element.previousElementSibling.getAttribute(attribute)
          : null;
      }
      getAttribute(element, name) {
        return element == null ? void 0 : element.getAttribute(name);
      }
      setAttribute(element, name, value) {
        element == null ? void 0 : element.setAttribute(name, value);
      }
      setAttributeToAll(element, name, value) {
        element.forEach((el) => {
          el.setAttribute(name, value);
        });
      }
      addClass(element, className) {
        element == null ? void 0 : element.classList.add(className);
      }
      removeClass(element, className) {
        element == null ? void 0 : element.classList.remove(className);
      }
      removeAttribute(element, name) {
        element == null ? void 0 : element.removeAttribute(name);
      }
      removeAttributeToAll(element, name) {
        element.forEach((el) => {
          el.removeAttribute(name);
        });
      }
      focusOnElement(element, custom = false) {
        element == null ? void 0 : element.focus();
        if (custom) {
          const u1Focus = new CustomEvent("u1focus");
          element.dispatchEvent(u1Focus);
        }
      }
      matches(element, selector) {
        return $(element).is(selector);
      }
      addSingleEventListener(
        element,
        eventType,
        funcToExecute,
        useCapture = false
      ) {
        if (element) {
          const eventListenerProvider = EventListenerHandler.Instance();
          const executeAndRemove = (evt) => {
            funcToExecute(evt);
            eventListenerProvider.removeEventListener(
              element,
              eventType,
              executeAndRemove
            );
          };
          eventListenerProvider.addEventListener(
            element,
            eventType,
            executeAndRemove,
            useCapture
          );
        }
      }
      addEventListener(element, eventType, funcToExecute, useCapture = false) {
        if (element) {
          const eventListenerProvider = EventListenerHandler.Instance();
          eventListenerProvider.addEventListener(
            element,
            eventType,
            funcToExecute,
            useCapture
          );
        }
      }
      addEventListenerToAll(
        elements,
        eventType,
        funcToExecute,
        useCapture = false
      ) {
        elements.forEach((el) => {
          this.addEventListener(el, eventType, funcToExecute, useCapture);
        });
      }
      hasClass(element, className) {
        return element.classList.contains(className);
      }
      append(element, context, id) {
        if (this.querySelector(`[id='${id}']`)) return;
        element.id = id;
        context.append(element);
      }
      appendChild(element, context, id) {
        if (this.querySelector(`[id='${id}']`)) return;
        element.id = id;
        context.appendChild(element);
      }
      prepend(element, context, id) {
        if (this.querySelector(`[id='${id}']`, context)) return;
        element.id = id;
        context.prepend(element);
      }
      insertAfter(insertAfter, elmToInsert, id) {
        if (this.querySelector(`[id='${id}']`)) return;
        elmToInsert.id = id;
        insertAfter.after(elmToInsert);
      }
      insertBefore(insertBefore, elmToInsert, id) {
        if (this.querySelector(`[id='${id}']`)) return;
        elmToInsert.id = id;
        insertBefore.before(elmToInsert);
      }
      dispatchClickEvent(element) {
        element.click();
      }
      dispatchMouseClickEvent(element) {
        const clickEvent = new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: true,
        });
        element.dispatchEvent(clickEvent);
      }
      dispatchMouseDownEvent(element) {
        const clickEvent = new MouseEvent("mousedown", {
          view: window,
          bubbles: true,
          cancelable: true,
        });
        element.dispatchEvent(clickEvent);
      }
      dispatchMouseOverEvent(element) {
        const mouseEvent = new MouseEvent("mouseover", {
          view: window,
          bubbles: true,
          cancelable: true,
        });
        element.dispatchEvent(mouseEvent);
      }
      dispatchMouseEvent(element, type) {
        const mouseEvent = new MouseEvent(type, {
          view: window,
          bubbles: true,
          cancelable: true,
        });
        element.dispatchEvent(mouseEvent);
      }
      dispatchMouseOutEvent(element) {
        const mouseEvent = new MouseEvent("mouseout", {
          view: window,
          bubbles: true,
          cancelable: true,
        });
        element.dispatchEvent(mouseEvent);
      }
      dispatchCustomClickEvent(element, customEvent) {
        const clickEvent = new MouseEvent(customEvent, {
          view: window,
          bubbles: true,
          cancelable: true,
        });
        element.dispatchEvent(clickEvent);
      }
      dispatchKeydownEvent(element, key, bubbles = false) {
        element.dispatchEvent(
          new KeyboardEvent("keydown", { key, bubbles, code: key })
        );
      }
      getTextContent(element) {
        return element.textContent;
      }
      getInnerText(element) {
        return element.innerText;
      }
      getTagName(element) {
        return element.tagName;
      }
      createElement(tagName) {
        return this.domDocument.createElement(tagName);
      }
      getElementProperty(element, property) {
        return element[property];
      }
      innerText(el, text) {
        el.innerText = text;
      }
      addStyle(styleContent, id) {
        const styleElement = this.domDocument.createElement("style");
        styleElement.innerText = styleContent;
        const headElement = document.head;
        this.append(styleElement, headElement, id);
      }
      closest(el, selector, startFromParent) {
        const $el = $(el);
        const $parent = $el.parent();
        return startFromParent
          ? $parent && $parent.closest(selector)[0]
          : $el.closest(selector)[0];
      }
      contains(el, context = this.domDocument.body) {
        return context.contains(el);
      }
      changeValue(el, newVale) {
        if (el.tagName.toLowerCase() !== TAG_NAMES.INPUT) return;
        Object.getOwnPropertyDescriptor(
          window.HTMLInputElement.prototype,
          "value"
        ).set.call(el, newVale);
        el.dispatchEvent(new Event("input", { bubbles: true }));
        el.value = newVale;
      }
      setAttributeWithID(fromElement, toElement, attribute) {
        if (!fromElement || !toElement) return;
        let id = this.getAttribute(fromElement, "id");
        if (!id) {
          id = Utils$1.uuid();
          this.setAttribute(fromElement, "id", id);
        }
        this.setAttribute(toElement, attribute, id);
      }
      getActiveElement() {
        return document.activeElement;
      }
      setProperty(el, ruleName, value, isImportant) {
        if (!el) return;
        isImportant
          ? el.style.setProperty(ruleName, value, "important")
          : el.style.setProperty(ruleName, value);
      }
      removeProperty(el, ruleName) {
        if (!el) return;
        el.style.removeProperty(ruleName);
        !el.style.length && this.removeAttribute(el, "style");
      }
      cloneElement(elementToClone) {
        return elementToClone.cloneNode(true);
      }
      insertAdjacentHTML(element, position, text) {
        element.insertAdjacentHTML(position, text);
      }
      insertAdjacentElement(element, position, elToInsert) {
        element.insertAdjacentElement(position, elToInsert);
      }
      hasChildNodes(element) {
        return element.hasChildNodes();
      }
      removeEventListener(element, eventType, callback) {
        element.removeEventListener(eventType, callback);
      }
      hasAttribute(element, attributeName) {
        return element.hasAttribute(attributeName);
      }
      title() {
        return this.domDocument.title;
      }
      scrollIntoView(
        element,
        options = {
          behavior: "smooth",
          block: "nearest",
          inline: "nearest",
        }
      ) {
        scrollIntoView(element, options);
      }
      setCustomValidity(element, value) {
        element == null ? void 0 : element.setCustomValidity(value);
      }
      getPreviousSiblingWithSelector(element, selector) {
        let sibling = element.previousElementSibling;
        while (sibling) {
          if (sibling.matches(selector)) {
            return sibling;
          }
          sibling = sibling.previousElementSibling;
        }
        return null;
      }
    }

    class MenuMessages {
      static send(msg) {
        var _a;
        const iframe = document.getElementById(MENU_IFRAME_ID);
        (_a = iframe == null ? void 0 : iframe.contentWindow) == null
          ? void 0
          : _a.postMessage(msg, "*");
      }
    }

    class Logger {
      constructor() {
        var _a;
        this.env = (_a = "production") == null ? void 0 : _a.trim();
        this.logCollection = [];
        window.addEventListener("beforeunload", () => this.sendLogs());
      }
      static getInstance() {
        if (!Logger.instance) {
          Logger.instance = new Logger();
        }
        return Logger.instance;
      }
      info(msg) {
        if (this.VerifyEnv("development" /* Development */)) {
          console.info(msg);
        }
      }
      error(msg) {
        if (this.VerifyEnv("development" /* Development */)) {
          console.error(msg);
        } else if (this.VerifyEnv("production" /* Production */)) {
          this.logCollection.push(msg.toString());
        }
      }
      sendLogs() {
        if (
          this.logCollection.length > 0 &&
          this.VerifyEnv("production" /* Production */)
        ) {
          MenuMessages.send({
            action: "sendLog",
            url: location.href,
            logMsg: JSON.stringify(this.logCollection),
          });
        }
      }
      VerifyEnv(requiredEnv) {
        return this.env === requiredEnv;
      }
    }

    var __defProp$8 = Object.defineProperty;
    var __getOwnPropDesc$7 = Object.getOwnPropertyDescriptor;
    var __decorateClass$7 = (decorators, target, key, kind) => {
      var result =
        kind > 1 ? void 0 : kind ? __getOwnPropDesc$7(target, key) : target;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if ((decorator = decorators[i]))
          result =
            (kind ? decorator(target, key, result) : decorator(result)) || result;
      if (kind && result) __defProp$8(target, key, result);
      return result;
    };
    const _ChangeDetection = class {
      constructor(elementVisibility, domProvider) {
        this.observer = null;
        this.logger = Logger.getInstance();
        this.elementVisibility = elementVisibility;
        this.activeElementsDictionary = [];
        this.domProvider = domProvider;
        this.contextDictionary = {};
        this.config = {
          attributes: true,
          attributeFilter: ["class", "style"],
          childList: true,
          subtree: true,
        };
      }
      static getInstance(elementVisibility, domProvider) {
        if (!_ChangeDetection.instance) {
          _ChangeDetection.instance = new _ChangeDetection(
            elementVisibility,
            domProvider
          );
        }
        return _ChangeDetection.instance;
      }
      reset() {
        _ChangeDetection.instance = void 0;
      }
      createObserver() {
        this.observer = this.domProvider.setInterval(() => {
          this.handle();
        }, 1e3);
      }
      register(contextSelector, selector, name, onVisible, onHidden) {
        const sub = this.contextDictionary[contextSelector];
        const subSelector = sub && sub[selector];
        const subName = subSelector && subSelector[name];
        const data = {
          [name]: {
            onVisible,
            onHidden,
          },
        };
        if (subName) {
          return;
        } else if (subSelector) {
          subSelector[name] = data[name];
        } else if (sub) {
          sub[selector] = data;
        } else {
          this.contextDictionary[contextSelector] = {
            [selector]: data,
          };
        }
        if (!this.observer) {
          this.createObserver();
        }
      }
      subscribe(contextSelector, name, selector, onVisible, onHidden) {
        if (Array.isArray(selector)) {
          selector.forEach((selector2) =>
            this.register(contextSelector, selector2, name, onVisible, onHidden)
          );
        } else
          this.register(contextSelector, selector, name, onVisible, onHidden);
      }
      handle() {
        const subArray = Object.entries(this.contextDictionary);
        this.onRemove();
        for (const [contextSelector, subscribersData] of subArray) {
          if (this.domProvider.querySelector(contextSelector)) {
            for (const [selector, data] of Object.entries(subscribersData)) {
              const elements = this.domProvider.querySelectorAll(
                selector,
                contextSelector
              );
              for (const element of elements) {
                const markAsDetected = this.isDetected(element);
                const isVisible = this.elementVisibility.isVisible(element);
                if (
                  (element && !markAsDetected && isVisible) ||
                  this.shouldInvokeOnFound(data)
                ) {
                  this.onVisible(element, data, selector);
                } else if (markAsDetected && !isVisible) {
                  this.onHidden(element, data);
                }
              }
            }
          }
        }
      }
      shouldInvokeOnFound(data) {
        const allowedFixers = ["focusTo", "excludeEl"];
        const shouldInvoke = !!allowedFixers.find((fixer) => data[fixer]);
        return shouldInvoke;
      }
      isDetected(element) {
        const markAsDetected =
          element && element.getAttribute(PROJECT_CLASSES.AVOID_CHANGE_DETECTION);
        return markAsDetected;
      }
      onVisible(element, data, selector) {
        const dataArray = Object.entries(data);
        element &&
          this.domProvider.setAttribute(
            element,
            PROJECT_CLASSES.AVOID_CHANGE_DETECTION,
            "true"
          );
        for (const [name, callback] of dataArray) {
          callback.onVisible(element);
          if (callback.onHidden) {
            this.activeElementsDictionary.push({
              selector,
              element,
              onHidden: callback.onHidden,
            });
          }
        }
      }
      onRemove() {
        for (let i = 0; i < this.activeElementsDictionary.length; i++) {
          const activeElement = this.activeElementsDictionary[i];
          if (!this.domProvider.contains(activeElement.element)) {
            try {
              activeElement.onHidden(activeElement.element);
            } catch (e) {
              if (e instanceof Error) {
                this.logger.error(e.message);
              }
            }
            this.activeElementsDictionary.splice(i, 1);
          }
        }
      }
      onHidden(element, data) {
        const isMarkedAsHidden = this.domProvider.getAttribute(
          element,
          "aria-hidden"
        );
        if (isMarkedAsHidden === "true") {
          const dataArray = Object.entries(data);
          let onHidenInvoked = false;
          for (const [name, callback] of dataArray) {
            try {
              callback.onHidden && callback.onHidden(element);
              onHidenInvoked = true;
            } catch (error) {}
          }
          onHidenInvoked &&
            this.domProvider.removeAttribute(
              element,
              PROJECT_CLASSES.AVOID_CHANGE_DETECTION
            );
        }
      }
    };
    let ChangeDetection = _ChangeDetection;
    __decorateClass$7([catchable], ChangeDetection.prototype, "handle", 1);
    __decorateClass$7([catchable], ChangeDetection.prototype, "onVisible", 1);

    const AVOID_AUTO_HIDDEN_ATTRIBUTE = "u1st-avoid-auto-hidden";
    const AVOID_AUTO_TABBABLE_ATTRIBUTE = "u1st-avoid-auto-tabbable";
    class ElementVisibility {
      isVisible(element, avoidAriaHidden) {
        if (!element) return false;
        let isVisible = true;
        const originalElement = element;
        const isInViewPort = this.isInViewPort(originalElement);
        while (element && element.tagName != "HTML") {
          const elementStyle = window.getComputedStyle(element);
          const isClipValid = this.isVisibleClip(elementStyle);
          if (
            (this.isHidden(elementStyle) || !isInViewPort || !isClipValid) &&
            !element.getAttribute("u1-visible")
          ) {
            isVisible = false;
            break;
          }
          element = element.parentElement;
        }
        if (
          !avoidAriaHidden &&
          !(originalElement == null
            ? void 0
            : originalElement.getAttribute(AVOID_AUTO_HIDDEN_ATTRIBUTE))
        ) {
          this.setAriaHidden(originalElement, !isVisible);
          this.setTabbables(originalElement, isVisible);
        }
        return isVisible;
      }
      isVisibleOnPage(element) {
        if (!element) return false;
        let isVisible = true;
        while (element && element.tagName != "HTML") {
          const elementStyle = window.getComputedStyle(element);
          const isClipValid = this.isVisibleClip(elementStyle);
          if (this.isHidden(elementStyle) || !isClipValid) {
            isVisible = false;
            break;
          }
          element = element.parentElement;
        }
        return isVisible;
      }
      isHidden(elementStyle) {
        return (
          elementStyle.display == "none" ||
          elementStyle.visibility == "hidden" ||
          (elementStyle.height == "0px" &&
            (elementStyle.overflow == "auto" ||
              elementStyle.overflow == "hidden")) ||
          elementStyle.width == "0px" ||
          elementStyle.opacity == "0" ||
          elementStyle.transform == "translateX(0%)"
        );
      }
      isInViewPort(element) {
        const clientRect =
          element == null ? void 0 : element.getBoundingClientRect();
        return (
          clientRect.right >= 0 &&
          clientRect.left <=
            (window.innerWidth || document.documentElement.clientWidth)
        );
      }
      isVisibleClip(elementStyle) {
        let clip =
          elementStyle.clip != "" ? elementStyle.clip : elementStyle.clipPath;
        let isClipValid = true;
        if (clip.startsWith("rect")) {
          clip = clip.split("(")[1].split(")")[0];
          const topClip = Number(clip.split("px")[0]);
          const rightClip = Number(clip.split(",")[1].split("px")[0]);
          const bottomClip = Number(clip.split(",")[2].split("px")[0]);
          const leftClip = Number(clip.split(",")[3].split("px")[0]);
          if (
            (topClip >= bottomClip && leftClip >= rightClip) ||
            (topClip == 0 && rightClip == 0 && bottomClip == 0 && leftClip == 0)
          ) {
            isClipValid = false;
          }
        }
        return isClipValid;
      }
      setAriaHidden(element, isVisible) {
        element == null
          ? void 0
          : element.setAttribute(ARIA.HIDDEN, isVisible.toString());
      }
      setTabbables(element, isVisible) {
        const tabbableElements = Array.from(
          element.querySelectorAll(
            `${COMMON_SELECTORS.FOCUSABLE_ELEMENTS_SELECTOR}, .${PROJECT_CLASSES.TABBABLE_ELEMENT}`
          )
        ).filter(
          (element2) =>
            element2.getAttribute(AVOID_AUTO_TABBABLE_ATTRIBUTE) !== "true"
        );
        const isElementTabbable =
          element.matches(COMMON_SELECTORS.TABBABLE_ELEMENTS_SELECTOR) &&
          element.getAttribute(AVOID_AUTO_TABBABLE_ATTRIBUTE) !== "true";
        isElementTabbable && tabbableElements.unshift(element);
        tabbableElements.forEach((el) => this.setTabIndex(el, isVisible));
      }
      setTabIndex(element, isVisible) {
        const tabindex = isVisible ? 0 : -1;
        if (
          !element.matches(COMMON_SELECTORS.FOCUSABLE_ELEMENTS_SELECTOR) ||
          element.getAttribute(ARIA.CHECKED) === "true"
        ) {
          element.classList.add(PROJECT_CLASSES.TABBABLE_ELEMENT);
        }
        element.setAttribute(ATTRIBUTES.TABINDEX, tabindex.toString());
      }
      getVisibleElements(selector, context) {
        const contextElement = context != null ? context : document;
        return Array.from(contextElement.querySelectorAll(selector)).filter(
          (element) => this.isVisible(element)
        );
      }
    }
    const testIsVisibile = (element) => {
      return new ElementVisibility().isVisible(element);
    };

    function catchable(_, __, descriptor) {
      const originalMethod = descriptor.value;
      descriptor.value = function (...args) {
        try {
          return originalMethod.apply(this, args);
        } catch (error) {
          const logger = Logger.getInstance();
          logger.error(error);
        }
      };
    }

    var __defProp$7 = Object.defineProperty;
    var __defProps$1 = Object.defineProperties;
    var __getOwnPropDescs$1 = Object.getOwnPropertyDescriptors;
    var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
    var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
    var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
    var __defNormalProp$1 = (obj, key, value) =>
      key in obj
        ? __defProp$7(obj, key, {
            enumerable: true,
            configurable: true,
            writable: true,
            value,
          })
        : (obj[key] = value);
    var __spreadValues$1 = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
      if (__getOwnPropSymbols$1)
        for (var prop of __getOwnPropSymbols$1(b)) {
          if (__propIsEnum$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
        }
      return a;
    };
    var __spreadProps$1 = (a, b) => __defProps$1(a, __getOwnPropDescs$1(b));
    const camelize = (string) =>
      string.replace(/[A-Z]/g, (character, index) =>
        index === 0 ? character.toLowerCase() : character
      );
    function inject(...serviceConstructors) {
      return function (targetConstructor) {
        return class FixerWithServices extends targetConstructor {
          constructor() {
            super(...arguments);
            this.services = serviceConstructors.reduce(
              (servicesAccumulator, ServiceConstructor) =>
                __spreadProps$1(__spreadValues$1({}, servicesAccumulator), {
                  [camelize(ServiceConstructor.name)]: new ServiceConstructor(),
                }),
              {}
            );
          }
        };
      };
    }

    function partials(...constructors) {
      return function (targetConstructor) {
        constructors.forEach((constructor) => {
          Object.getOwnPropertyNames(constructor.prototype).forEach((name) => {
            Object.defineProperty(
              targetConstructor.prototype,
              name,
              Object.getOwnPropertyDescriptor(constructor.prototype, name) ||
                /* @__PURE__ */ Object.create(null)
            );
          });
        });
      };
    }

    var __defProp$6 = Object.defineProperty;
    var __defProps = Object.defineProperties;
    var __getOwnPropDesc$6 = Object.getOwnPropertyDescriptor;
    var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
    var __getOwnPropSymbols = Object.getOwnPropertySymbols;
    var __hasOwnProp = Object.prototype.hasOwnProperty;
    var __propIsEnum = Object.prototype.propertyIsEnumerable;
    var __defNormalProp = (obj, key, value) =>
      key in obj
        ? __defProp$6(obj, key, {
            enumerable: true,
            configurable: true,
            writable: true,
            value,
          })
        : (obj[key] = value);
    var __spreadValues = (a, b) => {
      for (var prop in b || (b = {}))
        if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      if (__getOwnPropSymbols)
        for (var prop of __getOwnPropSymbols(b)) {
          if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
        }
      return a;
    };
    var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
    var __decorateClass$6 = (decorators, target, key, kind) => {
      var result =
        kind > 1 ? void 0 : kind ? __getOwnPropDesc$6(target, key) : target;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if ((decorator = decorators[i]))
          result =
            (kind ? decorator(target, key, result) : decorator(result)) || result;
      if (kind && result) __defProp$6(target, key, result);
      return result;
    };
    var _a;
    const _StateManagement = class {
      constructor() {
        this.u1stConfiguration = (_a = window.u1) == null ? void 0 : _a.config;
      }
      static getInstance() {
        if (!_StateManagement.instance) {
          _StateManagement.instance = new _StateManagement();
        }
        return _StateManagement.instance;
      }
      getLang() {
        var _a2;
        return (_a2 = window.u1) == null ? void 0 : _a2.lang;
      }
      getConfigurationStyle(element) {
        var _a2, _b;
        return (_b = (_a2 = window.u1.config) == null ? void 0 : _a2[element]) ==
          null
          ? void 0
          : _b.style;
      }
    };
    let StateManagement = _StateManagement;
    __decorateClass$6(
      [catchable],
      StateManagement.prototype,
      "getConfigurationStyle",
      1
    );
    const setConfiguration$1 = (u1Configuration) => {
      window.u1 = __spreadProps(__spreadValues({}, window.u1), {
        config: u1Configuration,
      });
    };

    class VisualFocusFixer {
      constructor(domProvider, elementVisbiilty) {
        this.defaultColor = "black";
        this.secondaryDefaultColor = "white";
        this.defaultWidth = 3;
        this.domProvider = domProvider;
        this.elementVisibility = elementVisbiilty;
        this.stateManagement = StateManagement.getInstance();
      }
      fix() {
        const targetElement = this.domProvider.getDocumentElement();
        const activateOnTab = (e) => {
          const eventKey = e.key;
          if (eventKey === "Tab") {
            this.setVisualFocus();
            this.domProvider.removeEventListener(
              targetElement,
              "keydown",
              activateOnTab
            );
          }
        };
        this.domProvider.addEventListener(
          targetElement,
          "keydown",
          activateOnTab
        );
      }
      setVisualFocus() {
        var _a, _b;
        const customStyle = this.getCustomStyle();
        const primaryColor =
          (_a = customStyle == null ? void 0 : customStyle.color) != null
            ? _a
            : this.defaultColor;
        const secondaryColor =
          (_b = customStyle == null ? void 0 : customStyle.secondaryColor) != null
            ? _b
            : this.secondaryDefaultColor;
        document.body.style.setProperty("--outline-color", primaryColor);
        document.body.style.setProperty(
          "--secondary-outline-color",
          secondaryColor
        );
        if (customStyle == null ? void 0 : customStyle.doubleBorder) {
          this.setDoubleBorder(secondaryColor);
        } else {
          this.setRegularBorder(customStyle);
        }
      }
      setRegularBorder(customStyle) {
        var _a;
        const customWidth = customStyle == null ? void 0 : customStyle.width;
        const outlineWidth = !customWidth
          ? this.defaultWidth
          : customWidth <= 2
          ? 2
          : customWidth;
        document.body.style.setProperty(
          "--outline-width",
          `${String(outlineWidth)}px`
        );
        document.body.style.setProperty(
          "--outline-offset",
          `${String(
            (_a = customStyle == null ? void 0 : customStyle.offset) != null
              ? _a
              : 2
          )}px`
        );
        (customStyle == null ? void 0 : customStyle.customProperty) &&
          document.body.style.setProperty(
            "--custom-property",
            customStyle == null ? void 0 : customStyle.customProperty
          );
      }
      setDoubleBorder(outerBorderColor) {
        const boxShadowProp = `0 0 0 4px ${outerBorderColor}`;
        document.body.style.setProperty("--outline-width", `2px`);
        document.body.style.setProperty("--outline-offset", `0px`);
        document.body.style.setProperty("--outer-border", boxShadowProp);
      }
      getCustomStyle() {
        return this.stateManagement.getConfigurationStyle("visualFocus");
      }
    }
    const visualFocusApi = () =>
      new VisualFocusFixer(new DomProvider(), new ElementVisibility()).fix();

    const FOCUS_TO_ATTRIBUTE = "u1-focus-to";
    const FOCUSED_ATTR = `u1-focused`;
    const ALL_FOCUS_TO_ATTRIBUTES = `[data-${FOCUS_TO_ATTRIBUTE}]:not([${FOCUSED_ATTR}]), [${FOCUS_TO_ATTRIBUTE}]:not([${FOCUSED_ATTR}])`;
    class FocusToFixer {
      constructor(context, domProvider, changeDetection) {
        this.focusOnElement = () => {
          const nextElToFocus = this.domProvider.querySelector(
            ALL_FOCUS_TO_ATTRIBUTES
          );
          if (nextElToFocus) {
            this.domProvider.setAttribute(nextElToFocus, FOCUSED_ATTR, "true");
            this.domProvider.setAttribute(
              nextElToFocus,
              ATTRIBUTES.TABINDEX,
              "0"
            );
            this.domProvider.focusOnElement(nextElToFocus);
            this.domProvider.setTimeout(() => {
              this.domProvider.setAttribute(
                nextElToFocus,
                AVOID_AUTO_TABBABLE_ATTRIBUTE,
                "true"
              );
              this.domProvider.removeAttribute(nextElToFocus, FOCUS_TO_ATTRIBUTE);
              this.domProvider.removeAttribute(nextElToFocus, FOCUSED_ATTR);
              this.domProvider.removeAttribute(
                nextElToFocus,
                ATTRIBUTES.TABINDEX
              );
              const anchor = this.domProvider.getElementById("u1-anchor");
              anchor == null ? void 0 : anchor.remove();
            }, 500);
          }
        };
        this.domProvider = domProvider;
        this.changeDetection = changeDetection;
        this.context = context;
      }
      fix() {
        this.changeDetection.subscribe(
          this.context,
          "focusTo",
          ALL_FOCUS_TO_ATTRIBUTES,
          () => this.focusOnElement()
        );
      }
      createAnchorAndFocusTo(focusTo) {
        let anchor = this.domProvider.getElementById("u1-anchor");
        if (!anchor) {
          anchor = document.createElement("a");
          anchor.id = "u1-anchor";
          anchor.classList.add("u1st-sr-only");
          focusTo == null ? void 0 : focusTo.prepend(anchor);
        }
        this.domProvider.setAttribute(anchor, FOCUS_TO_ATTRIBUTE, "true");
      }
    }
    const focusToApi = (context = "body") => {
      const domProvider = new DomProvider();
      const elementVisibility = new ElementVisibility();
      const changeDetection = ChangeDetection.getInstance(
        elementVisibility,
        domProvider
      );
      new FocusToFixer(context, domProvider, changeDetection).fix();
    };

    const EXCLUDED_ATTRIBUTE = "u1-excluded";
    const ALL_EXCLUDE_ATTRIBUTES = `[${PROJECT_CLASSES.EXCLUDE_ATTRIBUTE}='true']:not([${EXCLUDED_ATTRIBUTE}]), [data-${PROJECT_CLASSES.EXCLUDE_ATTRIBUTE}='true']:not([${EXCLUDED_ATTRIBUTE}])`;
    class ExcludeElFixer {
      constructor(context, domProvider, changeDetection) {
        this.hideElement = (elToHide) => {
          this.domProvider.setAttribute(elToHide, ARIA.HIDDEN, "true");
          this.domProvider.setAttribute(elToHide, ATTRIBUTES.TABINDEX, "-1");
          this.domProvider.setAttribute(elToHide, EXCLUDED_ATTRIBUTE, "true");
          this.domProvider.setAttribute(
            elToHide,
            AVOID_AUTO_HIDDEN_ATTRIBUTE,
            "true"
          );
          this.domProvider.setAttribute(
            elToHide,
            AVOID_AUTO_TABBABLE_ATTRIBUTE,
            "true"
          );
        };
        this.domProvider = domProvider;
        this.changeDetection = changeDetection;
        this.context = context;
      }
      fix() {
        this.changeDetection.subscribe(
          this.context,
          "excludeEl",
          ALL_EXCLUDE_ATTRIBUTES,
          (visibleElement) => {
            setTimeout(() => {
              this.hideElement(visibleElement);
            }, 1e3);
          }
        );
      }
    }
    const excludeElApi = (context = "body") => {
      const domProvider = new DomProvider();
      const elementVisibility = new ElementVisibility();
      const changeDetection = ChangeDetection.getInstance(
        elementVisibility,
        domProvider
      );
      new ExcludeElFixer(context, domProvider, changeDetection).fix();
    };

    const STATUS_ID = "u1-status-element";
    const STATUS_ATTR = "u1-status";

    class StatusFixer {
      constructor(context, domProvider, changeDetection) {
        this.domProvider = domProvider;
        this.changeDetection = changeDetection;
        this.context = context;
        const statusElement = this.domProvider.getElementById(STATUS_ID);
        if (statusElement) {
          this.statusEl = statusElement;
        } else {
          this.statusEl = this.domProvider.createElement("div");
          this.domProvider.setAttribute(
            this.statusEl,
            ATTRIBUTES.ROLE,
            ROLE$1.STATUS
          );
          this.domProvider.setAttribute(this.statusEl, ATTRIBUTES.ID, STATUS_ID);
          this.domProvider.addClass(this.statusEl, PROJECT_CLASSES.SR_ONLY);
          this.domProvider.insertAdjacentElement(
            this.domProvider.getBody(),
            "beforeend",
            this.statusEl
          );
        }
      }
      fix() {
        this.changeDetection.subscribe(
          this.context,
          "status",
          `[${STATUS_ATTR}], [data-${STATUS_ATTR}]`,
          (statusEl) => this.onStatusShow(statusEl)
        );
      }
      onStatusShow(statusEl) {
        const statusElLabel = this.domProvider.getAttribute(statusEl, ARIA.LABEL);
        this.announceStatus(
          statusElLabel != null ? statusElLabel : statusEl.innerText
        );
        this.domProvider.removeAttribute(statusEl, STATUS_ATTR);
        this.domProvider.removeAttribute(statusEl, `data-${STATUS_ATTR}`);
        this.domProvider.removeAttribute(
          statusEl,
          PROJECT_CLASSES.AVOID_CHANGE_DETECTION
        );
      }
      announceStatus(status) {
        this.domProvider.innerText(this.statusEl, status.trim());
        this.domProvider.setTimeout(() => {
          this.domProvider.innerText(this.statusEl, "");
        }, 3e3);
      }
    }
    const statusApi = (context = "body") => {
      const domProvider = new DomProvider();
      const elementVisibility = new ElementVisibility();
      const changeDetection = ChangeDetection.getInstance(
        elementVisibility,
        domProvider
      );
      new StatusFixer(context, domProvider, changeDetection).fix();
    };

    const ACCESSIBILITY_BUTTON_ID = "u1-accessibility-button";
    const ACCESSIBILITY_ICON = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='25' height='30' viewBox='0 0 25 30'%3E%3Cg id='Group_2' data-name='Group 2' transform='translate(57 -21.604)'%3E%3Ccircle id='Ellipse_2' data-name='Ellipse 2' cx='3.5' cy='3.5' r='3.5' transform='translate(-48 21.604)' fill='%23fff'/%3E%3C/g%3E%3Cpath id='Path_7' data-name='Path 7' d='M443.339,303.731l-11-1-1,1,9,3v5l-3,13h2l4-10h1l4,10h2l-3-13v-5l9-3-1-1Z' transform='translate(-431.339 -294.731)' fill='%23fff'/%3E%3C/svg%3E%0A`;
    const U1_SHOULD_ACTIVATE_ACCESSIBILITY_KEY =
      "u1_should-activate-accessibility";
    const _AccessibilityButton = class {
      constructor() {
        this.getBackgroundColor = () => {
          var _a;
          const isActive = _AccessibilityButton.getShouldActivateAccessibility();
          const defaultColor =
            "linear-gradient(180deg, #4A00CB 0%, #7914C5 100%)";
          const customColor =
            (_a = this.stateManagement.getConfigurationStyle("button")) == null
              ? void 0
              : _a.background;
          return this.getAccessibilityButtonStyle(
            customColor != null ? customColor : defaultColor,
            isActive ? 1 : 0.8
          );
        };
        this.getAccessibilityButtonStyle = (bgColor, opacity = 1) => `
      #u1-accessibility-button {
        border: none;
        border-radius: 50px;
        width: 50px;
        height: 50px;
        background-size: 100%;
        background-repeat: no-repeat;
        background-position: center;
        position: fixed !important;
        background: ${bgColor} !important;
        opacity: ${opacity} !important;
        bottom: 20px;
        left: 20px;
        z-index: 2147483647 !important;
        cursor: pointer;
        padding: .5rem .5rem;
      }

      #u1-accessibility-button:before {
        content: url("${ACCESSIBILITY_ICON}");
      }
  `;
        this.domProvider = new DomProvider();
        this.stateManagement = StateManagement.getInstance();
        this.button = this.domProvider.createElement("button");
        if (_AccessibilityButton.getShouldShow()) {
          this.domProvider.setAttribute(
            this.button,
            ARIA.LABEL,
            U1_ACCESSIBILITY_BUTTON
          );
          !this.domProvider.getElementById(ACCESSIBILITY_BUTTON_ID) &&
            this.domProvider.append(
              this.button,
              document.body,
              ACCESSIBILITY_BUTTON_ID
            );
          this.domProvider.addEventListener(this.button, "click", () =>
            this.toggleAccessibility()
          );
          this.addStyle();
        }
      }
      toggleAccessibility() {
        const shouldActivateAccessibility =
          _AccessibilityButton.getShouldActivateAccessibility();
        localStorage.setItem(
          U1_SHOULD_ACTIVATE_ACCESSIBILITY_KEY,
          String(!shouldActivateAccessibility)
        );
        location.reload();
      }
      addStyle() {
        const style = this.getBackgroundColor();
        this.domProvider.addStyle(style, `${ACCESSIBILITY_BUTTON_ID}-style`);
      }
      static getShouldActivateAccessibility() {
        const serializedShouldActivateAccessibility = localStorage.getItem(
          U1_SHOULD_ACTIVATE_ACCESSIBILITY_KEY
        );
        return serializedShouldActivateAccessibility === null
          ? false
          : JSON.parse(serializedShouldActivateAccessibility);
      }
    };
    let AccessibilityButton = _AccessibilityButton;
    AccessibilityButton.initialize = () => {
      if (_AccessibilityButton.instance === void 0) {
        _AccessibilityButton.instance = new _AccessibilityButton();
      }
    };
    AccessibilityButton.getShouldShow = () => {
      var _a, _b, _c, _d;
      return (_d =
        (_c =
          (_b =
            (_a = window == null ? void 0 : window.u1stConfiguration) == null
              ? void 0
              : _a.desktop) == null
            ? void 0
            : _b.button) == null
          ? void 0
          : _c.display) != null
        ? _d
        : false;
    };

    var AccessibilityButton$1 = /*#__PURE__*/ Object.freeze({
      __proto__: null,
      AccessibilityButton: AccessibilityButton,
    });

    var __defProp$5 = Object.defineProperty;
    var __getOwnPropDesc$5 = Object.getOwnPropertyDescriptor;
    var __decorateClass$5 = (decorators, target, key, kind) => {
      var result =
        kind > 1 ? void 0 : kind ? __getOwnPropDesc$5(target, key) : target;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if ((decorator = decorators[i]))
          result =
            (kind ? decorator(target, key, result) : decorator(result)) || result;
      if (kind && result) __defProp$5(target, key, result);
      return result;
    };
    class FixerAbstract {
      constructor(
        context,
        domProvider,
        changeDetection,
        props,
        waitForElement,
        onClose
      ) {
        this.services = {};
        this.logger = Logger.getInstance();
        this.stateManagement = StateManagement.getInstance();
        this.domProvider = domProvider;
        this.observer = changeDetection;
        this.props = props;
        this.context = context;
        this.waitForElementSelector =
          waitForElement != null ? waitForElement : props.waitForFixer;
        this.init(onClose);
      }
      subscribe(fixerName, elementSelector, onClose) {
        this.observer.subscribe(
          this.context,
          fixerName,
          elementSelector,
          (visibleElement) => this.onFixerLoaded(visibleElement),
          onClose
        );
      }
      init(onClose) {
        const fixerName = Object.getPrototypeOf(this).constructor.name;
        if (typeof this.waitForElementSelector === "string")
          this.subscribe(fixerName, this.waitForElementSelector, onClose);
        else {
          this.waitForElementSelector.forEach((elementSelector) =>
            this.subscribe(fixerName, elementSelector, onClose)
          );
        }
      }
      queryAndFix(elementSelector, visibleElement) {
        const fixerElement = this.domProvider.querySelector(elementSelector);
        if (fixerElement) {
          this.tryFix(visibleElement);
        }
      }
      tryFix(visibleElement) {
        this.fix(visibleElement);
      }
      onFixerLoaded(visibleElement) {
        if (typeof this.waitForElementSelector === "string")
          this.queryAndFix(this.waitForElementSelector, visibleElement);
        else {
          this.waitForElementSelector.forEach((elementSelector) => {
            this.queryAndFix(elementSelector, visibleElement);
          });
        }
      }
    }
    __decorateClass$5([catchable], FixerAbstract.prototype, "init", 1);
    __decorateClass$5([catchable], FixerAbstract.prototype, "tryFix", 1);

    class AccordionRoles {
      constructor(domProvider, elementVisibility) {
        this.domProvider = domProvider;
        this.elementVisibility = elementVisibility;
      }
      assignOnLoadAccordionAttr(
        header,
        content,
        disabledSelector,
        headerContentMatch
      ) {
        var _a;
        this.handleHeaderId(header);
        const tagName =
          (_a = this.domProvider.getTagName(header)) == null
            ? void 0
            : _a.toLowerCase();
        if (tagName != "button") {
          this.domProvider.setAttribute(header, "role", "button");
          this.domProvider.setAttribute(header, "tabindex", "0");
        }
        this.setContentRoles(content, header);
        if (headerContentMatch) {
          const headerExpand = this.elementVisibility.isVisible(content);
          this.domProvider.setAttribute(
            header,
            ARIA.EXPANDED,
            String(headerExpand)
          );
          this.assignOnLoadAriaControlsAttr(header, content);
        } else {
          this.domProvider.setAttribute(header, ARIA.EXPANDED, "false");
        }
        if (
          disabledSelector &&
          this.domProvider.matches(header, disabledSelector)
        ) {
          this.domProvider.setAttribute(header, ARIA.DISABLED, "true");
        }
      }
      setContentRoles(content, header) {
        this.domProvider.setAttribute(content, ATTRIBUTES.ROLE, ROLE$1.REGION);
        const headerId = Utils$1.getOrCreateId(header);
        this.domProvider.setAttribute(content, ARIA.LABELLEDBY, headerId);
      }
      handleHeaderId(header) {
        Utils$1.getOrCreateId(header);
      }
      assignOnLoadAriaControlsAttr(header, content) {
        let contentId = this.domProvider.getAttribute(content, "id");
        if (contentId == null) {
          contentId = Utils$1.uuid();
          this.domProvider.setAttribute(content, "id", contentId);
        }
        this.domProvider.setAttribute(header, ARIA.CONTROLS, contentId);
      }
    }

    class AccordionEvents {
      constructor(context, domProvider, changeDetection, accordionRole) {
        this.context = context;
        this.domProvider = domProvider;
        this.changeDetection = changeDetection;
        this.accordionHeaders = new Array();
        this.accordionContent = new Array();
        this.headerStack = new Array();
        this.collapsesOthers = false;
        this.disabledHeaders = new Array();
        this.accordionRole = accordionRole;
      }
      initAccordionEvents(props) {
        const { collapsesOthers, selectors } = props;
        const { contentSelector, disabledElementsSelector, headerSelector } =
          selectors;
        this.accordionHeaders = this.domProvider.querySelectorAll(
          headerSelector,
          this.context
        );
        this.accordionContent = this.domProvider.querySelectorAll(
          contentSelector,
          this.context
        );
        this.collapsesOthers = collapsesOthers;
        this.disabledSelector = disabledElementsSelector;
        this.disabledHeaders = disabledElementsSelector
          ? this.accordionContent
          : new Array();
      }
      setAccordionEvents(contentSelector) {
        this.domProvider.addEventListenerToAll(
          this.accordionHeaders,
          "keydown",
          (event) => this.handleKeyboardEvent(event),
          true
        );
        this.domProvider.addEventListenerToAll(
          this.accordionHeaders,
          "click",
          (event) => this.handleMouseClick(event)
        );
        this.changeDetection.subscribe(
          this.context,
          "contentVisibility",
          contentSelector,
          (visibleContent) => this.accordionContentVisible(visibleContent),
          (hiddenContent) => this.accordionContentHidden(hiddenContent)
        );
      }
      handleKeyboardEvent(event) {
        const { code } = event;
        if (code === "Space" || code === "Enter") {
          event.preventDefault();
          event.stopPropagation();
          const target = event.currentTarget;
          this.domProvider.dispatchClickEvent(target);
        }
      }
      handleMouseClick(event) {
        const target = event.currentTarget;
        this.headerStack.push(target);
      }
      accordionContentVisible(content) {
        this.collapsesOthers && this.collapseAllContents();
        if (this.headerStack.length > 0) {
          const header = this.headerStack.pop();
          this.setLabelledby(content, header);
          if (this.domProvider.getAttribute(content, ATTRIBUTES.ID) === null) {
            this.setContentId(content, header);
          }
          this.assignExpandedEvent(header, content, true);
          this.assignNewContentEvent(header, content);
        }
      }
      accordionContentHidden(content) {
        this.collapsesOthers && this.collapseAllContents();
        let header = this.headerStack.pop();
        if (this.isInDifferentPanel(content, header)) {
          header && this.headerStack.push(header);
          header = this.getCorrectHeader(content);
        }
        this.domProvider.setAttribute(header, ARIA.EXPANDED, "false");
        if (this.headerStack.length > 0) {
          header && this.assignExpandedEvent(header, content, false);
        }
      }
      isInDifferentPanel(content, header) {
        var _a;
        const headerId =
          (_a = this.domProvider.getAttribute(content, ARIA.LABELLEDBY)) != null
            ? _a
            : "";
        return this.domProvider.getAttribute(header, ATTRIBUTES.ID) !== headerId;
      }
      getCorrectHeader(content) {
        var _a;
        const headerId =
          (_a = this.domProvider.getAttribute(content, ARIA.LABELLEDBY)) != null
            ? _a
            : "";
        return this.domProvider.getElementById(headerId);
      }
      setLabelledby(content, header) {
        var _a;
        const headerId =
          (_a = this.domProvider.getAttribute(header, ATTRIBUTES.ID)) != null
            ? _a
            : "";
        this.domProvider.setAttribute(content, ARIA.LABELLEDBY, headerId);
      }
      setContentId(content, header) {
        const ariaControlsId = this.domProvider.getAttribute(
          header,
          ARIA.CONTROLS
        );
        if (ariaControlsId !== null) {
          this.domProvider.setAttribute(content, ATTRIBUTES.ID, ariaControlsId);
        }
      }
      collapseAllContents() {
        this.domProvider.setAttributeToAll(
          this.accordionHeaders,
          ARIA.EXPANDED,
          "false"
        );
        this.domProvider.setAttributeToAll(
          this.disabledHeaders,
          ARIA.EXPANDED,
          "false"
        );
        this.domProvider.setAttributeToAll(
          this.accordionContent,
          ARIA.HIDDEN,
          "true"
        );
      }
      assignExpandedEvent(header, content, expandedValue) {
        const disabledSelector = this.disabledSelector;
        if (
          disabledSelector &&
          this.domProvider.matches(header, disabledSelector)
        ) {
          this.domProvider.setAttribute(
            header,
            ARIA.DISABLED,
            String(expandedValue)
          );
        }
        this.domProvider.setAttribute(
          header,
          ARIA.EXPANDED,
          String(expandedValue)
        );
        this.domProvider.setAttribute(
          content,
          ARIA.HIDDEN,
          String(!expandedValue)
        );
      }
      assignNewContentEvent(header, content) {
        if (
          content != void 0 &&
          this.domProvider.getAttribute(header, ARIA.CONTROLS) == null
        ) {
          let contentId = this.domProvider.getAttribute(content, "id");
          if (contentId == null) {
            contentId = Utils$1.uuid();
            this.domProvider.setAttribute(content, "id", contentId);
          }
          this.domProvider.setAttribute(header, ARIA.CONTROLS, contentId);
        }
        this.accordionRole.setContentRoles(content, header);
      }
    }

    class AccordionFixer extends FixerAbstract {
      constructor(
        context,
        props,
        domProvider,
        changeDetection,
        accordionRoles,
        accordionEvents
      ) {
        super(
          context,
          domProvider,
          changeDetection,
          props,
          props.selectors.headerSelector
        );
        this.accordionRoles = accordionRoles;
        this.accordionEvents = accordionEvents;
      }
      fix() {
        this.accordionEvents.initAccordionEvents(this.props);
        const { headerSelector, contentSelector, disabledElementsSelector } =
          this.props.selectors;
        const accordionHeaders = this.domProvider.querySelectorAll(
          headerSelector,
          this.context
        );
        const accordionContent = this.domProvider.querySelectorAll(
          contentSelector,
          this.context
        );
        const headerContentMatch =
          accordionHeaders.length == accordionContent.length;
        for (let i = 0; i < accordionHeaders.length; i++) {
          this.accordionRoles.assignOnLoadAccordionAttr(
            accordionHeaders[i],
            accordionContent[i],
            disabledElementsSelector,
            headerContentMatch
          );
        }
        this.accordionEvents.setAccordionEvents(contentSelector);
      }
    }
    const AccordionApi = (context = "body") => {
      const domProvider = new DomProvider();
      const elementVisibility = new ElementVisibility();
      const changeDetection = ChangeDetection.getInstance(
        elementVisibility,
        domProvider
      );
      const accordionRoles = new AccordionRoles(domProvider, elementVisibility);
      const accordionEvents = new AccordionEvents(
        context,
        domProvider,
        changeDetection,
        accordionRoles
      );
      return (props) => {
        new AccordionFixer(
          context,
          props,
          domProvider,
          changeDetection,
          accordionRoles,
          accordionEvents
        );
      };
    };

    const free = (constructor) => {
      constructor.prototype.isFreeFixer = true;
    };

    var __defProp$4 = Object.defineProperty;
    var __getOwnPropDesc$4 = Object.getOwnPropertyDescriptor;
    var __decorateClass$4 = (decorators, target, key, kind) => {
      var result =
        kind > 1 ? void 0 : kind ? __getOwnPropDesc$4(target, key) : target;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if ((decorator = decorators[i]))
          result =
            (kind ? decorator(target, key, result) : decorator(result)) || result;
      if (kind && result) __defProp$4(target, key, result);
      return result;
    };
    let ButtonFixer = class extends FixerAbstract {
      constructor(context, props, domProvider, changeDetection) {
        super(
          context,
          domProvider,
          changeDetection,
          props,
          props.selectors.element
        );
        this.buttons = [];
      }
      fix() {
        const focusTo = this.props.selectors.focusTo;
        const label = this.props.label;
        this.buttons = this.domProvider.querySelectorAll(
          this.props.selectors.element
        );
        this.buttons &&
          this.buttons.forEach((element) => {
            const isButton = element instanceof HTMLButtonElement;
            if (!isButton) {
              this.domProvider.setAttribute(element, "role", ROLE$1.BUTTON);
              this.domProvider.setAttribute(element, "tabindex", "0");
              this.domProvider.addEventListener(element, "keydown", (e) =>
                this.addMouseEvent(e, element)
              );
            }
            if (label)
              this.domProvider.setAttribute(element, "aria-label", label);
            const focusToId =
              focusTo != null
                ? focusTo
                : this.domProvider.getAttribute(element, "u1-to");
            if (focusToId) {
              const id = focusToId.replace("#", "");
              this.domProvider.addEventListener(element, "click", () => {
                const focusToEl = this.domProvider.getElementById(id);
                this.domProvider.setAttribute(
                  focusToEl,
                  FOCUS_TO_ATTRIBUTE,
                  "true"
                );
              });
            }
          });
      }
      addMouseEvent(e, el) {
        const evt = e;
        if (evt.code === "Enter" || evt.code === "Space") {
          this.domProvider.dispatchMouseClickEvent(el);
          evt.preventDefault();
        }
      }
    };
    ButtonFixer = __decorateClass$4([free], ButtonFixer);

    class ToggleStateService {
      constructor(domProvider, clickOnly) {
        this.domProvider = domProvider;
        this.clickOnly = clickOnly;
      }
      fix(element, stateProps, attributeName, siblings) {
        if (stateProps.stateHandler) {
          const callback = (mutationsList) => {
            mutationsList.forEach(() => {
              if (stateProps.stateHandler && stateProps.stateHandler(element)) {
                this.handleState(element, true, attributeName, siblings);
              } else {
                this.handleState(element, false, attributeName, siblings);
              }
            });
          };
          const config = { attributes: true, childList: true, subtree: true };
          const observer = new MutationObserver(callback);
          observer.observe(element, config);
          return;
        }
        const { trueState, falseState } = stateProps.selectors;
        const isTrue = trueState
          ? this.domProvider.matches(element, trueState)
          : false;
        const isFalse = falseState
          ? this.domProvider.matches(element, falseState)
          : false;
        if ((isTrue && !isFalse) || (!isTrue && isFalse)) {
          this.handleState(element, isTrue, attributeName, siblings);
        } else if (trueState !== void 0) {
          const isChecked = element.querySelector(trueState) !== null;
          this.handleState(element, isChecked, attributeName, siblings);
        }
      }
      handleState(element, value, attributeName, siblings) {
        this.domProvider.setAttribute(element, attributeName, String(value));
        !this.clickOnly &&
          this.domProvider.addEventListener(element, "keypress", (e) =>
            this.handleKeydown(e, attributeName)
          );
        fromEvent(element, "click")
          .pipe(debounce(() => timer(0)))
          .subscribe((event) => {
            this.handleAria(element, attributeName);
            siblings && this.handleSiblingsAria(attributeName, siblings);
            if (event.target !== element) {
              element.focus();
            }
          });
      }
      handleKeydown(e, attribute) {
        const evt = e;
        if (evt.code === "Enter" || evt.code === "Space") {
          this.handleAria(e.target, attribute);
          evt.preventDefault();
        }
      }
      handleAria(el, attribute) {
        const attrValue = this.domProvider.getAttribute(el, attribute);
        if (!attrValue) return;
        const updatedValue = !(attrValue === "true");
        this.domProvider.setAttribute(el, attribute, String(updatedValue));
      }
      handleSiblingsAria(attribute, elements) {
        elements == null
          ? void 0
          : elements.forEach((el) =>
              this.domProvider.setAttribute(el, attribute, "false")
            );
      }
      runHandler(stateHandler) {
        stateHandler();
      }
    }

    class ToggleButtonFixer extends ButtonFixer {
      constructor(context, props, domProvider, changeDetection) {
        super(context, props, domProvider, changeDetection);
      }
      fix() {
        super.fix();
        const { pressedState, notPressedState, element } =
          this.props.selectors.toggleSelectors;
        const stateService = new ToggleStateService(this.domProvider, true);
        const stateProps = {
          selectors: {
            trueState: pressedState,
            falseState: notPressedState,
            element,
          },
          stateHandler: this.props.stateHandler,
        };
        this.buttons &&
          this.buttons.forEach((element2) => {
            stateService.fix(element2, stateProps, ARIA.PRESSED);
          });
      }
    }

    const ButtonApi = (context = "body") => {
      const domProvider = new DomProvider();
      const elementVisibility = new ElementVisibility();
      const changeDetection = ChangeDetection.getInstance(
        elementVisibility,
        domProvider
      );
      return function (props) {
        new ButtonFixer(context, props, domProvider, changeDetection);
      };
    };
    const ToggleButtonApi = (context = "body") => {
      const domProvider = new DomProvider();
      const elementVisibility = new ElementVisibility();
      const changeDetection = ChangeDetection.getInstance(
        elementVisibility,
        domProvider
      );
      return function (props) {
        new ToggleButtonFixer(context, props, domProvider, changeDetection);
      };
    };

    class CarouselFixer extends FixerAbstract {
      constructor(
        context,
        props,
        domProvider,
        changeDetection,
        carouselRoles,
        movingContent
      ) {
        super(
          context,
          domProvider,
          changeDetection,
          props,
          props.selectors.carouselContainer
        );
        this.carouselRoles = carouselRoles;
        this.movingContent = movingContent;
      }
      fix(visibleElement) {
        this.carouselRoles.handleCarouselRoles(visibleElement, this.props);
        this.movingContent.handleMovingContent(this.props);
      }
    }

    var Direction = /* @__PURE__ */ ((Direction2) => {
      Direction2[(Direction2["Right"] = 1)] = "Right";
      Direction2[(Direction2["Left"] = -1)] = "Left";
      return Direction2;
    })(Direction || {});

    class MovingContent {
      constructor(domProvider) {
        this.domProvider = domProvider;
      }
      handleMovingContent(props) {
        const {
          carouselContainer,
          slide,
          slidePickerButtons,
          prevButton,
          nextButton,
        } = props.selectors;
        const slides = this.domProvider.querySelectorAll(
          slide,
          carouselContainer
        );
        const prev =
          prevButton &&
          this.domProvider.querySelector(prevButton, carouselContainer);
        const next =
          nextButton &&
          this.domProvider.querySelector(nextButton, carouselContainer);
        const pickers =
          slidePickerButtons &&
          this.domProvider.querySelectorAll(
            slidePickerButtons,
            carouselContainer
          );
        this.initialProps(slides, props);
        if (prev && next) {
          this.domProvider.addEventListener(next, "click", () =>
            this.handleButtonClick(slides, Direction.Right, pickers, props)
          );
          this.domProvider.addEventListener(prev, "click", () =>
            this.handleButtonClick(slides, Direction.Left, pickers, props)
          );
        }
        if (pickers) {
          pickers.forEach((picker, i) =>
            this.domProvider.addEventListener(picker, "click", () =>
              this.handlePickerClick(slides, i, pickers, props)
            )
          );
        }
      }
      initialProps(slides, props) {
        var _a;
        if ((_a = props.selectors) == null ? void 0 : _a.activeSlides) {
          this.handleMultipleSlides(props);
          this.domProvider.addEventListenerToAll(slides, "click", () => {
            this.handleMultipleSlides(props);
          });
        } else {
          this.domProvider.addClass(slides[0], PROJECT_CLASSES.ACTIVE_ELEMENT);
          for (let i = 1; i < slides.length; i++)
            this.domProvider.setAttribute(slides[i], ARIA.HIDDEN, "true");
        }
      }
      handleButtonClick(slides, direction, pickers, props) {
        var _a;
        const currentIndex = this.getCurrentSlideIndex(slides);
        const nextActiveIndex = this.getNextIndex(
          currentIndex,
          slides.length,
          direction
        );
        ((_a = props.selectors) == null ? void 0 : _a.activeSlides)
          ? this.handleMultipleSlides(props)
          : this.handleSingleSlide(slides[currentIndex], slides[nextActiveIndex]);
        pickers &&
          this.handlePicker(pickers[currentIndex], pickers[nextActiveIndex]);
      }
      handlePickerClick(slides, nextActiveIndex, pickers, props) {
        var _a;
        const currentSlide = slides[this.getCurrentSlideIndex(slides)];
        const currentPicker = pickers[this.getCurrentSlideIndex(slides)];
        ((_a = props.selectors) == null ? void 0 : _a.activeSlides)
          ? this.handleMultipleSlides(props)
          : this.handleSingleSlide(currentSlide, slides[nextActiveIndex]);
        this.handlePicker(currentPicker, pickers[nextActiveIndex]);
      }
      getCurrentSlideIndex(slides) {
        return slides.findIndex((slide) =>
          this.domProvider.hasClass(slide, PROJECT_CLASSES.ACTIVE_ELEMENT)
        );
      }
      getNextIndex(currentIndex, length, direction) {
        if (currentIndex + direction >= length) return 0;
        if (currentIndex + direction < 0) return length - 1;
        return currentIndex + direction;
      }
      handleMultipleSlides(props) {
        this.domProvider.setTimeout(() => {
          if (props.selectors.activeSlides) {
            const { activeSlides, carouselContainer, slide } = props.selectors;
            const currentActiveSlides = this.domProvider.querySelectorAll(
              activeSlides,
              carouselContainer
            );
            currentActiveSlides.forEach((slide2) =>
              Utils$1.makeElementTabbable(slide2)
            );
            const nonActiveSlides = this.domProvider.querySelectorAll(
              `${slide}:not(${activeSlides})`,
              carouselContainer
            );
            nonActiveSlides.forEach((slide2) => Utils$1.hideElement(slide2));
          }
        }, 1e3);
      }
      handleSingleSlide(current, nextActiveSlide) {
        if (current === nextActiveSlide) return;
        this.domProvider.removeClass(current, PROJECT_CLASSES.ACTIVE_ELEMENT);
        this.domProvider.setAttribute(current, ARIA.HIDDEN, "true");
        this.domProvider.addClass(
          nextActiveSlide,
          PROJECT_CLASSES.ACTIVE_ELEMENT
        );
        this.domProvider.setAttribute(nextActiveSlide, ARIA.HIDDEN, "false");
      }
      handlePicker(current, nextActivePicker) {
        if (current === nextActivePicker) return;
        this.domProvider.setAttribute(current, ARIA.DISABLED, "false");
        this.domProvider.setAttribute(nextActivePicker, ARIA.DISABLED, "true");
      }
    }

    const en = {
      OPEN_MENU_SKIP_LINK: "Open Accessibility Menu",
      ACCESSIBILITY_BUTTON: "Accessibility",
      NEXT_MONTH: "next month",
      NEXT_YEAR: "next year",
      PREV_MONTH: "previous month",
      PREV_YEAR: "previous year",
      CHOOSE_DATE: "choose date",
      MAIN_SKIP_LINK: "Skip to Main",
      SEARCH_SKIP_LINK: "Skip to Search",
      NAVIGATION_SKIP_LINK: "Skip to Navigation",
      ZOOM_IN: "Zoom-In",
      ZOOM_OUT: "Zoom-Out",
      DESKTOP_SNOOZE_TEXT: `To make this website accessible to screen reader, press combination of alt and 1 keys.
    To stop getting this message, press the combination of alt and 2 keys.`,
      MOBILE_ACTIVATE_SR_SNOOZE_TEXT: "Adjust the page for a screen reader",
      MOBILE_DISABLE_SNOOZE_TEXT: "Turn off screen reader adjustment suggestion",
      PREV_SLIDE: "previous slide",
      NEXT_SLIDE: "next slide",
      CHOOSE_DISPLAY: "Choose slide to display",
      OF: "of",
      SLIDE: "slide",
      CAROUSEL: "carousel",
      CLOSE: "close",
      PREV_PAGE: "previous page",
      NEXT_PAGE: "next page",
      PREV_SKIP: "skip {{skipAmount}} pages back",
      NEXT_SKIP: "skip {{skipAmount}} pages forward",
      FEW: "few",
      PAGE: "page",
      SLIDES: "slides navigation",
      LOADING: "loading, please wait",
    };

    const he = {
      OPEN_MENU_SKIP_LINK:
        "\u05E4\u05EA\u05D7 \u05EA\u05E4\u05E8\u05D9\u05D8 \u05E0\u05D2\u05D9\u05E9\u05D5\u05EA",
      ACCESSIBILITY_BUTTON: "\u05E0\u05D2\u05D9\u05E9\u05D5\u05EA",
      NEXT_MONTH: "\u05D7\u05D5\u05D3\u05E9 \u05D4\u05D1\u05D0",
      NEXT_YEAR: "\u05E9\u05E0\u05D4 \u05D4\u05D1\u05D0\u05D4",
      PREV_MONTH: "\u05D7\u05D5\u05D3\u05E9 \u05E7\u05D5\u05D3\u05DD",
      PREV_YEAR: "\u05E9\u05E0\u05D4 \u05E7\u05D5\u05D3\u05DE\u05EA",
      CHOOSE_DATE:
        "\u05D1\u05D7\u05D9\u05E8\u05EA \u05EA\u05D0\u05E8\u05D9\u05DA",
      MAIN_SKIP_LINK:
        "\u05D3\u05DC\u05D2 \u05DC\u05EA\u05D5\u05DB\u05DF \u05DE\u05E8\u05DB\u05D6\u05D9",
      SEARCH_SKIP_LINK: "\u05D3\u05DC\u05D2 \u05DC\u05D7\u05D9\u05E4\u05D5\u05E9",
      NAVIGATION_SKIP_LINK:
        "\u05D3\u05DC\u05D2 \u05DC\u05E0\u05D9\u05D5\u05D5\u05D8",
      ZOOM_IN: "\u05D4\u05D2\u05D3\u05DC \u05D8\u05E7\u05E1\u05D8",
      ZOOM_OUT: "\u05D4\u05E7\u05D8\u05DF \u05D8\u05E7\u05E1\u05D8",
      DESKTOP_SNOOZE_TEXT: `To make this website accessible to screen reader, press combination of alt and 1 keys.
    To stop getting this message, press the combination of alt and 2 keys.`,
      MOBILE_ACTIVATE_SR_SNOOZE_TEXT: "Adjust the page for a screen reader",
      MOBILE_DISABLE_SNOOZE_TEXT: "Turn off screen reader adjustment suggestion",
      PREV_SLIDE:
        "\u05E9\u05E7\u05D5\u05E4\u05D9\u05EA \u05E7\u05D5\u05D3\u05DE\u05EA",
      NEXT_SLIDE: "\u05E9\u05E7\u05D5\u05E4\u05D9\u05EA \u05D4\u05D1\u05D0\u05D4",
      CHOOSE_DISPLAY:
        "\u05D1\u05D7\u05E8 \u05E9\u05E7\u05E3 \u05DC\u05D4\u05E6\u05D2\u05D4",
      OF: "\u05DE\u05EA\u05D5\u05DA",
      SLIDE: "\u05E9\u05E7\u05D5\u05E4\u05D9\u05EA",
      CAROUSEL:
        "\u05E1\u05DC\u05D9\u05D9\u05D3\u05E8 \u05E9\u05E7\u05D5\u05E4\u05D9\u05D5\u05EA",
      CLOSE: "\u05E1\u05D2\u05D9\u05E8\u05D4",
      PREV_PAGE: "\u05E2\u05DE\u05D5\u05D3 \u05E7\u05D5\u05D3\u05DD",
      NEXT_PAGE: "\u05E2\u05DE\u05D5\u05D3 \u05D4\u05D1\u05D0",
      PREV_SKIP:
        "\u05E7\u05E4\u05D5\u05E5 {{skipAmount}} \u05E2\u05DE\u05D5\u05D3\u05D9\u05DD \u05D0\u05D7\u05D5\u05E8\u05D4",
      NEXT_SKIP:
        "\u05E7\u05E4\u05D5\u05E5 {{skipAmount}} \u05E2\u05DE\u05D5\u05D3\u05D9\u05DD \u05E7\u05D3\u05D9\u05DE\u05D4",
      FEW: "\u05DE\u05E1\u05E4\u05E8",
      PAGE: "\u05E2\u05DE\u05D5\u05D3",
      SLIDES:
        "\u05E0\u05D9\u05D5\u05D5\u05D8 \u05E9\u05E7\u05D5\u05E4\u05D9\u05D5\u05EA",
      LOADING:
        "\u05D1\u05D8\u05E2\u05D9\u05E0\u05D4, \u05D0\u05E0\u05D0 \u05D4\u05DE\u05EA\u05DF",
    };

    const da = {
      OPEN_MENU_SKIP_LINK: "",
      ACCESSIBILITY_BUTTON: "TILG\xC6NGELIGHED",
      NEXT_MONTH: "next month",
      NEXT_YEAR: "next year",
      PREV_MONTH: "previous month",
      PREV_YEAR: "previous year",
      CHOOSE_DATE: "choose date",
      MAIN_SKIP_LINK: "Skip to Main",
      SEARCH_SKIP_LINK: "Skip to Search",
      NAVIGATION_SKIP_LINK: "Skip to Navigation",
      ZOOM_IN: "Zoom-In",
      ZOOM_OUT: "Zoom-Out",
      DESKTOP_SNOOZE_TEXT: `To make this website accessible to screen reader, press combination of alt and 1 keys.
    To stop getting this message, press the combination of alt and 2 keys.`,
      MOBILE_ACTIVATE_SR_SNOOZE_TEXT: "Adjust the page for a screen reader",
      MOBILE_DISABLE_SNOOZE_TEXT: "Turn off screen reader adjustment suggestion",
      PREV_SLIDE: "previous slide",
      NEXT_SLIDE: "next slide",
      CHOOSE_DISPLAY: "Choose slide to display",
      OF: "of",
      SLIDE: "slide",
      CAROUSEL: "carousel",
      CLOSE: "close",
      PREV_PAGE: "previous page",
      NEXT_PAGE: "next page",
      PREV_SKIP: "skip {{skipAmount}} pages back",
      NEXT_SKIP: "skip {{skipAmount}} pages forward",
      FEW: "few",
      PAGE: "page",
      SLIDES: "slides navigation",
      LOADING: "loading, please wait",
    };

    const de = {
      OPEN_MENU_SKIP_LINK: "Zug\xE4nglichkeitsmen\xFC \xF6ffnen",
      ACCESSIBILITY_BUTTON: "Zug\xE4nglichkeit",
      NEXT_MONTH: "next month",
      NEXT_YEAR: "next year",
      PREV_MONTH: "previous month",
      PREV_YEAR: "previous year",
      CHOOSE_DATE: "choose date",
      MAIN_SKIP_LINK: "Skip to Main",
      SEARCH_SKIP_LINK: "Skip to Search",
      NAVIGATION_SKIP_LINK: "Skip to Navigation",
      ZOOM_IN: "Zoom-In",
      ZOOM_OUT: "Zoom-Out",
      DESKTOP_SNOOZE_TEXT: `To make this website accessible to screen reader, press combination of alt and 1 keys.
    To stop getting this message, press the combination of alt and 2 keys.`,
      MOBILE_ACTIVATE_SR_SNOOZE_TEXT: "Adjust the page for a screen reader",
      MOBILE_DISABLE_SNOOZE_TEXT: "Turn off screen reader adjustment suggestion",
      PREV_SLIDE: "previous slide",
      NEXT_SLIDE: "next slide",
      CHOOSE_DISPLAY: "Choose slide to display",
      OF: "of",
      SLIDE: "slide",
      CAROUSEL: "carousel",
      CLOSE: "close",
      PREV_PAGE: "previous page",
      NEXT_PAGE: "next page",
      PREV_SKIP: "skip {{skipAmount}} pages back",
      NEXT_SKIP: "skip {{skipAmount}} pages forward",
      FEW: "few",
      PAGE: "page",
      SLIDES: "slides navigation",
      LOADING: "loading, please wait",
    };

    const es = {
      OPEN_MENU_SKIP_LINK: "Ir al men\xFA accesibilidad",
      ACCESSIBILITY_BUTTON: "Accesibilidad",
      NEXT_MONTH: "next month",
      NEXT_YEAR: "next year",
      PREV_MONTH: "previous month",
      PREV_YEAR: "previous year",
      CHOOSE_DATE: "choose date",
      MAIN_SKIP_LINK: "Skip to Main",
      SEARCH_SKIP_LINK: "Skip to Search",
      NAVIGATION_SKIP_LINK: "Skip to Navigation",
      ZOOM_IN: "Zoom-In",
      ZOOM_OUT: "Zoom-Out",
      DESKTOP_SNOOZE_TEXT: `To make this website accessible to screen reader, press combination of alt and 1 keys.
    To stop getting this message, press the combination of alt and 2 keys.`,
      MOBILE_ACTIVATE_SR_SNOOZE_TEXT: "Adjust the page for a screen reader",
      MOBILE_DISABLE_SNOOZE_TEXT: "Turn off screen reader adjustment suggestion",
      PREV_SLIDE: "previous slide",
      NEXT_SLIDE: "next slide",
      CHOOSE_DISPLAY: "Choose slide to display",
      OF: "of",
      SLIDE: "slide",
      CAROUSEL: "carousel",
      CLOSE: "close",
      PREV_PAGE: "previous page",
      NEXT_PAGE: "next page",
      PREV_SKIP: "skip {{skipAmount}} pages back",
      NEXT_SKIP: "skip {{skipAmount}} pages forward",
      FEW: "few",
      PAGE: "page",
      SLIDES: "slides navigation",
      LOADING: "loading, please wait",
    };

    const fr = {
      OPEN_MENU_SKIP_LINK: "Aller au menu d\u2019accessibilit\xE9",
      ACCESSIBILITY_BUTTON: "Accessibilit\xE9",
      NEXT_MONTH: "next month",
      NEXT_YEAR: "next year",
      PREV_MONTH: "previous month",
      PREV_YEAR: "previous year",
      CHOOSE_DATE: "choose date",
      MAIN_SKIP_LINK: "Skip to Main",
      SEARCH_SKIP_LINK: "Skip to Search",
      NAVIGATION_SKIP_LINK: "Skip to Navigation",
      ZOOM_IN: "Zoom-In",
      ZOOM_OUT: "Zoom-Out",
      DESKTOP_SNOOZE_TEXT: `To make this website accessible to screen reader, press combination of alt and 1 keys.
    To stop getting this message, press the combination of alt and 2 keys.`,
      MOBILE_ACTIVATE_SR_SNOOZE_TEXT: "Adjust the page for a screen reader",
      MOBILE_DISABLE_SNOOZE_TEXT: "Turn off screen reader adjustment suggestion",
      PREV_SLIDE: "previous slide",
      NEXT_SLIDE: "next slide",
      CHOOSE_DISPLAY: "Choose slide to display",
      OF: "of",
      SLIDE: "slide",
      CAROUSEL: "carousel",
      CLOSE: "close",
      PREV_PAGE: "previous page",
      NEXT_PAGE: "next page",
      PREV_SKIP: "skip {{skipAmount}} pages back",
      NEXT_SKIP: "skip {{skipAmount}} pages forward",
      FEW: "few",
      PAGE: "page",
      SLIDES: "slides navigation",
      LOADING: "loading, please wait",
    };

    const pt = {
      OPEN_MENU_SKIP_LINK: "Ativar o menu de acessibilidade",
      ACCESSIBILITY_BUTTON: "Acessibilidade",
      NEXT_MONTH: "next month",
      NEXT_YEAR: "next year",
      PREV_MONTH: "previous month",
      PREV_YEAR: "previous year",
      CHOOSE_DATE: "choose date",
      MAIN_SKIP_LINK: "Skip to Main",
      SEARCH_SKIP_LINK: "Skip to Search",
      NAVIGATION_SKIP_LINK: "Skip to Navigation",
      ZOOM_IN: "Zoom-In",
      ZOOM_OUT: "Zoom-Out",
      DESKTOP_SNOOZE_TEXT: `To make this website accessible to screen reader, press combination of alt and 1 keys.
    To stop getting this message, press the combination of alt and 2 keys.`,
      MOBILE_ACTIVATE_SR_SNOOZE_TEXT: "Adjust the page for a screen reader",
      MOBILE_DISABLE_SNOOZE_TEXT: "Turn off screen reader adjustment suggestion",
      PREV_SLIDE: "previous slide",
      NEXT_SLIDE: "next slide",
      CHOOSE_DISPLAY: "Choose slide to display",
      OF: "of",
      SLIDE: "slide",
      CAROUSEL: "carousel",
      CLOSE: "close",
      PREV_PAGE: "previous page",
      NEXT_PAGE: "next page",
      PREV_SKIP: "skip {{skipAmount}} pages back",
      NEXT_SKIP: "skip {{skipAmount}} pages forward",
      FEW: "few",
      PAGE: "page",
      SLIDES: "slides navigation",
      LOADING: "loading, please wait",
    };

    const sv = {
      OPEN_MENU_SKIP_LINK: "",
      ACCESSIBILITY_BUTTON: "Tillg\xE4nglighet",
      NEXT_MONTH: "next month",
      NEXT_YEAR: "next year",
      PREV_MONTH: "previous month",
      PREV_YEAR: "previous year",
      CHOOSE_DATE: "choose date",
      MAIN_SKIP_LINK: "Skip to Main",
      SEARCH_SKIP_LINK: "Skip to Search",
      NAVIGATION_SKIP_LINK: "Skip to Navigation",
      ZOOM_IN: "Zoom-In",
      ZOOM_OUT: "Zoom-Out",
      DESKTOP_SNOOZE_TEXT: `To make this website accessible to screen reader, press combination of alt and 1 keys.
    To stop getting this message, press the combination of alt and 2 keys.`,
      MOBILE_ACTIVATE_SR_SNOOZE_TEXT: "Adjust the page for a screen reader",
      MOBILE_DISABLE_SNOOZE_TEXT: "Turn off screen reader adjustment suggestion",
      PREV_SLIDE: "previous slide",
      NEXT_SLIDE: "next slide",
      CHOOSE_DISPLAY: "Choose slide to display",
      OF: "of",
      SLIDE: "slide",
      CAROUSEL: "carousel",
      CLOSE: "close",
      PREV_PAGE: "previous page",
      NEXT_PAGE: "next page",
      PREV_SKIP: "skip {{skipAmount}} pages back",
      NEXT_SKIP: "skip {{skipAmount}} pages forward",
      FEW: "few",
      PAGE: "page",
      SLIDES: "slides navigation",
      LOADING: "loading, please wait",
    };

    const nl = {
      OPEN_MENU_SKIP_LINK: "Klik voor toegankelijkheidsmenu",
      ACCESSIBILITY_BUTTON: "Toegankelijkheid",
      NEXT_MONTH: "next month",
      NEXT_YEAR: "next year",
      PREV_MONTH: "previous month",
      PREV_YEAR: "previous year",
      CHOOSE_DATE: "choose date",
      MAIN_SKIP_LINK: "Skip to Main",
      SEARCH_SKIP_LINK: "Skip to Search",
      NAVIGATION_SKIP_LINK: "Skip to Navigation",
      ZOOM_IN: "Zoom-In",
      ZOOM_OUT: "Zoom-Out",
      DESKTOP_SNOOZE_TEXT: `To make this website accessible to screen reader, press combination of alt and 1 keys.
    To stop getting this message, press the combination of alt and 2 keys.`,
      MOBILE_ACTIVATE_SR_SNOOZE_TEXT: "Adjust the page for a screen reader",
      MOBILE_DISABLE_SNOOZE_TEXT: "Turn off screen reader adjustment suggestion",
      PREV_SLIDE: "previous slide",
      NEXT_SLIDE: "next slide",
      CHOOSE_DISPLAY: "Choose slide to display",
      OF: "of",
      SLIDE: "slide",
      CAROUSEL: "carousel",
      CLOSE: "close",
      PREV_PAGE: "previous page",
      NEXT_PAGE: "next page",
      PREV_SKIP: "skip {{skipAmount}} pages back",
      NEXT_SKIP: "skip {{skipAmount}} pages forward",
      FEW: "few",
      PAGE: "page",
      SLIDES: "slides navigation",
      LOADING: "loading, please wait",
    };

    var TranslateText = /* @__PURE__ */ ((TranslateText2) => {
      TranslateText2[(TranslateText2["OPEN_MENU_SKIP_LINK"] = 0)] =
        "OPEN_MENU_SKIP_LINK";
      TranslateText2[(TranslateText2["ACCESSIBILITY_BUTTON"] = 1)] =
        "ACCESSIBILITY_BUTTON";
      TranslateText2[(TranslateText2["NEXT_MONTH"] = 2)] = "NEXT_MONTH";
      TranslateText2[(TranslateText2["NEXT_YEAR"] = 3)] = "NEXT_YEAR";
      TranslateText2[(TranslateText2["PREV_MONTH"] = 4)] = "PREV_MONTH";
      TranslateText2[(TranslateText2["PREV_YEAR"] = 5)] = "PREV_YEAR";
      TranslateText2[(TranslateText2["CHOOSE_DATE"] = 6)] = "CHOOSE_DATE";
      TranslateText2[(TranslateText2["MAIN_SKIP_LINK"] = 7)] = "MAIN_SKIP_LINK";
      TranslateText2[(TranslateText2["SEARCH_SKIP_LINK"] = 8)] =
        "SEARCH_SKIP_LINK";
      TranslateText2[(TranslateText2["NAVIGATION_SKIP_LINK"] = 9)] =
        "NAVIGATION_SKIP_LINK";
      TranslateText2[(TranslateText2["ZOOM_IN"] = 10)] = "ZOOM_IN";
      TranslateText2[(TranslateText2["ZOOM_OUT"] = 11)] = "ZOOM_OUT";
      TranslateText2[(TranslateText2["DESKTOP_SNOOZE_TEXT"] = 12)] =
        "DESKTOP_SNOOZE_TEXT";
      TranslateText2[(TranslateText2["MOBILE_ACTIVATE_SR_SNOOZE_TEXT"] = 13)] =
        "MOBILE_ACTIVATE_SR_SNOOZE_TEXT";
      TranslateText2[(TranslateText2["MOBILE_DISABLE_SNOOZE_TEXT"] = 14)] =
        "MOBILE_DISABLE_SNOOZE_TEXT";
      TranslateText2[(TranslateText2["PREV_SLIDE"] = 15)] = "PREV_SLIDE";
      TranslateText2[(TranslateText2["NEXT_SLIDE"] = 16)] = "NEXT_SLIDE";
      TranslateText2[(TranslateText2["CHOOSE_DISPLAY"] = 17)] = "CHOOSE_DISPLAY";
      TranslateText2[(TranslateText2["OF"] = 18)] = "OF";
      TranslateText2[(TranslateText2["SLIDE"] = 19)] = "SLIDE";
      TranslateText2[(TranslateText2["CAROUSEL"] = 20)] = "CAROUSEL";
      TranslateText2[(TranslateText2["CLOSE"] = 21)] = "CLOSE";
      TranslateText2[(TranslateText2["PREV_PAGE"] = 22)] = "PREV_PAGE";
      TranslateText2[(TranslateText2["NEXT_PAGE"] = 23)] = "NEXT_PAGE";
      TranslateText2[(TranslateText2["PREV_SKIP"] = 24)] = "PREV_SKIP";
      TranslateText2[(TranslateText2["NEXT_SKIP"] = 25)] = "NEXT_SKIP";
      TranslateText2[(TranslateText2["FEW"] = 26)] = "FEW";
      TranslateText2[(TranslateText2["PAGE"] = 27)] = "PAGE";
      TranslateText2[(TranslateText2["SLIDES"] = 28)] = "SLIDES";
      TranslateText2[(TranslateText2["LOADING"] = 29)] = "LOADING";
      return TranslateText2;
    })(TranslateText || {});
    class Translate {
      constructor(stateManagement) {
        this.stateManagement = stateManagement;
        this.defaultLang = "en";
        this.availableLangs = {
          en,
          he,
          da,
          de,
          es,
          fr,
          pt,
          sv,
          nl,
        };
        this.getValue = (value) => {
          var _a, _b;
          const currLangDictionary =
            (_a = this.availableLangs[this.langDetected]) != null
              ? _a
              : this.availableLangs[this.defaultLang];
          const label = TranslateText[value];
          const text = (_b = currLangDictionary[label]) != null ? _b : "";
          return text;
        };
        this.isRtl = () => {
          return Utils$1.isRtl(this.stateManagement.getLang());
        };
        var _a;
        this.langDetected = (
          (_a = stateManagement.getLang()) != null ? _a : this.defaultLang
        ).toLowerCase();
      }
    }

    class CarouselRoles {
      constructor(domProvider, carouselButtons, translateService) {
        this.domProvider = domProvider;
        this.carouselButtons = carouselButtons;
        this.translateService = translateService;
      }
      handleCarouselRoles(carouselContainerElement, props) {
        const {
          slide,
          prevButton,
          nextButton,
          absoluteCarouselContainerLabel,
          slidePickerButtons,
        } = props.selectors;
        const slides = this.domProvider.querySelectorAll(
          slide,
          carouselContainerElement
        );
        this.handleCarouselContainer(
          carouselContainerElement,
          absoluteCarouselContainerLabel
        );
        this.handleCarouselSlides(slides);
        prevButton &&
          this.handleCarouselButtons(
            carouselContainerElement,
            prevButton,
            this.translateService.getValue(TranslateText.PREV_SLIDE)
          );
        nextButton &&
          this.handleCarouselButtons(
            carouselContainerElement,
            nextButton,
            this.translateService.getValue(TranslateText.NEXT_SLIDE)
          );
        if (slidePickerButtons) {
          const btnsContainer = Utils$1.getSharedParent(
            slidePickerButtons,
            carouselContainerElement
          );
          this.handleCarouselPickerButtons(
            slidePickerButtons,
            carouselContainerElement,
            btnsContainer,
            slides
          );
        }
      }
      handleCarouselContainer(el, absoluteLabel) {
        this.domProvider.setAttribute(el, ATTRIBUTES.ROLE, ROLE$1.GROUP);
        this.domProvider.setAttribute(
          el,
          ARIA.ROLEDESCRIPTION,
          this.translateService.getValue(TranslateText.CAROUSEL)
        );
        if (absoluteLabel) {
          const labelElement = this.domProvider.querySelector(absoluteLabel);
          this.domProvider.setAttributeWithID(labelElement, el, ARIA.LABELLEDBY);
        }
      }
      handleCarouselSlides(slides) {
        slides.forEach((slide) => {
          this.domProvider.setAttribute(slide, ATTRIBUTES.ROLE, ROLE$1.GROUP);
          this.domProvider.setAttribute(
            slide,
            ARIA.ROLEDESCRIPTION,
            this.translateService.getValue(TranslateText.SLIDE)
          );
        });
        const numOfSlides = slides.length;
        let currentIndex = 1;
        slides.forEach((slide) => {
          const ofValue = this.translateService.getValue(TranslateText.OF);
          const slideText = `${currentIndex} ${ofValue} ${numOfSlides}`;
          this.domProvider.setAttribute(slide, ARIA.LABEL, slideText);
          currentIndex = currentIndex === numOfSlides ? 1 : currentIndex + 1;
        });
      }
      handleCarouselButtons(context, selector, label) {
        const element = this.domProvider.querySelector(selector, context);
        if (element) {
          this.domProvider.setAttribute(element, ARIA.LABEL, label);
          this.carouselButtons.setButton(element);
        }
      }
      handleCarouselPickerButtons(
        pickerBtnsSelector,
        carouselContainerElement,
        pickersContainer,
        slides
      ) {
        if (pickersContainer) {
          this.domProvider.setAttribute(
            pickersContainer,
            ATTRIBUTES.ROLE,
            ROLE$1.GROUP
          );
          this.domProvider.setAttribute(
            pickersContainer,
            ARIA.LABEL,
            this.translateService.getValue(TranslateText.SLIDES)
          );
        }
        const pickerButtons = this.domProvider.querySelectorAll(
          pickerBtnsSelector,
          carouselContainerElement
        );
        pickerButtons.forEach((el, i) => {
          this.domProvider.addEventListener(
            el,
            "keyup",
            (e) => {
              e.preventDefault();
              e.stopPropagation();
            },
            true
          );
          this.carouselButtons.setButton(el);
          this.domProvider.setAttributeWithID(slides[i], el, ARIA.LABELLEDBY);
        });
      }
    }

    var KEY_CODES = /* @__PURE__ */ ((KEY_CODES2) => {
      KEY_CODES2["TAB"] = "Tab";
      KEY_CODES2["SHIFT_TAB"] = "ShiftLeft";
      KEY_CODES2["ENTER"] = "Enter";
      KEY_CODES2["ESC"] = "Escape";
      KEY_CODES2["SPACE"] = "Space";
      KEY_CODES2["PAGEUP"] = "PageUp";
      KEY_CODES2["PAGEDOWN"] = "PageDown";
      KEY_CODES2["END"] = "End";
      KEY_CODES2["HOME"] = "Home";
      KEY_CODES2["LEFT"] = "ArrowLeft";
      KEY_CODES2["UP"] = "ArrowUp";
      KEY_CODES2["RIGHT"] = "ArrowRight";
      KEY_CODES2["DOWN"] = "ArrowDown";
      return KEY_CODES2;
    })(KEY_CODES || {});

    class CarouselButtons {
      constructor(domProvider) {
        this.domProvider = domProvider;
      }
      setButton(element) {
        this.domProvider.setAttribute(element, ATTRIBUTES.ROLE, ROLE$1.BUTTON);
        this.domProvider.setAttribute(element, ATTRIBUTES.TABINDEX, "0");
        this.domProvider.addEventListener(element, "keydown", (e) => {
          this.addMouseEvent(e, element);
        });
      }
      addMouseEvent(e, el) {
        const evt = e;
        if (evt.code === KEY_CODES.ENTER || evt.code === KEY_CODES.SPACE) {
          this.domProvider.dispatchMouseClickEvent(el);
        }
      }
    }

    const CarouselApi = (context = "body") => {
      const domProvider = new DomProvider();
      const elementVisibility = new ElementVisibility();
      const changeDetection = ChangeDetection.getInstance(
        elementVisibility,
        domProvider
      );
      const carouselButtons = new CarouselButtons(domProvider);
      const stateManagement = StateManagement.getInstance();
      const translateService = new Translate(stateManagement);
      const carouselRoles = new CarouselRoles(
        domProvider,
        carouselButtons,
        translateService
      );
      const movingContent = new MovingContent(domProvider);
      return (props) => {
        new CarouselFixer(
          context,
          props,
          domProvider,
          changeDetection,
          carouselRoles,
          movingContent
        );
      };
    };

    class CheckboxFixer extends FixerAbstract {
      constructor(
        context,
        props,
        domProvider,
        changeDetection,
        toggleStateService,
        elementVisibility
      ) {
        super(
          context,
          domProvider,
          changeDetection,
          props,
          props.selectors.element
        );
        this.toggleStateService = toggleStateService;
        this.elementVisibility = elementVisibility;
      }
      fix(visibleElement) {
        const { checkedState, uncheckedState, exclude, disabled, label } =
          this.props.selectors;
        this.domProvider.setAttribute(
          visibleElement,
          ATTRIBUTES.ROLE,
          ROLE$1.CHECKBOX
        );
        this.domProvider.setAttribute(visibleElement, ATTRIBUTES.TABINDEX, "0");
        this.domProvider.addEventListener(visibleElement, "keydown", (e) =>
          this.addKeyboardEvent(e)
        );
        if ((checkedState && uncheckedState) || this.props.stateHandler) {
          const stateProps = {
            selectors: {
              trueState: checkedState,
              falseState: uncheckedState,
              element: this.props.selectors.element,
            },
            stateHandler: this.props.stateHandler,
          };
          this.toggleStateService.fix(visibleElement, stateProps, ARIA.CHECKED);
        }
        const elToExclude = this.domProvider.querySelectorAll(
          exclude,
          this.context
        );
        elToExclude.forEach(
          (el) =>
            !this.elementVisibility.isVisible(el) &&
            this.excludeFocusFromEl(el, visibleElement)
        );
        if (disabled) {
          const disabledEls = this.domProvider.querySelectorAll(
            disabled,
            this.context
          );
          disabledEls.forEach((el) => {
            this.domProvider.setAttribute(
              el,
              AVOID_AUTO_TABBABLE_ATTRIBUTE,
              "true"
            );
            this.domProvider.setAttribute(el, ATTRIBUTES.TABINDEX, "-1");
            this.domProvider.setAttribute(el, ARIA.DISABLED, "true");
          });
        }
        if (label) {
          const labelEl = this.domProvider.querySelector(label, this.context);
          const labelText = labelEl == null ? void 0 : labelEl.innerText.trim();
          labelText &&
            this.domProvider.setAttribute(visibleElement, ARIA.LABEL, labelText);
          this.domProvider.setAttribute(labelEl, ARIA.HIDDEN, "true");
        }
      }
      addKeyboardEvent(e) {
        const evt = e;
        if (evt.code === "Space") {
          this.domProvider.dispatchMouseClickEvent(evt.target);
          evt.preventDefault();
        }
      }
      excludeFocusFromEl(el, checkbox) {
        if (el === checkbox) return;
        el.style.visibility = "hidden";
        this.domProvider.setAttribute(
          el,
          PROJECT_CLASSES.EXCLUDE_ATTRIBUTE,
          "true"
        );
      }
    }
    const CheckboxApi = (context = "body") => {
      const domProvider = new DomProvider();
      const elementVisibility = new ElementVisibility();
      const changeDetection = ChangeDetection.getInstance(
        elementVisibility,
        domProvider
      );
      const toggleStateService = new ToggleStateService(domProvider, true);
      return (props) =>
        new CheckboxFixer(
          context,
          props,
          domProvider,
          changeDetection,
          toggleStateService,
          elementVisibility
        );
    };

    class ScrollService {
      constructor(domProvider = new DomProvider()) {
        this.domProvider = domProvider;
      }
      getScrollableElement(element) {
        while (element && element.tagName != "BODY") {
          if (
            element.scrollWidth > element.clientWidth ||
            element.scrollHeight > element.clientHeight
          ) {
            return element;
          }
          element = element.parentElement;
        }
        return null;
      }
      isElementInContainerView(element, container) {
        const elementRect = element.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();
        const isInView =
          elementRect.top >= containerRect.top &&
          elementRect.bottom <= containerRect.bottom;
        return isInView;
      }
      scrollElementIntoView(element, container, evtKey) {
        if (element) {
          !this.isElementInContainerView(element, container) &&
            this.domProvider.scrollIntoView(element);
        }
      }
    }

    class ListboxOption {
      constructor(domProvider) {
        this.domProvider = domProvider;
      }
      handleOption(optionsElement, optionId, group) {
        if (optionId) {
          this.domProvider.setAttribute(optionsElement, ATTRIBUTES.ID, optionId);
        }
        if (group) {
          const grouping = this.domProvider.getPreviousSiblingWithSelector(
            optionsElement,
            group
          );
          const groupId = grouping && Utils$1.getOrCreateId(grouping);
          groupId &&
            this.domProvider.setAttribute(
              optionsElement,
              ARIA.DESCRIBEDBY,
              groupId
            );
        }
        const elementsInsideOption = this.domProvider.querySelectorAll(
          "*",
          optionsElement
        );
        Utils$1.removeClientsWCAGAttributes(elementsInsideOption);
        this.domProvider.setAttribute(
          optionsElement,
          ATTRIBUTES.ROLE,
          ROLE$1.OPTION
        );
        if (Utils$1.isMobileDevice()) {
          this.domProvider.setAttribute(optionsElement, ATTRIBUTES.TABINDEX, "0");
        }
      }
    }

    class AttributesHandler {
      constructor(domProvider) {
        this.domProvider = domProvider;
      }
      handleAttributes(
        focusedElement,
        optionsElements,
        triggerElement,
        activeElementID,
        listboxLabel,
        evtKey
      ) {
        var _a;
        if (!activeElementID) {
          if (evtKey == "ArrowUp") {
            const lastIndex = optionsElements.length - 1;
            activeElementID = String(
              this.domProvider.getAttribute(optionsElements[lastIndex], "id")
            );
          }
          if (evtKey == "ArrowDown") {
            activeElementID = String(
              this.domProvider.getAttribute(optionsElements[0], "id")
            );
          }
        }
        const activeElm = this.domProvider.getElementById(
          String(activeElementID)
        );
        if (listboxLabel) {
          const listboxLabelID =
            (_a = this.domProvider.getAttribute(listboxLabel, "id")) != null
              ? _a
              : "";
          this.domProvider.setAttribute(
            triggerElement,
            ARIA.LABELLEDBY,
            listboxLabelID + " " + activeElementID
          );
        }
        this.domProvider.setAttribute(
          focusedElement,
          ARIA.ACTIVEDESCENDANT,
          String(activeElementID)
        );
        const elmWithFocusedClass =
          this.domProvider.querySelector(".u1st-focused");
        this.domProvider.removeClass(
          elmWithFocusedClass,
          PROJECT_CLASSES.FOCUSED_ELEMENT
        );
        this.domProvider.addClass(activeElm, PROJECT_CLASSES.FOCUSED_ELEMENT);
        this.domProvider.removeAttributeToAll(optionsElements, ARIA.SELECTED);
        this.domProvider.setAttribute(activeElm, ARIA.SELECTED, "true");
      }
    }

    class NavigationHandler {
      constructor(
        domProvider,
        listboxAttributesHandler,
        scrollService,
        elementVisibility,
        shouldWrapOptions
      ) {
        this.domProvider = domProvider;
        this.listboxAttributesHandler = listboxAttributesHandler;
        this.scrollService = scrollService;
        this.elementVisibility = elementVisibility;
        this.shouldWrapOptions = shouldWrapOptions;
      }
      navigateToFirstOrLast(
        {
          focusedElement,
          triggerElement,
          listboxLabel,
          evt,
          focusedOption,
          scrollableElement,
          optionsElements,
        },
        isLast
      ) {
        const elementId = this.getFirstOrLastOption(optionsElements, isLast);
        optionsElements.length
          ? this.listboxAttributesHandler.handleAttributes(
              focusedElement,
              optionsElements,
              triggerElement,
              elementId,
              listboxLabel,
              evt.code
            )
          : null;
        focusedOption = this.domProvider.querySelector(".u1st-focused");
        scrollableElement
          ? this.scrollService.scrollElementIntoView(
              focusedOption,
              scrollableElement,
              evt.code
            )
          : null;
      }
      getFirstOrLastOption(optionsElements, isLast) {
        return this.getOptionId(
          isLast
            ? optionsElements[optionsElements.length - 1]
            : optionsElements[0]
        );
      }
      getNextOptionId(optionsElements, option) {
        return this.getNearOptionId(optionsElements, option, 1);
      }
      getPrevOptionId(optionsElements, option) {
        return this.getNearOptionId(optionsElements, option, -1);
      }
      getNearOptionId(optionsElements, option, indexAddition) {
        const optionIndex = this.getOptionNumber(optionsElements, option);
        let nearOptionIndex = optionIndex + indexAddition;
        if (this.shouldWrapOptions) {
          nearOptionIndex =
            (nearOptionIndex + optionsElements.length) % optionsElements.length;
        } else {
          if (
            nearOptionIndex < 0 ||
            nearOptionIndex > optionsElements.length - 1
          ) {
            nearOptionIndex = optionIndex;
          }
        }
        return this.getOptionId(optionsElements[nearOptionIndex]);
      }
      getOptionId(optionElement) {
        return this.domProvider.getAttribute(optionElement, "id");
      }
      getOptionNumber(optionsElements, option) {
        let optionIndex = 0;
        optionsElements.forEach((optionsElement, index) => {
          if (optionsElement === option) {
            optionIndex = index;
          }
        });
        return optionIndex;
      }
      handleDefaultKeycode({
        evt,
        optionsElements,
        focusedElement,
        triggerElement,
        listboxLabel,
        scrollableElement,
      }) {
        var _a;
        if (((_a = evt.code) == null ? void 0 : _a.slice(0, 3)) == "Key") {
          const prefix = evt.code.slice(3);
          optionsElements.forEach((optionElement) => {
            if (
              this.elementVisibility.isVisible(optionElement) &&
              optionElement.innerText
                .toLowerCase()
                .substring(0, prefix.length) === prefix.toLowerCase()
            ) {
              const optionId = this.getOptionId(optionElement);
              optionsElements.length
                ? this.listboxAttributesHandler.handleAttributes(
                    focusedElement,
                    optionsElements,
                    triggerElement,
                    optionId,
                    listboxLabel,
                    evt.code
                  )
                : null;
              const focusedOption =
                this.domProvider.querySelector(".u1st-focused");
              scrollableElement
                ? this.scrollService.scrollElementIntoView(
                    focusedOption,
                    scrollableElement,
                    evt.code
                  )
                : null;
            }
          });
        }
      }
      handleUpOrDown(
        {
          optionsElements,
          focusedElement,
          triggerElement,
          evt,
          listboxLabel,
          focusedOption,
          scrollableElement,
          activeElement,
        },
        isDown
      ) {
        const ElementID = isDown
          ? this.getNextOptionId(optionsElements, activeElement)
          : this.getPrevOptionId(optionsElements, activeElement);
        optionsElements.length
          ? this.listboxAttributesHandler.handleAttributes(
              focusedElement,
              optionsElements,
              triggerElement,
              ElementID,
              listboxLabel,
              evt.code
            )
          : null;
        focusedOption = this.domProvider.querySelector(".u1st-focused");
        scrollableElement
          ? this.scrollService.scrollElementIntoView(
              focusedOption,
              scrollableElement,
              evt.code
            )
          : null;
      }
    }

    class EventsHandler$1 {
      constructor(
        domProvider,
        listboxAttributesHandler,
        elementVisibility,
        scrollService
      ) {
        this.domProvider = domProvider;
        this.listboxAttributesHandler = listboxAttributesHandler;
        this.elementVisibility = elementVisibility;
        this.scrollService = scrollService;
      }
      handleEvents(
        optionsElements,
        focusedElement,
        triggerElement,
        evt,
        listboxLabel,
        props
      ) {
        const isCombobox =
          this.domProvider.getTagName(focusedElement) == "INPUT" ||
          focusedElement === triggerElement;
        const activeElementID = this.domProvider.getAttribute(
          focusedElement,
          ARIA.ACTIVEDESCENDANT
        );
        const activeElement = activeElementID
          ? this.domProvider.getElementById(activeElementID)
          : optionsElements[0];
        const scrollableElement = this.scrollService.getScrollableElement(
          isCombobox ? optionsElements[0] : focusedElement
        );
        const eventParams = {
          focusedElement,
          triggerElement,
          listboxLabel,
          evt,
          focusedOption: null,
          scrollableElement,
          optionsElements,
          activeElement,
        };
        const navigationHandler = new NavigationHandler(
          this.domProvider,
          this.listboxAttributesHandler,
          this.scrollService,
          this.elementVisibility,
          isCombobox
        );
        switch (evt.code) {
          case KEY_CODES.END:
            navigationHandler.navigateToFirstOrLast(eventParams, true);
            break;
          case KEY_CODES.HOME:
            navigationHandler.navigateToFirstOrLast(eventParams, false);
            break;
          case KEY_CODES.DOWN:
            navigationHandler.handleUpOrDown(eventParams, true);
            break;
          case KEY_CODES.UP:
            navigationHandler.handleUpOrDown(eventParams, false);
            break;
          case KEY_CODES.ENTER:
            this.domProvider.dispatchClickEvent(activeElement);
            if ((props == null ? void 0 : props.closeOnSelect) !== false) {
              this.domProvider.setTimeout(() => {
                this.closeListbox(focusedElement, triggerElement);
              }, 200);
            }
            break;
          case KEY_CODES.ESC:
            this.closeListbox(focusedElement, triggerElement);
            break;
          case KEY_CODES.TAB:
            if (evt.shiftKey) {
              triggerElement.setAttribute("tabindex", "-1");
              setTimeout(() => {
                triggerElement.setAttribute("tabindex", "0");
              }, 0);
            }
            this.domProvider.dispatchClickEvent(activeElement);
            this.closeListbox(focusedElement, triggerElement);
            break;
          default:
            navigationHandler.handleDefaultKeycode(eventParams);
        }
      }
      closeListbox(focusedElement, triggerElement) {
        var _a;
        const isFocusedElInDom = this.domProvider.contains(focusedElement);
        if (
          this.elementVisibility.isVisible(focusedElement) &&
          isFocusedElInDom
        ) {
          this.removeFocus();
          this.domProvider.dispatchClickEvent(triggerElement);
        }
        this.domProvider.setAttribute(triggerElement, ARIA.EXPANDED, "false");
        const lastClickledTrigger =
          (_a = this.domProvider.querySelector(
            PROJECT_CLASSES.TRIGGER_ELEMENT
          )) != null
            ? _a
            : triggerElement;
        this.domProvider.focusOnElement(lastClickledTrigger);
        this.domProvider.removeAttribute(
          lastClickledTrigger,
          PROJECT_CLASSES.TRIGGER_ELEMENT
        );
      }
      removeFocus() {
        const allFocusedElements =
          this.domProvider.querySelectorAll(".u1st-focused");
        allFocusedElements == null
          ? void 0
          : allFocusedElements.forEach((elem) =>
              this.domProvider.removeClass(elem, PROJECT_CLASSES.FOCUSED_ELEMENT)
            );
      }
    }

    class ComboboxListbox {
      constructor(domProvider) {
        this.listboxElement = null;
        this.labelElement = null;
        this.domProvider = domProvider;
      }
      handleListbox(props) {
        const { listbox, label } = props.selectors;
        listbox
          ? (this.listboxElement = this.domProvider.querySelector(listbox))
          : null;
        label
          ? (this.labelElement = this.domProvider.querySelector(label))
          : null;
        if (!this.listboxElement) return;
        this.domProvider.setAttribute(this.listboxElement, "role", "listbox");
        if (!this.labelElement) return;
        const labelText = String(
          this.domProvider.getTextContent(this.labelElement)
        );
        this.domProvider.setAttribute(
          this.listboxElement,
          ARIA.LABELLEDBY,
          labelText
        );
      }
    }

    class ComboboxTextbox {
      constructor(domProvider, eventsHandler, elementVisibility) {
        this.textboxElement = null;
        this.listboxElement = null;
        this.optionsElements = [];
        this.labelElement = null;
        this.domProvider = domProvider;
        this.eventsHandler = eventsHandler;
        this.elementVisibility = elementVisibility;
      }
      handleTextbox(props) {
        const { textbox, listbox, label } = props.selectors;
        const autocompleteType = props.isAutocompleteList ? "list" : "both";
        this.textboxElement = this.domProvider.querySelector(textbox);
        listbox
          ? (this.listboxElement = this.domProvider.querySelector(listbox))
          : null;
        if (this.textboxElement) {
          this.textboxElement.setAttribute(AVOID_AUTO_HIDDEN_ATTRIBUTE, "true");
          label && (this.labelElement = this.domProvider.querySelector(label));
          if (this.labelElement) {
            const labelIdSelector = Utils$1.getOrCreateId(this.labelElement);
            this.domProvider.setAttribute(
              this.textboxElement,
              ARIA.LABELLEDBY,
              labelIdSelector
            );
          }
          this.domProvider.setAttribute(
            this.textboxElement,
            ARIA.AUTOCOMPLETE,
            autocompleteType
          );
          this.domProvider.addEventListener(
            this.textboxElement,
            "keydown",
            (e) => this.textboxKeydownFunction(e, props),
            true
          );
        }
      }
      textboxKeydownFunction(_evt, props) {
        const evt = _evt;
        const isEscape = evt.code == "Escape";
        const isMoveEvent = evt.code == "Tab" || evt.code == "ShiftLeft";
        const isTextboxEvent =
          evt.code == "Enter" ||
          evt.code == "Space" ||
          evt.code == "ArrowDown" ||
          evt.code == "ArrowUp" ||
          isMoveEvent ||
          isEscape;
        const { options, textbox } = props.selectors;
        this.optionsElements = this.getVisibleOptions(options);
        this.textboxElement = this.domProvider.querySelector(textbox);
        this.labelElement = props.selectors.label
          ? this.domProvider.querySelector(props.selectors.label)
          : null;
        isEscape ? this.domProvider.changeValue(this.textboxElement, "") : null;
        const focusedOption = this.domProvider.querySelector(".u1st-focused");
        if (isMoveEvent && focusedOption)
          this.domProvider.dispatchClickEvent(focusedOption);
        if (
          isTextboxEvent &&
          this.optionsElements &&
          this.textboxElement &&
          this.elementVisibility.isVisible(this.optionsElements[0])
        ) {
          const focusedOption2 = this.domProvider.querySelector(".u1st-focused");
          if (isEscape && focusedOption2) {
            this.removeOptionFocus(this.textboxElement, focusedOption2);
          }
          const isHasLink =
            this.domProvider.querySelector("a", this.optionsElements[0]) != null;
          if (!isEscape && !isHasLink && evt.code != "Space" && !isMoveEvent) {
            _evt.preventDefault();
            _evt.stopPropagation();
          }
          this.eventsHandler.handleEvents(
            this.optionsElements,
            this.textboxElement,
            this.textboxElement,
            evt,
            this.labelElement
          );
        }
      }
      closeListbox(textbox) {
        const textboxElement = this.domProvider.querySelector(textbox);
        textboxElement ? this.domProvider.focusOnElement(textboxElement) : null;
      }
      getVisibleOptions(optionsSelector) {
        const options = this.domProvider.querySelectorAll(optionsSelector);
        return options.filter((option) =>
          this.elementVisibility.isVisible(option)
        );
      }
      removeOptionFocus(textboxElement, focusedOption) {
        this.domProvider.removeAttribute(textboxElement, ARIA.ACTIVEDESCENDANT);
        this.domProvider.removeAttribute(focusedOption, ARIA.SELECTED);
        this.domProvider.removeClass(
          focusedOption,
          PROJECT_CLASSES.FOCUSED_ELEMENT
        );
      }
    }

    const mutationSubject = new ReplaySubject();
    const mutation = new MutationObserver((mutations) => {
      mutations.forEach((mutation2) => mutationSubject.next(mutation2));
    });
    const observeMutations = () =>
      mutation.observe(document.body, {
        subtree: true,
        childList: true,
        attributes: true,
      });
    if (document.readyState === "complete") {
      observeMutations();
    } else {
      fromEvent(window, "DOMContentLoaded").subscribe(observeMutations);
    }
    const getMutations$ = () => mutationSubject.asObservable();
    const elementTypeGuard = (target) => target instanceof HTMLElement;
    const filterByHTMLElement = () => filter(elementTypeGuard);
    const fromSelector = (selector) => {
      const elements$ = iif(
        () => document.readyState === "complete",
        from(document.querySelectorAll(selector)),
        fromEvent(window, "load").pipe(
          mergeMap(() => document.querySelectorAll(selector))
        )
      ).pipe(filter(elementTypeGuard));
      const childListMutationElementsMatchingSelector$ = getMutations$().pipe(
        mergeMap(({ type, addedNodes, target }) =>
          iif(
            () => type === "childList",
            from(Array.from(addedNodes)).pipe(
              mergeMap((node) => {
                const matches = [];
                if (node.matches && node.matches(selector)) {
                  matches.push(node);
                }
                if (node.querySelectorAll) {
                  matches.push(...Array.from(node.querySelectorAll(selector)));
                }
                return from(matches);
              })
            ),
            of(target).pipe(
              filterByHTMLElement(),
              filter((target) => target.matches(selector))
            )
          )
        )
      );
      return merge(elements$, childListMutationElementsMatchingSelector$).pipe(
        distinct()
      );
    };

    class ComboboxFixer extends FixerAbstract {
      constructor(
        context,
        props,
        domProvider,
        changeDetection,
        comboboxTextbox,
        listboxOption,
        comboboxListbox,
        elementVisibility
      ) {
        var _a;
        super(
          context,
          domProvider,
          changeDetection,
          props,
          props.selectors.emptyOption
            ? [props.selectors.textbox, props.selectors.emptyOption]
            : props.selectors.textbox
        );
        this.textboxElement = null;
        this.listboxElement = null;
        this.optionsElements = [];
        this.labelElement = null;
        this.emptyOptionElement = null;
        this.domProvider = domProvider;
        this.changeDetection = changeDetection;
        this.comboboxTextbox = comboboxTextbox;
        this.listboxOption = listboxOption;
        this.comboboxListbox = comboboxListbox;
        this.elementVisibility = elementVisibility;
        this.optionHasFocus = false;
        this.isAutocompleteList =
          (_a = props.isAutocompleteList) != null ? _a : false;
        const {
          selectors: { combobox },
        } = props;
        const comboboxElement = document.querySelector(combobox);
        if (comboboxElement === null) {
          throw new Error(
            `Combobox with selector ${combobox} does not exist on page.`
          );
        }
        this.comboboxElement = comboboxElement;
      }
      fix() {
        const { selectors } = this.props;
        const { textbox, options, label, emptyOption, listbox } = selectors;
        this.textboxElement = this.domProvider.querySelector(textbox);
        this.labelElement = label ? this.domProvider.querySelector(label) : null;
        this.emptyOptionElement = emptyOption
          ? this.domProvider.querySelector(emptyOption)
          : null;
        this.handleCombobox();
        this.handleEmptyOption();
        this.comboboxTextbox.handleTextbox(this.props);
        this.changeDetection.subscribe(
          this.context,
          "comboboxOptions",
          options,
          () => this.onOptionsShow()
        );
        if (listbox !== void 0) {
          getMutations$()
            .pipe(
              mergeMap(({ addedNodes, removedNodes }) =>
                merge(from(addedNodes), from(removedNodes))
              ),
              filterByHTMLElement(),
              filter(
                (element) =>
                  element.matches(listbox) ||
                  element.dataset.u1Combobox === "listbox"
              ),
              map(
                (listboxElement) =>
                  document.contains(listboxElement) &&
                  Array.from(listboxElement.querySelectorAll(options)).some(
                    (optionElement) =>
                      this.elementVisibility.isVisible(optionElement)
                  )
              )
            )
            .subscribe((areOptionsVisible) =>
              this.comboboxElement.setAttribute(
                ARIA.EXPANDED,
                `${areOptionsVisible}`
              )
            );
        }
      }
      handleCombobox() {
        if (!this.comboboxElement) return;
        this.domProvider.setAttribute(this.comboboxElement, "role", "combobox");
        this.domProvider.setAttribute(
          this.comboboxElement,
          ARIA.EXPANDED,
          "false"
        );
        this.domProvider.setAttribute(
          this.comboboxElement,
          ARIA.HASPOPUP,
          "listbox"
        );
      }
      handleEmptyOption() {
        if (!this.emptyOptionElement) return;
        this.domProvider.setAttribute(this.emptyOptionElement, "role", "status");
      }
      onOptionsShow() {
        const { listbox, options } = this.props.selectors;
        this.optionsElements = this.getVisibleOptions(options);
        if (listbox) {
          this.listboxElement = this.domProvider.querySelector(listbox);
          this.comboboxListbox.handleListbox(this.props);
        }
        this.handleOptions();
        if (!this.optionHasFocus) {
          this.setInitialAttributes();
        }
      }
      handleOptions() {
        this.optionHasFocus = !!this.domProvider.querySelector(
          PROJECT_CLASSES.FOCUSED_ELEMENT
        );
        if (this.optionsElements.length) {
          this.optionsElements.forEach((option) => {
            const optionsElementsID = this.domProvider.getAttribute(option, "id");
            const hasId = optionsElementsID !== null && optionsElementsID !== "";
            this.listboxOption.handleOption(
              option,
              hasId ? null : Utils$1.uuid()
            );
          });
          if (!this.optionHasFocus) {
            this.domProvider.addClass(
              this.optionsElements[0],
              PROJECT_CLASSES.FOCUSED_ELEMENT
            );
            this.domProvider.setAttribute(
              this.optionsElements[0],
              ARIA.SELECTED,
              "true"
            );
          }
        }
      }
      setInitialAttributes() {
        this.domProvider.setAttribute(
          this.comboboxElement,
          ARIA.EXPANDED,
          "true"
        );
        this.domProvider.setAttributeWithID(
          this.listboxElement,
          this.comboboxElement,
          ARIA.OWNS
        );
        this.domProvider.setAttributeWithID(
          this.listboxElement,
          this.textboxElement,
          ARIA.CONTROLS
        );
        this.optionsElements &&
          this.domProvider.setAttributeWithID(
            this.optionsElements[0],
            this.textboxElement,
            ARIA.ACTIVEDESCENDANT
          );
      }
      getVisibleOptions(optionsSelector) {
        const options = this.domProvider.querySelectorAll(optionsSelector);
        return options.filter((option) =>
          this.elementVisibility.isVisible(option)
        );
      }
    }
    const ComboboxApi = (context = "body") => {
      const domProvider = new DomProvider();
      const elementVisibility = new ElementVisibility();
      const scrollService = new ScrollService();
      const changeDetection = ChangeDetection.getInstance(
        elementVisibility,
        domProvider
      );
      const attributesHandler = new AttributesHandler(domProvider);
      const eventsHandler = new EventsHandler$1(
        domProvider,
        attributesHandler,
        elementVisibility,
        scrollService
      );
      const comboboxTextbox = new ComboboxTextbox(
        domProvider,
        eventsHandler,
        elementVisibility
      );
      const listboxOption = new ListboxOption(domProvider);
      const comboboxListbox = new ComboboxListbox(domProvider);
      return (props) =>
        new ComboboxFixer(
          context,
          props,
          domProvider,
          changeDetection,
          comboboxTextbox,
          listboxOption,
          comboboxListbox,
          elementVisibility
        );
    };

    class DatepickerFixer extends FixerAbstract {
      constructor(
        context,
        props,
        domProvider,
        changeDetection,
        month,
        year,
        calendarService
      ) {
        super(context, domProvider, changeDetection, props, props.container);
        this.props = props;
        this.domProvider = domProvider;
        this.month = month;
        this.year = year;
        this.calendarService = calendarService;
      }
      fix(visibleCalendar) {
        this.month.fix(
          this.props.month,
          visibleCalendar,
          this.calendarService,
          this.props.uniqueClickEvent
        );
        this.year.fix(
          this.props.year,
          visibleCalendar,
          this.calendarService,
          this.props.uniqueClickEvent
        );
        this.calendarService.fix(visibleCalendar);
      }
    }

    class DatePickerHeader {
      constructor(domProvider) {
        this.domProvider = domProvider;
      }
      fix(props, context, calendarService, uniqueClickEvent) {
        this.props = props;
        this.context = context;
        this.calendarService = calendarService;
        this.uniqueClickEvent = uniqueClickEvent;
        this.setRoles();
      }
      setDescription(prevText, nextText) {
        this.prevEl &&
          this.domProvider.setAttribute(this.prevEl, ARIA.LABEL, prevText);
        this.nextEl &&
          this.domProvider.setAttribute(this.nextEl, ARIA.LABEL, nextText);
      }
      setRoles() {
        this.props.prevButton &&
          (this.prevEl = this.domProvider.querySelector(
            this.props.prevButton,
            this.context
          ));
        this.props.nextButton &&
          (this.nextEl = this.domProvider.querySelector(
            this.props.nextButton,
            this.context
          ));
        this.prevEl && this.setButton(this.prevEl);
        this.nextEl && this.setButton(this.nextEl);
      }
      setButton(el) {
        this.domProvider.setAttribute(el, "role", ROLE$1.BUTTON);
        this.domProvider.setAttribute(el, "tabindex", "0");
        this.domProvider.addEventListener(el, "keydown", (e) =>
          this.onKeydown(e)
        );
        if (this.uniqueClickEvent) {
          this.domProvider.addEventListener(el, "click", () =>
            this.domProvider.dispatchCustomClickEvent(el, this.uniqueClickEvent)
          );
        }
      }
      onKeydown(e) {
        const evt = e;
        const el = e.target;
        switch (evt.code) {
          case "Enter":
            this.gotoNextCalendarView(el);
            break;
        }
      }
      gotoNextCalendarView(el) {
        var _a;
        this.domProvider.dispatchCustomClickEvent(
          el,
          (_a = this.uniqueClickEvent) != null ? _a : "click"
        );
        this.calendarService.fix(this.context, false);
        this.setRoles();
      }
      setAriaLive(uniqueId) {
        var _a;
        const textSelector =
          (_a = this.props.text) == null ? void 0 : _a.selector;
        if (!textSelector) return;
        const textEl = this.domProvider.querySelector(textSelector, this.context);
        this.domProvider.setAttribute(textEl, ARIA.LIVE, "polite");
        this.domProvider.setAttribute(textEl, "role", "status");
        if (!this.domProvider.getAttribute(textEl, "id")) {
          this.domProvider.setAttribute(textEl, "id", uniqueId);
        }
      }
    }

    class Year extends DatePickerHeader {
      constructor(domProvider, translateService) {
        super(domProvider);
        this.translateService = translateService;
      }
      fix(props, context, calendarService, uniqueClickEvent) {
        super.fix(props, context, calendarService, uniqueClickEvent);
        this.setDescription(
          this.translateService.getValue(TranslateText.PREV_YEAR),
          this.translateService.getValue(TranslateText.NEXT_YEAR)
        );
        this.setAriaLive(Utils$1.uuid());
        if (props.text.isClickable) {
          const yearBtn = this.domProvider.querySelector(
            props.text.selector,
            this.context
          );
          yearBtn && this.setButton(yearBtn);
        }
      }
    }

    class DialogDescription {
      constructor(domProvider) {
        this.domProvider = domProvider;
      }
      add(dialogElement, headingSelector, textContent) {
        if (!dialogElement) return;
        const generatedId = Utils$1.uuid();
        this.setLabel(dialogElement, generatedId, headingSelector);
        textContent &&
          this.setDescribedBy(dialogElement, generatedId, textContent);
      }
      setLabel(dialogElement, generatedId, headingSelector) {
        const headingElement = headingSelector
          ? this.domProvider.querySelector(headingSelector, dialogElement)
          : this.domProvider.querySelector(
              COMMON_SELECTORS.HEADING_ELEMENTS_SELECTOR,
              dialogElement
            );
        if (headingElement) {
          const id = headingElement.id || generatedId;
          this.domProvider.setAttribute(headingElement, "id", id);
          this.domProvider.setAttribute(dialogElement, ARIA.LABELLEDBY, id);
        }
      }
      setDescribedBy(dialogElement, generatedId, textContent) {
        const contentElement = this.domProvider.querySelector(
          textContent,
          dialogElement
        );
        if (contentElement) {
          const id = contentElement.id || generatedId;
          this.domProvider.setAttribute(contentElement, "id", id);
          this.domProvider.setAttribute(dialogElement, ARIA.DESCRIBEDBY, id);
        }
      }
    }

    var DialogType = /* @__PURE__ */ ((DialogType2) => {
      DialogType2["MODAL"] = "modal";
      DialogType2["NON_MODAL"] = "non_modal";
      return DialogType2;
    })(DialogType || {});

    var __async$1 = (__this, __arguments, generator) => {
      return new Promise((resolve, reject) => {
        var fulfilled = (value) => {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        };
        var rejected = (value) => {
          try {
            step(generator.throw(value));
          } catch (e) {
            reject(e);
          }
        };
        var step = (x) =>
          x.done
            ? resolve(x.value)
            : Promise.resolve(x.value).then(fulfilled, rejected);
        step((generator = generator.apply(__this, __arguments)).next());
      });
    };
    class DialogBounding {
      constructor(domProvider, elementVisibility, closeHandler) {
        this.focusableElements = [];
        this.firstVisibleElement = null;
        this.lastElement = null;
        this.dialogType = DialogType.MODAL;
        this.domProvider = domProvider;
        this.elementVisibility = elementVisibility;
        this.closeHandler = closeHandler;
      }
      focusInBound(dialogElement) {
        return __async$1(this, null, function* () {
          this.domProvider
            .querySelectorAll(
              COMMON_SELECTORS.TABBABLE_ELEMENTS_SELECTOR,
              dialogElement
            )
            .filter((element) =>
              this.elementVisibility.isVisible(element, true)
            )[0]
            .focus();
          dialogElement.addEventListener("keydown", (e) => {
            if (e.code === "Tab") {
              const tabbableElements = this.domProvider
                .querySelectorAll(
                  COMMON_SELECTORS.TABBABLE_ELEMENTS_SELECTOR,
                  dialogElement
                )
                .filter((element) =>
                  this.elementVisibility.isVisible(element, true)
                );
              const { target } = e;
              if (e.shiftKey) {
                if (target === tabbableElements[0]) {
                  e.preventDefault();
                  tabbableElements[tabbableElements.length - 1].focus();
                }
              } else {
                if (target === tabbableElements[tabbableElements.length - 1]) {
                  if (this.dialogType == DialogType.MODAL) {
                    e.preventDefault();
                    tabbableElements[0].focus();
                  } else {
                    this.closeHandler.close();
                  }
                }
              }
            }
          });
        });
      }
    }

    const AVOID_TRIGGER_ATTRIBUTE = "avoid-trigger-element";
    class DialogTrigger {
      constructor(domProvider) {
        this.currentTriggerMarked = null;
        this.domProvider = domProvider;
      }
      handle(selector, props) {
        this.selector = selector;
        this.props = props;
        const triggerElements = this.domProvider.querySelectorAll(selector);
        triggerElements.forEach((el) => {
          if (!this.domProvider.getAttribute(el, AVOID_TRIGGER_ATTRIBUTE)) {
            this.domProvider.setAttribute(el, ARIA.HASPOPUP, ROLE$1.DIALOG);
            this.domProvider.setAttribute(el, ATTRIBUTES.ROLE, ROLE$1.BUTTON);
            this.domProvider.setAttribute(el, ATTRIBUTES.TABINDEX, "0");
            this.domProvider.setAttribute(el, AVOID_TRIGGER_ATTRIBUTE, "true");
            this.domProvider.addEventListener(el, "click", (evt) =>
              this.markTrigger(evt.target)
            );
            this.domProvider.addEventListener(el, "keydown", (evt) =>
              this.onKeyPress(evt)
            );
          }
        });
      }
      onKeyPress(e) {
        const evt = e;
        if (evt.code == "Enter") {
          const target = evt.target;
          if (!target) return;
          this.markTrigger(target);
          if (
            !this.domProvider.matches(
              target,
              COMMON_SELECTORS.FOCUSABLE_ELEMENTS_SELECTOR
            )
          ) {
            this.domProvider.dispatchMouseClickEvent(target);
          }
        }
      }
      markTrigger(element) {
        const alreadyMarked = this.domProvider.querySelectorAll(
          `[${PROJECT_CLASSES.TRIGGER_ELEMENT}]`
        );
        this.domProvider.removeAttributeToAll(
          alreadyMarked,
          PROJECT_CLASSES.TRIGGER_ELEMENT
        );
        this.domProvider.setAttribute(
          element,
          PROJECT_CLASSES.TRIGGER_ELEMENT,
          "true"
        );
      }
      focusOnTrigger() {
        var _a;
        let elToFocus;
        if (this.props) {
          const customElToFocus = this.domProvider.querySelector(
            this.props.selectors.focusTo
          );
          const lastClickedTrigger = this.domProvider.querySelector(
            `[${PROJECT_CLASSES.TRIGGER_ELEMENT}]`
          );
          const triggerEl = this.domProvider.querySelector(
            this.props.selectors.trigger
          );
          elToFocus =
            (_a =
              customElToFocus != null ? customElToFocus : lastClickedTrigger) !=
            null
              ? _a
              : triggerEl;
        }
        if (elToFocus) {
          this.domProvider.setTimeout(() => {
            this.domProvider.focusOnElement(elToFocus);
            this.domProvider.removeAttribute(
              elToFocus,
              PROJECT_CLASSES.TRIGGER_ELEMENT
            );
          }, 200);
        }
      }
    }

    class CloseHandler {
      constructor(domProvider, navigationControl, translateService, props) {
        this.translateService = translateService;
        this.domProvider = domProvider;
        this.props = props;
        this.navigationControl = navigationControl;
      }
      handle(dialogElement, props) {
        const { closeBtn } = props.selectors;
        this.props = props;
        this.domProvider.addEventListener(dialogElement, "keydown", (evt) =>
          this.onClose(evt)
        );
        if (closeBtn) {
          const closeBtnElement = this.domProvider.querySelector(
            closeBtn,
            dialogElement
          );
          if (closeBtnElement) {
            this.domProvider.setAttribute(closeBtnElement, "tabindex", "0");
            this.domProvider.setAttribute(closeBtnElement, "role", "button");
            this.domProvider.setAttribute(
              closeBtnElement,
              ARIA.LABEL,
              this.translateService.getValue(TranslateText.CLOSE)
            );
            this.domProvider.addEventListener(closeBtnElement, "keydown", (evt) =>
              this.onCloseButtonPressed(evt)
            );
          }
        }
      }
      onClose(e) {
        const evt = e;
        if (evt.code === "Escape") {
          evt.stopPropagation();
          evt.stopImmediatePropagation();
          this.close();
        }
      }
      onCloseButtonPressed(e) {
        const evt = e;
        if (evt.code === "Enter") {
          evt.preventDefault();
          evt.stopPropagation();
          evt.stopImmediatePropagation();
          this.close(evt.target);
        }
      }
      close(closeBtnEl) {
        var _a, _b, _c, _d, _e, _f, _g;
        const triggerSelector =
          (_b = (_a = this.props) == null ? void 0 : _a.selectors) == null
            ? void 0
            : _b.trigger;
        const closeBtnSelector =
          (_d = (_c = this.props) == null ? void 0 : _c.selectors) == null
            ? void 0
            : _d.closeBtn;
        const dialogSelector =
          (_f = (_e = this.props) == null ? void 0 : _e.selectors) == null
            ? void 0
            : _f.dialog;
        if ((_g = this.props) == null ? void 0 : _g.onClose) {
          this.props.onClose();
          return;
        }
        if (closeBtnEl) {
          this.domProvider.dispatchMouseClickEvent(closeBtnEl);
        } else if (closeBtnSelector) {
          const closeBtn = this.domProvider.querySelector(
            closeBtnSelector,
            dialogSelector
          );
          closeBtn && this.domProvider.dispatchMouseClickEvent(closeBtn);
        } else if (triggerSelector) {
          const trigger = this.domProvider.querySelector(triggerSelector);
          trigger && this.domProvider.dispatchMouseClickEvent(trigger);
        }
      }
    }

    var NavigationType = /* @__PURE__ */ ((NavigationType2) => {
      NavigationType2["Block"] = "block";
      NavigationType2["Release"] = "release";
      return NavigationType2;
    })(NavigationType || {});
    var NavigationPlatform = /* @__PURE__ */ ((NavigationPlatform2) => {
      NavigationPlatform2["Keyboard"] = "keyboard";
      NavigationPlatform2["Screen_Reader"] = "screenReader";
      return NavigationPlatform2;
    })(NavigationPlatform || {});
    var KeyboardEvents = /* @__PURE__ */ ((KeyboardEvents2) => {
      KeyboardEvents2["KeyUp"] = "keyup";
      KeyboardEvents2["KeyDown"] = "keydown";
      KeyboardEvents2["KeyPress"] = "keypress";
      return KeyboardEvents2;
    })(KeyboardEvents || {});

    class NavigationControlUtils {
      static getAttributeName(type) {
        return type == NavigationPlatform.Screen_Reader
          ? ARIA.HIDDEN
          : "tabindex";
      }
      static getBackupAttributeName(type) {
        return type == NavigationPlatform.Screen_Reader
          ? PROJECT_CLASSES.PREV_ARIA_HIDDEN
          : PROJECT_CLASSES.PREV_TABINDEX;
      }
    }

    const _NavigationControl = class {
      constructor(domProvider, domExtension) {
        this.domExtension = domExtension;
        this.domProvider = domProvider;
      }
      block(excludeElementSelector) {
        var _a;
        let excludedElemets = this.domProvider.querySelectorAll(
          `${excludeElementSelector},${excludeElementSelector} *`
        );
        excludedElemets = excludedElemets.concat(
          this.domExtension.getParentsElements(excludedElemets[0])
        );
        this.domProvider.setAttributeToAll(
          excludedElemets,
          _NavigationControl.u1stNavigationBlockFlag,
          "false"
        );
        this.blockedElements = this.domProvider.querySelectorAll(
          `*:not([${_NavigationControl.u1stNavigationBlockFlag}='false'])`
        );
        (_a = this.blockedElements) == null
          ? void 0
          : _a.forEach((el) => {
              this.domProvider.setAttribute(
                el,
                _NavigationControl.u1stNavigationBlockFlag,
                "true"
              );
              this.domProvider.setAttribute(
                el,
                AVOID_AUTO_TABBABLE_ATTRIBUTE,
                "true"
              );
              this.keyboard(NavigationType.Block, el);
              this.screenReader(NavigationType.Block, el);
            });
      }
      release() {
        const blockedElements = this.domProvider.querySelectorAll(
          `[${_NavigationControl.u1stNavigationBlockFlag}='true']`
        );
        blockedElements == null
          ? void 0
          : blockedElements.forEach((el) => {
              this.keyboard(NavigationType.Release, el);
              this.screenReader(NavigationType.Release, el);
              this.domProvider.removeAttribute(el, AVOID_AUTO_TABBABLE_ATTRIBUTE);
              this.domProvider.removeAttribute(
                el,
                _NavigationControl.u1stNavigationBlockFlag
              );
            });
      }
      keyboard(type, el) {
        if (type == NavigationType.Release) {
          this.releaseAttributes(NavigationPlatform.Keyboard, el);
        }
        if (type == NavigationType.Block) {
          this.blockAttributes(NavigationPlatform.Keyboard, el);
        }
      }
      screenReader(type, el) {
        if (type == NavigationType.Release) {
          this.releaseAttributes(NavigationPlatform.Screen_Reader, el);
        }
        if (type == NavigationType.Block) {
          this.blockAttributes(NavigationPlatform.Screen_Reader, el);
        }
      }
      releaseAttributes(type, el) {
        const attributeName = NavigationControlUtils.getAttributeName(type);
        const backupAttributeToRemove =
          NavigationControlUtils.getBackupAttributeName(type);
        const prevData = this.domProvider.getAttribute(
          el,
          backupAttributeToRemove
        );
        if (prevData) {
          this.domProvider.removeAttribute(el, backupAttributeToRemove);
          this.domProvider.setAttribute(el, attributeName, prevData);
          return;
        }
        this.domProvider.removeAttribute(el, attributeName);
      }
      blockAttributes(type, el) {
        const attributeName = NavigationControlUtils.getAttributeName(type);
        const backupAttribute =
          NavigationControlUtils.getBackupAttributeName(type);
        const currentAttr = this.domProvider.getAttribute(el, attributeName);
        const value = attributeName === ARIA.HIDDEN ? "true" : "-1";
        if (currentAttr) {
          this.domProvider.setAttribute(el, backupAttribute, currentAttr);
        }
        this.domProvider.setAttribute(el, attributeName, value);
      }
      stopTabPropagation(elementSelector) {
        const elements = this.domProvider.querySelectorAll(elementSelector);
        const dispatchKeyDownEvent = this.domProvider.dispatchKeydownEvent;
        Object.values(KeyboardEvents).forEach((keyboardEvent) => {
          elements.forEach((el) => {
            this.domProvider.addEventListener(
              el,
              keyboardEvent,
              function _listener(e) {
                const evt = e;
                switch (evt.code) {
                  case KEY_CODES.TAB:
                    evt.stopPropagation();
                    evt.stopImmediatePropagation();
                    break;
                  case KEY_CODES.ESC:
                    Object.values(KeyboardEvents).forEach((keyboardEvent2) => {
                      el.removeEventListener(keyboardEvent2, _listener);
                    });
                    dispatchKeyDownEvent(el, KEY_CODES.ESC, true);
                    break;
                }
              }
            );
          });
        });
      }
    };
    let NavigationControl = _NavigationControl;
    NavigationControl.u1stNavigationBlockFlag = "u1st-navigation";

    const CONSTS = {
      U1ST_CACHED_DATA: "u1st-cached-data-",
    };

    class DomExtensionProvider {
      constructor(domProvider) {
        this.domProvider = domProvider;
      }
      restoreCachedAttributeToAll(elements, attrs) {
        elements.forEach((e) => {
          const elAttributes = e.attributes;
          for (const attr in attrs) {
            const cachedAttrName = `${CONSTS.U1ST_CACHED_DATA}${attr}`;
            if (elAttributes[cachedAttrName]) {
              this.domProvider.setAttribute(
                e,
                `${attr}`,
                elAttributes[cachedAttrName].value
              );
              this.domProvider.removeAttribute(e, cachedAttrName);
            }
          }
        });
      }
      setCachedAttributeToAll(elements, attrs) {
        elements.forEach((e) => {
          const elAttributes = e.attributes;
          for (const attr in attrs) {
            if (elAttributes[attr]) {
              this.domProvider.setAttribute(
                e,
                `${CONSTS.U1ST_CACHED_DATA}${attr}`,
                elAttributes[attr].value
              );
              this.domProvider.setAttribute(e, attr, attrs[attr]);
            }
          }
        });
      }
      getParentsElements(el) {
        const parents = [];
        while (el.parentNode && el.parentNode.nodeName.toLowerCase() != "html") {
          el = el.parentNode;
          parents.push(el);
        }
        return parents;
      }
      getNodes(context, whatToShow, acceptNode) {
        const treeWalker = this.domProvider
          .getDomDocument()
          .createTreeWalker(
            context,
            whatToShow,
            acceptNode ? { acceptNode } : null
          );
        const nodeList = [];
        let currentNode = treeWalker.currentNode;
        while (currentNode) {
          nodeList.push(currentNode);
          currentNode = treeWalker.nextNode();
        }
        return nodeList;
      }
      getImgSrc(element) {
        let src;
        const imgElement =
          this.domProvider.getTagName(element) == "IMG"
            ? element
            : this.domProvider.querySelector("img", element);
        if (imgElement) {
          src = this.domProvider.getAttribute(imgElement, "src");
        } else {
          const elmsInItem = this.domProvider.querySelectorAll("*", element);
          elmsInItem.unshift(element);
          for (let i = 0; i < elmsInItem.length; i++) {
            const inlineImgStyle = elmsInItem[i].style.backgroundImage;
            const bgImg = inlineImgStyle
              ? inlineImgStyle
              : window
                  .getComputedStyle(elmsInItem[i])
                  .getPropertyValue("background-image");
            if (bgImg && bgImg.startsWith("url")) {
              const indexEnd = bgImg.length - 2;
              src = bgImg.substring(5, indexEnd);
              break;
            }
          }
        }
        return src;
      }
    }

    class DialogFixer extends FixerAbstract {
      constructor(
        context,
        props,
        domProvider,
        changeDetection,
        dialogDescription,
        dialogBounding,
        dialogTrigger,
        elementVisibility,
        closeHandler,
        navigationControl
      ) {
        var _a;
        super(
          context,
          domProvider,
          changeDetection,
          props,
          (_a = props.selectors.trigger) != null ? _a : props.selectors.dialog,
          (closedElement) =>
            !props.selectors.trigger && this.onClose(closedElement)
        );
        this.dialogElement = null;
        this.props = props;
        this.dialogDescription = dialogDescription;
        this.dialogBounding = dialogBounding;
        this.changeDetection = changeDetection;
        this.dialogTrigger = dialogTrigger;
        this.elementVisibility = elementVisibility;
        this.closeHandler = closeHandler;
        this.navigationControl = navigationControl;
        this.isMobile = Utils$1.isMobileDevice();
        this.contentObserver = null;
        this.observerOptions = {
          childList: true,
          attributes: true,
          subtree: true,
          attributeFilter: ["tabindex", "u1st-visualfocus"],
          attributeOldValue: true,
        };
      }
      fix() {
        const { dialog, trigger, waitForElement } = this.props.selectors;
        trigger && this.dialogTrigger.handle(trigger, this.props);
        if (trigger) {
          this.changeDetection.subscribe(
            this.context,
            "dialog",
            waitForElement || dialog,
            (visibleDialog) => this.onOpen(visibleDialog),
            (closedElement) => this.onClose(closedElement)
          );
        } else {
          this.onOpen();
        }
      }
      onClose(closedElement) {
        closedElement &&
          this.domProvider.removeAttribute(
            closedElement,
            PROJECT_CLASSES.AVOID_CHANGE_DETECTION
          );
        this.navigationControl.release();
        this.dialogTrigger.focusOnTrigger();
      }
      onOpen(visibleDialog) {
        const { trigger, dialog, heading, waitForElement, textContent } =
          this.props.selectors;
        const isModalType = this.props.type == DialogType.MODAL;
        this.dialogElement = waitForElement
          ? this.domProvider.querySelector(dialog)
          : visibleDialog || this.domProvider.querySelector(dialog);
        if (!this.dialogElement) return;
        this.fixDialogContent();
        this.closeHandler.handle(this.dialogElement, this.props);
        this.dialogDescription.add(this.dialogElement, heading, textContent);
        if (this.props.blockNavigation || this.isMobile) {
          const excludeSelector = this.isMobile
            ? `${dialog}, ${trigger}`
            : dialog;
          this.navigationControl.block(excludeSelector);
          this.navigationControl.stopTabPropagation(excludeSelector);
        }
        this.dialogBounding.focusInBound(this.dialogElement);
        this.domProvider.setAttribute(this.dialogElement, "role", ROLE$1.DIALOG);
        !this.isMobile &&
          this.domProvider.setAttribute(
            this.dialogElement,
            ARIA.MODAL,
            isModalType.toString()
          );
        this.props.onOpen && this.props.onOpen();
      }
      fixDialogContent() {
        const parentWithRoles = this.domProvider.closest(
          this.dialogElement,
          `[${ARIA.MODAL}],[role='dialog']`,
          true
        );
        if (parentWithRoles) {
          this.domProvider.removeAttribute(parentWithRoles, ARIA.MODAL);
          this.domProvider.removeAttribute(parentWithRoles, `role`);
        }
        const isDynamic =
          this.dialogElement &&
          this.props.selectors.dynamicContent &&
          this.domProvider.querySelector(
            this.props.selectors.dynamicContent,
            this.dialogElement
          ) !== null;
        const dialogChildren = this.domProvider.querySelectorAll(
          "*",
          this.dialogElement
        );
        dialogChildren.forEach((el) => {
          if (el.getAttribute("role") == ROLE$1.DIALOG) {
            this.domProvider.removeAttribute(el, "role");
          }
          if (el.getAttribute(ARIA.MODAL)) {
            this.domProvider.removeAttribute(el, ARIA.MODAL);
          }
        });
        if (
          isDynamic &&
          this.dialogElement &&
          this.props.selectors.dynamicContent
        ) {
          const dynamicContent = this.domProvider.querySelector(
            this.props.selectors.dynamicContent,
            this.dialogElement
          );
          if (dynamicContent) {
            this.contentObserver = new MutationObserver(
              this.dynamicConentCallback.bind(this)
            );
            this.contentObserver.observe(dynamicContent, this.observerOptions);
          }
        }
      }
      dynamicConentCallback(mutations) {
        for (const mutation of mutations) {
          if (mutation.attributeName == "tabindex" && mutation.oldValue == "-1") {
            const currentAvoidFocusOnOpenState = this.props.avoidFocusOnOpen;
            this.props.avoidFocusOnOpen = true;
            this.dialogBounding.focusInBound(this.dialogElement);
            this.props.avoidFocusOnOpen = currentAvoidFocusOnOpenState;
            return;
          }
        }
      }
    }
    const DialogApi = (context = "body") => {
      const domProvider = new DomProvider();
      const domExtension = new DomExtensionProvider(domProvider);
      const elementVisibility = new ElementVisibility();
      const navigationControl = new NavigationControl(domProvider, domExtension);
      const stateManagement = StateManagement.getInstance();
      const translateService = new Translate(stateManagement);
      const closeHandler = new CloseHandler(
        domProvider,
        navigationControl,
        translateService
      );
      const dialogDescription = new DialogDescription(domProvider);
      const dialogBounding = new DialogBounding(
        domProvider,
        elementVisibility,
        closeHandler
      );
      const changeDetection = ChangeDetection.getInstance(
        new ElementVisibility(),
        domProvider
      );
      const dialogTrigger = new DialogTrigger(domProvider);
      return (props) =>
        new DialogFixer(
          context,
          props,
          domProvider,
          changeDetection,
          dialogDescription,
          dialogBounding,
          dialogTrigger,
          elementVisibility,
          closeHandler,
          navigationControl
        );
    };

    class DatepickerDialog {
      constructor(domProvider, changeDetection, customTrigger, props) {
        this.domProvider = domProvider;
        this.changeDetection = changeDetection;
        this.customTrigger = customTrigger;
        this.props = props;
      }
      initDialog(context, navigation) {
        var _a, _b;
        if (
          (_a = this.props.openOnFocus) == null ? void 0 : _a.addCustomTrigger
        ) {
          this.customTrigger.subscribe(
            this.props.openOnFocus.addButtonCss,
            navigation,
            this.props,
            context
          );
        } else {
          const dialogProps = {
            selectors: {
              dialog: this.props.container,
              trigger: this.props.trigger,
            },
            type: DialogType.MODAL,
            avoidFocusOnOpen: true,
          };
          if ((_b = this.props.disable) == null ? void 0 : _b.arrowNavigation) {
            dialogProps.onClose = () => {
              navigation.closeCalendar();
            };
          } else if (this.props.onClose) {
            dialogProps.onClose = this.props.onClose;
          }
          DialogApi(context)(dialogProps);
        }
      }
    }

    const U1_DAY = "u1st-day";
    const _Navigation = class {
      constructor(
        domProvider,
        navigationControl,
        stateManagement,
        props,
        elementVisibility
      ) {
        this.domProvider = domProvider;
        this.navigationControl = navigationControl;
        this.stateManagement = stateManagement;
        this.props = props;
        this.elementVisibility = elementVisibility;
        var _a, _b;
        this.calendar = this.domProvider.querySelector(
          `${props.calendar.table}:not([u1-table-marked])`,
          this.props.container
        );
        this.domProvider.setAttribute(this.calendar, "u1-table-marked", "true");
        ((_a = props.month) == null ? void 0 : _a.prevButton) &&
          (this.prevButton = this.domProvider.querySelector(
            props.month.prevButton,
            this.props.container
          ));
        ((_b = props.month) == null ? void 0 : _b.nextButton) &&
          (this.nextButton = this.domProvider.querySelector(
            props.month.nextButton,
            this.props.container
          ));
      }
      navigate(e, uniqueClickEvent) {
        var _a, _b;
        const evt = e;
        const el = e.target;
        switch (evt.code) {
          case KEYBOARD_EVENT_CODE$1.PAGEUP:
            evt.preventDefault();
            (_a = this.gotoFollowingMonth(1)) == null
              ? void 0
              : _a.then((nextFocus) => {
                  this.setNextFocusWithAttr(el, nextFocus, 50);
                });
            break;
          case KEYBOARD_EVENT_CODE$1.PAGEDOWN:
            evt.preventDefault();
            (_b = this.gotoFollowingMonth(-1)) == null
              ? void 0
              : _b.then((nextFocus) => {
                  this.setNextFocusWithAttr(el, nextFocus, 50);
                });
            break;
          case KEYBOARD_EVENT_CODE$1.RIGHT:
            this.focusOnFollowingElement(
              el,
              this.getDirectionByLanguage(1 /* RIGHT */)
            );
            evt.stopPropagation();
            evt.stopImmediatePropagation();
            break;
          case KEYBOARD_EVENT_CODE$1.LEFT:
            this.focusOnFollowingElement(
              el,
              this.getDirectionByLanguage(-1 /* LEFT */)
            );
            evt.stopPropagation();
            evt.stopImmediatePropagation();
            break;
          case KEYBOARD_EVENT_CODE$1.UP:
            this.preventScrolling(evt);
            this.focusOnFollowingElement(el, -7 /* UP */);
            evt.stopPropagation();
            break;
          case KEYBOARD_EVENT_CODE$1.DOWN:
            this.preventScrolling(evt);
            this.focusOnFollowingElement(el, 7 /* DOWN */);
            evt.stopPropagation();
            break;
          case KEYBOARD_EVENT_CODE$1.ENTER:
            evt.preventDefault();
            this.domProvider.dispatchCustomClickEvent(
              el,
              uniqueClickEvent != null ? uniqueClickEvent : "click"
            );
            break;
          case KEYBOARD_EVENT_CODE$1.HOME:
            evt.preventDefault();
            this.focusOnFollowingWeekDay(el, DIRECTION.START);
            break;
          case KEYBOARD_EVENT_CODE$1.END:
            evt.preventDefault();
            this.focusOnFollowingWeekDay(el, DIRECTION.END);
            break;
          case KEYBOARD_EVENT_CODE$1.ESC:
            evt.preventDefault();
            this.closeCalendar();
            break;
        }
      }
      preventScrolling(keyboardEvent) {
        keyboardEvent.preventDefault();
      }
      onSelected() {
        this.navigationControl.release();
        this.focusOnTriggerAndClose();
      }
      closeCalendar() {
        const trigger = this.domProvider.querySelector(this.props.trigger);
        if (trigger) {
          this.domProvider.setTimeout(() => {
            if (this.props.openOnFocus) {
              this.domProvider.dispatchClickEvent(this.domProvider.getBody());
            } else {
              const calendar = this.domProvider.querySelector(
                this.props.calendar.table
              );
              this.domProvider.focusOnElement(trigger);
              calendar &&
                this.elementVisibility.isVisible(calendar) &&
                this.domProvider.dispatchMouseClickEvent(trigger);
            }
          }, 400);
        }
      }
      focusOnTriggerAndClose() {
        const trigger = this.domProvider.querySelector(
          `[${PROJECT_CLASSES.TRIGGER_ELEMENT}]`
        );
        if (trigger) {
          this.domProvider.setTimeout(() => {
            const calendar = this.domProvider.querySelector(
              this.props.calendar.table
            );
            this.domProvider.focusOnElement(trigger);
            calendar &&
              this.elementVisibility.isVisible(calendar) &&
              this.domProvider.dispatchMouseClickEvent(trigger);
            this.domProvider.removeAttribute(
              trigger,
              PROJECT_CLASSES.TRIGGER_ELEMENT
            );
          }, 400);
        }
      }
      getDirectionByLanguage(direction) {
        const isRtl = Utils$1.isRtl(this.stateManagement.getLang());
        return isRtl ? direction * -1 : direction;
      }
      focusOnFollowingElement(el, direction) {
        var _a;
        const currentCal = Utils$1.findParentWithAttribute(
          el,
          PROJECT_ATTRIBUTES.CALENDAR_INDEX
        );
        const currCalIndex = currentCal
          ? Number(
              this.domProvider.getAttribute(
                currentCal,
                PROJECT_ATTRIBUTES.CALENDAR_INDEX
              )
            )
          : void 0;
        let elToFocus = this.getNextElement(el, direction, currentCal);
        if (!elToFocus) {
          (_a = this.gotoFollowingMonth(direction, currCalIndex)) == null
            ? void 0
            : _a.then((data) => {
                elToFocus = data;
                this.setNextFocusWithAttr(el, elToFocus, 50);
                return;
              });
        } else {
          this.setNextFocusWithAttr(el, elToFocus);
        }
      }
      getNextElement(el, direction, currentCal) {
        const elCalendarPlace = this.domProvider.getAttribute(el, U1_DAY);
        return this.domProvider.querySelector(
          `[${U1_DAY}=${Number(elCalendarPlace) + direction}]`,
          currentCal != null ? currentCal : this.calendar
        );
      }
      focusOnFollowingWeekDay(el, direction) {
        if (
          this.domProvider.getTagName(this.calendar).toLowerCase() ===
          TAG_NAMES.TABLE
        ) {
          const row = this.domProvider.closest(el, TAG_NAMES.TR);
          if (!row) return;
          const weekDays = this.domProvider.querySelectorAll(`[${U1_DAY}]`, row);
          const elToFocus =
            direction == DIRECTION.START
              ? weekDays[0]
              : weekDays[weekDays.length - 1];
          if (!elToFocus) return;
          this.domProvider.setAttribute(elToFocus, ATTRIBUTES.TABINDEX, "0");
          this.domProvider.setAttribute(el, ATTRIBUTES.TABINDEX, "-1");
          this.domProvider.focusOnElement(elToFocus);
        } else {
          const currTopPos = el.getBoundingClientRect().top;
          let nextTopPos = el.getBoundingClientRect().top || void 0;
          let isEmpty = false;
          while (currTopPos === nextTopPos || !isEmpty) {
            if (direction === DIRECTION.START) {
              const next = this.getNextOrPrevEl(false);
              nextTopPos =
                next == null ? void 0 : next.getBoundingClientRect().top;
              if (!next.innerText) {
                isEmpty = true;
                break;
              }
              if (nextTopPos !== currTopPos || !next) break;
              this.setNewFocus(el, next);
            } else if (direction === DIRECTION.END) {
              const next = this.getNextOrPrevEl(true);
              nextTopPos =
                next == null ? void 0 : next.getBoundingClientRect().top;
              if (!next.innerText) {
                isEmpty = true;
                break;
              }
              if (nextTopPos !== currTopPos || !next) break;
              this.setNewFocus(el, next);
            }
          }
        }
      }
      getNextOrPrevEl(isNext) {
        var _a, _b;
        return isNext
          ? (_a = this.domProvider.querySelector(
              `[${U1_DAY}][u1st-visualfocus="true"]`
            )) == null
            ? void 0
            : _a.nextElementSibling
          : (_b = this.domProvider.querySelector(
              `[${U1_DAY}][u1st-visualfocus="true"]`
            )) == null
          ? void 0
          : _b.previousElementSibling;
      }
      setNewFocus(currEl, focusEl) {
        this.domProvider.setAttribute(focusEl, ATTRIBUTES.TABINDEX, "0");
        this.domProvider.setAttribute(currEl, ATTRIBUTES.TABINDEX, "-1");
        this.domProvider.focusOnElement(focusEl);
      }
      setNextFocusWithAttr(curentEl, nextEl, timeout = 10) {
        this.domProvider.setAttribute(nextEl, ATTRIBUTES.TABINDEX, "0");
        this.domProvider.setAttribute(curentEl, ATTRIBUTES.TABINDEX, "-1");
        this.domProvider.setAttribute(nextEl, ARIA.SELECTED, "true");
        this.domProvider.setAttribute(curentEl, ARIA.SELECTED, "false");
        this.domProvider.setTimeout(
          () => this.domProvider.focusOnElement(nextEl),
          timeout
        );
      }
      gotoFollowingMonth(direction, calIndex) {
        var _a, _b;
        const isNext = direction > 0;
        const followingMonth = isNext ? this.nextButton : this.prevButton;
        const daysSelector =
          (_a = this.props.calendar) == null ? void 0 : _a.activeDays;
        const tableSelector =
          (_b = this.props.calendar) == null ? void 0 : _b.table;
        const isDoubleDatepicker = this.props.doubleDatepicker;
        if (!followingMonth) return null;
        const isInFirstCalendar =
          typeof calIndex === "number" && calIndex % 2 === 0;
        const shouldGoToNextCal = isNext && !isInFirstCalendar;
        const shouldGoToPrevCal = !isNext && isInFirstCalendar;
        if (
          !isDoubleDatepicker ||
          (isDoubleDatepicker && (shouldGoToNextCal || shouldGoToPrevCal))
        )
          this.domProvider.dispatchKeydownEvent(
            followingMonth,
            KEYBOARD_EVENT_CODE$1.ENTER,
            true
          );
        return new Promise((res) => {
          this.domProvider.setTimeout(() => {
            _Navigation.focusOnLastDay = direction < 0;
            const nextCalIndex =
              typeof calIndex === "number" &&
              (direction > 0 ? calIndex + 1 : calIndex - 1);
            const calendarSelector =
              isDoubleDatepicker && nextCalIndex
                ? `${tableSelector}[${PROJECT_ATTRIBUTES.CALENDAR_INDEX}="${nextCalIndex}"]`
                : tableSelector;
            const activeDays = this.domProvider.querySelectorAll(
              `${daysSelector}`,
              calendarSelector
            );
            if (activeDays.length > 0) {
              const day = _Navigation.focusOnLastDay
                ? activeDays[activeDays.length - 1]
                : activeDays[0];
              res(day);
            }
          }, 200);
        });
      }
    };
    let Navigation$2 = _Navigation;
    Navigation$2.focusOnLastDay = false;

    class DatePickerDays {
      constructor(
        domProvider,
        calendarDialog,
        navigation,
        props,
        doubleDatepicker
      ) {
        this.domProvider = domProvider;
        this.calendarDialog = calendarDialog;
        this.navigation = navigation;
        this.props = props;
        this.doubleDatepicker = doubleDatepicker;
      }
      fix(autoFocus = true, uniqueClickEvent) {
        const { selectedDay, activeDays, disabledDays } = this.props;
        selectedDay &&
          !this.selectedDayElement &&
          (this.selectedDayElement = this.domProvider.querySelector(
            selectedDay,
            this.calendarDialog
          ));
        this.activeDaysElement = this.domProvider.querySelectorAll(
          activeDays,
          this.calendarDialog
        );
        this.domProvider.setAttributeToAll(
          this.activeDaysElement,
          AVOID_AUTO_TABBABLE_ATTRIBUTE,
          "true"
        );
        if (disabledDays) {
          const disabledEls = this.domProvider.querySelectorAll(disabledDays);
          this.domProvider.setAttributeToAll(disabledEls, ARIA.DISABLED, "true");
          this.domProvider.setAttributeToAll(
            disabledEls,
            ATTRIBUTES.TABINDEX,
            "-1"
          );
        }
        const tables = this.domProvider.querySelectorAll(
          this.props.table,
          this.calendarDialog
        );
        this.domProvider.setAttributeToAll(tables, ATTRIBUTES.ROLE, "grid");
        this.domProvider.setTimeout(() => {
          const shouldFocus = this.shouldFocusOnSelected(autoFocus);
          this.handleSelectedDay(shouldFocus);
          this.handleActiveDays(uniqueClickEvent);
        }, 50);
      }
      handleSelectedDay(autoFocus) {
        this.selectedDayElement = this.getSelectedDay();
        this.domProvider.setAttribute(
          this.selectedDayElement,
          ARIA.SELECTED,
          "true"
        );
        this.domProvider.setAttribute(
          this.selectedDayElement,
          ATTRIBUTES.TABINDEX,
          "0"
        );
        autoFocus && this.domProvider.focusOnElement(this.selectedDayElement);
        Navigation$2.focusOnLastDay = false;
      }
      handleActiveDays(uniqueClickEvent) {
        this.activeDaysElement.forEach((el, i) => {
          const ariaSelected = this.domProvider.getAttribute(el, ARIA.SELECTED);
          if (!ariaSelected) {
            this.domProvider.setAttribute(el, ATTRIBUTES.TABINDEX, "-1");
          }
          this.domProvider.setAttribute(el, "u1st-day", i.toString());
        });
        this.domProvider.addEventListenerToAll(
          this.activeDaysElement,
          "keydown",
          (e) => {
            this.navigation.navigate(e, uniqueClickEvent);
          }
        );
        this.domProvider.addEventListenerToAll(
          this.activeDaysElement,
          "click",
          (e) => {
            this.doubleDatepicker
              ? this.navigation.navigate(e, KEYBOARD_EVENT_CODE$1.ENTER)
              : this.navigation.onSelected();
          }
        );
      }
      setAriaDescribedBy(month, year) {
        var _a, _b;
        const monthId =
          (_a = this.domProvider.querySelector(month)) == null ? void 0 : _a.id;
        const yearId =
          (_b = this.domProvider.querySelector(year)) == null ? void 0 : _b.id;
        if (monthId && yearId) {
          this.domProvider.setAttributeToAll(
            this.activeDaysElement,
            ARIA.DESCRIBEDBY,
            `${monthId} ${yearId}`
          );
        }
      }
      getSelectedDay() {
        var _a;
        const dayIndexToFocus = Navigation$2.focusOnLastDay
          ? this.activeDaysElement.length - 1
          : 0;
        return (_a = this.selectedDayElement) != null
          ? _a
          : this.activeDaysElement[dayIndexToFocus];
      }
      shouldFocusOnSelected(autoFocus) {
        var _a;
        return (
          autoFocus &&
          !((_a = document.activeElement) == null
            ? void 0
            : _a.getAttribute("u1st-day"))
        );
      }
    }

    class DatePickerCalendar {
      constructor(domProvider, props, elementVisibility, navigation) {
        this.domProvider = domProvider;
        this.props = props;
        this.elementVisibility = elementVisibility;
        this.navigation = navigation;
      }
      fix(visibleCalendar, shouldAutoFocusDay = true) {
        var _a;
        if (!((_a = this.props.disable) == null ? void 0 : _a.arrowNavigation)) {
          setTimeout(() => {
            var _a2, _b, _c, _d, _e, _f, _g, _h;
            if (this.props.doubleDatepicker) {
              const indexedTables = this.domProvider.querySelectorAll(
                `${this.props.calendar.table}[${PROJECT_ATTRIBUTES.CALENDAR_INDEX}]`
              );
              this.domProvider.removeAttributeToAll(
                indexedTables,
                PROJECT_ATTRIBUTES.CALENDAR_INDEX
              );
              const tablesToIndex = this.elementVisibility.getVisibleElements(
                `${this.props.container} ${this.props.calendar.table}`
              );
              tablesToIndex == null
                ? void 0
                : tablesToIndex.forEach((table, i) => {
                    this.domProvider.setAttribute(
                      table,
                      PROJECT_ATTRIBUTES.CALENDAR_INDEX,
                      String(i)
                    );
                  });
            }
            const days = new DatePickerDays(
              this.domProvider,
              visibleCalendar,
              this.navigation,
              this.props.calendar,
              this.props.doubleDatepicker
            );
            days.fix(
              shouldAutoFocusDay && !!this.props.trigger,
              this.props.uniqueClickEvent
            );
            if (
              ((_b = (_a2 = this.props.month) == null ? void 0 : _a2.text) == null
                ? void 0
                : _b.selector) &&
              ((_d = (_c = this.props.year) == null ? void 0 : _c.text) == null
                ? void 0
                : _d.selector)
            ) {
              days.setAriaDescribedBy(
                (_f = (_e = this.props.month) == null ? void 0 : _e.text) == null
                  ? void 0
                  : _f.selector,
                (_h = (_g = this.props.year) == null ? void 0 : _g.text) == null
                  ? void 0
                  : _h.selector
              );
            }
          }, 1);
        }
      }
    }

    class Month extends DatePickerHeader {
      constructor(domProvider, translateService) {
        super(domProvider);
        this.translateService = translateService;
      }
      fix(props, context, calendarService, uniqueClickEvent) {
        super.fix(props, context, calendarService, uniqueClickEvent);
        this.setDescription(
          this.translateService.getValue(TranslateText.PREV_MONTH),
          this.translateService.getValue(TranslateText.NEXT_MONTH)
        );
        this.setAriaLive(Utils$1.uuid());
        if (props.text.isClickable) {
          const monthBtn = this.domProvider.querySelector(
            props.text.selector,
            this.context
          );
          monthBtn && this.setButton(monthBtn);
        }
      }
    }

    var __async = (__this, __arguments, generator) => {
      return new Promise((resolve, reject) => {
        var fulfilled = (value) => {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        };
        var rejected = (value) => {
          try {
            step(generator.throw(value));
          } catch (e) {
            reject(e);
          }
        };
        var step = (x) =>
          x.done
            ? resolve(x.value)
            : Promise.resolve(x.value).then(fulfilled, rejected);
        step((generator = generator.apply(__this, __arguments)).next());
      });
    };
    const CUSTOM_TRIGGER_CLASS = "u1st-custom-trigger";
    const CUSTOM_TRIGGER_STYLE_ID = "u1st-custom-datepicker-trigger";
    class CustomTrigger {
      constructor(
        context,
        domProvider,
        changeDetection,
        elementVisibility,
        waitForElement,
        translateService
      ) {
        this.context = context;
        this.domProvider = domProvider;
        this.translateService = translateService;
        this.elementVisibility = elementVisibility;
        this.waitForElement = waitForElement;
        this.changeDetection = changeDetection;
      }
      subscribe(customCss, navigation, props, context) {
        this.changeDetection.subscribe(
          this.context,
          "datepickerCustomTrigger",
          // wait for element is the datepicker trigger element
          this.waitForElement,
          // visible element is the datepicker trigger element
          (visibleElement) =>
            this.create(visibleElement, customCss, navigation, props, context)
        );
      }
      create(visibleElement, customCss, navigation, props, context) {
        var _a;
        this.handleRealTrigger(visibleElement);
        const customTriggerEl = this.domProvider.createElement("div");
        const uniqueId = Utils$1.getOrCreateId(customTriggerEl);
        this.domProvider.insertBefore(visibleElement, customTriggerEl, uniqueId);
        this.domProvider.setAttribute(customTriggerEl, "tabindex", "0");
        this.domProvider.setAttribute(customTriggerEl, "role", "button");
        this.domProvider.setAttribute(
          customTriggerEl,
          AVOID_AUTO_HIDDEN_ATTRIBUTE,
          "true"
        );
        this.domProvider.setAttribute(customTriggerEl, ARIA.HIDDEN, "false");
        this.domProvider.setAttribute(
          customTriggerEl,
          ARIA.LABEL,
          this.translateService.getValue(TranslateText.CHOOSE_DATE)
        );
        this.addStyle(customTriggerEl, customCss, uniqueId);
        this.domProvider.addEventListener(customTriggerEl, "click", () =>
          __async(this, null, function* () {
            yield this.open(customTriggerEl, visibleElement);
          })
        );
        this.domProvider.addEventListener(customTriggerEl, "keydown", (e) =>
          this.onEnter(e, visibleElement)
        );
        const dialogProps = {
          selectors: {
            dialog: props.container,
            trigger: `[id="${uniqueId}"]`,
          },
          type: DialogType.MODAL,
          avoidFocusOnOpen: true,
        };
        if ((_a = props.disable) == null ? void 0 : _a.arrowNavigation) {
          dialogProps.onClose = () => {
            navigation.closeCalendar();
          };
        } else if (props.onClose) {
          dialogProps.onClose = props.onClose;
        }
        DialogApi(context)(dialogProps);
      }
      handleRealTrigger(trigger) {
        this.domProvider.setAttribute(trigger, "tabindex", "-1");
        this.domProvider.setAttribute(
          trigger,
          AVOID_AUTO_HIDDEN_ATTRIBUTE,
          "true"
        );
        this.domProvider.setAttribute(
          trigger,
          AVOID_AUTO_TABBABLE_ATTRIBUTE,
          "true"
        );
        this.domProvider.setAttribute(trigger, ARIA.HIDDEN, "true");
      }
      onEnter(e, visibleElement) {
        const evt = e;
        const el = e.target;
        if (evt.code === "Enter") {
          evt.preventDefault();
          (() =>
            __async(this, null, function* () {
              return yield this.open(el, visibleElement);
            }))();
        }
      }
      open(el, visibleElement) {
        return __async(this, null, function* () {
          this.domProvider.focusOnElement(visibleElement);
          yield Utils$1.waitForTimeout(this.domProvider, 100);
          if (!this.elementVisibility.isVisible(el)) {
            this.domProvider.dispatchClickEvent(visibleElement);
          }
        });
      }
      addStyle(customTriggerEl, customCss, uniqueId) {
        this.domProvider.addClass(customTriggerEl, CUSTOM_TRIGGER_CLASS);
        customCss &&
          this.domProvider.addStyle(
            `[id='${uniqueId}']{${customCss.trim()}}`,
            `${CUSTOM_TRIGGER_STYLE_ID}-${uniqueId}`
          );
      }
    }

    const mapToOldProps$1 = (props) => {
      const {
        selectors,
        isMonthClickable,
        onClose,
        uniqueClickEvent,
        isYearClickable,
        openOnFocus,
        doubleDatepicker,
        disable,
      } = props;
      const { container, month, year, days, trigger, secondaryTrigger } =
        selectors;
      const { table, day, selected, disabled } = days;
      return {
        container,
        trigger,
        secondaryTrigger,
        year: {
          text: {
            selector: year.label,
            isClickable: isYearClickable,
          },
          prevButton: year.prevButton,
          nextButton: year.nextButton,
        },
        month: {
          text: {
            selector: month.label,
            isClickable: isMonthClickable,
          },
          prevButton: month.prevButton,
          nextButton: month.nextButton,
        },
        calendar: {
          table,
          selectedDay: selected,
          activeDays: `${day}:not(${disabled})`,
          disabledDays: disabled,
        },
        doubleDatepicker,
        openOnFocus,
        uniqueClickEvent,
        onClose,
        disable,
      };
    };

    const DatepickerApi = (context = "body") => {
      const domProvider = new DomProvider();
      const domExtension = new DomExtensionProvider(domProvider);
      const elementVisibility = new ElementVisibility();
      const translateService = new Translate(StateManagement.getInstance());
      const month = new Month(domProvider, translateService);
      const year = new Year(domProvider, translateService);
      const changeDetection = ChangeDetection.getInstance(
        elementVisibility,
        domProvider
      );
      const navigationControl = new NavigationControl(domProvider, domExtension);
      return (props) => {
        if ("selectors" in props) {
          props = mapToOldProps$1(props);
        }
        props = props;
        const customTrigger = new CustomTrigger(
          context,
          domProvider,
          changeDetection,
          elementVisibility,
          props.trigger,
          translateService
        );
        const datepickerDialog = new DatepickerDialog(
          domProvider,
          changeDetection,
          customTrigger,
          props
        );
        const stateManagement = StateManagement.getInstance();
        const navigation = new Navigation$2(
          domProvider,
          navigationControl,
          stateManagement,
          props,
          elementVisibility
        );
        const calendarService = new DatePickerCalendar(
          domProvider,
          props,
          elementVisibility,
          navigation
        );
        props.trigger && datepickerDialog.initDialog(context, navigation);
        new DatepickerFixer(
          context,
          props,
          domProvider,
          changeDetection,
          month,
          year,
          calendarService
        );
      };
    };

    class FormFields {
      constructor(domProvider) {
        this.domProvider = domProvider;
      }
      handleLabelInputFieldsRelationship(labelSelector, inputSelector, form) {
        const labels = this.domProvider.querySelectorAll(labelSelector, form);
        const inputs = this.domProvider.querySelectorAll(inputSelector, form);
        if (labels.length === inputs.length) {
          labels.forEach((label, index) => {
            const input = inputs[index];
            const inputId = Utils$1.getOrCreateId(input);
            this.domProvider.setAttribute(label, "for", inputId);
          });
        }
      }
      handleRequiredFields(selector, form) {
        const requiredFields = this.domProvider.querySelectorAll(selector, form);
        requiredFields.forEach((el) =>
          this.domProvider.setAttribute(el, ARIA.REQUIRED, "true")
        );
      }
      handleInvalidFields(selector, form) {
        this.cleanupAriaInvalid(form);
        const invalidFields = this.domProvider.querySelectorAll(selector, form);
        invalidFields.forEach((el) =>
          this.domProvider.setAttribute(el, ARIA.INVALID, "true")
        );
      }
      cleanupAriaInvalid(form) {
        const ariaInvalidSelector = `[${ARIA.INVALID}]`;
        const elementsWithAriaInvalid = this.domProvider.querySelectorAll(
          ariaInvalidSelector,
          form
        );
        elementsWithAriaInvalid.forEach((el) =>
          this.domProvider.removeAttribute(el, ARIA.INVALID)
        );
      }
    }

    class ErrorMessages {
      constructor(domProvider, statusFixer) {
        this.statusFixer = statusFixer;
        this.errorMessage = [];
        this.errorsArray = [];
        this.domProvider = domProvider;
      }
      clearAlert() {
        this.errorsArray = [];
      }
      populateAlert(errorMessage, form) {
        this.srOnlyErrorMessage = this.domProvider.querySelector(
          `.${PROJECT_CLASSES.SR_ONLY}:not(.${PROJECT_CLASSES.ALERT})`,
          errorMessage.parentElement
        );
        this.srOnlyErrorMessage && (errorMessage = this.srOnlyErrorMessage);
        this.errorMessage.push(errorMessage);
        if (!this.errorMessage || this.errorMessage.length == 0) return;
        this.cleanupRedundantMarkup(form);
        const errorToAdd = this.domProvider.getTextContent(errorMessage);
        this.errorsArray.push(errorToAdd);
        const finalText = this.errorsArray.join(",");
        this.statusFixer.announceStatus(finalText);
      }
      updateAlert(errorMessage) {
        this.errorMessage = this.errorMessage.filter(
          (err) => err !== errorMessage
        );
        let updatedText = "";
        this.errorsArray = [];
        this.errorMessage.forEach((error) => {
          const text = this.domProvider.getTextContent(error)
            ? this.domProvider.getTextContent(error)
            : "";
          this.errorsArray.push(text);
          updatedText += text + ",";
        });
        this.statusFixer.announceStatus(updatedText);
      }
      cleanupRedundantMarkup(formElement) {
        const selectorForCleanup = `[role=${ROLE$1.ALERT}],[role=${ROLE$1.STATUS}],[${ARIA.ATOMIC}],[${ARIA.LIVE}]`;
        const elementsToClean = this.domProvider.querySelectorAll(
          selectorForCleanup,
          formElement
        );
        elementsToClean.length &&
          Utils$1.removeClientsWCAGAttributes(elementsToClean, [
            ARIA.ATOMIC,
            ARIA.LIVE,
          ]);
      }
    }

    class SubmitButton {
      constructor(domProvider, errorMessages, elementVisibility) {
        this.elementVisibility = elementVisibility;
        this.domProvider = domProvider;
        this.errorMessages = errorMessages;
      }
      handleButton(props, context, formElement) {
        const { form, submitButton, errorMsg } = props.selectors;
        if (submitButton && errorMsg) {
          const submitButtonElement = this.domProvider.querySelector(
            submitButton,
            formElement
          );
          ButtonApi(context)({
            selectors: { element: `${form} ${submitButton}` },
          });
          this.domProvider.addEventListener(submitButtonElement, "click", () => {
            const interval = this.domProvider.setInterval(() => {
              let time = 0;
              if (time >= 5e3) clearInterval(interval);
              const visibleErrors =
                this.elementVisibility.getVisibleElements(errorMsg);
              if (visibleErrors.length) {
                clearInterval(interval);
                this.activateAlert(visibleErrors, formElement);
                this.handlInvalidField(props, formElement, submitButton);
              } else {
                time += 500;
              }
            }, 500);
          });
        }
      }
      activateAlert(visibleErrors, formElement) {
        this.errorMessages.clearAlert();
        visibleErrors.forEach((err) => {
          this.errorMessages.populateAlert(err, formElement);
        });
      }
      handlInvalidField(props, formElement, submitButton) {
        if (props.focusOnInvalidField && props.selectors.invalidField) {
          const nextInvalidField = this.domProvider.querySelector(
            props.selectors.invalidField,
            formElement
          );
          if (nextInvalidField) {
            this.domProvider.focusOnElement(nextInvalidField);
          } else {
            const submitButtonElement = this.domProvider.querySelector(
              submitButton,
              formElement
            );
            submitButtonElement &&
              this.domProvider.focusOnElement(submitButtonElement);
          }
        }
      }
    }

    class FormFixer extends FixerAbstract {
      constructor(
        context,
        props,
        domProvider,
        changeDetection,
        formFields,
        errorMessages,
        submitButton
      ) {
        super(context, domProvider, changeDetection, props, props.selectors.form);
        this.submitButton = submitButton;
        this.formElement = null;
        this.submitButtonElement = null;
        this.formFields = formFields;
        this.errorMessages = errorMessages;
        this.errorMessageAbsolute = props.selectors.errorMsg;
      }
      fix(visibleForm) {
        const { formLabelAbsolute, requiredField, successMsg, inputField } =
          this.props.selectors;
        this.formElement = visibleForm;
        if (!this.formElement) return;
        this.cleanupRedundantRoles();
        this.submitButton.handleButton(
          this.props,
          this.context,
          this.formElement
        );
        this.domProvider.getTagName(this.formElement) != "FORM" &&
          this.domProvider.setAttribute(this.formElement, "role", ROLE$1.FORM);
        if (formLabelAbsolute) {
          const labelElement = this.domProvider.querySelector(formLabelAbsolute);
          this.domProvider.setAttributeWithID(
            labelElement,
            this.formElement,
            ARIA.LABELLEDBY
          );
        }
        requiredField &&
          this.formFields.handleRequiredFields(requiredField, this.formElement);
        if (!this.errorMessageAbsolute) return;
        this.observer.subscribe(
          this.context,
          "formErrors",
          this.errorMessageAbsolute,
          (errorMessage) => this.onErrorsShow(errorMessage),
          (errorMessage) => this.onErrorsHide(errorMessage)
        );
        if (successMsg) {
          this.observer.subscribe(
            this.context,
            "formSuccessMsg",
            successMsg,
            (successMsg2) =>
              this.domProvider.setAttribute(successMsg2, STATUS_ATTR, "")
          );
        }
        if (formLabelAbsolute && inputField) {
          this.formFields.handleLabelInputFieldsRelationship(
            formLabelAbsolute,
            inputField,
            this.formElement
          );
        }
      }
      onErrorsShow(detectedError) {
        const invalidField = this.props.selectors.invalidField;
        this.errorMessages.populateAlert(detectedError, this.formElement);
        this.formFields.handleInvalidFields(invalidField, this.formElement);
      }
      onErrorsHide(detectedError) {
        const invalidField = this.props.selectors.invalidField;
        this.errorMessages.updateAlert(detectedError);
        this.formFields.handleInvalidFields(invalidField, this.formElement);
      }
      cleanupRedundantRoles() {
        const parent = this.domProvider.closest(
          this.formElement,
          `[role=${ROLE$1.FORM}],[role=${ROLE$1.SEARCH}]`
        );
        const elementsToClean = this.domProvider.querySelectorAll(
          `[role=${ROLE$1.FORM}]`,
          this.formElement
        );
        parent && elementsToClean.push(parent);
        elementsToClean.length &&
          Utils$1.removeClientsWCAGAttributes(elementsToClean);
      }
    }
    const FormApi = (context = "body") => {
      const domProvider = new DomProvider();
      const elementVisibility = new ElementVisibility();
      const changeDetection = ChangeDetection.getInstance(
        elementVisibility,
        domProvider
      );
      const formFields = new FormFields(domProvider);
      const statusFixer = new StatusFixer(context, domProvider, changeDetection);
      const errorMessages = new ErrorMessages(domProvider, statusFixer);
      const submitButton = new SubmitButton(
        domProvider,
        errorMessages,
        elementVisibility
      );
      return (props) =>
        new FormFixer(
          context,
          props,
          domProvider,
          changeDetection,
          formFields,
          errorMessages,
          submitButton
        );
    };

    class TableSorts {
      constructor(domProvider) {
        this.domProvider = domProvider;
      }
      setAriaSorts(tableElements) {
        const { columnHeaders, rows } = tableElements;
        columnHeaders.forEach((columnHeader, idx) => {
          this.isSortable(columnHeader) &&
            this.setSortOrder(rows, columnHeader, idx);
        });
      }
      isSortable(htmlElement) {
        return !!htmlElement.querySelector(
          COMMON_SELECTORS.TABBABLE_ELEMENTS_SELECTOR
        );
      }
      setSortOrder(rows, columnHeader, columnHeaderIdx) {
        const columnHeaderCells = Array.from(rows).map(
          (row) => row.children[columnHeaderIdx]
        );
        let ariaValue = "none";
        if (Utils$1.isAsc(columnHeaderCells)) {
          ariaValue = "ascending";
        } else if (Utils$1.isDesc(columnHeaderCells)) {
          ariaValue = "descending";
        }
        this.domProvider.setAttribute(columnHeader, ARIA.SORT, ariaValue);
      }
    }

    class TableRoles {
      constructor(domProvider) {
        this.domProvider = domProvider;
      }
      setRoles(tableElements, tableType = "table") {
        const { columnHeaders, rowHeaders, cells, table, rows } = tableElements;
        this.setRoleAttributes(
          [table],
          tableType === "table" ? ROLE$1.TABLE : ROLE$1.GRID
        );
        this.setRoleAttributes(
          cells,
          tableType === "table" ? ROLE$1.CELL : ROLE$1.GRIDCELL
        );
        this.setRoleAttributes(rows, ROLE$1.ROW);
        this.setRoleAttributes(rowHeaders, ROLE$1.ROWHEADER);
        this.setRoleAttributes(columnHeaders, ROLE$1.COLUMNHEADER);
      }
      setRoleAttributes(htmlElements, role) {
        this.domProvider.setAttributeToAll(htmlElements, ATTRIBUTES.ROLE, role);
      }
    }

    class Navigation$1 {
      constructor(domProvider, stateManagement) {
        this.domProvider = domProvider;
        this.stateManagement = stateManagement;
      }
      handleNavigation(gridElements, focusableElements, isRowClickable) {
        const directions = this.getDirections(gridElements);
        const { CELL_INDEX, ROW_INDEX } = PROJECT_ATTRIBUTES;
        this.numerationAttributes(focusableElements, CELL_INDEX);
        this.numerationAttributes(gridElements.rows, ROW_INDEX);
        this.domProvider.setAttribute(
          focusableElements[0],
          ATTRIBUTES.TABINDEX,
          "0"
        );
        this.domProvider.addEventListenerToAll(
          focusableElements,
          "keydown",
          (e) =>
            this.navigate(
              e,
              gridElements.table,
              focusableElements[0],
              directions,
              isRowClickable
            )
        );
      }
      navigate(event, table, tableStartingPoint, directions, isRowClickable) {
        const e = event;
        const el = e.target;
        const {
          RIGHT,
          LEFT,
          ENTER,
          DOWN,
          TAB,
          UP,
          SPACE,
          HOME,
          END,
          PAGEDOWN,
          PAGEUP,
        } = KEY_CODES;
        switch (e.code) {
          case RIGHT:
            e.preventDefault();
            this.focusOnFollowingElement(el, table, directions.right);
            break;
          case LEFT:
            e.preventDefault();
            this.focusOnFollowingElement(el, table, directions.left);
            break;
          case UP:
            e.preventDefault();
            this.focusOnFollowingElement(el, table, directions.up);
            break;
          case DOWN:
            e.preventDefault();
            this.focusOnFollowingElement(el, table, directions.down);
            break;
          case ENTER || SPACE: {
            const clickableEl = this.domProvider.querySelector(
              CLICKABLE_HTML_ELEMENTS,
              el
            );
            if (clickableEl) {
              this.domProvider.dispatchMouseClickEvent(clickableEl);
            } else if (isRowClickable) {
              this.domProvider.getAttribute(el, "role") === ROLE$1.GRIDCELL &&
                this.triggerParentClickEvent(el);
            }
            break;
          }
          case TAB:
            el.setAttribute(ATTRIBUTES.TABINDEX, "-1");
            tableStartingPoint.setAttribute(ATTRIBUTES.TABINDEX, "0");
            break;
          case HOME: {
            const currentCellRowIndex = this.getRowIndex(el);
            const firstCellInRow = table.querySelectorAll(
              `[${PROJECT_ATTRIBUTES.ROW_INDEX}='${currentCellRowIndex}'] [${PROJECT_ATTRIBUTES.CELL_INDEX}]`
            )[0];
            this.focusOnCell(el, firstCellInRow);
            break;
          }
          case END: {
            const currentCellRowIndex = this.getRowIndex(el);
            const cellsInRow = table.querySelectorAll(
              `[${PROJECT_ATTRIBUTES.ROW_INDEX}='${currentCellRowIndex}'] [${PROJECT_ATTRIBUTES.CELL_INDEX}]`
            );
            const lastCellInRow = cellsInRow[cellsInRow.length - 1];
            this.focusOnCell(el, lastCellInRow);
            break;
          }
          case PAGEUP: {
            e.preventDefault();
            const { CELL_INDEX, ROW_INDEX } = PROJECT_ATTRIBUTES;
            const currentRow = this.domProvider.closest(el, `[${ROW_INDEX}]`);
            if (currentRow) {
              const currentCellColumn = Array.from(
                currentRow == null
                  ? void 0
                  : currentRow.querySelectorAll(`[${CELL_INDEX}]`)
              ).findIndex((cell) => cell === el);
              const rows = table.querySelectorAll(
                `[${PROJECT_ATTRIBUTES.ROW_INDEX}]:has([${CELL_INDEX}])`
              );
              const firstCellInColumn = rows[0].querySelectorAll(
                `[${CELL_INDEX}]`
              )[currentCellColumn];
              this.focusOnCell(el, firstCellInColumn);
            }
            break;
          }
          case PAGEDOWN: {
            e.preventDefault();
            const { CELL_INDEX, ROW_INDEX } = PROJECT_ATTRIBUTES;
            const currentRow = this.domProvider.closest(el, `[${ROW_INDEX}]`);
            if (currentRow) {
              const currentCellColumn = Array.from(
                currentRow == null
                  ? void 0
                  : currentRow.querySelectorAll(`[${CELL_INDEX}]`)
              ).findIndex((cell) => cell === el);
              const rows = table.querySelectorAll(
                `[${PROJECT_ATTRIBUTES.ROW_INDEX}]:has([${CELL_INDEX}])`
              );
              const firstCellInColumn = rows[rows.length - 1].querySelectorAll(
                `[${CELL_INDEX}]`
              )[currentCellColumn];
              this.focusOnCell(el, firstCellInColumn);
            }
            break;
          }
        }
      }
      numerationAttributes(htmlElements, attribute) {
        htmlElements.forEach((htmlElement, index) =>
          htmlElement.setAttribute(attribute, (index + 1).toString())
        );
      }
      getDirections(gridElements) {
        const { rows, cells, columnHeaders, rowHeaders } = gridElements;
        let numOfColumns = Math.ceil(
          (columnHeaders.length + rowHeaders.length + cells.length) / rows.length
        );
        if (rowHeaders.length) {
          numOfColumns -= 1;
        }
        const isRtl = Utils$1.isRtl(this.stateManagement.getLang());
        return {
          right: isRtl ? -1 : 1,
          left: isRtl ? 1 : -1,
          up: -numOfColumns,
          down: numOfColumns,
        };
      }
      getRowIndex(cellElement) {
        var _a;
        const { ROW_INDEX } = PROJECT_ATTRIBUTES;
        const rowIndex =
          (_a = this.domProvider.closest(cellElement, `[${ROW_INDEX}]`)) == null
            ? void 0
            : _a.getAttribute(ROW_INDEX);
        return Number(rowIndex);
      }
      getNextElement(el, table, direction) {
        const { CELL_INDEX, ROW_INDEX } = PROJECT_ATTRIBUTES;
        const currentCell = Number(this.domProvider.getAttribute(el, CELL_INDEX));
        if (Math.abs(direction) === 1) {
          const rowIndex = this.getRowIndex(el);
          return table.querySelector(
            `[${ROW_INDEX}='${rowIndex}'] [${CELL_INDEX}='${
              currentCell + direction
            }']`
          );
        } else
          return table.querySelector(
            `[${CELL_INDEX}='${currentCell + direction}']`
          );
      }
      focusOnCell(currentCell, toFocusCell) {
        this.domProvider.setAttribute(currentCell, ATTRIBUTES.TABINDEX, "-1");
        this.domProvider.setAttribute(toFocusCell, ATTRIBUTES.TABINDEX, "0");
        this.domProvider.setTimeout(
          () => this.domProvider.focusOnElement(toFocusCell),
          10
        );
      }
      focusOnFollowingElement(el, table, direction) {
        const elToFocus = this.getNextElement(el, table, direction);
        if (!elToFocus) return;
        this.focusOnCell(el, elToFocus);
      }
      triggerParentClickEvent(el) {
        const parentRow = this.domProvider.closest(
          el,
          `[${PROJECT_ATTRIBUTES.ROW_INDEX}]`
        );
        this.domProvider.dispatchMouseClickEvent(parentRow);
      }
    }

    class GridFixer extends FixerAbstract {
      constructor(
        context,
        props,
        domProvider,
        changeDetection,
        tableSorts,
        tableRoles,
        navigation
      ) {
        super(context, domProvider, changeDetection, props, props.selectors.grid);
        this.tableSorts = tableSorts;
        this.tableRoles = tableRoles;
        this.navigation = navigation;
      }
      fix(grid) {
        const gridElements = this.getGridElements(grid);
        const focusableCells = this.getFocusableCells(gridElements);
        const focusableElements =
          Utils$1.getFirstTabbableElements(focusableCells);
        this.tableRoles.setRoles(gridElements, "grid");
        this.tableSorts.setAriaSorts(gridElements);
        const { columnHeaders } = gridElements;
        this.handleClickableColumns(grid, columnHeaders);
        this.disableAutoTabbable(gridElements);
        this.avoidTabUnnecessaryElements(grid);
        this.navigation.handleNavigation(
          gridElements,
          focusableElements,
          this.props.isRowClickable
        );
      }
      handleClickableColumns(grid, columnHeaders) {
        columnHeaders &&
          this.domProvider.addEventListenerToAll(
            columnHeaders,
            "keydown",
            (event) => {
              const e = event;
              if (e.code === "Enter" || e.code === "Space") {
                this.domProvider.dispatchMouseClickEvent(e.target);
                this.fix(grid);
              }
            }
          );
      }
      disableAutoTabbable(gridElements) {
        const { columnHeaders, rowHeaders, cells } = gridElements;
        this.domProvider.setAttributeToAll(
          [...cells, ...columnHeaders, ...rowHeaders],
          AVOID_AUTO_TABBABLE_ATTRIBUTE,
          "true"
        );
      }
      avoidTabUnnecessaryElements(grid) {
        this.domProvider.setAttributeToAll(
          [
            ...Array.from(
              grid.querySelectorAll(COMMON_SELECTORS.TABBABLE_ELEMENTS_SELECTOR)
            ),
          ],
          ATTRIBUTES.TABINDEX,
          "-1"
        );
      }
      getFocusableCells(gridElements) {
        const { isColumnHeaderFocusable, isRowHeaderFocusable } = this.props;
        const { columnHeaders, rowHeaders, cells } = gridElements;
        const focusableCells = [];
        if (
          columnHeaders &&
          columnHeaders.length > 0 &&
          (Utils$1.isContainsTabbable(columnHeaders) || isColumnHeaderFocusable)
        )
          focusableCells.push(...columnHeaders);
        if (
          rowHeaders &&
          rowHeaders.length > 0 &&
          (Utils$1.isContainsTabbable(rowHeaders) || isRowHeaderFocusable)
        )
          focusableCells.push(...rowHeaders);
        focusableCells.push(...cells);
        return focusableCells;
      }
      getGridElements(grid) {
        const { cell, row, columnheader, rowheader } = this.props.selectors;
        return {
          table: grid,
          rows: this.domProvider.querySelectorAll(row, grid),
          cells: this.domProvider.querySelectorAll(cell, grid),
          columnHeaders: columnheader
            ? this.domProvider.querySelectorAll(columnheader, grid)
            : [],
          rowHeaders: rowheader
            ? this.domProvider.querySelectorAll(rowheader, grid)
            : [],
        };
      }
    }

    const GridApi = (context = "body") => {
      return (props) => {
        const domProvider = new DomProvider();
        const elementVisibility = new ElementVisibility();
        const changeDetection = ChangeDetection.getInstance(
          elementVisibility,
          domProvider
        );
        const stateManagement = StateManagement.getInstance();
        const tableSorts = new TableSorts(domProvider);
        const tableRoles = new TableRoles(domProvider);
        const navigation = new Navigation$1(domProvider, stateManagement);
        new GridFixer(
          context,
          props,
          domProvider,
          changeDetection,
          tableSorts,
          tableRoles,
          navigation
        );
      };
    };

    var __defProp$3 = Object.defineProperty;
    var __getOwnPropDesc$3 = Object.getOwnPropertyDescriptor;
    var __decorateClass$3 = (decorators, target, key, kind) => {
      var result =
        kind > 1 ? void 0 : kind ? __getOwnPropDesc$3(target, key) : target;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if ((decorator = decorators[i]))
          result =
            (kind ? decorator(target, key, result) : decorator(result)) || result;
      if (kind && result) __defProp$3(target, key, result);
      return result;
    };
    let LinkFixer = class extends FixerAbstract {
      constructor(context, props, domProvider, changeDetection) {
        super(
          context,
          domProvider,
          changeDetection,
          props,
          props.selectors.element
        );
      }
      fix() {
        const element = this.props.selectors.element;
        const el = this.domProvider.querySelectorAll(element);
        if (!el) return;
        el.forEach((element2) => {
          this.domProvider.setAttribute(element2, "role", ROLE$1.LINK);
          this.domProvider.setAttribute(element2, "tabindex", "0");
          this.handleKeydown(element2);
        });
      }
      handleKeydown(el) {
        this.domProvider.addEventListener(el, "keydown", (e) => {
          const evt = e;
          evt.code === "Enter" && this.domProvider.dispatchMouseClickEvent(el);
        });
      }
    };
    LinkFixer = __decorateClass$3([free], LinkFixer);
    const LinkApi = (context = "body") => {
      const domProvider = new DomProvider();
      const elementVisibility = new ElementVisibility();
      const changeDetection = ChangeDetection.getInstance(
        elementVisibility,
        domProvider
      );
      return (props) =>
        new LinkFixer(context, props, domProvider, changeDetection);
    };

    class ListboxTrigger {
      constructor(domProvider, elementVisibility) {
        this.listboxElement = null;
        this.optionsElements = null;
        this.isOpenListboxEvent = false;
        this.triggerKeydownFunction = (
          _evt,
          triggerElement,
          listboxSelector,
          props
        ) => {
          const evt = _evt;
          this.isOpenListboxEvent =
            evt.code == "Enter" ||
            evt.code == "Space" ||
            (evt.code == "ArrowDown" && !props.disableDownArrowOpen) ||
            (evt.code == "ArrowUp" && !props.disableDownArrowOpen);
          this.domProvider.setTimeout(
            () => this.dispatchClickOnTrigger(triggerElement, listboxSelector),
            200
          );
        };
        this.domProvider = domProvider;
        this.elementVisibility = elementVisibility;
      }
      handleTrigger(triggerElement, listboxSelector, props, triggerLabel) {
        if (triggerLabel) {
          let labelID = this.domProvider.getAttribute(triggerLabel, "id");
          if (!labelID) {
            labelID = Utils$1.uuid();
            this.domProvider.setAttribute(triggerLabel, "id", labelID);
          }
          this.domProvider.setAttribute(triggerElement, ARIA.LABELLEDBY, labelID);
        }
        this.domProvider.setAttribute(triggerElement, "tabindex", "0");
        this.domProvider.setAttribute(triggerElement, "role", "button");
        this.domProvider.setAttribute(triggerElement, ARIA.HASPOPUP, "listbox");
        this.domProvider.setAttribute(triggerElement, ARIA.EXPANDED, "false");
        this.domProvider.addEventListener(triggerElement, "keydown", (e) =>
          this.triggerKeydownFunction(e, triggerElement, listboxSelector, props)
        );
      }
      dispatchClickOnTrigger(triggerElement, listboxSelector) {
        this.listboxElement = this.domProvider.querySelector(listboxSelector);
        const isElementVisible = this.elementVisibility.isVisible(
          this.listboxElement
        );
        if (this.isOpenListboxEvent) {
          this.domProvider.setAttribute(
            triggerElement,
            PROJECT_CLASSES.TRIGGER_ELEMENT,
            "true"
          );
          if (!isElementVisible && triggerElement) {
            if (!triggerElement.onclick && triggerElement.onmouseover)
              this.domProvider.dispatchMouseOverEvent(triggerElement);
            else this.domProvider.dispatchMouseClickEvent(triggerElement);
            this.domProvider.setTimeout(
              () => this.secondClickAttempt(triggerElement, listboxSelector),
              200
            );
          }
        }
      }
      secondClickAttempt(triggerElement, listboxSelector) {
        this.listboxElement = this.domProvider.querySelector(listboxSelector);
        !this.elementVisibility.isVisible(this.listboxElement) && triggerElement
          ? !triggerElement.onclick && triggerElement.onmouseover
            ? this.domProvider.dispatchMouseOverEvent(triggerElement)
            : this.domProvider.dispatchClickEvent(triggerElement)
          : null;
      }
      focusOnTrigger(triggerSelector) {
        const trigger = this.domProvider.querySelector(`${triggerSelector}`);
        if (trigger) {
          this.domProvider.focusOnElement(trigger);
        }
      }
    }

    class ListboxList {
      constructor(
        domProvider,
        elementVisibility,
        listboxAttributesHandler,
        listboxEventHandler
      ) {
        this.triggerElement = null;
        this.listboxElement = null;
        this.optionsElements = null;
        this.listboxLabel = null;
        this.listboxKeydownFunction = (_evt, props) => {
          const evt = _evt;
          if (evt.code !== "Tab") {
            evt.preventDefault();
            evt.stopPropagation();
          }
          const isListboxEvent = this.isListboxEvent(evt.code);
          const isCharPressed = this.isCharPressed(evt.code);
          if (
            (isListboxEvent || isCharPressed) &&
            this.optionsElements &&
            this.listboxElement &&
            this.triggerElement
          ) {
            this.listboxEventHandler.handleEvents(
              this.optionsElements,
              this.listboxElement,
              this.triggerElement,
              evt,
              this.listboxLabel,
              props
            );
          }
        };
        this.domProvider = domProvider;
        this.elementVisibility = elementVisibility;
        this.listboxAttributesHandler = listboxAttributesHandler;
        this.listboxEventHandler = listboxEventHandler;
      }
      handleListbox(
        listboxElement,
        triggerElement,
        optionsSelector,
        props,
        listboxLabel
      ) {
        this.listboxElement = listboxElement;
        this.triggerElement = triggerElement;
        this.listboxLabel = listboxLabel;
        if (listboxLabel) {
          const listboxLabelID = this.domProvider.getAttribute(
            listboxLabel,
            "id"
          );
          this.domProvider.setAttribute(
            listboxElement,
            ARIA.LABELLEDBY,
            `${listboxLabelID}`
          );
        }
        const allElementsNotOptions = this.domProvider.querySelectorAll(
          `*:not(${optionsSelector})`,
          this.listboxElement
        );
        if (allElementsNotOptions && allElementsNotOptions.length) {
          const elementsInsideListboxArray = Array.prototype.slice.call(
            allElementsNotOptions,
            0
          );
          Utils$1.removeClientsWCAGAttributes(elementsInsideListboxArray);
        }
        this.optionsElements = this.domProvider.querySelectorAll(
          optionsSelector,
          listboxElement
        );
        const activeDescendantElementId = this.getActiveDescendantElementId(
          this.listboxElement,
          this.optionsElements,
          this.triggerElement
        );
        this.listboxAttributesHandler.handleAttributes(
          this.listboxElement,
          this.optionsElements,
          this.triggerElement,
          activeDescendantElementId,
          listboxLabel,
          void 0
        );
        this.domProvider.setAttribute(
          this.listboxElement,
          ATTRIBUTES.ROLE,
          ROLE$1.LISTBOX
        );
        this.domProvider.setAttribute(
          this.listboxElement,
          ATTRIBUTES.TABINDEX,
          "-1"
        );
        this.domProvider.addEventListener(
          this.listboxElement,
          "keydown",
          (e) => this.listboxKeydownFunction(e, props),
          true
        );
      }
      getActiveDescendantElementId(
        listboxElement,
        optionsElements,
        triggerElement
      ) {
        var _a;
        const originalActiveDescendantElementId = this.domProvider.getAttribute(
          listboxElement,
          ARIA.ACTIVEDESCENDANT
        );
        const isActiveDescendantElementInDom =
          originalActiveDescendantElementId !== null &&
          this.domProvider.getElementById(originalActiveDescendantElementId) !==
            null;
        if (isActiveDescendantElementInDom) {
          return originalActiveDescendantElementId;
        }
        const targetOptionValue = triggerElement.innerText;
        const targetOption = optionsElements.find(
          (option) => option.innerText === targetOptionValue
        );
        const activeDescendantElementId =
          (_a = targetOption == null ? void 0 : targetOption.id) != null
            ? _a
            : optionsElements[0].id;
        return activeDescendantElementId;
      }
      isListboxEvent(eventCode) {
        return (
          eventCode == "Enter" ||
          eventCode == "Space" ||
          eventCode == "ArrowDown" ||
          eventCode == "ArrowUp" ||
          eventCode == "Escape" ||
          eventCode == "Tab" ||
          eventCode == "Home" ||
          eventCode == "End"
        );
      }
      isCharPressed(eventCode) {
        return eventCode.substring(0, 3) === "Key";
      }
    }

    class ListboxFixer extends FixerAbstract {
      constructor(
        context,
        props,
        domProvider,
        listboxTrigger,
        listboxList,
        listboxOption,
        elementVisibility,
        changeDetection,
        listboxEventHandler,
        listboxAttributesHandler,
        scrollService
      ) {
        super(
          context,
          domProvider,
          changeDetection,
          props,
          props.selectors.trigger
        );
        this.triggerElements = null;
        this.listboxElement = null;
        this.optionsElements = null;
        this.labelElement = null;
        this.isMobile = false;
        this.domProvider = domProvider;
        this.listboxTrigger = listboxTrigger;
        this.listboxList = listboxList;
        this.listboxOption = listboxOption;
        this.elementVisibility = elementVisibility;
        this.changeDetection = changeDetection;
        this.listboxEventHandler = listboxEventHandler;
        this.listboxAttributesHandler = listboxAttributesHandler;
        this.scrollService = scrollService;
      }
      fix() {
        const { listbox, trigger } = this.props.selectors;
        const label = this.props.selectors.label;
        this.triggerElements = this.domProvider.querySelectorAll(trigger);
        if (!this.triggerElements.length) {
          return;
        }
        if (label) {
          this.labelElement = this.domProvider.querySelector(label);
        }
        this.triggerElements.forEach((trigger2) => {
          this.listboxTrigger.handleTrigger(
            trigger2,
            listbox,
            this.props,
            this.labelElement
          );
        });
        this.changeDetection.subscribe(
          this.context,
          "listboxList",
          listbox,
          (visibleElement) => this.onListboxShow(visibleElement)
        );
      }
      onListboxShow(visibleElement) {
        const { listbox, options, trigger, group } = this.props.selectors;
        this.optionsElements = this.domProvider.querySelectorAll(
          options,
          listbox
        );
        const lastPressedTrigger = this.domProvider.querySelector(
          `${trigger}[${PROJECT_CLASSES.TRIGGER_ELEMENT}]`
        );
        this.generateIDForOptions(group);
        if (lastPressedTrigger) {
          this.listboxList.handleListbox(
            visibleElement,
            lastPressedTrigger,
            options,
            this.props,
            this.labelElement
          );
          this.domProvider.setAttribute(
            lastPressedTrigger,
            ARIA.EXPANDED,
            "true"
          );
          if (
            !(lastPressedTrigger == null
              ? void 0
              : lastPressedTrigger.contains(this.listboxElement)) &&
            this.optionsElements &&
            !(lastPressedTrigger == null
              ? void 0
              : lastPressedTrigger.contains(this.optionsElements[0]))
          ) {
            Utils$1.setRolePresentation(lastPressedTrigger);
          }
          const selectedOptionId = this.domProvider.getAttribute(
            visibleElement,
            ARIA.ACTIVEDESCENDANT
          );
          const selectedOptionElement = this.domProvider.querySelector(
            `[id=${selectedOptionId}]`
          );
          selectedOptionElement == null
            ? void 0
            : selectedOptionElement.scrollIntoView();
        }
        if (Utils$1.isMobileDevice()) {
          this.domProvider.focusOnElement(this.optionsElements[0]);
        } else {
          this.domProvider.focusOnElement(visibleElement);
        }
      }
      generateIDForOptions(group) {
        var _a;
        (_a = this.optionsElements) == null
          ? void 0
          : _a.forEach((option) => {
              const optionsElementsID = this.domProvider.getAttribute(
                option,
                "id"
              );
              this.listboxOption.handleOption(
                option,
                optionsElementsID != null ? null : Utils$1.uuid(),
                group
              );
              Utils$1.setRolePresentation(option);
            });
      }
    }
    const ListboxApi = (context = "body") => {
      const domProvider = new DomProvider();
      const elementVisibility = new ElementVisibility();
      const scrollService = new ScrollService();
      const listboxTrigger = new ListboxTrigger(domProvider, elementVisibility);
      const listboxOptions = new ListboxOption(domProvider);
      const changeDetection = ChangeDetection.getInstance(
        elementVisibility,
        domProvider
      );
      const attributesHandler = new AttributesHandler(domProvider);
      const eventsHandler = new EventsHandler$1(
        domProvider,
        attributesHandler,
        elementVisibility,
        scrollService
      );
      const listboxList = new ListboxList(
        domProvider,
        elementVisibility,
        attributesHandler,
        eventsHandler
      );
      return (props) =>
        new ListboxFixer(
          context,
          props,
          domProvider,
          listboxTrigger,
          listboxList,
          listboxOptions,
          elementVisibility,
          changeDetection,
          eventsHandler,
          attributesHandler,
          scrollService
        );
    };
    const keyCodes = {
      TAB: "Tab",
      ENTER: "Enter",
      ESC: "Escape",
      SPACE: "Space",
      PAGEUP: "PageUp",
      PAGEDOWN: "PageDown",
      END: "End",
      HOME: "Home",
      LEFT: "ArrowLeft",
      UP: "ArrowUp",
      RIGHT: "ArrowRight",
      DOWN: "ArrowDown",
    };

    class MenuFixer extends FixerAbstract {
      constructor(
        context = "body",
        domProvider,
        changeDetectionProvider,
        props,
        elementVisibility,
        rolesAndAttributes,
        navigation,
        elementsService
      ) {
        super(
          context,
          domProvider,
          changeDetectionProvider,
          props,
          props.selectors.menu
        );
        this.elementVisibility = elementVisibility;
        this.rolesAndAttributes = rolesAndAttributes;
        this.navigation = navigation;
        this.elementsService = elementsService;
      }
      fix(visibleElement) {
        this.props.selectors.submenus &&
          this.observer.subscribe(
            "body",
            MenuFixer.name,
            this.props.selectors.submenus,
            (visibleElement2) => this.fixSubmenu(visibleElement2),
            (visibleElement2) => this.destroySubmenu(visibleElement2)
          );
        this.fixMenu(visibleElement);
      }
      fixMenu(menuElement) {
        const elements = this.getMenuElements(menuElement, this.props.selectors);
        this.rolesAndAttributes.initMenu(elements);
        this.navigation.init(elements, this.props);
        this.elementsService.makeFirstItemTabbable(menuElement);
      }
      fixSubmenu(submenuElement) {
        const elements = this.getSubmenuElements(
          submenuElement,
          this.props.selectors
        );
        this.rolesAndAttributes.initSubmenu(elements);
        this.navigation.init(elements, this.props);
        this.rolesAndAttributes.setSubmenuState(submenuElement, true);
        this.elementsService.focusOnFirstItem(submenuElement);
      }
      destroySubmenu(submenuElement) {
        this.rolesAndAttributes.destroy(submenuElement);
        this.rolesAndAttributes.setSubmenuState(submenuElement, false);
      }
      getMenuElements(menuElement, selectors) {
        return {
          menu: menuElement,
          submenus: [],
          items: this.elementVisibility.getVisibleElements(
            selectors.items,
            menuElement
          ),
        };
      }
      getSubmenuElements(submenuElement, selectors) {
        return {
          menu: null,
          submenus: [submenuElement],
          items: this.elementVisibility.getVisibleElements(
            selectors.items,
            submenuElement
          ),
        };
      }
    }

    const ROLE = {
      NAVIGATION: "navigation",
      MENUBAR: "menubar",
      MENUITEM: "menuitem",
      NONE: "none",
      MENU: "menu",
      BUTTON: "button",
    };
    var KEYBOARD_EVENT_CODE = /* @__PURE__ */ ((KEYBOARD_EVENT_CODE2) => {
      KEYBOARD_EVENT_CODE2["TAB"] = "Tab";
      KEYBOARD_EVENT_CODE2["ENTER"] = "Enter";
      KEYBOARD_EVENT_CODE2["ESC"] = "Escape";
      KEYBOARD_EVENT_CODE2["SPACE"] = " ";
      KEYBOARD_EVENT_CODE2["PAGEUP"] = "PageUp";
      KEYBOARD_EVENT_CODE2["PAGEDOWN"] = "PageDown";
      KEYBOARD_EVENT_CODE2["END"] = "End";
      KEYBOARD_EVENT_CODE2["HOME"] = "Home";
      KEYBOARD_EVENT_CODE2["LEFT"] = "ArrowLeft";
      KEYBOARD_EVENT_CODE2["UP"] = "ArrowUp";
      KEYBOARD_EVENT_CODE2["RIGHT"] = "ArrowRight";
      KEYBOARD_EVENT_CODE2["DOWN"] = "ArrowDown";
      return KEYBOARD_EVENT_CODE2;
    })(KEYBOARD_EVENT_CODE || {});
    var SELECTORS = /* @__PURE__ */ ((SELECTORS2) => {
      SELECTORS2["TRIGGER"] = "u1st-trigger";
      SELECTORS2["MENU_X"] = "u1st-x";
      SELECTORS2["MENU_Y"] = "u1st-y";
      return SELECTORS2;
    })(SELECTORS || {});
    var OPEN_BY = /* @__PURE__ */ ((OPEN_BY2) => {
      OPEN_BY2["MOUSE_OVER"] = "mouseover";
      OPEN_BY2["MOUSE_OUT"] = "mouseout";
      OPEN_BY2["MOUSE_ENTER"] = "mouseenter";
      OPEN_BY2["MOUSE_LEAVE"] = "mouseleave";
      OPEN_BY2["FOCUS"] = "focus";
      OPEN_BY2["CLICK"] = "click";
      OPEN_BY2["FUNCTION"] = "function";
      return OPEN_BY2;
    })(OPEN_BY || {});

    class RolesAndAttributes {
      constructor(domProvider, props, context) {
        this.domProvider = domProvider;
        this.props = props;
        this.context = context;
      }
      initMenu(elements) {
        this.setRoles(elements);
        this.setAttributes(elements, this.props.menuDescription);
        this.setMenuNumbering(elements.items);
      }
      initSubmenu(elements) {
        this.setRoles(elements);
        this.setAttributes(elements, this.props.menuDescription);
        this.setSubmenuNumbering(elements.items);
      }
      destroy(htmlElement) {
        this.cleanLevels(htmlElement);
      }
      addTriggerSelector(item) {
        this.domProvider.setAttribute(item, SELECTORS.TRIGGER, "");
      }
      removeTriggerSelector(item) {
        this.domProvider.removeAttribute(item, SELECTORS.TRIGGER);
      }
      cleanTriggerSelectors(context) {
        const triggeredItems = this.domProvider.querySelectorAll(
          `[${SELECTORS.TRIGGER}]`,
          context ? context : this.context
        );
        this.domProvider.removeAttributeToAll(triggeredItems, SELECTORS.TRIGGER);
      }
      moveFocus(fromElement, toElement) {
        this.props.menubar && this.moveTabbable(fromElement, toElement);
        this.domProvider.focusOnElement(toElement, true);
      }
      addTabbable(element) {
        this.domProvider.setAttribute(element, ATTRIBUTES.TABINDEX, "0");
      }
      setSubmenuState(submenu, open) {
        this.domProvider.setAttribute(submenu, ARIA.EXPANDED, `${open}`);
      }
      removeTabbable(element) {
        this.domProvider.setAttribute(element, ATTRIBUTES.TABINDEX, "-1");
      }
      moveTabbable(fromElement, toElement) {
        this.removeTabbable(fromElement);
        this.addTabbable(toElement);
      }
      setRoles(elements) {
        const { menu, submenus, items } = elements;
        if (this.props.menubar) {
          this.domProvider.setAttribute(menu, ATTRIBUTES.ROLE, ROLE.MENUBAR);
          this.domProvider.setAttributeToAll(
            items,
            ATTRIBUTES.ROLE,
            ROLE.MENUITEM
          );
        } else {
          const triggers = this.props.selectors.triggers;
          triggers &&
            items.forEach(
              (item) =>
                this.domProvider.matches(item, triggers) &&
                this.domProvider.setAttribute(item, ATTRIBUTES.ROLE, ROLE.BUTTON)
            );
          this.domProvider.setAttribute(menu, ATTRIBUTES.ROLE, ROLE.NAVIGATION);
        }
        this.props.selectors.submenus &&
          this.domProvider.setAttributeToAll(
            submenus,
            ATTRIBUTES.ROLE,
            ROLE.MENU
          );
      }
      setAttributes(elements, menuDescription) {
        const { menu, items, submenus } = elements;
        const { triggers } = this.props.selectors;
        menuDescription &&
          this.domProvider.setAttribute(menu, ARIA.LABEL, menuDescription);
        if (this.props.menubar) {
          this.domProvider.setAttributeToAll(
            items,
            AVOID_AUTO_TABBABLE_ATTRIBUTE,
            "true"
          );
          this.domProvider.setAttributeToAll(items, ATTRIBUTES.TABINDEX, "-1");
        } else {
          this.domProvider.setAttributeToAll(items, ATTRIBUTES.TABINDEX, "0");
        }
        if (triggers) {
          items.forEach(
            (item) =>
              this.domProvider.matches(item, triggers) &&
              this.domProvider.setAttribute(item, ARIA.HASPOPUP, "true")
          );
        }
        this.props.selectors.submenus &&
          submenus.forEach((submenu) => this.setSubmenuState(submenu, false));
      }
      setSubmenuNumbering(items) {
        const menuLevel = this.getMaxLevel() + 1;
        this.setNumbering(items, menuLevel);
      }
      setMenuNumbering(items) {
        this.setNumbering(items, 0);
      }
      setNumbering(items, y) {
        items.forEach((item, index) => {
          this.domProvider.setAttribute(item, SELECTORS.MENU_Y, y.toString());
          this.domProvider.setAttribute(item, SELECTORS.MENU_X, index.toString());
        });
      }
      cleanLevels(htmlElement) {
        const elements = Array.from(
          this.domProvider.querySelectorAll(
            `[${SELECTORS.MENU_X}], [${SELECTORS.MENU_Y}]`,
            htmlElement
          )
        );
        elements.forEach((element) => {
          this.domProvider.removeAttribute(element, SELECTORS.MENU_X);
          this.domProvider.removeAttribute(element, SELECTORS.MENU_Y);
        });
      }
      getMaxLevel() {
        let maxLevel = 0;
        const { menu, submenus } = this.props.selectors;
        const items = this.domProvider.querySelectorAll(
          `[${SELECTORS.MENU_Y}]`,
          menu + "," + submenus
        );
        items.forEach((item) => {
          const itemLevel = Number(
            this.domProvider.getAttribute(item, SELECTORS.MENU_Y)
          );
          maxLevel = itemLevel > maxLevel ? itemLevel : maxLevel;
        });
        return maxLevel;
      }
    }

    var EventType$1 = /* @__PURE__ */ ((EventType2) => {
      EventType2["KEYDOWN"] = "keydown";
      EventType2["KEYUP"] = "keyup";
      EventType2["KEYPRESS"] = "keypress";
      EventType2["CLICK"] = "click";
      return EventType2;
    })(EventType$1 || {});

    class Navigation {
      constructor(domProvider, elementsService, stateManagement) {
        this.domProvider = domProvider;
        this.elementsService = elementsService;
        this.stateManagement = stateManagement;
      }
      init(elements, props) {
        const { menubar, selectors, customEvent } = props;
        const { triggers } = selectors;
        const { items } = elements;
        const eventType = customEvent != null ? customEvent : EventType$1.KEYDOWN;
        this.domProvider.addEventListenerToAll(
          items,
          eventType,
          (evt) => {
            const keyboardEvent = evt;
            keyboardEvent.stopPropagation();
            keyboardEvent.stopImmediatePropagation();
            this.preventScrolling(keyboardEvent);
            menubar
              ? this.navigateMenubarItem(keyboardEvent.target, keyboardEvent.key)
              : this.navigateMenuItem(keyboardEvent);
          },
          true
        );
        if (!menubar && triggers) {
          items == null
            ? void 0
            : items.forEach((item) => {
                if (this.domProvider.matches(item, triggers)) {
                  this.domProvider.addEventListener(
                    item,
                    "click",
                    (evt) => {
                      if (Utils$1.isAssistiveTechEvent(evt)) {
                        evt.preventDefault();
                        evt.stopPropagation();
                        this.elementsService.triggerItem(item, true);
                      }
                    },
                    true
                  );
                }
              });
        }
      }
      navigateMenuItem(keyboardEvent) {
        const item = keyboardEvent.target;
        const action = keyboardEvent.key;
        const isReversed = Utils$1.isRtl(this.stateManagement.getLang());
        const { DOWN, SPACE, ESC, UP, LEFT, RIGHT, ENTER, TAB } =
          KEYBOARD_EVENT_CODE;
        switch (action) {
          case TAB:
            if (keyboardEvent.shiftKey) {
              isReversed
                ? this.elementsService.focusNextItem(
                    item,
                    isReversed,
                    keyboardEvent
                  )
                : this.elementsService.focusPrevItem(
                    item,
                    isReversed,
                    keyboardEvent
                  );
            } else {
              isReversed
                ? this.elementsService.focusPrevItem(
                    item,
                    isReversed,
                    keyboardEvent
                  )
                : this.elementsService.focusNextItem(
                    item,
                    isReversed,
                    keyboardEvent
                  );
            }
            break;
          case UP:
            this.elementsService.focusPrevItem(item);
            break;
          case LEFT:
            this.elementsService.focusPrevItem(item, isReversed);
            break;
          case DOWN:
            this.elementsService.focusNextItem(item);
            break;
          case RIGHT:
            this.elementsService.focusNextItem(item, isReversed);
            break;
          case SPACE:
          case ENTER:
            this.elementsService.triggerItem(item, true);
            break;
          case ESC:
            this.handleEsc(item);
            break;
        }
      }
      navigateMenubarItem(item, action) {
        const { DOWN, SPACE, ESC, UP, LEFT, RIGHT, ENTER, TAB } =
          KEYBOARD_EVENT_CODE;
        switch (action) {
          case UP:
            this.handleUp(item);
            break;
          case DOWN:
            this.handleDown(item);
            break;
          case RIGHT:
            this.handleRight(item);
            break;
          case LEFT:
            this.handleLeft(item);
            break;
          case SPACE:
          case ENTER:
            this.elementsService.triggerItem(item, true);
            break;
          case ESC:
          case TAB:
            this.handleEsc(item);
            break;
        }
      }
      handleUp(item) {
        !this.elementsService.isInsideHorizontalMenu(item) &&
          this.elementsService.focusPrevItem(item);
      }
      handleDown(item) {
        const isVertical = !this.elementsService.isInsideHorizontalMenu(item);
        const shouldTriggerDown =
          isVertical || this.elementsService.hasSubmenu(item);
        if (shouldTriggerDown) {
          this.elementsService.isInsideHorizontalMenu(item)
            ? this.elementsService.triggerItem(item, true)
            : this.elementsService.focusNextItem(item);
        }
      }
      handleRight(item) {
        const isReversed = Utils$1.isRtl(this.stateManagement.getLang());
        if (this.elementsService.isInsideHorizontalMenu(item)) {
          this.elementsService.focusNextItem(item, isReversed);
        } else {
          if (this.elementsService.hasSubmenu(item)) {
            this.elementsService.openSubmenu(item);
          } else {
            this.elementsService.jumpToNextMainMenu(isReversed);
          }
        }
      }
      handleLeft(item) {
        if (this.elementsService.isInsideHorizontalMenu(item)) {
          const isReversed = Utils$1.isRtl(this.stateManagement.getLang());
          this.elementsService.focusPrevItem(item, isReversed);
        } else {
          this.elementsService.closeSubmenu(item, true);
        }
      }
      handleEsc(item) {
        this.elementsService.closeSubmenu(item, true);
      }
      preventScrolling(keyboardEvent) {
        const code = keyboardEvent.key;
        const { DOWN, UP, LEFT, RIGHT, ENTER, SPACE, ESC } = KEYBOARD_EVENT_CODE;
        if (
          code === DOWN ||
          code === UP ||
          code === LEFT ||
          code === RIGHT ||
          code === ENTER ||
          code === SPACE ||
          code === ESC
        ) {
          keyboardEvent.preventDefault();
        }
      }
    }

    class ElementsService {
      constructor(rolesAndAttributes, domProvider, props, context) {
        this.rolesAndAttributes = rolesAndAttributes;
        this.domProvider = domProvider;
        this.props = props;
        this.context = context;
      }
      hasSubmenu(item) {
        return this.domProvider.matches(item, this.props.selectors.triggers);
      }
      openSubmenu(item) {
        this.triggerItem(item, true);
      }
      closeSubmenu(item, moveFocus) {
        const triggeredItem = this.getTriggeredItemByItem(item);
        if (triggeredItem) {
          this.rolesAndAttributes.cleanTriggerSelectors(
            triggeredItem.parentElement
          );
          this.triggerItem(triggeredItem, false);
          moveFocus && this.rolesAndAttributes.moveFocus(item, triggeredItem);
        }
      }
      isInsideHorizontalMenu(item) {
        let isHorizontal = false;
        const parentMenu = this.getParentMenu(item);
        if (parentMenu) {
          isHorizontal = this.isHorizontal(parentMenu);
        }
        return isHorizontal;
      }
      focusPrevItem(item, isReversed, event) {
        const itemToFocus = this.getPrevItem(item, isReversed);
        this.rolesAndAttributes.cleanTriggerSelectors(item);
        if (itemToFocus) {
          event == null ? void 0 : event.preventDefault();
          this.rolesAndAttributes.moveFocus(item, itemToFocus);
        }
      }
      focusNextItem(item, isReversed, event) {
        const itemToFocus = this.getNextItem(item, isReversed);
        this.rolesAndAttributes.cleanTriggerSelectors(item);
        if (itemToFocus) {
          event == null ? void 0 : event.preventDefault();
          this.rolesAndAttributes.moveFocus(item, itemToFocus);
        }
      }
      jumpToNextMainMenu(isReversed = false) {
        const firstTriggeredItem = this.getTriggeredItem(0);
        if (firstTriggeredItem) {
          this.rolesAndAttributes.cleanTriggerSelectors();
          const nextItem = this.getNextItem(firstTriggeredItem);
          const isNeedToOpen = this.hasSubmenu(nextItem);
          this.triggerItem(firstTriggeredItem, false);
          if (isNeedToOpen) this.triggerItem(nextItem, true);
          else {
            this.rolesAndAttributes.moveFocus(firstTriggeredItem, nextItem);
          }
        }
      }
      focusOnFirstItem(menu) {
        const firstItem = this.domProvider.querySelector(
          `[${SELECTORS.MENU_X}="${0}"]`,
          menu
        );
        this.rolesAndAttributes.moveFocus(menu, firstItem);
      }
      makeFirstItemTabbable(menu) {
        const firstItem = this.domProvider.querySelector(
          `[${SELECTORS.MENU_X}="${0}"]`,
          menu
        );
        firstItem && this.rolesAndAttributes.addTabbable(firstItem);
      }
      triggerItem(item, toOpen) {
        const openBy = this.openBy(item);
        const { FOCUS, MOUSE_OVER, MOUSE_OUT, MOUSE_ENTER, MOUSE_LEAVE, CLICK } =
          OPEN_BY;
        const { openByFunc, closeByFunc } = this.props;
        if (toOpen && openByFunc) {
          openByFunc(item);
        } else if (!toOpen && closeByFunc) {
          closeByFunc(item);
        } else {
          switch (openBy) {
            case FOCUS:
              this.domProvider.focusOnElement(item);
              break;
            case MOUSE_OVER:
              if (toOpen) {
                this.domProvider.dispatchMouseEvent(item, MOUSE_OVER);
              } else {
                this.domProvider.dispatchMouseEvent(item, MOUSE_OUT);
              }
              break;
            case MOUSE_ENTER:
              if (toOpen) {
                this.domProvider.dispatchMouseEvent(item, MOUSE_ENTER);
              } else {
                this.domProvider.dispatchMouseEvent(item, MOUSE_LEAVE);
              }
              break;
            case CLICK:
              this.domProvider.dispatchMouseClickEvent(item);
              break;
          }
        }
        toOpen && this.rolesAndAttributes.addTriggerSelector(item);
        !toOpen && this.rolesAndAttributes.removeTriggerSelector(item);
      }
      getNextItem(item, isReversed) {
        const [currentX, currentY] = this.extractXY(item);
        const newIndex = isReversed ? currentX - 1 : currentX + 1;
        return this.getItem(
          item,
          currentX,
          currentY,
          newIndex,
          isReversed ? -1 : 1
        );
      }
      getPrevItem(item, isReversed) {
        const [currentX, currentY] = this.extractXY(item);
        const newIndex = isReversed ? currentX + 1 : currentX - 1;
        return this.getItem(
          item,
          currentX,
          currentY,
          newIndex,
          isReversed ? 1 : -1
        );
      }
      shouldGoBackToTrigger(currentX, itemAmount, nextIndex) {
        const isFirstItem = currentX === 0;
        const isLastItem = currentX === itemAmount - 1;
        return (nextIndex > 0 && isLastItem) || (nextIndex < 0 && isFirstItem);
      }
      getItem(item, currentX, currentY, newIndex, nextIndex) {
        let x, y, context;
        const itemAmount = this.getItemAmount(currentY, item);
        const isNavigation = !this.props.menubar;
        if (
          isNavigation &&
          this.shouldGoBackToTrigger(currentX, itemAmount, nextIndex)
        ) {
          context = this.props.selectors.menu;
          const [triggerX, triggerY] = this.extractTriggerXY();
          x = triggerX + nextIndex;
          y = triggerY;
          this.closeSubmenu(item, false);
        } else {
          x = Utils$1.mod(newIndex, itemAmount);
          y = currentY;
        }
        return this.getItemWithXY(x, y, item, context);
      }
      extractTriggerXY() {
        const trigger = this.domProvider.querySelector(
          `[${SELECTORS.TRIGGER}]`,
          this.context
        );
        return this.extractXY(trigger);
      }
      getItemAmount(y, item) {
        const context = this.getParentMenu(item);
        const items = this.domProvider.querySelectorAll(
          `[${SELECTORS.MENU_Y}="${y}"]`,
          context
        );
        return items.length;
      }
      extractXY(item) {
        const x = Number(this.domProvider.getAttribute(item, SELECTORS.MENU_X));
        const y = Number(this.domProvider.getAttribute(item, SELECTORS.MENU_Y));
        return [x, y];
      }
      getTriggeredItemByItem(item) {
        const [x, y] = this.extractXY(item);
        return this.getTriggeredItem(y - 1);
      }
      getTriggeredItem(y) {
        return this.domProvider.querySelector(
          `[${SELECTORS.TRIGGER}][${SELECTORS.MENU_Y}="${y}"]`,
          this.context
        );
      }
      getParentMenu(item) {
        return this.domProvider.closest(
          item,
          `[${ATTRIBUTES.ROLE}="${ROLE.MENUBAR}"], [${ATTRIBUTES.ROLE}="${ROLE.MENU}"], [${ATTRIBUTES.ROLE}="${ROLE.NAVIGATION}"]`
        );
      }
      getItemWithXY(x, y, item, contextSelector) {
        const context =
          contextSelector != null ? contextSelector : this.getParentMenu(item);
        const itemToFocus = this.domProvider
          .querySelectorAll(`[${SELECTORS.MENU_Y}="${y}"]`, context)
          .filter((item2) => {
            return (
              this.domProvider.getAttribute(item2, SELECTORS.MENU_X) ===
              x.toString()
            );
          })[0];
        return itemToFocus;
      }
      isHorizontal(menu) {
        if (!this.props.selectors.horizontalMenu) {
          return false;
        }
        return this.domProvider.matches(
          menu,
          this.props.selectors.horizontalMenu
        );
      }
      openBy(item) {
        const { openByFocus, openByMouseover, openByMouseenter } =
          this.props.selectors;
        const { FOCUS, MOUSE_OVER, MOUSE_ENTER, CLICK, FUNCTION } = OPEN_BY;
        if (openByFocus && this.domProvider.matches(item, openByFocus)) {
          return FOCUS;
        } else if (
          openByMouseover &&
          this.domProvider.matches(item, openByMouseover)
        ) {
          return MOUSE_OVER;
        } else if (
          openByMouseenter &&
          this.domProvider.matches(item, openByMouseenter)
        ) {
          return MOUSE_ENTER;
        }
        return CLICK;
      }
    }

    function MenuApi(context = "body") {
      return (props) => {
        const domProvider = new DomProvider();
        const elementVisibility = new ElementVisibility();
        const changeDetection = ChangeDetection.getInstance(
          elementVisibility,
          domProvider
        );
        const rolesAndAttributes = new RolesAndAttributes(
          domProvider,
          props,
          context
        );
        const elementsService = new ElementsService(
          rolesAndAttributes,
          domProvider,
          props,
          context
        );
        const stateManagement = StateManagement.getInstance();
        const navigation = new Navigation(
          domProvider,
          elementsService,
          stateManagement
        );
        new MenuFixer(
          context,
          domProvider,
          changeDetection,
          props,
          elementVisibility,
          rolesAndAttributes,
          navigation,
          elementsService
        );
      };
    }

    class EventsHandler {
      constructor(domProvider, stateManagement) {
        this.domProvider = domProvider;
        this.stateManagement = stateManagement;
      }
      navigate(e, context, length) {
        this.context = context;
        this.numOfRadios = length;
        const evt = e;
        const el = e.target;
        const currentAriaChecked = this.domProvider.getAttribute(
          el,
          ARIA.CHECKED
        );
        switch (evt.code) {
          case "ArrowRight":
            this.focusOnFollowingElement(
              el,
              evt,
              this.getDirectionByLanguage(1 /* NEXT */)
            );
            break;
          case "ArrowDown":
            this.focusOnFollowingElement(el, evt, 1 /* NEXT */);
            break;
          case "ArrowLeft":
            this.focusOnFollowingElement(
              el,
              evt,
              this.getDirectionByLanguage(-1 /* PREVIOUS */)
            );
            break;
          case "ArrowUp":
            this.focusOnFollowingElement(el, evt, -1 /* PREVIOUS */);
            break;
          case "Enter":
          case "Space":
            !currentAriaChecked || currentAriaChecked == "false"
              ? this.triggerClick(el, evt)
              : evt.preventDefault();
            break;
        }
      }
      getDirectionByLanguage(direction) {
        const isRtl = Utils$1.isRtl(this.stateManagement.getLang());
        return isRtl ? direction * -1 : direction;
      }
      focusOnFollowingElement(currentEl, evt, direction) {
        const currentIndex = this.domProvider.getAttribute(
          currentEl,
          PROJECT_ATTRIBUTES.RADIO_INDEX
        );
        if (!currentIndex) return;
        let nextIndex = Number(currentIndex) + direction;
        if (nextIndex > Number(this.numOfRadios) - 1) nextIndex = 0;
        else if (nextIndex < 0) nextIndex = Number(this.numOfRadios) - 1;
        const elToFocus = this.domProvider.querySelector(
          `[${PROJECT_ATTRIBUTES.RADIO_INDEX}=${nextIndex}]`,
          this.context
        );
        if (!elToFocus) return;
        this.domProvider.setAttribute(elToFocus, ATTRIBUTES.TABINDEX, "0");
        this.domProvider.setAttribute(currentEl, ATTRIBUTES.TABINDEX, "-1");
        this.domProvider.setTimeout(
          () => this.domProvider.focusOnElement(elToFocus),
          10
        );
        this.triggerClick(elToFocus, evt);
      }
      triggerClick(el, evt) {
        this.domProvider.dispatchClickEvent(el);
        evt.preventDefault();
      }
    }

    var __defProp$2 = Object.defineProperty;
    var __getOwnPropDesc$2 = Object.getOwnPropertyDescriptor;
    var __decorateClass$2 = (decorators, target, key, kind) => {
      var result =
        kind > 1 ? void 0 : kind ? __getOwnPropDesc$2(target, key) : target;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if ((decorator = decorators[i]))
          result =
            (kind ? decorator(target, key, result) : decorator(result)) || result;
      if (kind && result) __defProp$2(target, key, result);
      return result;
    };
    let RadioFixer = class extends FixerAbstract {
      constructor(
        context,
        props,
        domProvider,
        changeDetection,
        toggleStateService,
        eventsHandler,
        elementVisibility
      ) {
        super(
          context,
          domProvider,
          changeDetection,
          props,
          props.selectors.radioGroup
        );
        this.toggleStateService = toggleStateService;
        this.eventsHandler = eventsHandler;
        this.elementVisibility = elementVisibility;
      }
      fix(visibleElement) {
        const radios = this.domProvider.querySelectorAll(
          this.props.selectors.radioButton,
          visibleElement
        );
        this.handleRadio(visibleElement, radios);
        if (this.props.dynamic) {
          this.handleDynamic(visibleElement, radios);
        }
      }
      handleRadio(visibleElement, radios) {
        const { checkedState, uncheckedState, exclude } = this.props.selectors;
        const elsToExclude = this.domProvider.querySelectorAll(
          exclude,
          visibleElement
        );
        this.domProvider.setAttributeToAll(
          elsToExclude,
          PROJECT_CLASSES.EXCLUDE_ATTRIBUTE,
          "true"
        );
        this.domProvider.setAttribute(
          visibleElement,
          ATTRIBUTES.ROLE,
          ROLE$1.RADIOGROUP
        );
        const stateProps = {
          selectors: {
            trueState: checkedState,
            falseState: uncheckedState,
            element: this.props.selectors.element,
          },
        };
        radios.forEach((element, i) => {
          this.domProvider.setAttribute(element, ATTRIBUTES.ROLE, ROLE$1.RADIO);
          this.domProvider.setAttribute(
            element,
            PROJECT_ATTRIBUTES.RADIO_INDEX,
            i.toString()
          );
          this.domProvider.setAttribute(element, ATTRIBUTES.TABINDEX, "-1");
          this.domProvider.setAttribute(
            element,
            AVOID_AUTO_TABBABLE_ATTRIBUTE,
            "true"
          );
          this.domProvider.setAttribute(
            element,
            AVOID_AUTO_HIDDEN_ATTRIBUTE,
            "true"
          );
          this.domProvider.addEventListener(element, "keydown", (e) =>
            this.eventsHandler.navigate(e, visibleElement, radios.length)
          );
          const siblings = radios.filter((el) => element !== el);
          checkedState &&
            uncheckedState &&
            this.toggleStateService.fix(
              element,
              stateProps,
              ARIA.CHECKED,
              siblings
            );
          this.domProvider.addEventListener(element, "click", (e) => {
            radios.forEach((element2) => {
              this.domProvider.setAttribute(
                element2,
                ATTRIBUTES.TABINDEX,
                element2 === e.target ? "0" : "-1"
              );
            });
          });
        });
        this.handleFocusTabindex(radios, this.getCheckedRadio(radios));
        const nativeInputs = this.domProvider.querySelectorAll(
          TAG_NAMES.INPUT,
          visibleElement
        );
        this.handleExcludeFocusFromNativeInputs(nativeInputs, radios);
      }
      handleFocusTabindex(elements, defaultChecked) {
        const focused = defaultChecked != null ? defaultChecked : elements[0];
        this.domProvider.setAttribute(focused, ATTRIBUTES.TABINDEX, "0");
      }
      getCheckedRadio(radios) {
        for (let i = 0; i < radios.length; i++) {
          const attr = this.domProvider.getAttribute(radios[i], ARIA.CHECKED);
          if (!attr) return radios[i];
        }
        return null;
      }
      handleExcludeFocusFromNativeInputs(inputs, radios) {
        inputs.length > 0 &&
          radios.length > 0 &&
          !Array(inputs).some((input) => Array(radios).includes(input)) &&
          inputs.forEach(
            (input) =>
              input &&
              !this.elementVisibility.isVisible(input) &&
              (input.style.visibility = "hidden")
          );
      }
      handleDynamic(visibleElement, radios) {
        this.domProvider.addEventListenerToAll(radios, "click", (e) => {
          const clickedRadioIndex = this.domProvider.getAttribute(
            e.target,
            PROJECT_ATTRIBUTES.RADIO_INDEX
          );
          if (clickedRadioIndex) {
            this.domProvider.setTimeout(() => {
              const newRadios = this.domProvider.querySelectorAll(
                this.props.selectors.radioButton,
                visibleElement
              );
              this.fix(visibleElement);
              newRadios.forEach((radio, i) => {
                const isClickable = i === Number(clickedRadioIndex);
                const tabindex = isClickable ? "0" : "-1";
                this.domProvider.setAttribute(
                  radio,
                  ATTRIBUTES.TABINDEX,
                  tabindex
                );
                isClickable &&
                  this.domProvider.setTimeout(
                    () => this.domProvider.focusOnElement(radio),
                    100
                  );
              });
            }, 100);
          }
        });
      }
    };
    RadioFixer = __decorateClass$2([free], RadioFixer);
    const RadioApi = (context = "body") => {
      const domProvider = new DomProvider();
      const elementVisibility = new ElementVisibility();
      const changeDetection = ChangeDetection.getInstance(
        elementVisibility,
        domProvider
      );
      const toggleStateService = new ToggleStateService(domProvider, true);
      const eventsHandler = new EventsHandler(
        domProvider,
        StateManagement.getInstance()
      );
      return (props) =>
        new RadioFixer(
          context,
          props,
          domProvider,
          changeDetection,
          toggleStateService,
          eventsHandler,
          elementVisibility
        );
    };

    class TableFixer extends FixerAbstract {
      constructor(
        context,
        props,
        domProvider,
        changeDetection,
        tableSorts,
        tableRoles
      ) {
        super(
          context,
          domProvider,
          changeDetection,
          props,
          props.selectors.table
        );
        this.tableSorts = tableSorts;
        this.tableRoles = tableRoles;
      }
      fix(table) {
        const { cell, row, columnheader, rowheader } = this.props.selectors;
        const tableElements = {
          table,
          rows: this.domProvider.querySelectorAll(row, table),
          cells: this.domProvider.querySelectorAll(cell, table),
          columnHeaders: this.domProvider.querySelectorAll(columnheader, table),
          rowHeaders: this.domProvider.querySelectorAll(rowheader, table),
        };
        this.tableRoles.setRoles(tableElements, "table");
        this.tableSorts.setAriaSorts(tableElements);
      }
    }
    const TableApi = (context = "body") => {
      const domProvider = new DomProvider();
      const elementVisibility = new ElementVisibility();
      const changeDetection = ChangeDetection.getInstance(
        elementVisibility,
        domProvider
      );
      return (props) => {
        const tableSorts = new TableSorts(domProvider);
        const tableRoles = new TableRoles(domProvider);
        new TableFixer(
          context,
          props,
          domProvider,
          changeDetection,
          tableSorts,
          tableRoles
        );
      };
    };

    class FieldsAndMethods extends FixerAbstract {}

    class AttributeInitialization extends FieldsAndMethods {
      initializeIds() {
        [...this.tabElements, ...this.tabPanelElements, this.descriptorElement]
          .filter(
            (element) =>
              element instanceof HTMLElement &&
              this.domProvider.getAttribute(element, "id") === null
          )
          .forEach((element) =>
            this.domProvider.setAttribute(element, "id", Utils$1.uuid())
          );
      }
      initializeRoles() {
        this.tabElements.forEach(this.setRole(ROLE$1.TAB));
        this.tabPanelElements.forEach(this.setRole(ROLE$1.TABPANEL));
        this.setRole(ROLE$1.TABLIST)(this.tabListElement);
      }
      initializeTabListLabel() {
        this.descriptorElement instanceof HTMLElement &&
          this.domProvider.setAttribute(
            this.tabListElement,
            "aria-labeledby",
            this.domProvider.getAttribute(this.descriptorElement, "id")
          );
      }
      initializeActiveElementStates() {
        this.setTabIndexes(this.tabElements, this.tabPanelElements);
        this.setTabControlStates();
      }
      initializeTabRelationships(isConditionalRendering, activeTabIndex) {
        if (!isConditionalRendering) {
          this.tabElements.forEach((tabElement, i) => {
            this.domProvider.setAttribute(
              tabElement,
              "aria-controls",
              this.domProvider.getAttribute(this.tabPanelElements[i], "id")
            );
          });
        } else {
          this.domProvider.setAttribute(
            this.tabElements[activeTabIndex],
            "aria-controls",
            this.domProvider.getAttribute(this.tabPanelElements[0], "id")
          );
        }
      }
    }

    class KeyboardNavigation extends FieldsAndMethods {
      setTabElementTabIndexAndFocus() {
        this.setTabIndexes(this.tabElements);
        this.domProvider.focusOnElement(this.tabElements[this.activeTabIndex]);
      }
      handleClickEvents({ target }) {
        const tabElementIndex = this.tabElements.indexOf(target);
        this.activeTabIndex =
          tabElementIndex > 0
            ? tabElementIndex
            : this.tabElements.indexOf(this.getParentTabElement(target));
        this.activeTabPanelIndex = this.activeTabIndex;
        this.setTabElementTabIndexAndFocus();
        this.setTabIndexes(this.tabPanelElements);
        this.setTabControlStates();
      }
      handleNextNavigationKeyPress() {
        this.activeTabIndex =
          this.activeTabIndex === this.lastTabIndex ? 0 : this.activeTabIndex + 1;
      }
      handlePreviousNavigationKeyPress() {
        this.activeTabIndex =
          this.activeTabIndex === 0 ? this.lastTabIndex : this.activeTabIndex - 1;
      }
      getHandleKeyDownEvents([previousNavigationKey, nextNavigationKey]) {
        return (event) => {
          const { code } = event;
          if (code === previousNavigationKey || code === nextNavigationKey) {
            event.stopPropagation();
            code === previousNavigationKey
              ? this.handlePreviousNavigationKeyPress()
              : this.handleNextNavigationKeyPress();
            this.setTabElementTabIndexAndFocus();
          }
          if (code === keyCodes.ENTER || code === keyCodes.SPACE) {
            this.domProvider.dispatchClickEvent(event.target);
            event.preventDefault();
          }
        };
      }
      addKeyDownKeyboardHandler() {
        const horizontalKeys = Utils$1.isRtl(this.stateManagement.getLang())
          ? [keyCodes.RIGHT, keyCodes.LEFT]
          : [keyCodes.LEFT, keyCodes.RIGHT];
        const navigationKeys = this.isVertical
          ? [keyCodes.UP, keyCodes.DOWN]
          : horizontalKeys;
        this.domProvider.addEventListenerToAll(
          this.tabElements,
          "keydown",
          this.getHandleKeyDownEvents(navigationKeys)
        );
      }
      addClickHandler() {
        this.domProvider.addEventListenerToAll(this.tabElements, "click", (e) =>
          this.handleClickEvents(e)
        );
      }
      // below logic ensures that the active tab is set to the one corresponding to the open tab panel
      addFocusOutHandler() {
        this.domProvider.addEventListenerToAll(
          this.tabElements,
          "focusout",
          (e) => {
            const { relatedTarget } = e;
            if (
              (relatedTarget instanceof HTMLElement &&
                this.tabElements.indexOf(relatedTarget) === -1) ||
              relatedTarget == null
            ) {
              this.activeTabIndex = this.activeTabPanelIndex;
              this.setTabIndexes(this.tabElements);
            }
          }
        );
      }
    }

    class Utils extends FieldsAndMethods {
      generateNewTabsSelectors() {
        const { tabSelectors, tabPanelSelectors } = this.props;
        const initialTabSelector = tabSelectors[0].split(":eq")[0];
        const initialPanelSelector = tabPanelSelectors[0].split(":eq")[0];
        this.props.tabSelectors = Array.from(
          document.querySelectorAll(`${this.context} ${initialTabSelector}`)
        ).map((_, i) => `${initialTabSelector}:eq(${i})`);
        this.props.tabPanelSelectors = Array.from(
          document.querySelectorAll(`${this.context} ${initialTabSelector}`)
        ).map((_, i) => `${initialPanelSelector}:eq(${i})`);
      }
      getElement(selector) {
        const element = this.domProvider.querySelector(selector, this.context);
        if (element === null) {
          throw new Error(`Selector '${selector}' returned null.`);
        }
        return element;
      }
      setRole(role) {
        return (element) => this.domProvider.setAttribute(element, "role", role);
      }
      setTabIndexes(...elementsArray) {
        elementsArray.forEach((elements) => {
          const isElementsSame = elements.every(
            (element) => element === elements[0]
          );
          elements.forEach((element, i) => {
            this.domProvider.setAttribute(
              element,
              AVOID_AUTO_TABBABLE_ATTRIBUTE,
              "true"
            );
            this.domProvider.setAttribute(
              element,
              "tabindex",
              isElementsSame ? "0" : i === this.activeTabIndex ? "0" : "-1"
            );
          });
        });
      }
      setTabControlStates() {
        this.setAriaSelected();
        this.setAriaHidden();
      }
      setAriaHidden() {
        this.tabPanelElements.forEach((panelElement) => {
          const isVisible = this.elementVisibility.isVisible(panelElement);
          this.domProvider.setAttribute(
            panelElement,
            ARIA.HIDDEN,
            `${!isVisible}`
          );
        });
      }
      setAriaSelected() {
        this.tabElements.forEach((tabElement, i) =>
          this.domProvider.setAttribute(
            tabElement,
            ARIA.SELECTED,
            `${i === this.activeTabIndex}`
          )
        );
      }
      getParentTabElement(element) {
        const [tabElement] = this.tabElements.filter((tabElement2) =>
          tabElement2.contains(element)
        );
        return tabElement;
      }
    }

    var __defProp$1 = Object.defineProperty;
    var __getOwnPropDesc$1 = Object.getOwnPropertyDescriptor;
    var __decorateClass$1 = (decorators, target, key, kind) => {
      var result =
        kind > 1 ? void 0 : kind ? __getOwnPropDesc$1(target, key) : target;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if ((decorator = decorators[i]))
          result =
            (kind ? decorator(target, key, result) : decorator(result)) || result;
      if (kind && result) __defProp$1(target, key, result);
      return result;
    };
    class TestService {}
    let TabsFixer = class extends FixerAbstract {
      constructor(
        context,
        tabsProps,
        domProvider = new DomProvider(),
        changeDetection = ChangeDetection.getInstance(
          new ElementVisibility(),
          domProvider
        )
      ) {
        super(
          context,
          domProvider,
          changeDetection,
          tabsProps,
          tabsProps.tabListSelector
        );
        this.activeTabIndex = 0;
        this.lastTabIndex = 0;
        this.tabElements = [];
        this.tabPanelElements = [];
        this.tabListElement = {};
        this.descriptorElement = {};
        this.isConditionalRendering = false;
        this.elementVisibility = new ElementVisibility();
        const { tabSelectors, tabPanelSelectors, isVertical } = tabsProps;
        if (tabSelectors.length !== tabPanelSelectors.length) {
          throw new Error(
            "There must be the same number of Tab element selectors as Tab Panel element selectors."
          );
        }
        this.isVertical = isVertical != null ? isVertical : false;
      }
      initializeElements() {
        const {
          tabSelectors,
          tabPanelSelectors,
          tabListSelector,
          descriptorElementSelector,
        } = this.props;
        this.tabElements = tabSelectors.map(this.getElement.bind(this));
        tabPanelSelectors.forEach((tabPanelSelector, idx) => {
          const el = this.domProvider.querySelector(tabPanelSelector);
          if (!el && idx >= 1) this.isConditionalRendering = true;
        });
        this.tabPanelElements = this.isConditionalRendering
          ? [this.getElement(tabPanelSelectors[0])]
          : tabPanelSelectors.map(this.getElement.bind(this));
        this.tabListElement = this.getElement(tabListSelector);
        descriptorElementSelector !== void 0 &&
          (this.descriptorElement = this.getElement(descriptorElementSelector));
      }
      activateMutationObserver() {
        const targetNodes = this.domProvider.querySelectorAll(
          this.props.tabListSelector
        );
        const config = { childList: true, subtree: true };
        const callback = (mutationList) => {
          let hasChildMutation = false;
          for (const mutation of mutationList) {
            if (mutation.type === "childList") {
              hasChildMutation = true;
            }
          }
          if (hasChildMutation) {
            this.generateNewTabsSelectors();
            this.handleTabs();
          }
        };
        targetNodes == null
          ? void 0
          : targetNodes.forEach((node) => {
              const observer = new MutationObserver(callback);
              observer.observe(node, config);
            });
      }
      handleTabs() {
        this.activeTabIndex = 0;
        this.activeTabPanelIndex = this.activeTabIndex;
        this.lastTabIndex = this.props.tabSelectors.length - 1;
        this.initializeElements();
        this.initializeIds();
        this.initializeRoles();
        this.initializeTabListLabel();
        this.initializeActiveElementStates();
        this.initializeTabRelationships(
          this.isConditionalRendering,
          this.activeTabIndex
        );
        this.addClickHandler();
        this.addKeyDownKeyboardHandler();
        this.addFocusOutHandler();
      }
      fix() {
        this.handleTabs();
        if (this.props.isDynamic) {
          this.activateMutationObserver();
        }
      }
    };
    TabsFixer = __decorateClass$1(
      [
        partials(AttributeInitialization, KeyboardNavigation, Utils),
        inject(TestService),
      ],
      TabsFixer
    );
    var TabsFixer$1 = TabsFixer;

    const mapToOldProps = (props, context) => {
      if ("selectors" in props) {
        const { tab, tabPanel, tabList, descriptorElement } = props.selectors;
        return {
          tabSelectors: Array.from(
            document.querySelectorAll(`${context} ${tab}`)
          ).map((_, i) => `${tab}:eq(${i})`),
          tabPanelSelectors: Array.from(
            document.querySelectorAll(`${context} ${tab}`)
          ).map((_, i) => `${tabPanel}:eq(${i})`),
          tabListSelector: tabList,
          descriptorElementSelector: descriptorElement,
          isVertical: props.isVertical,
          isDynamic: props.isDynamic,
        };
      }
      return props;
    };

    function TabsApi(context = "body") {
      return (props) => {
        props = mapToOldProps(props, context);
        return new TabsFixer$1(context, props);
      };
    }

    var EventType = /* @__PURE__ */ ((EventType2) => {
      EventType2["KEYDOWN"] = "keydown";
      EventType2["KEYUP"] = "keyup";
      EventType2["KEYPRESS"] = "keypress";
      EventType2["CLICK"] = "click";
      EventType2["MOUSEENTER"] = "mouseenter";
      EventType2["MOUSELEAVE"] = "mouseleave";
      EventType2["MOUSEOVER"] = "mouseover";
      EventType2["MOUSEOUT"] = "mouseout";
      return EventType2;
    })(EventType || {});
    const CounterEvent = {
      mouseenter: "mouseleave",
      mouseleave: "mouseenter",
      mouseover: "mouseout",
      mouseout: "mouseover",
    };

    class TooltipFixer extends FixerAbstract {
      constructor(context, props, domProvider, changeDetection) {
        super(
          context,
          domProvider,
          changeDetection,
          props,
          props.selectors.trigger
        );
        this.changeDetection = changeDetection;
      }
      fix() {
        var _a;
        const { trigger, tooltip } = this.props.selectors;
        const customEvent =
          (_a = this.props.customEvent) != null ? _a : EventType.MOUSEOVER;
        const triggerEls = this.domProvider.querySelectorAll(trigger);
        triggerEls == null
          ? void 0
          : triggerEls.forEach((el) => this.setButton(el, customEvent));
        this.changeDetection.subscribe(
          this.context,
          "tooltip",
          tooltip,
          (visibleTooltip) => this.onTooltipShow(visibleTooltip, triggerEls)
        );
      }
      onTooltipShow(tooltip, triggers) {
        this.domProvider.setAttribute(tooltip, ATTRIBUTES.ROLE, ROLE$1.TOOLTIP);
        this.domProvider.setAttribute(tooltip, STATUS_ATTR, "true");
        Utils$1.getOrCreateId(tooltip);
        triggers == null
          ? void 0
          : triggers.forEach((trigger) =>
              this.domProvider.setAttributeWithID(
                tooltip,
                trigger,
                ARIA.DESCRIBEDBY
              )
            );
      }
      setButton(element, customEvent) {
        if (
          !this.domProvider.matches(
            element,
            COMMON_SELECTORS.FOCUSABLE_ELEMENTS_SELECTOR
          )
        ) {
          this.domProvider.setAttribute(element, ATTRIBUTES.ROLE, ROLE$1.BUTTON);
          this.domProvider.setAttribute(element, ATTRIBUTES.TABINDEX, "0");
        }
        this.handleButtonEvents(element, customEvent);
      }
      handleButtonEvents(element, customEvent) {
        const events = [
          EVENT_TYPES.KEYDOWN,
          EVENT_TYPES.FOCUS_IN,
          EVENT_TYPES.FOCUS_OUT,
        ];
        events.forEach((evt) => {
          this.domProvider.addEventListener(element, evt, (e) =>
            this.addMouseEvent(e, element, customEvent)
          );
        });
      }
      addMouseEvent(e, el, customEvent) {
        const evt = e;
        if (evt.type == EVENT_TYPES.FOCUS_IN) {
          this.domProvider.dispatchMouseEvent(el, customEvent);
        }
        if (
          evt.code === KEYBOARD_EVENT_CODE$1.ESC ||
          evt.type == EVENT_TYPES.FOCUS_OUT
        ) {
          this.domProvider.dispatchMouseEvent(el, CounterEvent[customEvent]);
        }
      }
    }
    const TooltipApi = (context = "body") => {
      const domProvider = new DomProvider();
      const elementVisibility = new ElementVisibility();
      const changeDetection = ChangeDetection.getInstance(
        elementVisibility,
        domProvider
      );
      return (props) =>
        new TooltipFixer(context, props, domProvider, changeDetection);
    };

    var BUTTON_TYPE = /* @__PURE__ */ ((BUTTON_TYPE2) => {
      BUTTON_TYPE2[(BUTTON_TYPE2["PAGE_BTN"] = 0)] = "PAGE_BTN";
      BUTTON_TYPE2[(BUTTON_TYPE2["NEXT_BTN"] = 1)] = "NEXT_BTN";
      BUTTON_TYPE2[(BUTTON_TYPE2["PREV_BTN"] = 2)] = "PREV_BTN";
      BUTTON_TYPE2[(BUTTON_TYPE2["SKIP_NEXT"] = 3)] = "SKIP_NEXT";
      BUTTON_TYPE2[(BUTTON_TYPE2["SKIP_PREV"] = 4)] = "SKIP_PREV";
      return BUTTON_TYPE2;
    })(BUTTON_TYPE || {});
    const PAGINATION = {
      PAGE_INDEX: "u1-page-index",
    };

    class ButtonsHandler {
      constructor(
        context,
        changeDetection,
        domProvider,
        translateService,
        paginationButton
      ) {
        this.context = context;
        this.changeDetection = changeDetection;
        this.domProvider = domProvider;
        this.translateService = translateService;
        this.paginationButton = paginationButton;
      }
      handleButtons(props) {
        const { pageButtons, prevBtn, nextBtn, prevSkip, nextSkip } =
          props.selectors;
        if (pageButtons) {
          const pageButtonsEls = this.domProvider.querySelectorAll(pageButtons);
          if (pageButtons.length) {
            this.domProvider.setAttribute(
              pageButtonsEls[0],
              ARIA.CURRENT,
              "true"
            );
          } else {
            console.error(`pageButtons Elements are not found`);
          }
          this.changeDetection.subscribe(
            this.context,
            "pageBtn",
            pageButtons,
            () => this.handlePageButtons(BUTTON_TYPE.PAGE_BTN, pageButtons, props)
          );
        } else {
          console.error(`pageButtons Selector is mandatory`);
        }
        if (prevBtn) {
          this.handleArrowButton(
            BUTTON_TYPE.PREV_BTN,
            props,
            prevBtn,
            TranslateText.PREV_PAGE
          );
        }
        if (nextBtn) {
          this.handleArrowButton(
            BUTTON_TYPE.NEXT_BTN,
            props,
            nextBtn,
            TranslateText.NEXT_PAGE
          );
        }
        if (prevSkip) {
          this.changeDetection.subscribe(
            this.context,
            "prevSkipBtn",
            prevSkip,
            (BtnEl) =>
              this.handleSkipButton(
                BUTTON_TYPE.SKIP_PREV,
                props,
                BtnEl,
                TranslateText.PREV_SKIP
              )
          );
        }
        if (nextSkip) {
          this.changeDetection.subscribe(
            this.context,
            "prevSkipBtn",
            nextSkip,
            (BtnEl) =>
              this.handleSkipButton(
                BUTTON_TYPE.SKIP_NEXT,
                props,
                BtnEl,
                TranslateText.NEXT_SKIP
              )
          );
        }
      }
      handlePageButtons(direction, pageButtons, props) {
        const pageButtonsEls = this.domProvider.querySelectorAll(pageButtons);
        pageButtonsEls == null
          ? void 0
          : pageButtonsEls.forEach((btn, i) => {
              var _a, _b;
              this.domProvider.setAttribute(
                btn,
                PAGINATION.PAGE_INDEX,
                String(i)
              );
              const pageNumber =
                (_b =
                  (_a = this.domProvider.getTextContent(btn)) == null
                    ? void 0
                    : _a.match(/\d+\.\d+|\d+/)) != null
                  ? _b
                  : i + 1;
              this.paginationButton.handlePaginationButton(
                btn,
                `${this.translateService.getValue(
                  TranslateText.PAGE
                )} ${pageNumber}`,
                props,
                direction
              );
            });
      }
      handleArrowButton(type, props, btnSelector, text) {
        const btnEl = this.domProvider.querySelector(btnSelector);
        if (btnEl) {
          this.paginationButton.handlePaginationButton(
            btnEl,
            this.translateService.getValue(text),
            props,
            type
          );
        } else {
          console.error(
            `Element with the following selector not found: ${btnSelector}`
          );
        }
      }
      handleSkipButton(type, props, btnEl, text) {
        var _a;
        if (btnEl) {
          if (!props.skipAmount) {
            console.error("Skip amount must be provided");
          }
          const skipBtnText = this.translateService
            .getValue(text)
            .replace(
              "{{skipAmount}}",
              String(
                (_a = props.skipAmount) != null
                  ? _a
                  : this.translateService.getValue(TranslateText.FEW)
              )
            );
          this.paginationButton.handlePaginationButton(
            btnEl,
            skipBtnText,
            props,
            type
          );
        }
      }
    }

    class PaginationButton {
      constructor(
        domProvider,
        statusFixer,
        currentPageHandler,
        focusToFixer,
        elementVisibility
      ) {
        this.domProvider = domProvider;
        this.statusFixer = statusFixer;
        this.currentPageHandler = currentPageHandler;
        this.focusToFixer = focusToFixer;
        this.elementVisibility = elementVisibility;
      }
      handlePaginationButton(buttonEl, label, props, type) {
        if (buttonEl) {
          this.domProvider.setAttribute(buttonEl, ARIA.LABEL, label);
          this.domProvider.setAttribute(buttonEl, ATTRIBUTES.ROLE, ROLE$1.BUTTON);
          this.domProvider.setAttribute(buttonEl, ATTRIBUTES.TABINDEX, "0");
          this.domProvider.addEventListener(buttonEl, "keydown", (e) =>
            this.addMouseEvent(e, buttonEl)
          );
          this.domProvider.addEventListener(buttonEl, "click", (e) => {
            const isNotDisabled =
              this.domProvider.getAttribute(e.target, ARIA.DISABLED) !== "true";
            if (isNotDisabled) {
              this.handlePaginationClicked(e, props, type);
            }
          });
        }
      }
      addMouseEvent(e, el) {
        const evt = e;
        if (evt.code === "Enter" || evt.code === "Space") {
          this.domProvider.dispatchMouseClickEvent(el);
        }
      }
      handlePaginationClicked(e, props, type) {
        const prevPage = this.domProvider.querySelector(
          `[${ARIA.CURRENT}]`,
          props.selectors.container
        );
        let newIndex = 0;
        if (type === BUTTON_TYPE.PAGE_BTN) {
          newIndex = this.currentPageHandler.getClickedPageIndex(e.target);
        } else {
          newIndex = this.currentPageHandler.getNextPageIndex(
            prevPage,
            type,
            props.skipAmount
          );
        }
        this.domProvider.setTimeout(() => {
          this.currentPageHandler.setCurrentPage(newIndex, prevPage);
          this.setPageStatus(props.selectors.container, props.selectors.results);
          if (props.autoFocus) {
            this.focusOnTop(props.selectors.container);
          }
        }, 500);
      }
      focusOnTop(containerSelector) {
        const container = this.domProvider.querySelector(containerSelector);
        container && this.focusToFixer.createAnchorAndFocusTo(container);
      }
      setPageStatus(containerSelector, resultsSelector) {
        let statusText = "Page changed";
        const currentPage = this.domProvider.querySelector(
          `[${ARIA.CURRENT}]`,
          containerSelector
        );
        const label =
          currentPage && this.domProvider.getAttribute(currentPage, ARIA.LABEL);
        if (label) {
          statusText = `${label}`;
        }
        const results =
          resultsSelector && this.domProvider.querySelectorAll(resultsSelector);
        if (results == null ? void 0 : results.length) {
          const visibleResults = Array.prototype.slice
            .call(results, 0)
            .filter((res) => this.elementVisibility.isVisibleOnPage(res));
          statusText += `. Showing ${visibleResults.length} results.`;
        }
        this.statusFixer.announceStatus(statusText);
      }
    }

    class CurrentPageHandler {
      constructor(domProvider) {
        this.domProvider = domProvider;
      }
      setCurrentPage(index, prevPage) {
        this.domProvider.removeAttribute(prevPage, ARIA.CURRENT);
        const newCurrent = this.domProvider.querySelector(
          `[${PAGINATION.PAGE_INDEX}="${index}"]`
        );
        if (newCurrent) {
          this.domProvider.setAttribute(newCurrent, ARIA.CURRENT, "true");
        }
      }
      getClickedPageIndex(clickedEl) {
        return Number(
          this.domProvider.getAttribute(clickedEl, PAGINATION.PAGE_INDEX)
        );
      }
      getNextPageIndex(prevPage, type, skipAmount) {
        const prevIndex = Number(
          this.domProvider.getAttribute(prevPage, PAGINATION.PAGE_INDEX)
        );
        return prevIndex + this.getDirection(type, skipAmount);
      }
      getDirection(type, skipAmount) {
        const skip = skipAmount != null ? skipAmount : 0;
        switch (type) {
          case BUTTON_TYPE.NEXT_BTN:
            return 1;
          case BUTTON_TYPE.PREV_BTN:
            return -1;
          case BUTTON_TYPE.SKIP_NEXT:
            return skip;
          case BUTTON_TYPE.SKIP_PREV:
            return -skip;
          case BUTTON_TYPE.PAGE_BTN:
          default:
            return 0;
        }
      }
    }

    class PaginationFixer extends FixerAbstract {
      constructor(context, props, domProvider, changeDetection, buttonsHandler) {
        super(
          context,
          domProvider,
          changeDetection,
          props,
          props.selectors.container
        );
        this.buttonsHandler = buttonsHandler;
      }
      fix() {
        Utils$1.addContextToSelectors(this.props, this.props.selectors.container);
        this.buttonsHandler.handleButtons(this.props);
      }
    }
    const PaginationApi = (context = "body") => {
      const domProvider = new DomProvider();
      const elementVisibility = new ElementVisibility();
      const changeDetection = ChangeDetection.getInstance(
        elementVisibility,
        domProvider
      );
      const stateManagement = StateManagement.getInstance();
      const translateService = new Translate(stateManagement);
      const statusFixer = new StatusFixer(context, domProvider, changeDetection);
      const currentPageHandler = new CurrentPageHandler(domProvider);
      const focusToFixer = new FocusToFixer(
        context,
        domProvider,
        changeDetection
      );
      const paginationButton = new PaginationButton(
        domProvider,
        statusFixer,
        currentPageHandler,
        focusToFixer,
        elementVisibility
      );
      const buttonsHandler = new ButtonsHandler(
        context,
        changeDetection,
        domProvider,
        translateService,
        paginationButton
      );
      return (props) => {
        new PaginationFixer(
          context,
          props,
          domProvider,
          changeDetection,
          buttonsHandler
        );
      };
    };

    class LoadingFixer extends FixerAbstract {
      constructor(
        context,
        props,
        domProvider,
        changeDetection,
        statusFixer,
        translateService
      ) {
        super(context, domProvider, changeDetection, props, [
          props.selectors.loadingBar,
        ]);
        this.statusFixer = statusFixer;
        this.translateService = translateService;
      }
      fix(visibleBar) {
        this.domProvider.setAttribute(visibleBar, ATTRIBUTES.ROLE, ROLE$1.METER);
        const loadingText = this.translateService.getValue(TranslateText.LOADING);
        this.statusFixer.announceStatus(loadingText);
      }
    }
    const LoadingApi = (context = "body") => {
      const domProvider = new DomProvider();
      const elementVisibility = new ElementVisibility();
      const changeDetection = ChangeDetection.getInstance(
        elementVisibility,
        domProvider
      );
      const stateManagement = StateManagement.getInstance();
      const translateService = new Translate(stateManagement);
      const statusFixer = new StatusFixer(context, domProvider, changeDetection);
      return (props) => {
        new LoadingFixer(
          context,
          props,
          domProvider,
          changeDetection,
          statusFixer,
          translateService
        );
      };
    };

    var __defProp = Object.defineProperty;
    var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
    var __decorateClass = (decorators, target, key, kind) => {
      var result =
        kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
      for (var i = decorators.length - 1, decorator; i >= 0; i--)
        if ((decorator = decorators[i]))
          result =
            (kind ? decorator(target, key, result) : decorator(result)) || result;
      if (kind && result) __defProp(target, key, result);
      return result;
    };
    class Localization {
      get() {
        var _a;
        const stateManagement = StateManagement.getInstance();
        const localization =
          (_a = stateManagement.localization) != null
            ? _a
            : window.u1st.localization;
        return (key) => {
          var _a2;
          return (_a2 = localization[key]) != null ? _a2 : "";
        };
      }
    }
    __decorateClass([catchable], Localization.prototype, "get", 1);

    if (window !== void 0) {
      Promise.resolve()
        .then(function () {
          return AccessibilityButton$1;
        })
        .then(({ AccessibilityButton: AccessibilityButton2 }) =>
          AccessibilityButton2.initialize()
        );
    }

    var U1_SELECTOR = {
      ACCORDION: "[u1-accordion]",
      BUTTON: "[u1-button]",
      CAROUSEL: "[u1-carousel]",
      CHECKBOX: "[u1-checkbox]",
      COMBOBOX: "[u1-combobox]",
      DATEPICKER: "[u1-datepicker]",
      DIALOG: "[u1-dialog]",
      FORM: "[u1-form]",
      GRID: "[u1-grid]",
      LINK: "[u1-link]",
      LISTBOX: "[u1-listbox]",
      MENU: "[u1-menu]",
      RADIO: "[u1-radio]",
      TABLE: "[u1-table]",
      TABS: "[u1-tabs]",
      TOOLTIP: "[u1-tooltip]",
      PAGINATION: "[u1-pagination]",
      LOADING: "[u1-loading]",
      TOGGLE: "[u1-toggle]",
    };
    var SUFFIX_PH = "{suffix}";
    var SCOPE_PH = "{scope}";

    var ACCORDION_ATTRIBUTE = "[u1-accordion]";
    var accordionHandler = {
      selector: ACCORDION_ATTRIBUTE,
      props: {
        headingLevel: undefined,
        selectors: {
          contentSelector: "".concat(SCOPE_PH, " [u1-content]"),
          headerSelector: "".concat(SCOPE_PH, " [u1-header]"),
          disabledElementsSelector: "".concat(SCOPE_PH, " [u1-disabled]"),
        },
      },
    };

    var BUTTON_ATTRIBUTE = "[u1-button]";
    var buttonHandler = {
      selector: BUTTON_ATTRIBUTE,
      props: {
        selectors: {
          element: SCOPE_PH,
        },
      },
    };

    var CAROUSEL_ATTRIBUTE = "[u1-carousel]";
    var carouselHandler = {
      selector: CAROUSEL_ATTRIBUTE,
      props: {
        selectors: {
          carouselContainer: SCOPE_PH,
          absoluteCarouselContainerLabel: "[u1-label]",
          slide: "[u1-slide]",
          prevButton: "[u1-prev-btn]",
          nextButton: "[u1-next-btn]",
          slidePickerButtons: "[u1-picker]",
        },
      },
    };

    var checkboxHandler = {
      selector: U1_SELECTOR.CHECKBOX,
      props: {
        selectors: {
          element: SCOPE_PH,
          checkedState: "".concat(SCOPE_PH, '[u1-checked="true"]'),
          uncheckedState: "".concat(SCOPE_PH, '[u1-checked="false"]'),
          exclude: ""
            .concat(SCOPE_PH, '[u1-exclude="true"], ')
            .concat(SCOPE_PH, ' [u1-exclude="true"]'),
          disabled: ""
            .concat(SCOPE_PH, '[u1-disabled="true"], ')
            .concat(SCOPE_PH, ' [u1-disabled="true"]'),
        },
      },
      handleSpecialCases: function (_, el) {
        // below logic is necessary as focus will shift to the input element when a label element is selected
        var elementId = el.getAttribute("for");
        if (elementId) {
          var inputElement = document.getElementById(elementId);
          if (inputElement) {
            inputElement.addEventListener("focusin", function () {
              return el.focus();
            });
          }
        }
      },
    };

    var COMBOBOX_ATTRIBUTE = "[u1-combobox]";
    var comboboxHandler = {
      selector: COMBOBOX_ATTRIBUTE,
      props: {
        selectors: {
          combobox: "".concat(SCOPE_PH).concat(SUFFIX_PH, " [u1-combobox-input]"),
          textbox: "".concat(SCOPE_PH).concat(SUFFIX_PH, " [u1-textbox]"),
          options: "".concat(SCOPE_PH).concat(SUFFIX_PH, " [u1-option]"),
          listbox: "".concat(SCOPE_PH).concat(SUFFIX_PH, " [u1-listbox]"),
          label: "[u1-label]".concat(SUFFIX_PH),
          emptyOption: "".concat(SCOPE_PH, " [u1-empty-option]"),
        },
        isAutocompleteList: true,
      },
    };

    var DIALOG_TRIGGER_ATTRIBUTE = "[u1-dialog-trigger]";
    var DIALOG_ATTRIBUTE = "[u1-dialog]";
    var dialogHandler = {
      selector: DIALOG_ATTRIBUTE,
      props: {
        type: DialogType.MODAL,
        selectors: {
          dialog: "".concat(SCOPE_PH).concat(DIALOG_ATTRIBUTE).concat(SUFFIX_PH),
          closeBtn: "[u1-close-btn]",
          heading: "[u1-heading]",
          textContent: "[u1-content]",
          dynamicContent: "[u1-content-dynamic]",
          trigger: "".concat(DIALOG_TRIGGER_ATTRIBUTE).concat(SUFFIX_PH),
          focusTo: "[u1-focus-back]".concat(SUFFIX_PH),
        },
      },
    };

    var FORM_ATTRIBUTE = "[u1-form]";
    var formHandler = {
      selector: FORM_ATTRIBUTE,
      props: {
        selectors: {
          form: SCOPE_PH,
          submitButton: "".concat(SCOPE_PH, " [u1-submit]"),
          formLabelAbsolute: "".concat(SCOPE_PH, " [u1-label]"),
          requiredField: "".concat(SCOPE_PH, " [u1-required]"),
          errorMsg: "".concat(SCOPE_PH, " [u1-error]:not(:empty)"),
          invalidField: "".concat(SCOPE_PH, " [u1-invalid]"),
          successMsg: "".concat(SCOPE_PH, " [u1-success]"),
        },
      },
    };

    var GRID_ATTRIBUTE = "[u1-grid]";
    var gridHandler = {
      selector: GRID_ATTRIBUTE,
      props: {
        selectors: {
          grid: SCOPE_PH,
          row: "[u1-row]",
          cell: "[u1-cell]",
          columnheader: "[u1-col-header]",
          rowheader: "[u1-row-header]",
        },
      },
    };

    var LINK_ATTRIBUTE = "[u1-link]";
    var linkHandler = {
      selector: LINK_ATTRIBUTE,
      props: {
        selectors: {
          element: SCOPE_PH,
        },
      },
    };

    var listboxHandler = {
      selector: "[u1-listbox]",
      props: {
        selectors: {
          listbox: "".concat(SCOPE_PH, " [u1-list]").concat(SUFFIX_PH),
          trigger: "".concat(SCOPE_PH, " [u1-trigger]").concat(SUFFIX_PH),
          options: "[u1-option]".concat(SUFFIX_PH),
          label: "".concat(SCOPE_PH, " [u1-label]").concat(SUFFIX_PH),
          group: "".concat(SCOPE_PH, " [u1-group]").concat(SUFFIX_PH),
        },
      },
    };

    var RADIO_ATTRIBUTE = "[u1-radio]";
    var radioHandler = {
      selector: RADIO_ATTRIBUTE,
      props: {
        selectors: {
          radioGroup: "[u1-radio-group]",
          radioButton: "[u1-radio-button]",
          checkedState: '[u1-checked="true"]',
          uncheckedState: '[u1-checked="false"]',
          exclude: '[u1-exclude="true"]',
        },
      },
    };

    var TABLE_ATTRIBUTE = "u1-table";
    var tableHandler = {
      selector: "[".concat(TABLE_ATTRIBUTE, "]"),
      props: {
        selectors: {
          table: SCOPE_PH,
          row: "[u1-row]",
          cell: "[u1-cell]",
          columnheader: "[u1-col-header]",
          rowheader: "[u1-row-header]",
        },
      },
    };

    var TABS_ATTRIBUTE = "[u1-tabs]";
    var tabsHandler = {
      selector: TABS_ATTRIBUTE,
      props: {
        selectors: {
          tab: "".concat(SCOPE_PH, " [u1-tab]"),
          tabPanel: "".concat(SCOPE_PH, " [u1-panel]"),
          tabList: "".concat(SCOPE_PH, " [u1-list]"),
        },
        isVertical: false,
      },
    };

    var tooltipHandler = {
      selector: U1_SELECTOR.TOOLTIP,
      props: {
        selectors: {
          trigger: "[u1-trigger]".concat(SUFFIX_PH),
          tooltip: "[u1-tooltip]".concat(SUFFIX_PH),
        },
      },
    };

    var PAGINATION_ATTRIBUTE = "[u1-pagination]";
    var paginationHandler = {
      selector: PAGINATION_ATTRIBUTE,
      props: {
        selectors: {
          container: "".concat(SCOPE_PH).concat(PAGINATION_ATTRIBUTE),
          pageButtons: "[u1-page]",
          nextBtn: "[u1-next]",
          prevBtn: "[u1-prev]",
          nextSkip: "[u1-next-skip]",
          prevSkip: "[u1-prev-skip]",
          results: "[u1-result]",
        },
        autoFocus: false,
      },
    };

    var DATEPICKER_ATTRIBUTE = "[u1-datepicker]";
    var datepickerHandler = {
      selector: DATEPICKER_ATTRIBUTE,
      props: {
        selectors: {
          container: "".concat(SCOPE_PH, " [u1-modal]"),
          trigger: "".concat(SCOPE_PH, " [u1-trigger]"),
          month: {
            label: "[u1-month-label]",
            prevButton: "[u1-month-prev-btn]",
            nextButton: "[u1-month-next-btn]",
          },
          year: {
            label: "[u1-year-label]",
            prevButton: "[u1-year-prev-btn]",
            nextButton: "[u1-year-next-btn]",
          },
          days: {
            table: "[u1-days-table]",
            day: "[u1-day]",
            selected: "[u1-selected-day]",
            disabled: "[u1-disabled-day]",
          },
        },
        doubleDatepicker: false,
        isMonthClickable: false,
        isYearClickable: false,
      },
    };

    var LOADING_ATTRIBUTE = "[u1-loading]";
    var loadingHandler = {
      selector: LOADING_ATTRIBUTE,
      props: {
        selectors: {
          loadingBar: "[u1-loading]",
        },
      },
    };

    var MENU_ATTRIBUTE = "[u1-menu]";
    var menuHandler = {
      selector: MENU_ATTRIBUTE,
      props: {
        selectors: {
          menu: SCOPE_PH,
          submenus: "".concat(SCOPE_PH, " [u1-submenu]"),
          horizontalMenu: "[u1-horizontal]",
          items: "[u1-item]",
          openByFocus: "[u1-open-by-focus]",
          openByMouseover: "[u1-open-by-mouseover]",
          triggers: "[u1-trigger]",
        },
      },
      handleSpecialCases: function (props, element) {
        if (element.hasAttribute("u1-menubar")) {
          props.menubar = true;
        }
      },
    };

    var TOGGLE_ATTRIBUTE = "[u1-toggle]";
    var toggleHandler = {
      selector: TOGGLE_ATTRIBUTE,
      props: {
        selectors: {
          element: SCOPE_PH,
          toggleSelectors: {
            pressedState: "".concat(SCOPE_PH, "[u1-selected]"),
            notPressedState: "".concat(SCOPE_PH, ":not([u1-selected])"),
          },
        },
      },
    };

    var ComponentToHandlerMap = {
      accordion: accordionHandler,
      button: buttonHandler,
      carousel: carouselHandler,
      checkbox: checkboxHandler,
      combobox: comboboxHandler,
      datepicker: datepickerHandler,
      dialog: dialogHandler,
      form: formHandler,
      grid: gridHandler,
      link: linkHandler,
      listbox: listboxHandler,
      menu: menuHandler,
      radio: radioHandler,
      table: tableHandler,
      tabs: tabsHandler,
      tooltip: tooltipHandler,
      pagination: paginationHandler,
      loading: loadingHandler,
      toggle: toggleHandler,
    };

    var REF_ID_ATTRIBUTE = "u1-a11y-ref";
    var activate = function (selector, component, api, manualProps) {
      fromSelector(selector).subscribe(function (element) {
        var props;
        if (manualProps) {
          props = manualProps;
        } else {
          var handler = ComponentToHandlerMap[component];
          props = handler.props;
          var refId = element.getAttribute(REF_ID_ATTRIBUTE);
          // below handles placeholder replacement, performs function of `Utils.getU1Props` in `ui-library-mapper`
          // replaces logic in `Utils.getU1Scoping`
          var suffix = refId
            ? "[".concat(REF_ID_ATTRIBUTE, "='").concat(refId, "']")
            : "";
          var elementId = "[id='".concat(Utils$1.getOrCreateId(element), "']");
          var scope = refId ? "" : elementId;
          // replaces logic in `Utils.manipulateU1Props`
          var stringifiedProps = JSON.stringify(props);
          stringifiedProps = stringifiedProps.replaceAll(SUFFIX_PH, suffix);
          stringifiedProps = stringifiedProps.replaceAll(SCOPE_PH, scope);
          props = JSON.parse(stringifiedProps);
          if (handler.handleSpecialCases) {
            handler.handleSpecialCases(props, element);
          }
        }
        api("body")(props);
      });
    };
    var fix = {
      accordion: function (selector, props) {
        return activate(selector, "accordion", AccordionApi, props);
      },
      button: function (selector, props) {
        return activate(selector, "button", ButtonApi, props);
      },
      carousel: function (selector, props) {
        return activate(selector, "carousel", CarouselApi, props);
      },
      checkbox: function (selector, props) {
        return activate(selector, "checkbox", CheckboxApi, props);
      },
      combobox: function (selector, props) {
        return activate(selector, "combobox", ComboboxApi, props);
      },
      datepicker: function (selector, props) {
        return activate(selector, "datepicker", DatepickerApi, props);
      },
      dialog: function (selector, props) {
        return activate(selector, "dialog", DialogApi, props);
      },
      form: function (selector, props) {
        return activate(selector, "form", FormApi, props);
      },
      grid: function (selector, props) {
        return activate(selector, "grid", GridApi, props);
      },
      link: function (selector, props) {
        return activate(selector, "link", LinkApi, props);
      },
      listbox: function (selector, props) {
        return activate(selector, "listbox", ListboxApi, props);
      },
      menu: function (selector, props) {
        return activate(selector, "menu", MenuApi, props);
      },
      radio: function (selector, props) {
        return activate(selector, "radio", RadioApi, props);
      },
      table: function (selector, props) {
        return activate(selector, "table", TableApi, props);
      },
      tabs: function (selector, props) {
        return activate(selector, "tabs", TabsApi, props);
      },
      tooltip: function (selector, props) {
        return activate(selector, "tooltip", TooltipApi, props);
      },
      pagination: function (selector, props) {
        return activate(selector, "pagination", PaginationApi, props);
      },
      loading: function (selector, props) {
        return activate(selector, "loading", LoadingApi, props);
      },
      toggle: function (selector, props) {
        return activate(selector, "toggle", ToggleButtonApi, props);
      },
    };
    var activateFixers = function () {
      //Component fixers
      fix.button(U1_SELECTOR.BUTTON);
      fix.toggle(U1_SELECTOR.TOGGLE);
      fix.link(U1_SELECTOR.LINK);
      fix.checkbox(U1_SELECTOR.CHECKBOX);
      fix.radio(U1_SELECTOR.RADIO);
      fix.grid(U1_SELECTOR.GRID);
      fix.table(U1_SELECTOR.TABLE);
      fix.accordion(U1_SELECTOR.ACCORDION);
      fix.combobox(U1_SELECTOR.COMBOBOX);
      fix.listbox(U1_SELECTOR.LISTBOX);
      fix.carousel(U1_SELECTOR.CAROUSEL);
      fix.tabs(U1_SELECTOR.TABS);
      fix.tooltip(U1_SELECTOR.TOOLTIP);
      fix.pagination(U1_SELECTOR.PAGINATION);
      fix.datepicker(U1_SELECTOR.DATEPICKER);
      fix.loading(U1_SELECTOR.LOADING);
      fix.form(U1_SELECTOR.FORM);
      fix.menu(U1_SELECTOR.MENU);
      fix.dialog(U1_SELECTOR.DIALOG);
      //Global fixers
      visualFocusApi();
      focusToApi();
      excludeElApi();
      statusApi();
    };
    if (document.readyState === "complete") {
      activateFixers();
    } else {
      window.addEventListener("DOMContentLoaded", function () {
        activateFixers();
      });
    }
    var test = {
      isVisible: function (element) {
        return testIsVisibile(element);
      },
    };
    var setConfiguration = setConfiguration$1;
    var u1 = {
      fix: fix,
      test: test,
      setConfiguration: setConfiguration,
    };

    window.u1 = __assign(__assign({}, window.u1), u1);
  })();

  const MOBILE_BREAKPOINT = 768;

  const skipLinksWithMobileLandmarks = [];

  window.addEventListener("resize", () => {
    skipLinksWithMobileLandmarks.forEach(
      ({ skipLink, landmarkId, mobileLandmarkId }) => {
        skipLink.href = `#${
          window.innerWidth < MOBILE_BREAKPOINT ? mobileLandmarkId : landmarkId
        }`;
      }
    );
  });

  const addSkipLink = ({
    landmarkSelector,
    mobileLandmarkSelector,
    role,
    landmarkDescription,
  }) => {
    const landmark = document.querySelector(landmarkSelector);

    if (landmark) {
      landmark.id = landmark.id === "" ? role : landmark.id;
      const skipLink = document.createElement("a");
      skipLink.classList.add("skip-link");
      const path = window.location.pathname;

      skipLink.href = `${path}#${role}`;
      skipLink.textContent = `דלג אל ${landmarkDescription}`;
      document.body.prepend(skipLink);

      if (mobileLandmarkSelector) {
        const mobileLandmark = document.querySelector(mobileLandmarkSelector);
        if (mobileLandmark) {
          mobileLandmark.id =
            mobileLandmark.id === "" ? `mobile-${role}` : mobileLandmark.id;

          if (window.innerWidth < MOBILE_BREAKPOINT) {
            skipLink.href = `${path}#${mobileLandmark.id}`;
          }

          skipLinksWithMobileLandmarks.push({
            skipLink,
            landmarkId: landmark.id,
            mobileLandmarkId: mobileLandmark.id,
          });
        }
      }
    }
  };

  const skipLinks = [
    {
      landmarkSelector: "footer",
      role: "footer",
      landmarkDescription: "תחתית העמוד",
    },
    {
      landmarkSelector: "[role='main']",
      role: "main",
      landmarkDescription: "תוכן ראשי",
    },
    {
      landmarkSelector: ".open-search-box-desktop",
      mobileLandmarkSelector: "#search-box-search .icon-container",
      role: "search",
      landmarkDescription: "חיפוש",
    },
    {
      landmarkSelector: "nav",
      mobileLandmarkSelector: ".navbar-toggler",
      role: "navigation",
      landmarkDescription: "תפריט ניווט",
    },
  ];

  const addSkipLinks = () => {
    skipLinks.forEach((skipLink) => {
    addSkipLink(skipLink);
    });
  };
  setTimeout(function(){

    addSkipLinks();

  },2000)
